var vpn = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.40182,2.925l-.00528,5.09293c0,4.02133-2.399,7.80642-6.60849,10.46746-4.19818-2.62228-6.591-6.4071-6.591-10.4663L4.2023,2.925H17.40182M18.528,1.8H3.07846L3.072,8.01793c0,4.80111,3.031,9.07214,7.71988,11.78207,4.68881-2.74918,7.72964-7.02014,7.72964-11.78207L18.528,1.8ZM12.03485,12.42555l.79687-.79492a2.92609,2.92609,0,0,0-4.042,0l.79492.79492A1.7746,1.7746,0,0,1,12.03485,12.42555Zm2.09472-2.248a4.69788,4.69788,0,0,0-6.63769,0l.79492.79492a3.65855,3.65855,0,0,1,5.04785,0ZM15.3825,8.72828a6.46344,6.46344,0,0,0-9.14355,0l.79492.79493a5.34119,5.34119,0,0,1,7.55371,0Z"
			},
			children: [
			]
		}
	]
};
var accessibility = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.6,10.5c-1.9-3-5.3-4.7-8.8-4.7c-3.7,0-6.9,1.7-8.8,4.7l-0.2,0.3L2,11.1c1.9,3,5.2,4.7,8.8,4.7c3.6,0,6.9-1.7,8.8-4.7\n\tl0.2-0.3L19.6,10.5z M3.1,10.8c1-1.5,2.5-2.7,4.3-3.3c-1.7,1.8-1.7,4.7,0,6.5C5.6,13.5,4.1,12.3,3.1,10.8z M10.8,14.5\n\tc-2,0-3.7-1.6-3.7-3.7s1.6-3.7,3.7-3.7c2,0,3.7,1.6,3.7,3.7C14.5,12.8,12.8,14.5,10.8,14.5z M14.3,14.1c1.7-1.8,1.7-4.7,0-6.5\n\tc1.7,0.6,3.2,1.7,4.3,3.3C17.5,12.3,16,13.5,14.3,14.1z M12.3,10.8c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5l0,0\n\tC11.6,9.3,12.3,10,12.3,10.8z"
			},
			children: [
			]
		}
	]
};
var airport = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.7,7.5c-0.2-0.5-0.5-0.9-1-1.1c-0.3-0.1-0.6-0.2-0.9-0.2c-0.2,0-0.4,0-0.6,0.1L13,7.4L7.4,3.9L4.8,4.6l4.1,4l-3,0.9\n\tL3.5,8L3.3,8L2.4,8.3L2.2,8.3L1.8,8.5l0,0L3.3,11l1.2,2l0.4,0.7l1.6-0.5l3.6-1L9,17.7l2.5-0.7l2.7-5.9l4.2-1.2\n\tc0.5-0.1,0.9-0.5,1.2-0.9C19.8,8.5,19.9,7.9,19.7,7.5z M7,5.1l0.2-0.1l4.4,2.7l-1.4,0.4L9.7,7.8L7,5.1z M18.6,8.4\n\tc-0.1,0.2-0.3,0.3-0.5,0.4L13.9,10l-0.5,0.1l-0.2,0.5l-2.5,5.5l-0.2,0.1l0.7-3.7l0.4-1.8l-1.8,0.5l-3.6,1l-0.8,0.2l-1.1-1.9L3.6,9.4\n\tl1.7,1l0.4,0.3l0.5-0.1l3-0.9l0.7-0.2l0,0l2.9-0.8l0,0l0.5-0.1l4.2-1.2c0.1,0,0.2,0,0.3,0c0.1,0,0.3,0,0.4,0.1\n\tc0.2,0.1,0.3,0.3,0.4,0.5C18.7,8,18.7,8.2,18.6,8.4z"
			},
			children: [
			]
		}
	]
};
var analytics = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M2.06,18.65h3.8V13.72H2.06Zm1.13-3.81H4.73v2.68H3.19ZM6.8,18.63h3.7V8.05H6.8ZM7.93,9.17H9.37v8.34H7.93Zm3.54,9.46H15V11.42H11.47Zm1.13-6.08h1.3v5H12.6ZM16.09,9.3v9.27h3.7V9.3Zm2.58,8.14H17.22v-7h1.45Zm-16-5.82-.88-.71L8.17,3l5.37,5.41L19.06,4l.69.89-6.3,5L8.26,4.64Z"
			},
			children: [
			]
		}
	]
};
var announcement = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.6,8V4L8.9,7.7H1.8v5.2H4.1v4.7H7.9V12.9h1l8.6,3.7v-4A2.3,2.3,0,0,0,17.6,8ZM6.8,16.5H5.2V12.9H6.8ZM9,11.8H3V8.9H9Zm7.5,3.1-6.4-2.8V8.5l6.4-2.8Zm1.1-3.4V9.1a1.21,1.21,0,0,1,1.1,1.3A1.11,1.11,0,0,1,17.6,11.5Z"
			},
			children: [
			]
		}
	]
};
var ar = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M4.43,7.47H3.3V3.3H7.47V4.43h-3Zm0,6.66H3.3V18.3H7.47V17.18h-3ZM14.13,3.3V4.43h3v3H18.3V3.3Zm3,13.88h-3V18.3H18.3V14.13H17.18ZM16,13.77,10.8,16.65,5.63,13.77V7.83L10.8,5,16,7.83Zm-5.73-2.71L6.76,9.12v4l3.48,1.94Zm.56-1,3.45-1.93L10.8,6.24,7.35,8.16Zm4-1-3.48,1.94v4l3.48-1.94Z"
			},
			children: [
			]
		}
	]
};
var archive = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,2.93v4.5H2.93V18.68H18.68V7.43H19.8V2.93ZM17.55,17.55H4.05V7.43h13.5ZM18.68,6.3H2.93V4.05H18.68ZM8.55,12.49h4.5a1.69,1.69,0,0,0,0-3.38H8.55a1.69,1.69,0,0,0,0,3.38Zm0-2.25h4.5a.56.56,0,1,1,0,1.12H8.55a.56.56,0,1,1,0-1.12Z"
			},
			children: [
			]
		}
	]
};
var artboard = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.4100056,16.4294586H5.0500054V5.0694594h11.3600006V16.4294586z M6.1627274,15.3167372h9.1345568V6.1821809H6.1627274\n\tV15.3167372z M16.4100056,1.8h-1.125v2.2373049h1.125V1.8z M19.7999992,5.0694594h-2.2373047v1.125h2.2373047V5.0694594z\n\t M6.1750054,1.8h-1.125v2.2373049h1.125V1.8z M4.0373049,5.0694594H1.8v1.125h2.2373049V5.0694594z M4.0373049,15.3044596H1.8\n\tv1.124999h2.2373049V15.3044596z M19.7999992,15.3044596h-2.2373047v1.124999h2.2373047V15.3044596z M6.1750054,17.5626945h-1.125\n\tv2.2373047h1.125V17.5626945z M16.4100056,17.5626945h-1.125v2.2373047h1.125V17.5626945z"
			},
			children: [
			]
		}
	]
};
var at = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M8.43474,15.4429a3.35663,3.35663,0,0,1-1.1769-.85814,3.86182,3.86182,0,0,1-.74831-1.31992,5.19569,5.19569,0,0,1-.26408-1.69529,7.2308,7.2308,0,0,1,.34121-2.29912A5.20961,5.20961,0,0,1,7.54389,7.521,4.23085,4.23085,0,0,1,8.97413,6.41a4.11151,4.11151,0,0,1,1.78218-.38514,2.95081,2.95081,0,0,1,1.68261.451,3.06913,3.06913,0,0,1,1.02313,1.111H13.506l.1767-1.34189H15.399l-.74782,6.11781q-.2431,1.82612,1.21057,1.82562a1.74773,1.74773,0,0,0,.86888-.24211,2.18978,2.18978,0,0,0,.75954-.77028,4.83611,4.83611,0,0,0,.5389-1.35214,8.15653,8.15653,0,0,0,.20893-1.9706,7.28865,7.28865,0,0,0-.55062-2.94834A5.7427,5.7427,0,0,0,16.18,4.82546a6.29657,6.29657,0,0,0-2.25519-1.232,9.22189,9.22189,0,0,0-2.77261-.4071,8.03282,8.03282,0,0,0-2.94834.55012,7.36851,7.36851,0,0,0-2.47533,1.584A7.5182,7.5182,0,0,0,4.0342,7.85093a8.69129,8.69129,0,0,0-.62726,3.38864A8.30777,8.30777,0,0,0,3.89117,14.123a6.29782,6.29782,0,0,0,3.71862,3.79575,8.52223,8.52223,0,0,0,3.14652.5389,11.073,11.073,0,0,0,2.14536-.19819,11.217,11.217,0,0,0,1.94668-.57209l.50571,1.2096A10.99991,10.99991,0,0,1,10.86614,19.8a10.45411,10.45411,0,0,1-3.66346-.617A8.2823,8.2823,0,0,1,4.353,17.44523,7.79027,7.79027,0,0,1,2.50487,14.739a9.06728,9.06728,0,0,1-.66-3.52141,9.52923,9.52923,0,0,1,.803-4.01589A8.99916,8.99916,0,0,1,4.77128,4.25337a9.20609,9.20609,0,0,1,3.0035-1.82612A9.78352,9.78352,0,0,1,11.21809,1.8a10.01593,10.01593,0,0,1,3.146.5062,8.22812,8.22812,0,0,1,2.73942,1.50736,7.39113,7.39113,0,0,1,1.92521,2.4973,7.82,7.82,0,0,1,.72634,3.45454,10.24579,10.24579,0,0,1-.25188,2.3328,5.89872,5.89872,0,0,1-.74782,1.84808,3.69922,3.69922,0,0,1-1.24377,1.21057,3.40825,3.40825,0,0,1-1.76119.4403,2.83311,2.83311,0,0,1-1.66064-.4403,2.27,2.27,0,0,1-.86986-1.14419H13.176a3.943,3.943,0,0,1-1.3414,1.25451,3.58859,3.58859,0,0,1-1.8266.48326A3.82625,3.82625,0,0,1,8.43474,15.4429Zm3.08062-1.3863a2.85821,2.85821,0,0,0,.93527-.89134,3.97716,3.97716,0,0,0,.54964-1.33163,7.402,7.402,0,0,0,.17573-1.65039,3.26,3.26,0,0,0-.57209-2.01307,2.11141,2.11141,0,0,0-1.80367-.75905,2.31563,2.31563,0,0,0-1.254.33,2.55864,2.55864,0,0,0-.85814.89085,4.473,4.473,0,0,0-.49546,1.30966,7.458,7.458,0,0,0-.165,1.606,4.87413,4.87413,0,0,0,.12106,1.112,2.6381,2.6381,0,0,0,.38514.90208,1.8925,1.8925,0,0,0,.67119.60529,2.03478,2.03478,0,0,0,.9792.21966A2.58281,2.58281,0,0,0,11.51536,14.0566Z"
			},
			children: [
			]
		}
	]
};
var attach = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M8,19.7c-2.9,0-5.3-2.4-5.3-5.3c0-1.4,0.6-2.8,1.6-3.7l7.6-7.6c1.6-1.6,4.1-1.6,5.6,0c1.6,1.6,1.6,4.1,0,5.6l-6.2,6.2\n\tc-1.1,1.1-2.9,1.1-4,0s-1.1-2.9,0-4l6.3-6.3l0.8,0.8l-6.3,6.3c-0.7,0.7-0.7,1.7,0,2.4s1.7,0.7,2.4,0l6.2-6.2c1.1-1.1,1.1-2.9,0-4\n\ts-2.9-1.1-4,0L5,11.5c-1.6,1.6-1.6,4.3,0,5.9s4.3,1.6,5.9,0l0,0l7.2-7.2l0.8,0.8l-7.2,7.2C10.7,19.1,9.4,19.7,8,19.7z"
			},
			children: [
			]
		}
	]
};
var award = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17,6.6c0.1-1.1,0.2-2.2,0.2-3.3V2.7H4.5v0.6c0,1.1,0.1,2.2,0.2,3.3H1.8v0.6c0,2.7,1.8,5.1,4.8,6.3c1,1.9,2.3,3.1,3.7,3.4\n\tv0.9H7v1.1h7.7v-1.1h-3.3v-0.9c1.4-0.3,2.7-1.5,3.7-3.4c2.9-1.2,4.8-3.6,4.8-6.3V6.6L17,6.6z M3,7.7h1.9c0.2,1.4,0.6,2.8,1,4.1\n\tC4.3,11,3.3,9.5,3,7.7z M10.8,15.8c-2.5,0-5.1-4.8-5.2-11.9H16C15.9,11,13.3,15.8,10.8,15.8z M15.8,11.8c0.5-1.3,0.8-2.7,1-4.1h1.9\n\tC18.4,9.5,17.3,11,15.8,11.8z"
			},
			children: [
			]
		}
	]
};
var awareness = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13.66,11,17,6.86,14.15,1.8H7.57L4.69,7l3.36,4.13L4.28,15.64,6.49,19.8l4.36-5.28,4.26,5.25,2.21-4.16Zm.87-6.3,1.15,2-2.74,3.38-1.35-1.7Zm-3.66,2.8L9.79,6.19h2.14ZM8.23,2.93H13.5l.42.75L12.83,5.06H8.89L7.8,3.69ZM6.69,17.78l-1.06-2L8.77,12l1.35,1.66Zm8.22,0L6.05,6.83,7.21,4.75l8.76,11Z"
			},
			children: [
			]
		}
	]
};
var barcode = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Barcode",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M4.05,6.3H6.3v9H4.05Zm11.25,0H11.925v9H15.3Zm-7.875,9H8.55v-9H7.425Zm9-9v9H17.55v-9Zm-6.75,9H10.8v-9H9.675Zm-6.75,0H1.8v4.5H6.3V18.675H2.925Zm15.75,3.375H15.3V19.8h4.5V15.3H18.675ZM1.8,6.3H2.925V2.925H6.3V1.8H1.8ZM15.3,1.8V2.925h3.375V6.3H19.8V1.8Z"
			},
			children: [
			]
		}
	]
};
var battery = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12.8,3.8v-2h-4v2h-3v16h10V3.8ZM9.93,2.93h1.75v.75H9.93Zm4.75,15.75H6.93V4.93h7.75Zm-.88-1.32h-6V16.24h6Zm0-3h-6V13.24h6Zm0-3h-6V10.24h6Z"
			},
			children: [
			]
		}
	]
};
var bid = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,1.8a6.74729,6.74729,0,0,0-.5625,13.47131V19.8h1.125V15.27156A6.74742,6.74742,0,0,0,10.8,1.8Zm0,12.375A5.625,5.625,0,1,1,16.425,8.55,5.63143,5.63143,0,0,1,10.8,14.175Zm.3418-6.186V5.58369A1.31155,1.31155,0,0,1,12.469,6.74141h.80859A2.01637,2.01637,0,0,0,11.1418,4.91523V4.36641h-.5586v.54882c-1.27734.04981-2.1455.75831-2.1455,1.86622,0,1.26709.918,1.60644,2.1455,1.876v2.58447A1.601,1.601,0,0,1,8.95625,9.61543H8.11738a2.335,2.335,0,0,0,2.46582,2.30518v.84814h.5586v-.83838c1.30664-.07959,2.29492-.78808,2.29492-1.9956C13.43672,8.57734,12.44844,8.258,11.1418,7.989Zm-.5586-.10986c-.92871-.20947-1.35742-.499-1.35742-1.13769,0-.7085.54883-1.09766,1.35742-1.16748Zm.5586,3.37305V8.7873c.958.20948,1.47656.439,1.47656,1.17725A1.39788,1.39788,0,0,1,11.1418,11.25215Z"
			},
			children: [
			]
		}
	]
};
var blind = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M7.02006,13.6989,5.65489,19.15739a.61708.61708,0,1,1-1.19721-.29974l1.36517-5.4585a.61708.61708,0,1,1,1.19721.29975ZM8.55888,4.875a1.48621,1.48621,0,1,0-1.48621-1.4862A1.48623,1.48623,0,0,0,8.55888,4.875Zm9.21673,13.97443L13.44444,12.2921a.25813.25813,0,0,0-.43109.28405l4.33117,6.55732a.257.257,0,0,0,.216.1159.25351.25351,0,0,0,.142-.04285A.25743.25743,0,0,0,17.77561,18.84941Zm-4.86255-7.94928S9.18589,5.40086,9.17863,5.39146a.41977.41977,0,0,0-.10071-.09271.43061.43061,0,0,0-.04645-.03125A.42127.42127,0,0,0,8.84361,5.22H6.49107a.42447.42447,0,0,0-.17884.04132.442.442,0,0,0-.04345.02936C6.23216,5.3134,3.7816,7.7512,3.7816,7.7512l.06457,3.28711a.49616.49616,0,0,0,.49609.48621h.00953a.49671.49671,0,0,0,.48663-.506L4.78239,8.162,6.06077,6.9174v3.438c0,.074-.03247.226.00409.29065l1.04175,1.46716.00586-.00409C7.777,13.057,8.6287,14.26622,8.95713,14.732l1.28681,4.51709a.61708.61708,0,1,0,1.18683-.3385l-1.31519-4.61786-.08868-.18647c-.58515-.8305-1.33558-1.89721-1.90693-2.71179l.94135-.66766a.43.43,0,0,0,.21258-.3714V7.31l2.81922,4.14825a.49593.49593,0,1,0,.81994-.5581Z"
			},
			children: [
			]
		}
	]
};
var bluetooth = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.75,6.69,10.3,1.8V9.43L6.65,5.75l-.8.8,4.22,4.25L5.85,15.05l.8.79,3.65-3.67V19.8l5.45-4.89L11.66,10.8ZM11.43,4.33l2.68,2.4-2.68,2.7Zm0,12.94v-5.1l2.68,2.7Z"
			},
			children: [
			]
		}
	]
};
var bookmark = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "b30534b8-66a5-40e4-9a79-c63f7843a0f0",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.23,1.8H4.34v18l6.6-3.15,6.32,3.15ZM5.48,2.93H16.1V6.48L5.48,6.54ZM11,15.39,5.48,18V7.67l10.63-.06V18Z"
			},
			children: [
			]
		}
	]
};
var bot = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.01633,10.88366v-3.7h-3v-2.1a.90948.90948,0,0,0,.4-.8,1,1,0,1,0-2,0,1.23451,1.23451,0,0,0,.4.8v2.1h-10.2v3.8h-1.8v3.6h1.8v3.7h14.4v-3.8h1.8v-3.6Zm-14.4,2.5h-.7v-1.4h.7Zm13.3,3.7h-12.2v-8.8h12.2Zm1.8-3.7h-.7v-1.4h.7Zm-10.1,1.2h4.3v1.1h-4.3Zm4.9-.6a2.3,2.3,0,1,0-2.3-2.3A2.3,2.3,0,0,0,13.51633,13.98369Zm0-3.475a1.175,1.175,0,1,1-1.175,1.175A1.17632,1.17632,0,0,1,13.51633,10.50866Zm-5.4,3.475a2.3,2.3,0,1,0-2.3-2.3A2.3,2.3,0,0,0,8.11631,13.98369Zm0-3.475a1.175,1.175,0,1,1-1.175,1.175A1.17632,1.17632,0,0,1,8.11631,10.50866Z"
			},
			children: [
			]
		}
	]
};
var braille = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.97114,8.50862l.00287,7.67822a3.75174,3.75174,0,0,1-3.36511,3.58533,4.35637,4.35637,0,0,1-.497.02783,3.88918,3.88918,0,0,1-3.49805-2.13281l-3.226-6.19348a.49113.49113,0,1,1,.87115-.4538l3.22315,6.18774a2.90306,2.90306,0,0,0,3.01019,1.58881A2.76444,2.76444,0,0,0,15.99159,16.182l-.00287-7.6734a.49121.49121,0,0,1,.98242,0Zm-2.60766,4.81244a.491.491,0,0,0,.49121-.49121V7.73243a.49121.49121,0,0,0-.98242,0v5.09742A.49092.49092,0,0,0,14.36348,13.32106Zm-2.602-7.34626V12.875a.49124.49124,0,0,0,.98248,0V5.9748a.49124.49124,0,0,0-.98248,0ZM9.65077,6.963v5.912a.49124.49124,0,0,0,.98248,0V6.963a.49124.49124,0,0,0-.98248,0ZM3.10658,1.8a.71567.71567,0,1,0,.7157.71564A.71568.71568,0,0,0,3.10658,1.8Zm0,2.147a.71567.71567,0,1,0,.7157.7157A.7157.7157,0,0,0,3.10658,3.947Zm2.147,0a.71567.71567,0,1,0,.71564.7157A.7157.7157,0,0,0,5.25361,3.947Zm-2.147,2.147a.71567.71567,0,1,0,.7157.71563A.71568.71568,0,0,0,3.10658,6.094ZM7.40052,3.23134a.71567.71567,0,1,0-.71557-.7157A.71563.71563,0,0,0,7.40052,3.23134Zm0,2.147A.71567.71567,0,1,0,6.685,4.66267.71562.71562,0,0,0,7.40052,5.37831ZM5.25361,6.094a.71567.71567,0,1,0,.71564.71563A.71572.71572,0,0,0,5.25361,6.094ZM18.49342,3.23134a.71567.71567,0,1,0-.7157-.7157A.71562.71562,0,0,0,18.49342,3.23134Zm0,.71563a.71567.71567,0,1,0,.71564.7157A.71571.71571,0,0,0,18.49342,3.947Zm0,2.147a.71567.71567,0,1,0,.71564.71563A.71569.71569,0,0,0,18.49342,6.094ZM9.54762,3.23134a.71567.71567,0,1,0-.7157-.7157A.71562.71562,0,0,0,9.54762,3.23134Zm2.147,0a.71567.71567,0,1,0-.71563-.7157A.71567.71567,0,0,0,11.69459,3.23134ZM16.34639,1.8a.71567.71567,0,1,0,.71569.71564A.71567.71567,0,0,0,16.34639,1.8Zm0,1.78918a.71567.71567,0,1,0,.71569.7157A.71566.71566,0,0,0,16.34639,3.58918Z"
			},
			children: [
			]
		}
	]
};
var brightness = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.24944,4.19823V1.8h1.20211V4.19823ZM5.83015,3.2781l1.19613,2.08,1.04219-.60032-1.2021-2.0739ZM5.435,6.92068,3.343,5.71849,2.74876,6.76078l2.086,1.2021ZM4.19823,10.14836H1.8v1.19612H4.19823Zm-.92,5.63355L5.352,14.58578,4.75178,13.5481l-2.07391,1.196Zm2.457,2.49166,1.03769.59424,1.2021-2.0739-1.03769-.60032ZM10.14836,19.8h1.19612V17.40177H10.14836ZM13.542,16.84224l1.19612,2.0739,1.03769-.5958-1.196-2.07989Zm4.73763-.98494.59424-1.03621L16.8,13.619l-.60031,1.03622Zm-.87788-4.40575H19.8V10.24944H17.40177Zm1.52036-4.59126-.59572-1.03612-2.08,1.196.60179,1.04229Zm-3.05884-3.5218L14.82716,2.7367,13.625,4.81051l1.03621.60188Zm-5.07245,2.5202a4.93473,4.93473,0,1,1-4.93215,4.93215A4.94047,4.94047,0,0,1,10.79084,5.85869Zm.05892,1.13721v7.595a3.79786,3.79786,0,0,0,0-7.595Z"
			},
			children: [
			]
		}
	]
};
var calendar = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Calendar",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,1.8v18h18v-18C19.8,1.8,1.8,1.8,1.8,1.8z M18.7,18.7H2.9V5.2h15.7v13.5H18.7z M18.7,4H2.9V2.9h15.7V4H18.7z M10.7,13.8\n\tc0-1.1-0.8-1.7-2.2-1.7H8v-0.8h0.5c1.3,0,2-0.6,2-1.5c0-0.9-0.8-1.5-1.8-1.5c-1.2,0-2,0.8-2,2h-1c0-1.7,1.1-2.8,3-2.8\n\tc1.6,0,2.8,0.9,2.8,2.3c0,1-0.6,1.5-1.4,1.8v0c1.2,0.3,1.7,1.1,1.7,2.2c0,1.6-1.3,2.6-3.1,2.6c-1.9,0-3.4-1.1-3.4-3h1\n\tc0,1.4,0.9,2.1,2.3,2.1C9.9,15.6,10.7,15,10.7,13.8z M14.8,10h-1.9V9.3c1,0,1.9-0.4,2.1-1.7h0.8v8.6h-1V10z"
			},
			children: [
			]
		}
	]
};
var calibrate = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.784,6.6a4.7889,4.7889,0,0,1-4.778,4.8H12.324V10.275h2.682A3.675,3.675,0,1,0,11.344,6.6V15a4.78,4.78,0,1,1-4.783-4.8h.903V8.98l2.151,1.782L7.464,12.543V11.325H6.561A3.675,3.675,0,1,0,10.224,15V6.6a4.78,4.78,0,1,1,9.56,0Z"
			},
			children: [
			]
		}
	]
};
var camera = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,4.05v13.5h18V4.05Zm16.9,12.4H2.9V5.25H18.7Zm-6.2-1.7a3.9,3.9,0,0,0,3.9-3.9A4,4,0,0,0,12.5,7a3.9,3.9,0,0,0-3.9,3.9A3.84,3.84,0,0,0,12.5,14.75Zm0-6.7a2.8,2.8,0,1,1-2.8,2.8A2.73,2.73,0,0,1,12.5,8.05Zm-8.4-.6a1.1,1.1,0,1,1,1.1,1.1A1.1,1.1,0,0,1,4.1,7.45Z"
			},
			children: [
			]
		}
	]
};
var chat = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "b7dbe3e2-07ae-43a7-93ef-438950c26831",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,1.8A9,9,0,0,0,3.19,15.6L2.12,19.68l4-1.23A9,9,0,1,0,10.8,1.8Zm0,16.88A7.88,7.88,0,0,1,6.67,17.5l-.43-.27-.49.15-2,.63.56-2.13.13-.47L4.15,15a7.87,7.87,0,1,1,6.65,3.68Zm1.1-7.78a1.13,1.13,0,1,1-1.13-1.13A1.12,1.12,0,0,1,11.9,10.9Zm3.95,0a1.13,1.13,0,1,1-1.13-1.13A1.12,1.12,0,0,1,15.85,10.9ZM8,10.9A1.13,1.13,0,1,1,6.88,9.77,1.12,1.12,0,0,1,8,10.9Z"
			},
			children: [
			]
		}
	]
};
var checkmark = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.74,5.29,7.88,17.15,1.74,11l.84-.84,5.3,5.31,11-11Z"
			},
			children: [
			]
		}
	]
};
var clock = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,1.8a9,9,0,1,0,9,9A9,9,0,0,0,10.8,1.8Zm0,16.88a7.88,7.88,0,1,1,7.87-7.88A7.89,7.89,0,0,1,10.8,18.68ZM14.7,7.87l.64.89-5.1,3.71V4.3h1.12v5.91Z"
			},
			children: [
			]
		}
	]
};
var close = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.59,10.8l7.11,7.1-.8.8-7.1-7.11L3.7,18.7l-.8-.8L10,10.8,2.9,3.7l.8-.8L10.8,10,17.9,2.9l.8.8Z"
			},
			children: [
			]
		}
	]
};
var cloud = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.9,6.3c1.9,0,3.4,1.5,3.4,3.4v1.1h1.1c1.3,0,2.3,1,2.3,2.3s-1,2.3-2.3,2.3H6.3c-1.9,0-3.4-1.5-3.4-3.4s1.5-3.4,3.4-3.4\n\tc0.4,0,0.8,0.1,1.2,0.2l1,0.4l0.4-0.9C9.4,7,10.6,6.3,11.9,6.3 M11.9,5.2c-1.7,0-3.3,1-4.1,2.6C5.5,6.9,3,8.1,2.1,10.4\n\ts0.3,4.9,2.6,5.8c0.5,0.2,1,0.3,1.6,0.3h10.1c1.9,0,3.4-1.5,3.4-3.4s-1.5-3.4-3.4-3.4C16.4,7.2,14.4,5.2,11.9,5.2L11.9,5.2z"
			},
			children: [
			]
		}
	]
};
var coax = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 38 38"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m27.01807,5l-16.02637.03186-7.9917,13.96814,7.9917,14h16.02637l7.98193-14-7.98193-14Zm-1.16187,26h-13.70337l-6.84937-11.99884,6.84937-11.97162,13.70459-.02722,6.84033,11.99768-6.84155,12Zm-4.8562-12.00012v.00018c0,1.10455-.89551,1.99994-2,1.99994-1.10474-.00006-2-.89551-2-2.00012,0-1.10455.89551-1.99994,2-1.99988,1.10449,0,2,.89539,2,1.99988Zm-2-9.49988c-5.24683,0-9.5,4.2533-9.5,9.5s4.25317,9.5,9.5,9.5,9.5-4.2533,9.5-9.5-4.25342-9.5-9.5-9.5Zm0,17c-4.1355,0-7.5-3.3645-7.5-7.5s3.3645-7.5,7.5-7.5,7.5,3.3645,7.5,7.5-3.3645,7.5-7.5,7.5Z"
			},
			children: [
			]
		}
	]
};
var coffee = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M6.71992,5.09736A.696.696,0,0,0,6.717,4.10908l-.45605-.45556.7959-.7959.45166.45166a1.82,1.82,0,0,1,.02441,2.5664.7062.7062,0,0,0-.05029,1.01123l.67871.67774-.7959.7959L6.7126,7.70771A1.83242,1.83242,0,0,1,6.71992,5.09736Zm5.66992,1.27539a1.842,1.842,0,0,0,.55274,1.33887l.666.65283.78711-.80371-.68652-.67431a.70392.70392,0,0,1,.0498-1.01075,1.81707,1.81707,0,0,0-.01953-2.56L13.301,2.864l-.80664.78321.44824.4624a.69545.69545,0,0,1,.00293.98779A1.80514,1.80514,0,0,0,12.38984,6.37275Zm-2.70361,1.062.65283.86621.89844-.67676-.63916-.84717a1.56822,1.56822,0,0,1,0-1.771,2.70122,2.70122,0,0,0-.01172-3.06494l-.439-.59033-.90235.6709.42725.57471a1.56568,1.56568,0,0,1,0,1.7705A2.70425,2.70425,0,0,0,9.68623,7.43477ZM13.469,19.12422H17.6291v1.125H1.90156v-1.125H5.70912a6.5795,6.5795,0,0,1-1.86176-1.60645,7.21794,7.21794,0,0,1-1.46972-4.47461V10.343A1.169,1.169,0,0,1,3.54512,9.17549H15.65547a1.16947,1.16947,0,0,1,1.168,1.16748v1.38769h.2539a2.60212,2.60212,0,1,1,.002,5.20411H15.73274a6.32443,6.32443,0,0,1-.379.583A6.4952,6.4952,0,0,1,13.469,19.12422Zm3.35443-6.26856v.1875a7.63456,7.63456,0,0,1-.52661,2.76661h.78149a1.47717,1.47717,0,1,0-.001-2.95411ZM14.4709,16.82051a6.08959,6.08959,0,0,0,1.22754-3.77735l-.043-2.74267H3.54512l-.04248,2.74267a6.09019,6.09019,0,0,0,1.227,3.77735A5.92815,5.92815,0,0,0,9.279,19.008c.002,0,.41211.01855.63379,0A6.05612,6.05612,0,0,0,14.4709,16.82051Z"
			},
			children: [
			]
		}
	]
};
var coin = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,1.80006a8.99994,8.99994,0,1,0,9,9A8.96258,8.96258,0,0,0,10.8,1.80006Zm0,16.9a7.9,7.9,0,1,1,7.9-7.9A7.91668,7.91668,0,0,1,10.8,18.7Zm.3877-8.72369V6.56764a1.8582,1.8582,0,0,1,1.88085,1.64062H14.215c-.21289-1.52734-1.11816-2.43262-3.02734-2.58838V4.84205h-.792v.77783c-1.81054.0708-3.041,1.0752-3.041,2.645,0,1.79639,1.30127,2.27735,3.041,2.65918v3.66358A2.26892,2.26892,0,0,1,8.09,12.282H6.90156c.0708,1.62695,1.04688,3.11231,3.49414,3.26758v1.20215h.792V15.56324c1.85253-.1123,3.25293-1.11719,3.25293-2.82812C14.44063,10.8108,13.04023,10.35816,11.1877,9.97633Zm-.792-.15528c-1.31543-.29736-1.92382-.70752-1.92382-1.61279,0-1.00439.77783-1.55566,1.92382-1.65478Zm.792,4.78125V11.10816c1.35839.29688,2.09375.62207,2.09375,1.669A1.98248,1.98248,0,0,1,11.1877,14.6023Z"
			},
			children: [
			]
		}
	]
};
var comparison = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.7,7.9c0-1.8-1.5-3.4-3.3-3.4S13,6,13,7.9c0,1.5,1,2.8,2.5,3.2L4.2,9.6c1.2-0.1,2.2-1.1,2.1-2.3c0-1.2-1-2.2-2.3-2.2\n\tC2.8,5.2,1.9,6.2,1.9,7.5c0,0.9,0.7,1.8,1.6,2l-1-0.1l-0.1,1.1l8.2,1.1L7.5,17h6.7l-3.1-5.4l8,1.1l0.1-1.1l-2.8-0.4\n\tC18.2,11.2,19.7,9.7,19.7,7.9z M14.1,7.9c0-1.2,1-2.2,2.2-2.2s2.2,1,2.2,2.2s-1,2.2-2.2,2.2l0,0C15.1,10.1,14.1,9.1,14.1,7.9z\n\t M3,7.4c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1S4.7,8.5,4.1,8.5l0,0C3.5,8.5,3,8,3,7.4z M9.4,15.9l1.4-2.4l1.4,2.4H9.4z"
			},
			children: [
			]
		}
	]
};
var compass = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.23,11.37a.81.81,0,1,1,1.14,0A.81.81,0,0,1,10.23,11.37Zm9.57-.57a9,9,0,1,1-9-9A9,9,0,0,1,19.8,10.8Zm-1.12,0a7.88,7.88,0,1,0-7.88,7.87A7.89,7.89,0,0,0,18.68,10.8ZM8.73,8.73l6.74-2.6-2.6,6.74-6.74,2.6Zm.87.87L8.1,13.5,12,12l1.51-3.91Z"
			},
			children: [
			]
		}
	]
};
var compose = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.3,11.8l1.13-1v9H1.8V5.18h9L9.8,6.3H2.93V18.68H15.3Zm-6-2.75L16.62,1.8,19.8,5l-7.27,7.25L7.68,13.91Zm6.11-4.5,1.59,1.59L18.21,5,16.62,3.39Zm-6,7.54,2.43-.84,4.33-4.32L14.66,5.34,10.33,9.66Z"
			},
			children: [
			]
		}
	]
};
var connect = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,19.07h3v-3h-3Zm1.12-1.88h.75v.75H2.92ZM6.8,19.07h3v-5h-3Zm1.12-3.88h.75v2.75H7.92Zm3.88,3.88h3v-9h-3Zm1.12-7.88h.75v6.75h-.75ZM16.8,6.07v13h3v-13Zm1.87,11.87h-.75V7.19h.75ZM11.92,3.43,6.41,8.94l-3-3,.89-.89L6.41,7.15,11,2.53Z"
			},
			children: [
			]
		}
	]
};
var convergence = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M3.77589,9.7455,2.63948,9.74318a8.22575,8.22575,0,0,1,16.31738,0l-1.13641.00238A7.09956,7.09956,0,0,0,3.77589,9.7455Zm7.02228,8.16388a7.11444,7.11444,0,0,1-7.01831-6.029l-1.13709-.002a8.22519,8.22519,0,0,0,16.31079,0l-1.13708.002A7.11444,7.11444,0,0,1,10.79817,17.90938Zm5.24206-9.67353-.70312-.875-3.757,3.44141,3.757,3.44922.6875-.90625L13.7635,11.387l6.0376-.0105-.00293-1.13532-6.0401.01276ZM5.57539,13.34523l.6875.90625,3.757-3.44922-3.757-3.44141-.70312.875,2.28216,2.01807-6.0401-.01276L1.7989,11.37648l6.0376.0105Z"
			},
			children: [
			]
		}
	]
};
var conversion = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,10.6h-1.1c0-4.2-3.4-7.6-7.6-7.6c-2.4,0-4.6,1.1-6,3h2.7V7H3.2V2.5h1.1V5c3.1-3.7,8.6-4.2,12.3-1.1\n\tC18.6,5.5,19.8,8,19.8,10.6z M13.9,15.8h2.6c-2.6,3.3-7.4,3.9-10.7,1.3c-1.8-1.4-2.9-3.6-2.9-6H1.8c0,4.8,3.9,8.7,8.7,8.7\n\tc2.6,0,5.1-1.2,6.7-3.2v2.5h1.1v-4.5h-4.5L13.9,15.8z M12.1,6.6V14h1.1V6.6H12.1z M11.1,9.3H9.9V14h1.1V9.3z M7.7,11v3h1.1v-3H7.7z"
			},
			children: [
			]
		}
	]
};
var crash = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.67088,11.27171l.0257-.01062a.63243.63243,0,1,0-.481-1.16986l-.28955.119L12.90276,8.75139l-.18323-.44574-.45874.18859-.29932-.72808-.59338.24395L11.06877,7.282l-1.07666.44262L5.69878,9.48985a1.59632,1.59632,0,0,0-.99726,1.72089l.4444,2.60937-.28955.11908a.63243.63243,0,1,0,.481,1.16986l.02575-.01056.02118.12464,1.87708,4.56555,2.33978-.962-.56323-1.36993,4.67963-1.924.56323,1.36993,2.33984-.962-1.87707-4.56556ZM7.3026,16.93046,6.47246,14.9113l-.00018-.001-.07379-.38885.00756-.00306-.15112-.88714L5.81066,11.0222a.47426.47426,0,0,1,.31591-.49188l4.29328-1.76514.03619-.01489.29938.72809.59332-.244.29938.72809.56659-.23291.72735,1.03686-.0003.00012.45984.655.12012.17127h.00006l.22827.32519.00061.00086.83008,2.019ZM7.9785,6.5789l1.55371-.63867L8.42284,3.241l2.55957,1.28516.91406-2.71485,1.11133,2.7002L15.708,3.40214,14.42088,5.96171l2.71485.91407-2.583,1.0625.86914,1.23242-.8164.57617L13.01366,7.491l1.2666-.52148-1.26953-.42774.60156-1.19824-1.14941.47265-.47266-1.14941-.42773,1.26953-1.19825-.60156.47266,1.15039L8.35936,7.50468Zm.1355,7.31128a.63249.63249,0,1,1-.82587-.34351A.63259.63259,0,0,1,8.114,13.89018Zm4.82587-1.98193a.63245.63245,0,1,1-.82581-.34357A.63244.63244,0,0,1,12.93987,11.90825Z"
			},
			children: [
			]
		}
	]
};
var crop = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.0253201,14.7299995V5.8600001H6.9763203v-4H5.8684301v4H1.94688V6.98h3.9215503v8.8800011h9.0489998v4H16.02528v-4\n\th3.9215603v-1.1300011H16.0253201z M6.9763203,14.7299995V6.98H14.91751v7.7499995H6.9763203z"
			},
			children: [
			]
		}
	]
};
var cta = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9.3591433,15.7016115l0.2254639,1.078124c-0.0025635,0-0.005127,0.0004272-0.0077515,0.0004272\n\tc-4.1299438,0-7.4898071-3.3599234-7.4898071-7.4902945C2.0870483,5.1599245,5.4469118,1.8,9.5768557,1.8\n\ts7.4898672,3.3599246,7.4898672,7.4898682c0,0.545166-0.0620117,1.0756836-0.1731567,1.5880737l-0.9959707-0.4851074\n\tc0.0625-0.3591309,0.1016235-0.7262573,0.1016235-1.1029663c0-3.5415649-2.8807983-6.4224243-6.4223633-6.4224243\n\tc-3.5415039,0-6.4223633,2.8808594-6.4223633,6.4224243C3.1544921,12.7583742,5.9189577,15.5854616,9.3591433,15.7016115z\n\t M9.5138674,5.4582644C9.544446,5.4573488,9.5754519,5.4569216,9.6060305,5.4569216\n\tc1.0058594,0,1.956604,0.3807983,2.6867676,1.078064c0.7423706,0.7090454,1.1644287,1.6619873,1.1987305,2.6859131\n\tl1.0343018,0.5037842c0.0123901-0.1626587,0.0418701-0.3207397,0.0380859-0.4871826V9.2370119\n\tc-0.0305786-1.3250732-0.5754395-2.5588379-1.5335693-3.473877c-0.9590454-0.9154663-2.2266235-1.3996582-3.5410767-1.3723145\n\tC8.164258,4.4213991,6.9304323,4.9657717,6.014966,5.9243898C5.0994387,6.882947,4.6120729,8.1403933,4.6426516,9.4649782\n\tc0.0305786,1.3250732,0.5749512,2.5588379,1.5335083,3.4743652c0.7966309,0.7612305,1.8045654,1.2042847,2.8817749,1.3218384\n\tl-0.2290649-1.0957031c-0.7124023-0.1429443-1.3766479-0.4836426-1.9155884-0.9980469\n\tc-0.7519531-0.7185669-1.1795654-1.6868896-1.203186-2.7269897C5.6859865,8.4007692,6.0682497,7.4138918,6.7868166,6.6619387\n\tC7.5053835,5.9095583,8.4737062,5.481885,9.5138674,5.4582644z M15.464612,14.1031618l2.1756582,2.939208l-2.1886587,1.6206665\n\tl-0.0823364-0.1112671l-2.0108643-2.7158194l-0.0499878,0.0963745l-2.0057373,3.8676748l-0.0651855-0.3119507l-0.5842285-2.7943726\n\tl-0.2185059-1.0451651l-0.2906494-1.3900146l-0.2181396-1.043396L8.8376589,8.0095949L8.7934084,7.797986l4.6386719,2.2597046\n\tl0.9699707,0.4724731l1.3150024,0.640625l0.9660025,0.4705811l2.829895,1.3786011L15.464612,14.1031618z M14.6441164,14.7897463\n\tl-0.637146-0.8610229l-0.3054199-0.4127808l-0.0290527-0.0391846l0.9762573-0.2610474l1.5382681-0.411438l0.2119751-0.0567017\n\tl0.0765381-0.0204468l-0.2034912-0.0991211l-0.9584341-0.4668579l-1.2821655-0.6245117l-0.9553223-0.465332l-2.7918091-1.3598633\n\tl0.0135498,0.0646973l0.6698608,3.2047119l0.2189331,1.0474854l0.2919312,1.3967285l0.2183838,1.0447989l0.010498,0.050293\n\tl0.0270386,0.1293335l0.1165161-0.2247314l0.7674561-1.4799795l0.4691772-0.9048462l0.1113281-0.2147827l0.3639526,0.4916992\n\tl0.6339722,0.8566895l1.4662476,1.9811392l0.0108643,0.0146484l0.4725332-0.3493042L14.6441164,14.7897463z"
			},
			children: [
			]
		}
	]
};
var ctr = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.84138,15.7071l-2.73016.18995,1.635,3.29791-1.0445.54028-1.63592-3.35089-2.03064,1.74078V9.73976ZM19.8,9.73976a2.25005,2.25005,0,1,1-4.34521-.80493L11.112,5.83284a2.19761,2.19761,0,0,1-2.39539.31024L5.87318,9.55513a2.28168,2.28168,0,1,1-.86511-.71894L7.85145,5.424a2.25228,2.25228,0,1,1,3.91864-.504l4.34265,3.10186A2.23845,2.23845,0,0,1,19.8,9.73976Zm-14.625,1.125a1.125,1.125,0,1,0-1.125,1.125A1.12627,1.12627,0,0,0,5.175,10.86476Zm5.625-6.75a1.125,1.125,0,1,0-1.125,1.125A1.12627,1.12627,0,0,0,10.8,4.11476Zm7.875,5.625a1.125,1.125,0,1,0-1.125,1.125A1.12627,1.12627,0,0,0,18.675,9.73976Z"
			},
			children: [
			]
		}
	]
};
var customize = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M5.16,1.8H4V12.5H1.8v5.6H4v1.7H5.16V18.1H7.4V12.5H5.16ZM6.28,13.63V17H2.92V13.63H6.28ZM17.56,10.8v-9H16.44v9H14.2v5.6h2.24v3.4h1.12V16.4H19.8V10.8Zm1.11,4.47H15.33V11.92h3.34ZM11.36,1.8H10.24V3.5H8V9.1h2.24V19.8h1.12V9.1H13.6V3.5H11.36Zm1.11,2.83V8H9.13V4.63h3.34Z"
			},
			children: [
			]
		}
	]
};
var data = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.53425,9.98l-1.62719.93946-.47644-.80957L15.06721,9.165V4.255L10.815,1.8,6.56282,4.255v4.91l1.631.94165-.48053.82459L6.06569,9.98l-4.252,2.455v4.91l4.252,2.455,4.25225-2.455V15.349h.96412v1.996l4.25219,2.455,4.25214-2.455v-4.91Zm-2.02966,2.4682.76239,1.295a1.67549,1.67549,0,0,0-.29785.48309H12.4048V13.0832ZM7.6855,8.5168V4.90315L10.815,3.09639l3.12952,1.80676V8.5168l-1.08337.62549L12.08534,7.824a1.684,1.684,0,1,0-2.56525.00665l-.761,1.306Zm4.20343,1.18676-1.07392.62L9.73109,9.69777l.756-1.29749a1.58737,1.58737,0,0,0,.6341-.00085ZM9.1952,16.69685l-3.12951,1.8067-3.12934-1.8067V13.0832l3.12934-1.80682,1.08227.62488-.74957,1.28631A1.68234,1.68234,0,1,0,7.7137,15.349H9.1952Zm0-2.47052H7.67927a1.675,1.675,0,0,0-.30218-.48834l.74316-1.27539,1.07495.6206Zm2.08686,0h-.96412V12.435l-1.6325-.94251.48047-.82464L10.815,11.62l1.64344-.94886.47656.80957-1.653.95435Zm7.38159,2.47052-3.1294,1.8067-3.12945-1.8067V15.349h1.5299a1.696,1.696,0,1,0,1.30756-2.1607l-.76575-1.30121,1.05774-.61072,3.1294,1.80682Z"
			},
			children: [
			]
		}
	]
};
var deaf = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.6092072,1.8v1.8221669l-2.6653328,2.5725043c-0.3793564-0.7635145-0.9598808-1.3276649-1.6020985-1.8756776\n\tL16.8919697,1.8H18.6092072z M8.9043398,13.3246918l-4.1389756,4.2254848H2.9907935v-1.7650261l4.1092186-4.1959629\n\tC7.5785971,12.2816467,8.1928854,12.8724833,8.9043398,13.3246918z M10.1702204,19.7999992\n\tc-0.3314409,0-0.5795317-0.0284367-0.6462116-0.037262c-0.3098679-0.0392227-0.5275602-0.3216343-0.4883366-0.6315022\n\tc0.0392237-0.3088875,0.3118296-0.5295219,0.6315031-0.4883366c0.4422474,0.0549126,1.4757938,0.0558949,1.8307695-0.2990818\n\tc0.2373037-0.2373028,0.2274981-0.6991634,0.1931772-1.4316673c-0.0205927-0.4530334-0.0451078-0.9668655,0.0215731-1.5032511\n\tc0.1186514-0.9394093,0.9246998-2.1553459,1.6356306-3.228116c0.3981218-0.6011047,0.8099709-1.2228012,0.9364681-1.569931\n\tc0.4373446-1.2031898,0.1814098-2.8535299-0.6216974-4.0135727c-0.537365-0.77565-1.5650282-1.7052536-3.4036427-1.7238851\n\tc-0.0196114,0-0.0392237,0-0.058835,0c-3.7517543,0-4.4136553,3.7576375-4.4401312,3.9184546\n\tC5.7094965,9.0987749,5.4153185,9.3086214,5.1123147,9.2586117C4.8044081,9.208601,4.5955415,8.9203062,4.6445713,8.6124001\n\tC4.915215,6.921855,6.4233694,3.7437491,10.2006187,3.7437491c0.0235338,0,0.0470686,0,0.0706024,0\n\tc1.8111572,0.0186312,3.345788,0.8040872,4.3204985,2.2102594c1.0149155,1.4659886,1.3179188,3.4918962,0.754077,5.0431962\n\tc-0.1716042,0.4736271-0.5814924,1.0914021-1.0560999,1.8072357c-0.6109104,0.9217587-1.3708706,2.0680733-1.4552021,2.7456636\n\tc-0.0558939,0.4393063-0.0343208,0.8815536-0.0147085,1.3090935c0.0392237,0.8266411,0.0784473,1.6807384-0.5236378,2.2828236\n\tC11.7440739,19.695076,10.8046646,19.7999992,10.1702204,19.7999992z M12.6393566,11.1756735\n\tc0.0323591-0.0451078,0.7991838-1.1208191,0.5756083-2.3926506c-0.1392441-0.7874169-0.6187544-1.4650078-1.4267645-2.0111985\n\tC11.0586386,6.2776046,10.324173,6.1177678,9.6063786,6.296236C8.2717896,6.6286573,7.5167317,8.0269852,7.485353,8.0858202\n\tC7.3882742,8.2691917,7.4578962,8.4966898,7.6412673,8.5937681c0.1804295,0.0980597,0.4108691,0.0284376,0.5089288-0.1539526\n\tC8.1560793,8.4280481,8.7836599,7.274869,9.7917109,7.0267787c0.4971609-0.1255159,1.029624,0,1.5748339,0.3687034\n\tc0.6295414,0.4265585,1.0021677,0.9354868,1.1051302,1.5120764c0.1716042,0.9550991-0.4363642,1.8190022-0.4432287,1.8278275\n\tc-0.1206131,0.168663-0.0823698,0.4030247,0.0862923,0.5246181c0.06668,0.048049,0.1441469,0.0715837,0.2196531,0.0715837\n\tC12.4510822,11.3315878,12.5658121,11.2776546,12.6393566,11.1756735z"
			},
			children: [
			]
		}
	]
};
var decrease = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13.80049,14.43746l-2.38818,2.67627V13.21461c1.82-.14874,3.18408-1.15326,3.18408-2.85187,0-1.90906-1.36407-2.387-3.18408-2.76935V4.14161a1.85127,1.85127,0,0,1,1.79443,1.63617h1.16114c-.21045-1.51624-1.101-2.42237-2.95557-2.6067V2.17035h-1.125V3.17829C8.57319,3.319,7.41865,4.30835,7.41865,5.83491c0,1.7445,1.21606,2.26233,2.86865,2.64343v3.726a2.26331,2.26331,0,0,1-2.124-2.30005H6.95966A3.31238,3.31238,0,0,0,10.2873,13.1844v3.9333L7.87959,14.43648l-.83692.752,3.81006,4.24122,3.78761-4.24219Zm-.3789-4.03175a1.97236,1.97236,0,0,1-2.00928,1.83375V8.74116C12.71309,9.03547,13.42159,9.37538,13.42159,10.40571ZM8.55049,5.77778c0-.95307.69592-1.49811,1.73681-1.64673V7.35712C9.10664,7.05994,8.55049,6.64283,8.55049,5.77778Z"
			},
			children: [
			]
		}
	]
};
var dining = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M8.9,5.9H7.8v-4h1.1V5.9z M9.7,6.5L9.7,6.5C9.6,6.6,9.4,6.8,9.2,6.9l0,0c-0.3,0.2-0.5,0.6-0.5,1L9.1,18\n\tc0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7L8,7.9c0-0.4-0.2-0.8-0.5-1l0,0C7.3,6.8,7.1,6.6,7,6.5l0,0l0-4.7l-1.1,0l0,4.7l0,0.1\n\tC5.9,6.8,5.9,7,6,7.1c0,0.1,0.1,0.2,0.8,0.7c0,0,0,0,0,0L6.5,18c0,1,0.8,1.8,1.8,1.8l0,0c1,0,1.8-0.8,1.8-1.8c0,0,0,0,0,0L9.8,7.8v0\n\tc0,0,0,0,0,0c0.7-0.4,0.8-0.6,0.8-0.7c0.1-0.2,0.2-0.3,0.2-0.5l0-4.8l-1.1,0L9.7,6.5z M15.7,3.7c-0.2,1.2-0.4,2.4-0.4,3.6L15.7,18\n\tc0,1-0.8,1.8-1.8,1.8l0,0c-1,0-1.8-0.8-1.8-1.8l0.3-7.8c0,0,0,0,0,0c-0.7-0.4-0.8-0.6-0.8-0.7c-0.1-0.2-0.2-0.3-0.2-0.5\n\tc-0.1-0.8-0.1-1.6,0.1-2.4c0.1-1.4,0.6-2.8,1.4-4c0.4-0.7,1.3-1,2-0.7C15.5,2.2,15.8,2.9,15.7,3.7L15.7,3.7z M14.2,7.3L14.2,7.3\n\tc0-1.3,0.2-2.6,0.4-3.8c0-0.2-0.1-0.4-0.3-0.5c-0.2-0.1-0.5,0-0.7,0.3c-0.7,1.1-1.1,2.3-1.2,3.5v0c-0.1,0.7-0.1,1.4-0.1,2.1\n\tc0,0,0,0,0,0C12.6,9,12.8,9.1,13,9.3l0,0c0.3,0.2,0.5,0.6,0.5,1L13.1,18c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7L14.2,7.3z"
			},
			children: [
			]
		}
	]
};
var directory = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.067,10.739a2.25,2.25,0,1,0-2.25-2.25A2.24957,2.24957,0,0,0,11.067,10.739Zm0-3.375A1.125,1.125,0,1,1,9.942,8.489,1.12666,1.12666,0,0,1,11.067,7.364ZM6.543,13.065v2.168H15.3V13.065a6.47457,6.47457,0,0,0-8.757,0Zm7.633.528v.515H7.668v-.515a5.33233,5.33233,0,0,1,6.508,0ZM15.3,1.8H2.925v18H15.3a3.37494,3.37494,0,0,0,3.375-3.375V5.175A3.37494,3.37494,0,0,0,15.3,1.8Zm2.25,14.625a2.25207,2.25207,0,0,1-2.25,2.25H4.05V2.925H15.3a2.25207,2.25207,0,0,1,2.25,2.25Z"
			},
			children: [
			]
		}
	]
};
var display = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.9,4.2v13.3h17.9V4.2H1.9z M18.6,16.3H3v-11h15.6V16.3z M10,8.9l-1.4-1h1.7l0.5-1.6l0.5,1.6h1.7l-1.4,1l0.5,1.6l-1.4-1\n\tl-1.4,1L10,8.9z M9.4,12.3H4.2v-1h5.2V12.3z M9.4,14.3H4.2v-1h5.2V14.3z M12.2,11.3h5.3v1h-5.2L12.2,11.3z M12.2,13.3h5.3v1h-5.2\n\tL12.2,13.3z"
			},
			children: [
			]
		}
	]
};
var distribution = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,10.8l-3.4-2.2v1.7h-3.9V4.6h3.9v1.7l3.4-2.2l-3.4-2.3v1.7h-5.1v6.8H8.6V7.4H1.8v6.8h6.8v-2.8h2.8v6.7h5.1v1.7l3.4-2.2\n\tl-3.4-2.2V17h-3.9v-5.6h3.9v1.7L19.8,10.8z M7.4,13.1H2.9V8.6h4.5V13.1z"
			},
			children: [
			]
		}
	]
};
var doorbell = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.79951,19.8a3.80167,3.80167,0,0,1-3.53233-2.36143H5.83541V4.14279H7.276a3.82178,3.82178,0,0,1,7.048,0h1.44059V17.43857H14.33184A3.86037,3.86037,0,0,1,10.79951,19.8ZM6.96513,16.30885H8.089l.11964.406a2.69481,2.69481,0,0,0,5.18278,0l.11964-.406h1.12384V5.27251H13.50711l-.12062-.403a2.69431,2.69431,0,0,0-5.173,0l-.12062.403H6.96513Zm3.83438-2.93511a2.57325,2.57325,0,1,1,2.57325-2.57325A2.576,2.576,0,0,1,10.79951,13.37374Zm0-4.01678A1.44353,1.44353,0,1,0,12.243,10.80049,1.44474,1.44474,0,0,0,10.79951,9.357Z"
			},
			children: [
			]
		}
	]
};
var download = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "bb57d41c-34be-44a0-8a4e-cbb01462aa0f",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,17,4.21,10.41,5,9.62l5.23,5.22V1.8h1.12v13l5.23-5.22.8.79ZM4.05,18.68V19.8h13.5V18.68Z"
			},
			children: [
			]
		}
	]
};
var driver = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,3.2375A7.5625,7.5625,0,1,0,18.3625,10.8,7.57114,7.57114,0,0,0,10.8,3.2375Zm0,1.125a6.4451,6.4451,0,0,1,6.10645,4.413l-4.18116,1.30286a2.05268,2.05268,0,0,0-3.85058,0L4.69355,8.77546A6.4451,6.4451,0,0,1,10.8,4.3625ZM10.2375,17.209A6.38221,6.38221,0,0,1,4.437,9.87379l4.3465,1.35437a2.06111,2.06111,0,0,0,1.454,1.54663ZM9.8625,10.8a.9375.9375,0,1,1,.9375.9375A.939.939,0,0,1,9.8625,10.8Zm1.5,6.409V12.77479a2.06111,2.06111,0,0,0,1.454-1.54663L17.163,9.87379A6.38221,6.38221,0,0,1,11.3625,17.209Z"
			},
			children: [
			]
		}
	]
};
var duplicate = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "b20b59a8-fb01-48fe-a1f9-ce87257444f1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M8.55,1.8V4.05H1.8V16.43L5.18,19.8h7.87V17.55H19.8V1.8ZM5.74,18.68h-.1L2.93,16v-.1H5.74Zm6.19,0H6.86V14.74H2.93V5.18h9Zm6.75-2.25H13.05V4.05H9.68V2.93h9Z"
			},
			children: [
			]
		}
	]
};
var edit = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "b1d2b552-e272-4a9b-84a8-c892057a659b",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13.88,1.82l-9,12.89L4,19.78l4.49-2.49L17.57,4.4ZM7.75,16.43,5.51,17.68l.4-2.54,6-8.57,1.85,1.29ZM12.57,5.65l1.58-2.27L16,4.68,14.41,6.94Z"
			},
			children: [
			]
		}
	]
};
var education = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,9.62l-9-4.56-9,4.56,1.82.89v4.88H4.7V11.05l2.37,1.16A5.7,5.7,0,0,0,5.68,16v.55H15.92V16a5.7,5.7,0,0,0-1.41-3.8Zm-9-3.35L17.37,9.6l-6.61,3.22L4.22,9.6Zm4,9.16h-8a4.48,4.48,0,0,1,1.3-2.7L10.76,14l2.7-1.31A4.5,4.5,0,0,1,14.78,15.43Z"
			},
			children: [
			]
		}
	]
};
var email = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "aebb2ac1-482c-4dc0-aaf9-18be0bdb3934",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,4.05v13.5h18V4.05ZM18.34,5.18l-7.54,6-7.54-6Zm.34,11.25H2.93V6.35l7.87,6.3,7.88-6.3Z"
			},
			children: [
			]
		}
	]
};
var emoji = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,19.8a8.999,8.999,0,1,0-6.36424-2.63576A9.01095,9.01095,0,0,0,10.8,19.8Zm0-16.87353A7.87457,7.87457,0,1,1,2.92647,10.8,7.8823,7.8823,0,0,1,10.8,2.92647ZM7.09141,11.47406h7.42864C14.26172,16.16172,7.34974,16.16172,7.09141,11.47406Zm-.751-3.02637A1.05964,1.05964,0,1,1,7.39777,9.50357,1.0608,1.0608,0,0,1,6.34043,8.44769Zm6.81288,0a1.05886,1.05886,0,1,1,1.06184,1.05588A1.06082,1.06082,0,0,1,13.15331,8.44769Z"
			},
			children: [
			]
		}
	]
};
var enterprise = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M6.28,5.68H5.16V4.57H6.28ZM8.36,4.57H7.24V5.68H8.36Zm2.08,0H9.32V5.68h1.12ZM6.28,6.8H5.16V7.91H6.28Zm2.08,0H7.24V7.91H8.36Zm2.08,0H9.32V7.91h1.12ZM6.28,9H5.16v1.11H6.28ZM8.36,9H7.24v1.11H8.36Zm2.08,0H9.32v1.11h1.12ZM6.28,11.26H5.16v1.11H6.28Zm2.08,0H7.24v1.11H8.36Zm2.08,0H9.32v1.11h1.12ZM6.28,13.49H5.16V14.6H6.28Zm2.08,0H7.24V14.6H8.36Zm2.08,0H9.32V14.6h1.12ZM6.28,15.72H5.16v1.11H6.28Zm2.08,0H7.24v1.11H8.36Zm2.08,0H9.32v1.11h1.12Zm4.08-8H13.41V8.85h1.11Zm2.08,0H15.49V8.85H16.6ZM14.52,10H13.41v1.12h1.11Zm2.08,0H15.49v1.12H16.6Zm-2.08,2.23H13.41v1.12h1.11Zm2.08,0H15.49v1.12H16.6Zm-2.08,2.23H13.41v1.12h1.11Zm2.08,0H15.49v1.12H16.6Zm-2.08,2.23H13.41v1.12h1.11Zm2.08,0H15.49v1.12H16.6Zm3.19,2V19.8h-18V18.69h1.3V1.8H12.6V5.45h5.89V18.69ZM11.48,2.91H4.23V18.67h7.25Zm5.89,3.66H12.63v12.1h4.74Z"
			},
			children: [
			]
		}
	]
};
var error = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.80213,19.80122a2.39567,2.39567,0,0,1-1.705-.707L2.50743,12.50444a2.41244,2.41244,0,0,1,0-3.40913L9.09808,2.50555a2.4159,2.4159,0,0,1,3.40908-.001l6.58967,6.59073a2.41244,2.41244,0,0,1,0,3.40913L12.50716,19.0942A2.394,2.394,0,0,1,10.80213,19.80122Zm-7.4998-9.911a1.289,1.289,0,0,0,0,1.81931L9.893,18.29929a1.31476,1.31476,0,0,0,1.81928,0l6.58967-6.58976a1.289,1.289,0,0,0,0-1.81931L11.71226,3.30047a1.29076,1.29076,0,0,0-1.81928,0ZM9.95,15.05h1.7V13.367H9.95Zm0-6.00953.561,2.635h.56952l.56951-2.635V6.55H9.95Z"
			},
			children: [
			]
		}
	]
};
var ethernet = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 38 38"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m3,5v28h32V5H3Zm30,26H5V7h28v24Zm-20-3h12v-5h5v-13H8v13h5v5Zm-3-7v-9h3v5h2v-5h3v5h2v-5h3v5h2v-5h3v9h-5v5h-8v-5h-5Z"
			},
			children: [
			]
		}
	]
};
var euro = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,3c4.3,0,7.8,3.5,7.8,7.8s-3.5,7.8-7.8,7.8S3,15.1,3,10.8C3,6.5,6.5,3,10.8,3 M10.8,1.9c-4.9,0-8.9,4-8.9,8.9\n\ts4,8.9,8.9,8.9s8.9-4,8.9-8.9S15.7,1.9,10.8,1.9C10.8,1.9,10.8,1.9,10.8,1.9z M8.1,13.8c-0.4-0.4-0.7-0.8-0.9-1.3H11l1-1.1H7\n\tc0-0.4,0-0.7,0-1.1h4l1-1.1H7.3C8.2,7,10.6,6.1,12.7,7c0.5,0.2,0.9,0.5,1.3,0.9l0.8-0.8C12.8,5,9.4,5,7.3,7.1\n\tc-0.6,0.6-1,1.3-1.3,2.1H4.8v1.1h1.1c0,0.4,0,0.7,0,1.1H4.8v1.1h1.3c0.9,2.8,3.9,4.3,6.7,3.3c0.8-0.3,1.5-0.7,2.1-1.3L14,13.8\n\tC12.4,15.4,9.8,15.4,8.1,13.8z"
			},
			children: [
			]
		}
	]
};
var expense = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.17463,1.8H4.05v18h13.5V5.175ZM16.425,18.675H5.175V2.925h7.31244V6.8625H16.425Zm0-12.9375H13.61244V2.925h.09625L16.425,5.64106ZM6.3,6.3H9.675V7.425H6.3Zm0,2.25H9.675V9.675H6.3Zm0,2.25H9.675v1.125H6.3Zm0,2.25H9.675v1.125H6.3Zm4.51367-1.12061c0,1.18213.85645,1.49854,2.00195,1.75V16.09A1.49342,1.49342,0,0,1,11.29805,14.573H10.5168a2.17586,2.17586,0,0,0,2.29882,2.1499v.791h.52051v-.78174c1.21973-.07422,2.1416-.73535,2.1416-1.86133,0-1.26611-.92187-1.564-2.1416-1.81543V10.81221a1.22379,1.22379,0,0,1,1.23828,1.08008h.75391a1.88,1.88,0,0,0-1.99219-1.70362V9.677h-.52051v.51172C11.62422,10.23506,10.81367,10.89619,10.81367,11.92939ZM13.33613,13.8c.89356.1958,1.37793.40967,1.37793,1.09863a1.30367,1.30367,0,0,1-1.37793,1.20069Zm-.52051-2.99707v2.15039c-.86621-.1958-1.2666-.46533-1.2666-1.061C11.549,11.23115,12.06172,10.86836,12.81562,10.80293Z"
			},
			children: [
			]
		}
	]
};
var facebook = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,2.8v16a1.00209,1.00209,0,0,1-1,1H14.3v-7h2.3L17,10H14.3V8.3c0-.8.2-1.3,1.3-1.3H17V4.6c-.3,0-1.1-.1-2.1-.1a3.28453,3.28453,0,0,0-3.5,3.6v2H9.1v2.7h2.3v7H2.8a1.00209,1.00209,0,0,1-1-1V2.8a.94477.94477,0,0,1,1-1h16A.94477.94477,0,0,1,19.8,2.8Z"
			},
			children: [
			]
		}
	]
};
var favorite = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,5.70011,12,9.6h4.3L12.8,12.4l1.6,4.3999-3.6-2.79993L7.3,16.69987,8.6,12.3,5.2,9.6H9.5l1.3-3.89992m0-3.79991L8.6,8.50005H1.8L7.3,12.8,5.2,19.6998l5.6-4.2999,5.6,4.2999L14.2,12.8l5.6-4.2999H12.9Z"
			},
			children: [
			]
		}
	]
};
var fax = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.5499992,7.4250002v-2.25L14.1750002,1.8h-10.125v5.625H1.8v12.374999h18V7.4250002H17.5499992z M16.4249992,5.6409998\n\tv0.0090003h-2.7249994V2.925h0.0089998L16.4249992,5.6409998z M5.1750002,2.925h7.4000006v3.8499997h3.8500004v2.8999996H5.1750002\n\tV2.925z M18.6749992,18.6749992H2.925V8.5500002h1.1250002v2.25h13.499999v-2.25h1.125V18.6749992z M4.612,11.9259996\n\tc0.3103838,0,0.5620003,0.2516155,0.5620003,0.5620003c0,0.3103838-0.251616,0.5619993-0.5619998,0.5619993\n\tc-0.3103843,0-0.5620003-0.2516155-0.5620003-0.5619993S4.3016157,11.9259996,4.612,11.9259996L4.612,11.9259996z M4.612,14.1759996\n\tc0.3103838,0,0.5620003,0.2516155,0.5620003,0.5620003c0,0.3103838-0.251616,0.5619993-0.5619998,0.5619993\n\tc-0.3103843,0-0.5620003-0.2516155-0.5620003-0.5619993S4.3016157,14.1759996,4.612,14.1759996L4.612,14.1759996z M4.612,16.4259987\n\tc0.3103838,0,0.5620003,0.2516155,0.5620003,0.5620003c0,0.3103828-0.251616,0.5620003-0.5619998,0.5620003\n\tc-0.3103843,0-0.5620003-0.2516155-0.5620003-0.5620003C4.0500011,16.6776161,4.3016167,16.4260006,4.612,16.4259987z\n\t M6.862,11.9259987c0.3103838,0,0.5620003,0.2516155,0.5620003,0.5620003c0,0.3103838-0.251616,0.5619993-0.5619998,0.5619993\n\tc-0.3103843,0-0.5620003-0.2516155-0.5620003-0.5619993C6.3000007,12.1776152,6.5516162,11.9259996,6.862,11.9259987z\n\t M6.862,14.1759987c0.3103838,0,0.5620003,0.2516155,0.5620003,0.5620003c0,0.3103838-0.251616,0.5619993-0.5619998,0.5619993\n\tc-0.3103843,0-0.5620003-0.2516155-0.5620003-0.5619993C6.3000007,14.4276152,6.5516162,14.1759996,6.862,14.1759987z\n\t M6.862,16.4259987c0.3103838,0,0.5620003,0.2516155,0.5620003,0.5620003c0,0.3103828-0.251616,0.5620003-0.5619998,0.5620003\n\tc-0.3103843,0-0.5620003-0.2516155-0.5620003-0.5620003C6.3000011,16.6776161,6.5516167,16.4260006,6.862,16.4259987z\n\t M9.1119995,11.9259987c0.3103838,0,0.5620003,0.2516165,0.5619993,0.5620003c0,0.3103838-0.2516155,0.5620003-0.5620003,0.5619993\n\tc-0.3103838,0-0.5619993-0.2516155-0.5619993-0.5619993s0.2516165-0.5619993,0.5620003-0.5619993\n\tC9.1120005,11.9259996,9.1120005,11.9259996,9.1119995,11.9259987z M9.1119995,14.1759987\n\tc0.3103838,0,0.5620003,0.2516165,0.5619993,0.5620003c0,0.3103838-0.2516155,0.5620003-0.5620003,0.5619993\n\tc-0.3103838,0-0.5619993-0.2516155-0.5619993-0.5619993s0.2516165-0.5619993,0.5620003-0.5619993\n\tC9.1120005,14.1759996,9.1120005,14.1759996,9.1119995,14.1759987z M9.1119995,16.4259987\n\tc0.3103838,0,0.5620003,0.2516155,0.5619993,0.5620003c0,0.3103848-0.2516155,0.5620003-0.5620003,0.5620003\n\tc-0.3103838,0-0.5619993-0.2516155-0.5619993-0.5620003C8.5500002,16.6776142,8.8016167,16.4260006,9.1119995,16.4259987z\n\t M10.8000002,15.3000002h6.749999v-3.375h-6.749999V15.3000002z M11.9250002,13.0500002h4.499999v1.125h-4.5L11.9250002,13.0500002z\n\t"
			},
			children: [
			]
		}
	]
};
var feedback = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_4",
		"data-name": "Layer 4",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.41,10.18,17.51,9v6.76H6L1.8,19.68V1.92H17.42L16.31,3H2.9V17.15L5.24,15a1.09,1.09,0,0,1,.75-.3H16.41ZM12.67,8.34l5-5.15,2.11,2-5.65,5.91-2.67.6.44-2.39H5.18v-1Zm3.91-2.68.78.75,1.13-1.18-.78-.74ZM12.82,9.51l-.18,1,1-.23,3-3.19-.79-.76Zm1.06-4.1H5.18v1h8.7Zm-8.7,6.84H10v-1H5.18Z"
			},
			children: [
			]
		}
	]
};
var filter = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "bd6ee55b-5aef-4a1b-b60f-8d067ac29f27",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.81,2.93l-5.88,9.81v5.94H9.68V12.74L3.79,2.93h14m2-1.13H1.8L8.55,13.05V19.8h4.5V13.05L19.8,1.8Z"
			},
			children: [
			]
		}
	]
};
var financial = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18,7.83H19.8l-9-5.08-9,5.08H3.61v9.91H1.8v1.11h18V17.74H18ZM10.8,4l4.75,2.68H6.05Zm-4,13.71H4.72V10.48H6.83Zm3.41,0H8V10.48h2.29Zm3.41,0H11.36V10.48h2.29Zm3.23,0H14.77V10.48h2.11Zm0-8.37H4.72V7.83H16.88Z"
			},
			children: [
			]
		}
	]
};
var fire = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.772,3.97881a3.73233,3.73233,0,0,1,.10565,3.04994,8.29261,8.29261,0,0,0-.22676.94728H10.651s-.04453.36552-.04606.52168A2.5941,2.5941,0,0,0,13.09685,11.258a2.38243,2.38243,0,0,0,1.54459-.59563c.38.69578.58183,1.09445.68853,1.32271A4.909,4.909,0,0,1,13.624,17.935c-.15486-1.817-1.33154-3.187-2.80564-3.187-1.47445,0-2.65148,1.37035-2.80582,3.18784a4.87946,4.87946,0,0,1-2.099-4.0239,5.706,5.706,0,0,1,.47443-2.03212c.79154-1.65572,3.07142-5.63546,4.384-7.901m-.00156-2.21539S6.546,8.96168,5.3811,11.39844a6.74554,6.74554,0,0,0-.58359,2.51346A6.01716,6.01716,0,0,0,9.42,19.76344,3.285,3.285,0,0,1,9.11136,18.344c0-1.36974.76429-2.48006,1.707-2.48006.94254,0,1.70684,1.11032,1.70684,2.48006a3.286,3.286,0,0,1-.30832,1.419,6.01855,6.01855,0,0,0,4.13156-8.23438c-.3194-.68779-1.09512-2.08468-1.96963-3.61173a1.89033,1.89033,0,0,1,.09387.58078,1.512,1.512,0,0,1-1.37584,1.6443A1.477,1.477,0,0,1,11.721,8.49771c.00144-.10373.03233-.34823.03233-.34823.18861-1.19878,1.1693-2.73528-.19547-5.06188C11.08187,2.28428,10.77038,1.76344,10.77038,1.76344Z"
			},
			children: [
			]
		}
	]
};
var flag = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.6,4.4c-3.3,0-6.5-2.1-9.8-2.1c-0.7,0-1.5,0.1-2.2,0.4V1.8H2.4v18h1.2v-5.1c0.7-0.2,1.4-0.4,2.2-0.4\n\tc3.3,0,6.5,2.1,9.8,2.1c1.3,0,2.5-0.4,3.6-1V3.3C18.1,4,16.8,4.4,15.6,4.4z M17.9,14.7c-0.7,0.4-1.5,0.5-2.3,0.5\n\tc-1.5-0.1-3.1-0.4-4.5-1c-1.7-0.6-3.5-1-5.3-1.1c-0.7,0-1.5,0.1-2.2,0.3V4c0.7-0.3,1.4-0.5,2.2-0.5c1.5,0.1,3.1,0.4,4.5,1\n\tc1.7,0.6,3.5,1,5.3,1.1c0.8,0,1.6-0.1,2.3-0.3V14.7z"
			},
			children: [
			]
		}
	]
};
var fleet = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.06318,3.15242H4.6422901v3.92558H1.8v9.4737501h0.94629c0.0001771,1.0471325,0.849189,1.8958569,1.8963211,1.8956795\n\tc1.0468812-0.0001774,1.8955016-0.8487988,1.895679-1.8956795h5.6831102\n\tc-0.0004854,0.2534428,0.0501652,0.5043774,0.1489201,0.7377892c0.0273237,0.0573769,0.0576391,0.1132793,0.0908203,0.1674805\n\tc0.0283203,0.0513992,0.0512695,0.1060791,0.0839996,0.1544209c0.585166,0.8682022,1.7633553,1.0976486,2.6315584,0.5124836\n\tc0.5228386-0.3523922,0.8362637-0.9416656,0.8362122-1.5721741h0.9453106v-2.0298204l0.0009995,0.0001202\n\tc1.0470753-0.0001383,1.8958626-0.8489256,1.8959999-1.8959999h0.9447784V8.8366203L15.06318,3.15242z M5.5446301,16.5517101\n\tc-0.000102,0.4984531-0.4042616,0.9024467-0.9027152,0.9023457c-0.4984531-0.000103-0.902447-0.4042625-0.9023447-0.9027157\n\tc0.000102-0.4984531,0.4042616-0.9024467,0.9027147-0.9023447c0.4983091,0.000102,0.9022431,0.4040365,0.9023452,0.9023447\n\tV16.5517101z M14.11689,17.4544201c-0.4985533-0.0000725-0.9026518-0.4042873-0.9025803-0.9028397\n\ts0.4042864-0.9026518,0.9028397-0.9025803c0.4985018,0.0000715,0.9025803,0.4042072,0.9025803,0.90271\n\tc-0.0000114,0.4985638-0.4041862,0.9027214-0.90275,0.90271C14.11695,17.4544201,14.1169195,17.4544201,14.11689,17.4544201z\n\t M15.9649801,15.5584202h-0.2397499c-0.1601753-0.2580814-0.3800592-0.4738636-0.6411104-0.6291504\n\tc-0.0131798-0.0079298-0.0268602-0.0141602-0.0405302-0.0220003c-0.1175966-0.0662832-0.2420168-0.1196537-0.3710899-0.1591797\n\tc-0.0292997-0.0092201-0.0581102-0.0195303-0.0878897-0.0273399c-0.3050175-0.0863752-0.6280031-0.086545-0.9331102-0.0004902\n\tc-0.0336905,0.0085402-0.0649405,0.0200005-0.0976496,0.0302696c-0.1234303,0.0383787-0.2425556,0.0894346-0.3554697,0.1523504\n\tc-0.0180702,0.0104904-0.0375996,0.0190001-0.0556698,0.0302696c-0.2579384,0.1550989-0.4752026,0.3694324-0.63379,0.6252403\n\tH6.25068C6.0911188,15.3015089,5.8724842,15.0864744,5.6129899,14.9312C5.5973601,14.92167,5.58076,14.9141102,5.5646501,14.9049501\n\tc-0.115068-0.0645685-0.2366834-0.1167021-0.3627901-0.1555204c-0.03125-0.0098801-0.0609999-0.0206299-0.0932698-0.0288696\n\tc-0.3048759-0.0863333-0.6277342-0.0863333-0.93261,0C4.1442399,14.7286797,4.1139803,14.7395601,4.0832,14.7493105\n\tc-0.1264513,0.0389376-0.2483957,0.0912333-0.36377,0.1560001c-0.0161099,0.0089102-0.0322199,0.0162296-0.0473599,0.02563\n\tc-0.2597711,0.1551933-0.4786,0.3703394-0.63818,0.6274395H2.7936499V8.0712404h8.9624004l4.2089996,5.0506601\n\tL15.9649801,15.5584202z M16.95998,13.52876h-0.0009098l-0.0009995-0.0002403v-0.7662401l-0.633791-0.7607403\n\tc0.1642418-0.1761885,0.3939037-0.2767992,0.6347694-0.27808c0.4985199-0.0002508,0.902853,0.4036751,0.9031048,0.902195\n\ts-0.4036751,0.902854-0.902195,0.9031048L16.95998,13.52876z M18.8067207,11.6328897h-0.2392502\n\tc-0.3429165-0.5598602-0.9518681-0.9015875-1.6084003-0.9025898c-0.472435,0.0028906-0.9260349,0.1856089-1.2685604,0.5109997\n\tl-3.46912-4.1632996H5.6354499V4.1455798h8.9628887l4.2084999,5.0505395L18.8067207,11.6328897z M10.2589998,9.7884102\n\tl0.6389999,0.6380005l-3.3169999,3.3169994l-1.7750001-1.7749996L6.4449997,11.33041l1.1360002,1.1359997L10.2589998,9.7884102z"
			},
			children: [
			]
		}
	]
};
var flexibility = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17,12.14,19.8,15,17,17.81,16.18,17l1.49-1.49H14.45L6.16,6.82H1.8V5.7H6.64l8.29,8.71h2.73l-1.48-1.49Zm-2-4.95h2.73L16.18,8.67l.79.79L19.8,6.62,17,3.79l-.79.79,1.49,1.49H14.45L11.33,9.35l.81.77ZM6.16,14.78H1.8v1.11H6.64l3.47-3.64-.81-.77Z"
			},
			children: [
			]
		}
	]
};
var flurry = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13.05893,15.86243h-9V2.925h9V7.24311l1.125-1.125V1.8h-11.25v18h11.25V10.89112l-1.125,1.125Zm0,2.81257h-9V16.98743h3.375v1.125h2.25v-1.125h3.375Zm-1.43509-8.58691,6.15454-6.05622.88769.902-7.06421,6.9516L8.46362,8.64229,5.472,11.93928l-.93713-.85034L8.434,6.79164Z"
			},
			children: [
			]
		}
	]
};
var folder = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 38 38"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m12.75342,7l2.95752,3.41187.59814.69h16.69092v19.89813H5V7h7.75342m.91309-2H3v28h32V9.10187h-17.77783l-3.55566-4.10187h0Z"
			},
			children: [
			]
		}
	]
};
var fridge = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.33574,1.8H6.26426a1.29734,1.29734,0,0,0-1.2961,1.29609v13.8961a1.29734,1.29734,0,0,0,1.2961,1.29609h1.1039V19.8h1.2V18.28828h4.46368V19.8h1.2V18.28828h1.1039a1.29734,1.29734,0,0,0,1.2961-1.29609V3.09609A1.29734,1.29734,0,0,0,15.33574,1.8ZM6.26426,3h9.07148a.09653.09653,0,0,1,.0961.09609V7.35586H6.16816V3.09609A.09653.09653,0,0,1,6.26426,3Zm9.07148,14.08828H6.26426a.09653.09653,0,0,1-.0961-.09609V8.55586h9.26368v8.43633A.09653.09653,0,0,1,15.33574,17.08828ZM8.29219,6.26426h-1.2V4.70391h1.2Zm-1.2,3.2039h1.2v1.55977h-1.2Z"
			},
			children: [
			]
		}
	]
};
var fullscreen = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "efb07708-4353-45ee-a511-1c5ba1bb8742",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,1.8V8.5H18.7V3.7l-15,15h5v1.1H1.8V12.9H2.9v5l15-15H13.8V1.8Z"
			},
			children: [
			]
		}
	]
};
var gaming = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M7.39708,9.352h1.126v1.126h-1.126v1.125h-1.125V10.478h-1.125V9.352h1.125V8.227h1.125Zm7.316,0a.563.563,0,1,0-.563-.563A.563.563,0,0,0,14.71306,9.352Zm-1.126,0a.563.563,0,1,0,.563.563A.563.563,0,0,0,13.58708,9.352Zm2.251,0a.563.563,0,1,0,.563.563A.563.563,0,0,0,15.83806,9.352Zm-1.125,1.125a.563.563,0,1,0,.563.563A.563.563,0,0,0,14.71306,10.477Zm4.508,4.595a3.32813,3.32813,0,0,1-1.936,1.798,1.104,1.104,0,0,1-.346.055c-1.246,0-2.709-1.923-3.115-2.668a1.09356,1.09356,0,0,0-.965-.568H8.704a1.09163,1.09163,0,0,0-.965.568c-.406.74506-1.87,2.668-3.115,2.668a1.10823,1.10823,0,0,1-.346-.055,3.33158,3.33158,0,0,1-1.936-1.798,7.74186,7.74186,0,0,1-.008-5.777A7.382,7.382,0,0,1,5.89708,5.038a3.46364,3.46364,0,0,1,2.73-.149,3.21223,3.21223,0,0,1,1.228.866.69066.69066,0,0,0,.52.204h.812a.69371.69371,0,0,0,.52-.203,3.20761,3.20761,0,0,1,1.228-.867,3.464,3.464,0,0,1,2.73.149,7.38918,7.38918,0,0,1,3.563,4.257A7.742,7.742,0,0,1,19.22106,15.072Zm-1.05-5.39294a6.26262,6.26262,0,0,0-2.971-3.617,2.37172,2.37172,0,0,0-1.858-.124,2.09417,2.09417,0,0,0-.798.569,1.81023,1.81023,0,0,1-1.357.578h-.812a1.8119,1.8119,0,0,1-1.357-.578,2.09413,2.09413,0,0,0-.798-.569,2.37052,2.37052,0,0,0-1.859.125A6.27265,6.27265,0,0,0,3.389,9.679a6.61118,6.61118,0,0,0-.038,4.9,2.41691,2.41691,0,0,0,1.272,1.22c.387.147,1.575-1.069,2.126-2.08a2.2173,2.2173,0,0,1,1.954-1.156h4.155a2.21737,2.21737,0,0,1,1.954,1.156c.551,1.011,1.74,2.226,2.126,2.08a2.41352,2.41352,0,0,0,1.272-1.22A6.60687,6.60687,0,0,0,18.17107,9.679Z"
			},
			children: [
			]
		}
	]
};
var gas = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.7630901,13.80653h0.0007305l-0.0087795-0.2597599L16.7381916,13.34797\n\tc-0.0078678-0.0624857-0.0125732-0.125329-0.0140991-0.1882896c0.0030003,0.0266104,0.0024395,0.0542002,0.0051308,0.0810003\n\tl-0.0069008-0.0810003h0.00177l-0.0042095-0.0281401l-0.0024395-0.0279999h-0.00177\n\tc-0.0670452-0.5612888-0.2142792-1.110054-0.4372005-1.6295204c-0.9069996-1.9530001-5.526-9.6739998-5.526-9.6739998\n\ts-4.1849999,7.1310005-5.3390002,9.5450001c-0.3067093,0.688159-0.4964476,1.4226704-0.5613999,2.1732798l0.0040002-0.0408297\n\tl-0.00421,0.0422401c-0.00177,0.0202599-0.00458,0.04284-0.006,0.0624304v0.0000696\n\tc-0.0065298,0.0921602-0.0103798,0.1778498-0.0103798,0.2528c-0.0006919,0.6029024,0.0901046,1.2024202,0.26929,1.77808\n\tc0.2711091,1.0473442,0.8729239,1.9792557,1.7160001,2.6572304c0.963407,0.868103,2.1847773,1.3965359,3.4771099,1.5043907\n\tl0.0891171,0.0252876l-0.0092697-0.0212994l-0.4563599-1.0573101c-0.0190001-0.0440006-0.0332098-0.0921707-0.0502996-0.1378803\n\tc-0.1504993-0.4127693-0.2262669-0.8490467-0.2237501-1.2883892c0.0078363-0.3455734,0.0554838-0.6890907,0.1420002-1.0237503\n\tc0.2847052-0.8466377,0.6206589-1.675168,1.0059996-2.4809999c0.3979521,0.8225002,0.7501125,1.666379,1.0548697,2.52777\n\tc0.0806398,0.3193645,0.1207285,0.6476154,0.1193199,0.9769993c0.0024824,0.4383259-0.0729713,0.8736038-0.2228403,1.2855206\n\tc-0.0175695,0.04669-0.0319996,0.0958195-0.0513296,0.1407509l-0.4561701,1.0563908l-0.0094604,0.0221977l0.0930004-0.0264301\n\tc3.0786972-0.2703972,5.4406948-2.8480206,5.4417896-5.9385691L16.7630901,13.80653z M4.84586,13.5820999\n\tc0-0.0060997,0.0036001-0.0379,0.0061002-0.0624304h0.0042701C4.8507376,13.5400896,4.8472643,13.5610008,4.84586,13.5820999z\n\t M15.5790691,14.5568399c-0.2247944,1.5287104-1.1994219,2.8436213-2.5966797,3.5032892\n\tc0.0374107-0.2532787,0.056098-0.5089722,0.0559101-0.7649994c0.0013323-0.4308949-0.0521774-0.8602066-0.1592398-1.2775898\n\tc-0.4691372-1.2752247-1.0055571-2.5246782-1.6070004-3.7431002L10.7974596,11.29144l-0.4784603,0.9812002\n\tc-0.591795,1.1938515-1.1106701,2.4224825-1.5537701,3.6791306c-0.1162825,0.4385815-0.178894,0.889658-0.1864595,1.3433304\n\tC8.578455,17.5587139,8.5982456,17.8219681,8.63797,18.082571c-0.2798395-0.1206474-0.5489321-0.2648315-0.8043799-0.4309998\n\tC6.6523738,16.7375889,5.9604692,15.3285303,5.9594998,13.835c0.0320268-0.6913452,0.1906824-1.3709393,0.46808-2.0050001\n\tc0.7817998-1.6360502,3.0328999-5.5650001,4.3338604-7.8109999c1.3990002,2.3640003,3.8730001,6.5869999,4.4830999,7.901\n\tC15.6059866,12.7488508,15.7220879,13.6639891,15.5790691,14.5568399z"
			},
			children: [
			]
		}
	]
};
var gateway = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.6,10.22v1.2H14.2l1.4,1.4-.8.8L12,10.82,14.8,8l.8.8-1.4,1.4ZM6.8,8l-.8.8,1.4,1.4H4v1.2H7.4L6,12.82l.8.8,2.8-2.8Zm4.6,7.5v-3.2H10.2v3.2L8.8,14l-.8.8,2.8,2.8,2.8-2.8-.8-.8Zm-1.2-9.4v3.2h1.2V6.12l1.4,1.5.8-.8L10.8,4,8,6.82l.8.8Zm7,11a9,9,0,1,1,0-12.7A9,9,0,0,1,17.2,17.12Zm-.8-11.8A7.85,7.85,0,0,0,5.3,16.42a7.79,7.79,0,0,0,11.1,0A7.88,7.88,0,0,0,16.4,5.32Z"
			},
			children: [
			]
		}
	]
};
var geofence = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_3",
		"data-name": "Layer 3",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M7.9779,4.41555a1.00517,1.00517,0,0,1-.24646.06457.76834.76834,0,0,1-.36468-1.47007.783.783,0,0,1,1.00839.39777A.77315.77315,0,0,1,7.9779,4.41555ZM7.18675,17.29682A.76789.76789,0,0,0,6.4108,18.622a.76784.76784,0,0,0,.77595-1.32522Zm2.10784.84233a.76122.76122,0,0,0-.3352,1.485.58448.58448,0,0,0,.232.02436.765.765,0,0,0,.10316-1.50937Zm6.36973-1.63024a.76426.76426,0,0,0-.06348,1.07819.78083.78083,0,0,0,.63531.25363.72782.72782,0,0,0,.44392-.19023.764.764,0,0,0-1.01575-1.14159Zm2.49184-2.0169a.7629.7629,0,0,0-.77641,1.3134.74284.74284,0,0,0,.457.105.7607.7607,0,0,0,.31943-1.41843ZM13.751,17.72109a.76171.76171,0,0,0,.37372,1.45753A.65327.65327,0,0,0,14.36,19.115a.7606.7606,0,1,0-.60906-1.39393ZM3.58415,7.65439A.719.719,0,0,0,4.031,7.7591.73457.73457,0,0,0,4.62336,7.381a.76016.76016,0,1,0-1.03921.27341Zm6.21053.93747a4.66027,4.66027,0,0,1-.477-2.06466,4.76223,4.76223,0,0,1,9.52421,0A4.65327,4.65327,0,0,1,18.3394,8.643c-.39706.78558-4.2595,6.34329-4.2595,6.34329S10.37136,9.76966,9.79468,8.59186Zm.75094-2.06466a3.44,3.44,0,0,0,.35226,1.52534,56.925,56.925,0,0,0,3.17633,4.80819,50.483,50.483,0,0,0,3.16942-4.772,3.43662,3.43662,0,0,0,.37043-1.56154,3.53439,3.53439,0,0,0-7.06844,0Zm1.12957.10239a2.40465,2.40465,0,1,1,2.40465,2.40458A2.40731,2.40731,0,0,1,11.67519,6.62959Zm1.09144,0a1.31318,1.31318,0,1,0,1.31321-1.31321A1.31479,1.31479,0,0,0,12.76663,6.62959ZM2.88925,10.07881a.83257.83257,0,0,0,.23107.01318.76534.76534,0,1,0-.81169-.92868A.76481.76481,0,0,0,2.88925,10.07881ZM4.23348,13.953a.76449.76449,0,1,0-.64461,1.06171.67071.67071,0,0,0,.24645-.06451A.76638.76638,0,0,0,4.23348,13.953Zm.13257,1.83934a.76526.76526,0,0,0-.06289,1.07916.72237.72237,0,0,0,.63466.2526.80056.80056,0,0,0,.44488-.17956.77692.77692,0,0,0,.06289-1.07819A.7667.7667,0,0,0,4.36605,15.79235ZM5.55483,4.2986a.76134.76134,0,1,0,.76135.76134A.76134.76134,0,0,0,5.55483,4.2986ZM2.89964,11.06921a.76135.76135,0,1,0,.76134.76134A.76135.76135,0,0,0,2.89964,11.06921Zm8.73289,7.2081a.76135.76135,0,1,0,.76134.76135A.76135.76135,0,0,0,11.63253,18.27731Zm7.06783-6.215a.76135.76135,0,1,0,.76135.76135A.76134.76134,0,0,0,18.70036,12.06234Z"
			},
			children: [
			]
		}
	]
};
var gift = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.2,7.3c1.3-0.7,1.7-2.8,0.8-4.1c-0.9-1.3-2.7-1.7-4.1-0.9c-0.8,0.5-2.2,2.8-3.1,4.3C9.9,5.1,8.5,2.8,7.7,2.3\n\tC6.3,1.4,4.4,1.8,3.6,3.2c0,0,0,0,0,0c-1.3,2.4,0.3,4.5,3,4.8l-2.9,0v11.9h14.2V7.9h-2.9C15.8,7.8,16.5,7.6,17.2,7.3z M5.1,6.3\n\tC4.3,5.7,4,4.6,4.6,3.8C5.1,3,6.2,2.8,7,3.3c0.9,0.7,2,2.5,2.8,3.9C8.2,7.1,6.2,7,5.1,6.3z M10.2,18.6H4.9V9.1h5.3V18.6z M14.6,3.3\n\tC15.4,2.8,16.5,3,17,3.8c0.5,0.8,0.3,2-0.5,2.4c-1.1,0.7-3.1,0.8-4.7,0.9C12.5,5.8,14.1,3.6,14.6,3.3L14.6,3.3z M16.7,9.1v9.5h-5.3\n\tV9.1L16.7,9.1z"
			},
			children: [
			]
		}
	]
};
var government = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.21,11.14V8h0a4.29,4.29,0,0,0-3.82-4.19v-2H10.27v2A4.3,4.3,0,0,0,6.39,8v3.17H1.8V19.8h18V11.14ZM14.09,8v3.17H12.65V8ZM11.54,8v3.17H10.12V8ZM10.8,4.85a3.29,3.29,0,0,1,3.07,2H7.73a3.29,3.29,0,0,1,3.07-2ZM7.51,8H9v3.17H7.51Zm1.63,8.46,1.74-1.75,1.7,1.75,0,2.24H9.14Zm9.54,2.24h-5.1V16.91h1.09l-3.79-3.83L7.09,16.91H8v1.76H2.92v-6.4H18.68Z"
			},
			children: [
			]
		}
	]
};
var growth = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M8.37,19.8H13.3V9.71H8.37Zm1.14-9h2.65v7.83H9.51Zm5.35-4.71V19.8H19.8V6.13Zm3.8,12.54H16V7.25h2.66ZM1.87,19.8H6.81V12.25H1.87ZM3,13.37H5.67v5.3H3ZM10.14,1.8l4,.77-.77,4-1.12-.21.41-2.14L2.4,10.54l-.6-1L12,3.3,9.92,2.91Z"
			},
			children: [
			]
		}
	]
};
var hackers = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.8,12.18V3.3H3.8v8.88l-2,6.12h18ZM4.92,4.42H16.68v7.76H4.92ZM4.61,13.3H17l1.25,3.88H3.36Zm8.89,2,.3,1h-6l.44-1Zm0-6.89-1.74,1,1.38.76-.45.8-1.88-1-1.88,1-.45-.8,1.38-.76-1.74-1,.44-.81L10.8,8.85,13.05,7.6ZM9.74,6.94A1.06,1.06,0,1,1,10.8,8h0A1.06,1.06,0,0,1,9.74,6.94Z"
			},
			children: [
			]
		}
	]
};
var headphones = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		"enable-background": "new 0 0 21.6 21.6",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.41011,14.595c1.37518-4.77636-1.38202-9.76316-6.15838-11.13834S3.48857,4.83869,2.1134,9.61504\n\tc-0.46832,1.6266-0.46842,3.3523-0.00029,4.97896l-0.009,0.005l0.019,0.032c0.41781,1.44478,1.19143,2.76165,2.25,3.83l0.008-0.005\n\tl0.011,0.018l3.148-1.844l-2.288-3.875l-2.13,1.243C2.08565,9.77633,4.66778,5.51379,8.88944,4.47733\n\ts8.48421,1.54567,9.52067,5.76733c0.15108,0.61536,0.22729,1.2467,0.227,1.88033c-0.00218,0.63194-0.08143,1.26125-0.236,1.874\n\tl-2.118-1.244l-2.288,3.875l3.134,1.844l0.003-0.004l0.007,0.004c1.06632-1.07299,1.84497-2.39746,2.264-3.851l0.014-0.024\n\tL19.41011,14.595z M4.85511,14.296l1.144,1.938l-1.41,0.81l-1.144-1.938L4.85511,14.296z M16.68111,14.296l1.388,0.817l-1.144,1.938\n\tl-1.388-0.817L16.68111,14.296z"
			},
			children: [
			]
		}
	]
};
var history = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "e272655c-f20a-4f07-9c27-b0503d8fb61a",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.59,6.58v5.17l3.33-2.33.64.88L9.47,14V6.58Zm4.68,8.83h1.9a7.85,7.85,0,0,1-11,1.74,7.7,7.7,0,0,1-1.88-1.94,7.84,7.84,0,1,1,14.32-4.63l1.14,0A9,9,0,1,0,18.14,16v2.27h1.14v-4h-4Z"
			},
			children: [
			]
		}
	]
};
var home = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,11.86239l-9-9.00031-9,9.00031H3.37642l.79809-.798V18.7379H17.426V11.06477l.7976.79762Zm-3.49,5.75969H5.29023V9.94863L10.8,4.43908,16.31,9.9489Z"
			},
			children: [
			]
		}
	]
};
var humidity = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13.01236,10.44071l.663.663L8.5914,16.1876l-.663-.6629ZM9.10562,12.469a.8472.8472,0,1,0-.84717-.84723A.84726.84726,0,0,0,9.10562,12.469Zm3.38879,1.69433a.8472.8472,0,1,0,.84717.84723A.84725.84725,0,0,0,12.49441,14.16337Zm4.28113-.33887a5.97553,5.97553,0,1,1-11.951,0,6.61655,6.61655,0,0,1,.58173-2.502C6.45108,9.13108,10.75485,1.8,10.75485,1.8s4.6991,7.85632,5.5293,9.64105l.00567.01129A5.98248,5.98248,0,0,1,16.77554,13.8245Zm-1.09,0a4.89627,4.89627,0,0,0-.39538-1.926c-.64386-1.38934-3.4057-6.07153-4.524-7.95227C9.7156,5.748,7.2023,10.0969,6.39462,11.79124a5.46473,5.46473,0,0,0-.47443,2.02765,4.88266,4.88266,0,0,0,9.76532.00561Z"
			},
			children: [
			]
		}
	]
};
var inclusivity = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,10.8a8.55518,8.55518,0,0,0-3.03-6.53632,1.24506,1.24506,0,0,0,.03583-.17755A1.32527,1.32527,0,0,0,15.4806,2.76091a1.28912,1.28912,0,0,0-.71057.23541A8.55639,8.55639,0,0,0,2.74147,9.56389a1.29747,1.29747,0,0,0,.00366,2.49639,8.5637,8.5637,0,0,0,13.81708,5.44623,1.28771,1.28771,0,0,0,.68933.22113,1.3253,1.3253,0,0,0,1.32525-1.32538,1.29334,1.29334,0,0,0-.27227-.76519A8.53635,8.53635,0,0,0,19.8,10.8ZM3.856,11.888A1.27168,1.27168,0,0,0,3.85273,9.7332,7.43861,7.43861,0,0,1,14.18037,3.96208a1.23069,1.23069,0,0,0-.025.12408A1.32528,1.32528,0,0,0,15.4806,5.41148a1.28829,1.28829,0,0,0,.657-.19934,7.41629,7.41629,0,0,1,1.17,9.87628c-.01971-.00085-.03625-.01135-.05615-.01135a1.32526,1.32526,0,0,0-1.32526,1.32519,1.24692,1.24692,0,0,0,.03021.14978A7.4423,7.4423,0,0,1,3.856,11.888Zm9.61493-1.93a1.66651,1.66651,0,1,0-1.666-1.667A1.66919,1.66919,0,0,0,13.4709,9.958Zm0-2.208a.54151.54151,0,1,1-.541.541A.54244.54244,0,0,1,13.4709,7.75Zm0,2.36035a2.44132,2.44132,0,0,0-2.15613,1.3028,3.11608,3.11608,0,0,0-4.78918,2.59564h1.125a1.99547,1.99547,0,0,1,3.99023,0h1.125a3.03575,3.03575,0,0,0-.55817-1.752,1.30767,1.30767,0,0,1,2.58356.27154h1.125A2.4345,2.4345,0,0,0,13.4709,10.11033Zm-3.8252.66211a1.66651,1.66651,0,1,0-1.6665-1.666A1.66793,1.66793,0,0,0,9.6457,10.77244Zm0-2.208a.54151.54151,0,1,1-.5415.542A.54223.54223,0,0,1,9.6457,8.56443Z"
			},
			children: [
			]
		}
	]
};
var increase = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.38774,12.10487v-3.41a1.82034,1.82034,0,0,1,1.74081,1.60926H14.276A2.82309,2.82309,0,0,0,11.38774,7.733V4.13667l2.40857,2.69911.847-.75541L10.82339,1.8,6.98081,6.07889l.84406.75837,2.42827-2.70453v3.602c-1.69858.13635-2.84341,1.1146-2.84341,2.626,0,1.726,1.206,2.237,2.84341,2.61342v3.68143a2.23815,2.23815,0,0,1-2.10719-2.2745H6.95668a3.27493,3.27493,0,0,0,3.29646,3.243V19.8h1.1346V17.64806c1.782-.15586,3.11474-1.14519,3.11474-2.81392C14.50248,12.95927,13.16973,12.48153,11.38774,12.10487ZM8.52809,10.3041c0-.944.69139-1.48344,1.725-1.62822v3.19083C9.08086,11.57284,8.52809,11.1609,8.52809,10.3041ZM11.38774,16.685V13.23972c1.26479.28943,1.95354.62836,1.95354,1.63677A1.9403,1.9403,0,0,1,11.38774,16.685Z"
			},
			children: [
			]
		}
	]
};
var industry = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.3,11.54V9.75l-4.5,1.79V9.75L6.3,11.54V5.82H1.8V18.47h18V9.75Zm3.38,5.82H2.92V6.94H5.19v6.25l1.53-.61,3-1.19v1.8l1.53-.61,3-1.19v1.8l1.52-.61,3-1.19ZM4.37,4.82l-.64-.91c1.92-1.36,3.61-.67,5.11-.06s2.62,1.07,4,.06l.64.91a3.85,3.85,0,0,1-2.33.79,7.43,7.43,0,0,1-2.77-.72C7,4.31,5.8,3.82,4.37,4.82Z"
			},
			children: [
			]
		}
	]
};
var info = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "defs",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					name: "style",
					type: "element",
					value: "",
					attributes: {
					},
					children: [
						{
							name: "",
							type: "text",
							value: ".cls-1{fill:#010101;}",
							attributes: {
							},
							children: [
							]
						}
					]
				}
			]
		},
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				"class": "cls-1",
				d: "M19.8,10.8a9,9,0,1,0-9,9A9.01054,9.01054,0,0,0,19.8,10.8Zm-1.12488,0A7.87513,7.87513,0,1,1,10.8,2.92486,7.88411,7.88411,0,0,1,18.67509,10.8ZM11.625,7.45852H9.95v-1.675h1.675ZM9.95834,9.11662H11.65v6.6999H9.95834Z"
			},
			children: [
			]
		}
	]
};
var instagram = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.74971,7.08772a6.61127,6.61127,0,0,0-.41852-2.18561,4.60387,4.60387,0,0,0-2.6333-2.6333,6.60973,6.60973,0,0,0-2.18561-.41852c-.96033-.04382-1.267-.05414-3.71228-.05414s-2.75189.01032-3.71228.05414a6.60973,6.60973,0,0,0-2.18561.41852,4.60407,4.60407,0,0,0-2.63324,2.6333,6.60819,6.60819,0,0,0-.41852,2.18561c-.04382.96033-.0542,1.267-.0542,3.71228,0,2.44525.01038,2.75189.0542,3.71228a6.60747,6.60747,0,0,0,.41852,2.18555,4.60415,4.60415,0,0,0,2.63324,2.6333,6.60819,6.60819,0,0,0,2.18561.41852c.96039.04382,1.267.0542,3.71228.0542s2.75195-.01038,3.71228-.0542a6.60819,6.60819,0,0,0,2.18561-.41852,4.60395,4.60395,0,0,0,2.6333-2.6333,6.61055,6.61055,0,0,0,.41852-2.18555c.04382-.96039.05414-1.267.05414-3.71228C19.80385,8.35469,19.79353,8.04805,19.74971,7.08772ZM18.129,14.43831a4.98194,4.98194,0,0,1-.31,1.67187,2.98166,2.98166,0,0,1-1.7088,1.7088,4.98233,4.98233,0,0,1-1.67193.31006c-.94928.04334-1.234.05249-3.63831.05249s-2.689-.00915-3.63831-.05249A4.98152,4.98152,0,0,1,5.48982,17.819,2.982,2.982,0,0,1,3.781,16.11018a4.98194,4.98194,0,0,1-.31-1.67187c-.04334-.94941-.05249-1.2342-.05249-3.63831,0-2.40417.00915-2.6889.05249-3.63837a4.98188,4.98188,0,0,1,.31-1.67187A2.98153,2.98153,0,0,1,5.48982,3.781,4.98308,4.98308,0,0,1,7.16169,3.4709c.94941-.04328,1.2342-.05243,3.63831-.05243,2.40417,0,2.6889.00915,3.63831.05243a4.98389,4.98389,0,0,1,1.67193.31006,2.98166,2.98166,0,0,1,1.7088,1.7088,4.98188,4.98188,0,0,1,.31,1.67187c.04334.94947.05249,1.2342.05249,3.63837C18.18153,13.20411,18.17238,13.4889,18.129,14.43831ZM10.8,6.1764A4.6236,4.6236,0,1,0,15.4236,10.8,4.62358,4.62358,0,0,0,10.8,6.1764Zm0,7.62488A3.00128,3.00128,0,1,1,13.80128,10.8,3.00132,3.00132,0,0,1,10.8,13.80128Zm5.88678-7.80755a1.08048,1.08048,0,1,1-1.08051-1.08051A1.08049,1.08049,0,0,1,16.68678,5.99373Z"
			},
			children: [
			]
		}
	]
};
var insurance = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.55,2.93V7.76c0,4.13-2.45,8-6.75,10.72C6.5,15.77,4.05,11.89,4.05,7.76V2.93h13.5M18.68,1.8H2.93v6c0,4.89,3.09,9.24,7.87,12,4.78-2.8,7.88-7.15,7.88-12Z"
			},
			children: [
			]
		}
	]
};
var international = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.81895,1.78105a9,9,0,1,0,9,9A8.99943,8.99943,0,0,0,10.81895,1.78105Zm7.847,8.438H14.897a13.41531,13.41531,0,0,0-1.856-6.988A7.8834,7.8834,0,0,1,18.66593,10.219Zm-7.847-7.313c1.161,0,2.822,2.833,2.953,7.312H7.866C7.99723,5.73863,9.658,2.90605,10.81895,2.90605ZM8.597,3.23a13.41646,13.41646,0,0,0-1.856,6.989H2.972A7.88584,7.88584,0,0,1,8.597,3.23Zm-5.625,8.113h3.769a13.41533,13.41533,0,0,0,1.856,6.988A7.8834,7.8834,0,0,1,2.972,11.34307Zm7.847,7.313c-1.161,0-2.822-2.833-2.953-7.312h5.906C13.641,15.82305,11.98,18.65605,10.81895,18.65605Zm2.222-.324a13.39689,13.39689,0,0,0,1.856-6.988h3.769A7.88569,7.88569,0,0,1,13.04093,18.33208Z"
			},
			children: [
			]
		}
	]
};
var inventory = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M6.83638,1.82612V5.90425H4.32075V9.98237H1.80513v9.79151H14.76362V15.69575h2.51563V11.61763h2.51562V1.82612Zm11.83349,8.66651H17.27925V5.90425H7.96138V2.95112H18.66987Zm-2.51562,1.125v2.95312H14.76362V9.98237H5.44575V7.02925h10.7085v4.58838Zm-2.51563,4.07812v2.95313H2.93013v-7.542H13.63862v4.58887Z"
			},
			children: [
			]
		}
	]
};
var irobot = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,2.925A7.875,7.875,0,1,1,2.925,10.8,7.88392,7.88392,0,0,1,10.8,2.925m0-1.125a9,9,0,1,0,9,9,9,9,0,0,0-9-9Zm0,7.72437A1.27563,1.27563,0,1,1,9.52437,10.8,1.27708,1.27708,0,0,1,10.8,9.52437m0-1.125A2.40063,2.40063,0,1,0,13.20063,10.8,2.40062,2.40062,0,0,0,10.8,8.39937Zm-.00038-4.04981a6.45751,6.45751,0,0,0-6.45019,6.4502h1.125a5.3252,5.3252,0,1,1,10.65039,0h1.125A6.45751,6.45751,0,0,0,10.79962,4.34956Z"
			},
			children: [
			]
		}
	]
};
var landscape = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "a3729d30-b334-4af6-946f-53e0efd5378b",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,4V17.6H1.8V4ZM18.7,5.1H2.9V16.5H18.6V5.1Z"
			},
			children: [
			]
		}
	]
};
var law = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.19,3.93h.86V2.81H11.36v-1H10.24v1H4.47V3.93H5.4L1.8,10.18l.05.22a4,4,0,0,0,7.73,0l.06-.22L6,3.93h4.22V18.68h-5V19.8H16V18.68H11.36V3.93h4.2L12,10.18l.06.22a4,4,0,0,0,7.73,0l.05-.22ZM5.72,12.3A2.84,2.84,0,0,1,3.32,11h4.8A2.84,2.84,0,0,1,5.72,12.3ZM8.17,9.87H3.27L5.71,5.62Zm7.71,2.43A2.84,2.84,0,0,1,13.48,11h4.8A2.84,2.84,0,0,1,15.88,12.3ZM13.43,9.87l2.44-4.25,2.46,4.25Z"
			},
			children: [
			]
		}
	]
};
var levers = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.6784191,16.7716198v1.0837994H2.19508v-1.0837994H19.6784191z M1.90547,5.9503899\n\tc0.0026234-1.2271352,0.99954-2.2197983,2.2266755-2.2171748C5.3555722,3.7358305,6.3467045,4.726963,6.3493199,5.9503899\n\tC6.3471737,6.4517174,6.1738281,6.9372692,5.8579998,7.3266101L6.27951,7.8535299\n\tc4.0221467-2.5773282,9.3720779-1.4060717,11.9494076,2.6160755c0.8942642,1.3955774,1.3687134,3.018714,1.3668823,4.6762247\n\tv0.5419302H2.27754v-0.5419302c-0.0017447-2.5582304,1.1306372-4.9856224,3.0920002-6.6280594L4.9607902,8.0067711\n\tC3.8284349,8.4705296,2.5345294,7.928524,2.0707712,6.7961688C1.9608488,6.5277719,1.904693,6.2404041,1.9054902,5.9503708\n\tL1.90547,5.9503899z M12.3177004,14.0890598c-0.3077307-0.7633181-1.1759882-1.1326447-1.9393063-0.824914\n\tc-0.3756485,0.1514425-0.6734715,0.4492655-0.824914,0.824914H12.3177004z M6.9613199,8.7056999l2.8290997,3.5364399\n\tc0.3804207-0.1992092,0.8028307-0.3049116,1.2322397-0.3083496c1.4843616,0.0104256,2.6978502,1.186779,2.7543898,2.6701002\n\th4.7156992c-0.2942696-4.1679134-3.9115829-7.3081217-8.0794954-7.0138521\n\tC9.1891546,7.6764636,8.0044527,8.0593586,6.9613199,8.7056999z M3.38026,14.6038904h4.8884902\n\tc0.0237331-0.6089239,0.2500973-1.1924906,0.6431904-1.6581402l-2.8649406-3.58111\n\tC4.4866571,10.6789713,3.524708,12.5688791,3.38026,14.6038904z M3.0304699,5.9503908\n\tC3.0303321,6.5562086,3.5213327,7.0474324,4.1271505,7.0475702s1.0970416-0.4908628,1.0971794-1.0966806\n\tS4.7334671,4.853848,4.1276493,4.8537102c-0.0000033,0-0.0000062,0-0.0000095,0\n\tC3.5221412,4.8543382,3.0313685,5.3448915,3.0304699,5.9503908z"
			},
			children: [
			]
		}
	]
};
var light = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "f1a31f26-f20b-4b38-93a3-2b69065b184b",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.29,1.8h1.12V5.18H10.29ZM7.54,6.19l1-.57L6.83,2.7l-1,.56ZM5.67,8.43l.56-1L3.31,5.77l-.56,1ZM1.8,11.31H5.18V10.19H1.8Zm1.46,4.44,2.93-1.69-.57-1L2.7,14.77Zm3.48,3.1,1.69-2.92-1-.57L5.77,18.29Zm3.45.95h1.12V16.42H10.19Zm4.58-.9,1-.57-1.69-2.92-1,.56Zm3.52-3.07.56-1-2.93-1.69-.56,1Zm-1.87-4.42H19.8V10.29H16.42ZM16,8.52,18.9,6.83l-.57-1L15.41,7.54ZM14.14,6.24l1.69-2.93-1-.56L13.16,5.68Zm.59,4.55a3.94,3.94,0,1,1-3.94-3.94A3.95,3.95,0,0,1,14.73,10.79Zm-1.13,0a2.82,2.82,0,1,0-2.81,2.81A2.81,2.81,0,0,0,13.6,10.79Z"
			},
			children: [
			]
		}
	]
};
var link = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "f017ae31-3166-4da9-a0a8-1f1e855acd16",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.21,12.34a1,1,0,0,1-.73-.3l-.21-.21-.8.79.22.22a2.16,2.16,0,0,0,3,0L17,7.52a2.15,2.15,0,0,0,0-3L15,2.43a2.14,2.14,0,0,0-1.52-.63A2.1,2.1,0,0,0,12,2.43L6.63,7.75a2.15,2.15,0,0,0,0,3l.62.61L4.56,14.08a2.15,2.15,0,0,0,0,3l2.05,2.05a2.14,2.14,0,0,0,1.52.63,2.1,2.1,0,0,0,1.51-.63L15,13.85a2.15,2.15,0,0,0,0-3l-.23-.23-.8.79.23.23a1,1,0,0,1,.3.72,1,1,0,0,1-.3.72L8.85,18.38a1,1,0,0,1-.72.29,1,1,0,0,1-.72-.29L5.35,16.32a1,1,0,0,1-.3-.72,1,1,0,0,1,.3-.72l5.32-5.32a1,1,0,0,1,1.45,0l.64.65L10.93,12A1,1,0,0,1,10.21,12.34Zm1.18-4.2a2.09,2.09,0,0,0-1.51.62L8,10.6,7.43,10a1,1,0,0,1,0-1.45l5.32-5.32a1,1,0,0,1,.72-.3,1,1,0,0,1,.72.3l2.06,2.06a1,1,0,0,1,0,1.44L13.56,9.41l-.65-.65A2.13,2.13,0,0,0,11.39,8.14Z"
			},
			children: [
			]
		}
	]
};
var list = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "f23d9130-f6c9-42ad-84be-8ea172700af8",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M4.37,4.37A1.29,1.29,0,1,1,3.09,3.09,1.28,1.28,0,0,1,4.37,4.37ZM3.09,9.51A1.29,1.29,0,1,0,4.37,10.8,1.29,1.29,0,0,0,3.09,9.51Zm0,6.43a1.29,1.29,0,1,0,0,2.57,1.29,1.29,0,0,0,0-2.57ZM6.94,3.73V5H19.8V3.73Zm0,7.71H19.8V10.16H6.94Zm0,6.43H19.8V16.59H6.94Z"
			},
			children: [
			]
		}
	]
};
var lmr = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.5,6.21a.73.73,0,0,0,.15-.4.7.7,0,0,0-.7-.7.69.69,0,0,0-.69.7.6.6,0,0,0,.15.4V8.62H8.36V7.89H7.27v.73H5.2V19.8h7.08V8.62H10.5Zm.68,12.5H6.29V12.07h4.89Zm0-9V11H6.29V9.71Zm2.27-1.19-.77-.77h0a2.74,2.74,0,0,0,0-3.89l.77-.77A3.84,3.84,0,0,1,13.45,8.52ZM11.39,6.46a.93.93,0,0,0,0-1.31l.77-.77h0a2,2,0,0,1,0,2.85Zm3.35,3.35L14,9a4.57,4.57,0,0,0,0-6.47l.77-.77A5.65,5.65,0,0,1,14.74,9.81Z"
			},
			children: [
			]
		}
	]
};
var loader = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.7,10.8h1.1a9,9,0,1,1-9-9V2.9a7.9,7.9,0,1,0,7.9,7.9Z"
			},
			children: [
			]
		}
	]
};
var location = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,1.8a6.7138,6.7138,0,0,0-6.16418,9.36676c1.02069,2.197,6.217,8.63324,6.217,8.63324s4.70861-5.77271,6.007-8.48785a7.53134,7.53134,0,0,0,.65076-2.80158A6.71053,6.71053,0,0,0,10.8,1.8Zm5.04486,9.02679a54.25636,54.25636,0,0,1-4.991,7.169,63.17012,63.17012,0,0,1-5.18512-7.27466,5.58625,5.58625,0,1,1,10.7168-2.21057A6.4108,6.4108,0,0,1,15.84486,10.82679ZM10.8,5.175A3.375,3.375,0,1,0,14.175,8.55,3.375,3.375,0,0,0,10.8,5.175Zm0,5.625a2.25,2.25,0,1,1,2.25-2.25A2.25254,2.25254,0,0,1,10.8,10.8Z"
			},
			children: [
			]
		}
	]
};
var locker = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "a",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,1.8V19.8H19.8V1.8H1.8ZM18.675,10.23756h-7.31232v-2.66602h1.125v-2.00049h-1.125V2.925h7.31232v7.31256ZM2.925,5.57106V2.925h7.31268v7.31256H2.925v-2.66602h1.125v-2.00049h-1.125Zm0,10.44189h1.125v-2.00098h-1.125v-2.64941h7.31268v7.31244H2.925v-2.66205Zm8.43768,2.66205v-2.66205h1.125v-2.00098h-1.125v-2.64941h7.31232v7.31244h-7.31232Z"
			},
			children: [
			]
		}
	]
};
var logout = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "e162cd9b-5708-4f06-a9cb-18649ae018ae",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.76,12.41h1.1v5.73H1.8V3.46H12.86V8.79h-1.1V4.57H2.91V17h8.85ZM15.27,6l-.8.81L17.69,10H8.94v1.2h8.75l-3.22,3.22.8.8L19.8,10.5Z"
			},
			children: [
			]
		}
	]
};
var manufacturing = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.66411,17.679a4.45663,4.45663,0,0,0-2.0586-3.22687V9.20884l6.51856-2.0993V8.832L13.13188,10.8239a.55731.55731,0,0,0-.16309.3944v1.12079a.55587.55587,0,0,0,.09375.30976l1.12158,1.68188.92823-.61944L14.08452,12.17v-.72034L15.39506,10.139H15.981L17.28569,11.449v.7221L16.26518,13.713l.93115.616,1.11279-1.68182a.55722.55722,0,0,0,.09229-.308V11.2183a.55615.55615,0,0,0-.1626-.39373L16.24028,8.81828v-2.068l.06494-.02094v-.002A2.00827,2.00827,0,0,0,15.68943,2.808L15.689,2.80516H6.19145l.00049.00445a3.49192,3.49192,0,0,0-2.30225,6.117v5.52557A4.30663,4.30663,0,0,0,1.8311,17.679l-.00556,1.11584H19.77446V17.679ZM3.81736,6.30162a2.35716,2.35716,0,0,1,2.37848-2.376L6.836,3.92112h7.93018l.00048.00165.92188.0011A.89231.89231,0,0,1,15.962,5.66533l-.55909.18206L7.95952,8.24424l-1.0337.3285a2.37609,2.37609,0,0,1-.35449.088,2.42959,2.42959,0,0,1-.374.02936A2.38422,2.38422,0,0,1,3.81736,6.30162ZM7.4893,9.56816v4.39319A4.41178,4.41178,0,0,0,6.24711,13.764a4.41027,4.41027,0,0,0-1.2417.19733V9.5933a3.47273,3.47273,0,0,0,1.1919.21283,3.35793,3.35793,0,0,0,1.0664-.1698l.001.00428ZM2.94682,17.679a3.34544,3.34544,0,0,1,6.60107,0Z"
			},
			children: [
			]
		}
	]
};
var maximize = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.7,1.8L3.6,9.2h3.5l-0.1,6h7.3v-6H18L10.7,1.8z M13.3,8.1v6H8.2l0.1-6H6.2l4.5-4.6l4.6,4.6H13.3z M7.1,16.5h7.2v1.1H7.1\n\tV16.5z M7.1,18.6h7.2v1.1H7.1L7.1,18.6z"
			},
			children: [
			]
		}
	]
};
var menu = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "a828801d-2d2f-486a-9f3e-d43f7d04e6a6",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.3,4.61V5.74H3.3V4.61ZM3.3,17h15V15.86H3.3Zm0-5.63h15V10.24H3.3Z"
			},
			children: [
			]
		}
	]
};
var microphone = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "b4df9da3-f46e-4c11-b80c-6b0b20ea4529",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,15.3a3.39,3.39,0,0,0,3.38-3.37V5.18a3.38,3.38,0,1,0-6.75,0v6.75A3.38,3.38,0,0,0,10.8,15.3ZM8.55,5.18a2.25,2.25,0,0,1,4.5,0v6.75a2.25,2.25,0,0,1-4.5,0Zm7.88,6.75H15.3a4.5,4.5,0,1,1-9,0H5.18a5.62,5.62,0,0,0,5.06,5.59v1.16H7.43V19.8h6.75V18.68H11.36V17.52A5.63,5.63,0,0,0,16.43,11.93Z"
			},
			children: [
			]
		}
	]
};
var minus = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.25,11.41h-15V10.29h15Z"
			},
			children: [
			]
		}
	]
};
var multicast = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.34,15.2124l-.8022-.8022a4.9644,4.9644,0,0,0,0-7.12l.8022-.8022A6.3646,6.3646,0,0,1,15.34,15.2124Zm1.9053-10.83-.8023.8022a7.808,7.808,0,0,1,0,11.1309l.8023.8023A9.0181,9.0181,0,0,0,17.2457,4.3823ZM5.3125,5.1845,4.51,4.3823a9.0181,9.0181,0,0,0,0,12.7354l.8022-.8023A7.9921,7.9921,0,0,1,5.3125,5.1845ZM6.6162,6.4882a6.1733,6.1733,0,0,0,0,8.7242l.8022-.8022a4.9643,4.9643,0,0,1,0-7.12Zm7.12,4.3119a2.8078,2.8078,0,1,1-2.8078-2.8078A2.8078,2.8078,0,0,1,13.7359,10.8Zm-1.125,0a1.6828,1.6828,0,1,0-1.6828,1.6828A1.6848,1.6848,0,0,0,12.6109,10.8Z"
			},
			children: [
			]
		}
	]
};
var music = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		"enable-background": "new 0 0 21.6 21.6",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.0903,7.42131l0.792-0.792l-4.84754-4.84759h-1.35218V12.517c-0.71044-0.54967-1.58845-0.83802-2.48645-0.81659\n\tc-0.99643,0.01164-1.97245,0.28393-2.831,0.78979C4.07,13.81523,3.04989,16.34489,4.08645,18.1403\n\tc0.69303,1.08458,1.9165,1.71182,3.20166,1.64142c0.99642-0.01167,1.97243-0.28394,2.831-0.78974\n\tc1.54578-0.80466,2.56114-2.35604,2.67989-4.09466h0.004V6.36869l2.67,2.67005l0.792-0.792l-3.462-3.462V3.13426L17.0903,7.42131z\n\t M11.46872,15.92424c-0.38689,0.89131-1.05864,1.62902-1.90992,2.09747c-0.68792,0.40821-1.47091,0.62877-2.27075,0.63965\n\tc-0.8845,0.06923-1.73754-0.34416-2.23126-1.0813c-0.32782-0.63085-0.34308-1.3784-0.04126-2.0221\n\tc0.38688-0.89131,1.0586-1.62904,1.90985-2.09753c0.68797-0.4082,1.471-0.62878,2.27088-0.63971\n\tc0.88448-0.0692,1.73748,0.34419,2.2312,1.0813C11.75522,14.53293,11.77047,15.28049,11.46872,15.92424z"
			},
			children: [
			]
		}
	]
};
var mute = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.9650002,1.84l-4.79,4.79V5.1750002c0-1.863961-1.5110388-3.375-3.375-3.375s-3.375,1.511039-3.375,3.375v6.75\n\tC7.4260559,12.3416719,7.5075469,12.7542219,7.665,13.1400003l-0.836,0.8360004\n\tc-0.3425808-0.6296568-0.5242972-1.334197-0.5289998-2.0510006h-1.125c0.0006084,1.0205412,0.2807441,2.0214214,0.8099999,2.8940001\n\tL1.835,18.9689999l0.7950001,0.7950001L19.7600002,2.6340001L18.9650002,1.84z M8.5500002,11.9250002v-6.75\n\tc0-1.2426407,1.0073595-2.25,2.25-2.25s2.25,1.0073593,2.25,2.25v2.5799999l-4.4730005,4.4729996\n\tC8.5603504,12.1278276,8.5513248,12.0265379,8.5500002,11.9250002z M15.3000002,11.9250002h1.1239996\n\tc-0.0003262,2.88832-2.1881781,5.3069715-5.0620003,5.5959997v1.1539993h2.8129997v1.125h-6.749999v-1.125h2.8129997v-1.1539993\n\tc-1.0025749-0.1013851-1.9590387-0.4721527-2.7680001-1.073l0.803-0.8029995\n\tc2.0523386,1.3977833,4.8492155,0.8671627,6.2469997-1.1851768C15.0289574,13.7125301,15.300786,12.8291483,15.3000002,11.9250002z\n\t M13.0500002,11.9250002V10.868l1.125-1.125v2.1820002c-0.0056286,1.8616247-1.5133753,3.3693714-3.375,3.375\n\tc-0.6005888-0.0033331-1.1890726-0.1691999-1.7030001-0.4799995l0.8249998-0.8240004\n\tc1.1431074,0.4855804,2.463419-0.047451,2.9489994-1.1905575C12.9892826,12.5269899,13.0501642,12.2275343,13.0500002,11.9250002z"
			},
			children: [
			]
		}
	]
};
var nationwide = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,1.8a9,9,0,1,0,9,9A9,9,0,0,0,10.8,1.8Zm0,16.88a7.88,7.88,0,1,1,7.87-7.88A7.9,7.9,0,0,1,10.8,18.68ZM17.51,9.5,17,9.8a.13.13,0,0,0-.07.1l-.06.42a.13.13,0,0,1-.09.11l-.51.19s-.07,0-.08.08l-.52,1.19a.14.14,0,0,0,0,.11l.1.25a.14.14,0,0,1,0,.17l-1.25,1a.15.15,0,0,0-.06.09l-.06.39a.12.12,0,0,0,0,.08l.36.87a.13.13,0,0,1,0,.12l-.11.22a.15.15,0,0,1-.25,0l-.33-.45a.08.08,0,0,1,0-.05L13.86,14a.14.14,0,0,0-.23-.07l-.16.12a.15.15,0,0,1-.16,0L13,13.84a.1.1,0,0,0-.07,0h-.23a.14.14,0,0,0-.14.14v0a.14.14,0,0,1-.14.14h-.53L11.42,14a.11.11,0,0,0-.11,0l-.46.26a.14.14,0,0,0-.07.1l-.11.45a.14.14,0,0,1-.22.09l-.35-.25a.13.13,0,0,1-.06-.07l-.13-.39a.1.1,0,0,0-.07-.08L9.65,14a.16.16,0,0,0-.15,0l-.16.12a.14.14,0,0,1-.18,0l-.31-.31,0,0-.19-.32a.17.17,0,0,0-.13-.07H7.86a3.13,3.13,0,0,1-.81,0l-.65-.32-1-.56a.1.1,0,0,1,0,0l-.54-.78h0l-.46-.8a.17.17,0,0,1,0-.1L4.53,10l.15-.85a.11.11,0,0,0,0-.08l-.24-.65a.13.13,0,0,1,.09-.18l.06,0h6.62l1,.14a.13.13,0,0,1,.12.16l0,.25a.14.14,0,0,0,.06.15l.13.08a.14.14,0,0,0,.09,0L13.38,9a.14.14,0,0,1,.13.21l-.38.71a.14.14,0,1,0,.25.13l.24-.47a.15.15,0,0,1,.24,0l.22.27a.19.19,0,0,1,0,.11l0,.39a.14.14,0,0,0,.18.15l.11,0h0l2-.88,0,0,.66-.66a.15.15,0,0,1,.23,0l.25.45A.16.16,0,0,1,17.51,9.5Z"
			},
			children: [
			]
		}
	]
};
var native = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M2.2,3.8v14h17.2v-14H2.2z M18.4,16.8H3.2v-12h15.2V16.8z M7.6,9.3l-1.4-1H8l0.5-1.6L9,8.3h1.7l-1.4,1L9.9,11l-1.4-1l-1.4,1\n\tL7.6,9.3z M13,14.8l-7.8,0l0-1l7.8,0L13,14.8z M15.2,14.8l-1,0l0-8.1l1,0L15.2,14.8z"
			},
			children: [
			]
		}
	]
};
var network = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.66,7V1.8H14.49v2H11.6v6.43H9.83V4.79H1.94V16.85H9.83V11.38H11.6v6.39h2.89v2h5.17V14.63H14.49v2H12.72V11.38h1.77v2h5.17V8.25H14.49v2H12.72V4.94h1.77V7Zm-4.05-4h2.93V5.85H15.61ZM8.71,15.73H3.06V5.9H8.71Zm6.9,0h2.93v2.93H15.61Zm0-6.38h2.93v2.94H15.61Z"
			},
			children: [
			]
		}
	]
};
var news = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "a1b337fd-597f-47b3-9e27-26f976e3cf74",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14,8.4H6.7V7.3H14Zm.8,1.8H6.7v1.1h8.1Zm-2.2,3H6.7v1.1h5.9Zm5-11.4v18H4V1.8ZM16.5,2.9H5.1V18.7H16.5Z"
			},
			children: [
			]
		}
	]
};
var next = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,1.8a9,9,0,1,0,9,9A9,9,0,0,0,10.8,1.8Zm0,16.9a7.9,7.9,0,1,1,7.9-7.9A7.85,7.85,0,0,1,10.8,18.7ZM13.6,7.6h1.1V14H13.6ZM6.9,14.1l5.7-3.3L6.9,7.5ZM8,9.5l2.3,1.3L8,12.2Z"
			},
			children: [
			]
		}
	]
};
var night = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.6837,3.004a10.02769,10.02769,0,0,0,4.18378,14.7038A7.81266,7.81266,0,1,1,11.6837,3.004m.54083-1.13526a8.93125,8.93125,0,1,0,6.08218,15.459A8.92053,8.92053,0,0,1,13.95719,2.03945a8.99109,8.99109,0,0,0-1.73266-.17069Z"
			},
			children: [
			]
		}
	]
};
var no = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,1.8a9,9,0,1,0,9,9A9,9,0,0,0,10.8,1.8Zm-7.88,9a7.87,7.87,0,0,1,13-6L4.86,16A7.83,7.83,0,0,1,2.92,10.8Zm7.88,7.87a7.82,7.82,0,0,1-5.15-1.93L16.74,5.65a7.86,7.86,0,0,1-5.94,13Z"
			},
			children: [
			]
		}
	]
};
var notification = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.425,13.041V7.425a5.625,5.625,0,0,0-11.25,0v5.616L1.8,15.3v1.125h18V15.3Zm0,2.259H3.823l1.978-1.324.499-.334V7.425a4.5,4.5,0,0,1,9,0v6.217l.499.334L17.777,15.3ZM8.55,17.55h4.5a2.25,2.25,0,0,1-4.5,0Z"
			},
			children: [
			]
		}
	]
};
var orders = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.696,6.3V4.722A2.92574,2.92574,0,0,0,11.773,1.8H9.827A2.92574,2.92574,0,0,0,6.904,4.722V6.3H4.05V19.8h13.5V6.3ZM7.946,4.722A1.88336,1.88336,0,0,1,9.827,2.841h1.947a1.88336,1.88336,0,0,1,1.881,1.881V6.3H7.946Zm8.479,13.953H5.175V7.425H6.904v1.293H7.946V7.425h5.708v1.293h1.042V7.425h1.729Zm-9-7.875H8.55v1.125H7.425Zm0,2.25H8.55v1.125H7.425Zm0,2.25H8.55v1.125H7.425Zm2.25-4.5h4.5v1.125h-4.5Zm3.375,3.375H9.675V13.05H13.05ZM9.675,15.3h4.5v1.125h-4.5Z"
			},
			children: [
			]
		}
	]
};
var passenger = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,10.7c2.2,0,4.1-1.8,4.1-4.1S13,2.6,10.8,2.6c-2.2,0-4.1,1.8-4.1,4.1c0,0,0,0,0,0C6.7,8.9,8.6,10.7,10.8,10.7\n\tC10.8,10.7,10.8,10.7,10.8,10.7z M10.8,3.8c1.6,0,2.9,1.3,2.9,2.9c0,1.6-1.3,2.9-2.9,2.9c-1.6,0-2.9-1.3-2.9-2.9c0,0,0,0,0,0\n\tC7.9,5.1,9.2,3.8,10.8,3.8z M10.8,11.2c-0.9,0-1.9,0.2-2.8,0.6L4.1,9.3v1.3l2.8,1.8c-2.1,1.3-3.3,3.6-3.3,6.1V19H18v-0.6\n\tC18,14.4,14.8,11.2,10.8,11.2z M10.8,12.3c2.9,0,5.5,2.1,6,5l-7.5-4.8C9.8,12.4,10.3,12.3,10.8,12.3z M8,13l7.6,4.8H4.7\n\tC4.9,15.8,6.1,14,8,13z"
			},
			children: [
			]
		}
	]
};
var pause = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,1.8a9,9,0,1,0,9,9A9,9,0,0,0,10.8,1.8Zm0,16.88a7.88,7.88,0,1,1,7.88-7.88A7.89,7.89,0,0,1,10.8,18.68ZM6.86,6.86v7.88h3.38V6.86Zm2.25,6.75H8V8H9.11Zm2.25-6.75v7.88h3.38V6.86Zm2.25,6.75H12.49V8h1.12Z"
			},
			children: [
			]
		}
	]
};
var pharmaceutical = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M4,1.8V6.48h.79V19.8h12V6.48h.89V1.8ZM15.52,18.57H6V16.72h9.54Zm0-3.08H6V9.84h9.54Zm0-6.88H6V6.48h9.54Zm.89-3.44H5.19V3H16.41Zm-3,9.21H7.86V13.15H13.4Zm-2.6-2.27H7.86V10.88H10.8Z"
			},
			children: [
			]
		}
	]
};
var phone = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.44479,11.7348l4.28184,4.3389L16.59934,19.8A18.36617,18.36617,0,0,1,6.861,14.68283,18.36671,18.36671,0,0,1,1.87337,4.87768L5.64074,1.8,9.92258,6.13891,8.67522,8.62323a15.39166,15.39166,0,0,0,1.91632,2.37811,15.3965,15.3965,0,0,0,2.35275,1.9479Zm2.68334,4.40334-2.92954-2.96863-1.73751.84385-.61345.29793-.56517-.38149a16.65458,16.65458,0,0,1-2.533-2.09751A16.64364,16.64364,0,0,1,7.68593,9.27191L7.312,8.70179l.306-.60934.86676-1.72628L5.55512,3.39747,3.17028,5.34575a17.1667,17.1667,0,0,0,4.53266,8.50613,17.16632,17.16632,0,0,0,8.44553,4.64518Z"
			},
			children: [
			]
		}
	]
};
var photo = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,4.05v13.5h18V4.05Zm16.8,12.4H2.9v-4.1l4.6-2.9,5.8,5.7,5.3-2.7Zm.1-5.3-5.1,2.6L7.7,8.05l-4.8,3V5.25H18.7Zm-4,.3a2.2,2.2,0,1,0-2.2-2.2A2.19993,2.19993,0,0,0,14.7,11.45Zm0-3.275A1.075,1.075,0,1,1,13.625,9.25,1.07619,1.07619,0,0,1,14.7,8.175Z"
			},
			children: [
			]
		}
	]
};
var platform = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.4,9l3.3-1.8l-9-4.7L1.8,7.3l3.3,1.8l-3.3,1.7l3.3,1.8l-3.3,1.7l8.8,4.8l9.1-4.8l-3.3-1.7l3.3-1.8L16.4,9z M4.2,7.3\n\tl6.6-3.5l6.6,3.4l-2.1,1.1l-0.6,0.3L14,9l-2.1,1.1l-0.6,0.3l-0.6,0.3l-0.5-0.3l-0.6-0.3l-2.1-1L6.9,8.7L6.3,8.4L4.2,7.3z M17.4,14.2\n\tl-6.7,3.5l-6.5-3.5l2.1-1.1l4.4,2.4l4.6-2.4L17.4,14.2z M15.2,11.9l-0.6,0.3L14,12.5l-3.4,1.8l-3.2-1.7l-0.6-0.3L6.2,12l-2.1-1.1\n\tl2.1-1.1l2.1,1.1l0.6,0.3l0.6,0.3l1.1,0.6l1.2-0.7l0.6-0.3l0.6-0.3l2.1-1.1l2.1,1.1L15.2,11.9z"
			},
			children: [
			]
		}
	]
};
var play = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,1.8a9,9,0,1,0,9,9A9,9,0,0,0,10.8,1.8Zm0,16.88a7.88,7.88,0,1,1,7.88-7.88A7.89,7.89,0,0,1,10.8,18.68ZM8,5.93v9.74l8.44-4.87Zm1.12,2,5.07,2.92L9.11,13.72Z"
			},
			children: [
			]
		}
	]
};
var plus = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.34,11.32H11.4v6.94H10.28V11.32H3.34V10.2h6.94V3.26H11.4V10.2h6.94Z"
			},
			children: [
			]
		}
	]
};
var portrait = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M4,1.8v18h13.6v-18H4z M16.5,18.6H5.1V2.9h11.4V18.6z"
			},
			children: [
			]
		}
	]
};
var pressure = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.4,7.5c0.3-2.8-1.6-5.3-4.4-5.6c-2.4-0.3-4.6,1-5.4,3.3c-2.8,0.1-4.9,2.5-4.8,5.3c0.1,2.3,1.7,4.2,4,4.7\n\tC6,18,8.5,20,11.3,19.8c2.4-0.2,4.3-2.1,4.6-4.5l0,0c2.2,0,3.9-1.8,3.9-3.9C19.8,9.4,18.3,7.7,16.4,7.5z M10.8,18.7\n\tc-2.2,0-3.9-1.8-3.9-3.9s1.7-4,3.9-4s3.9,1.8,3.9,3.9C14.7,16.9,13,18.7,10.8,18.7z M15.9,14.2L15.9,14.2c-0.3-2.8-2.8-4.8-5.6-4.5\n\tC8,10,6.2,11.7,5.9,14c-2.1-0.6-3.3-2.7-2.7-4.8c0.5-1.7,2.1-2.9,3.9-2.9h0.4c0-0.1,0.6-3.4,3.9-3.4c2.2,0,3.9,1.8,3.9,3.9\n\tc0,0.6-0.2,1.2-0.3,1.7c0.8-0.1,0.8-0.1,0.9-0.1c1.6,0,2.8,1.3,2.8,2.9S17.4,14.2,15.9,14.2z M12.6,12.3c0.2,0.1,0.2,0.3,0.1,0.5\n\tc0,0-0.8,1.8-1.2,2.4c-0.2,0.3-0.7,0.4-1,0.2l0,0c-0.3-0.2-0.4-0.7-0.2-1c0.3-0.4,1.8-1.9,1.8-1.9C12.3,12.2,12.5,12.2,12.6,12.3z"
			},
			children: [
			]
		}
	]
};
var previous = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,1.8c-5,0-9,4-9,9s4,9,9,9s9-4,9-9l0,0C19.8,5.9,15.8,1.8,10.8,1.8L10.8,1.8z M10.8,18.7c-4.3,0-7.9-3.5-7.9-7.8v-0.1\n\tc0-4.3,3.5-7.9,7.8-7.9h0.1c4.3,0,7.9,3.5,7.9,7.8v0.1C18.7,15.1,15.1,18.7,10.8,18.7L10.8,18.7z M6.9,7.6H8V14H6.9V7.6z M14.7,14.1\n\tV7.5L9,10.8L14.7,14.1z M13.6,12.2l-2.3-1.4l2.3-1.3V12.2z"
			},
			children: [
			]
		}
	]
};
var print = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.4,8.6V1.8H5.2v6.8H1.8v11.2h18V8.6H16.4z M6.3,2.9h9v9h-9V2.9z M15.3,18.7h-9v-2.2h9V18.7z M18.7,18.7h-2.2v-3.4H5.2\n\tv3.4H2.9v-9h2.2v3.4h11.2V9.7h2.2v9H18.7z"
			},
			children: [
			]
		}
	]
};
var question = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		"enable-background": "new 0 0 21.6 21.6",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,2.925c4.34924,0,7.875,3.52576,7.875,7.875s-3.52576,7.875-7.875,7.875S2.925,15.14924,2.925,10.8\n\tC2.925,6.45076,6.45076,2.925,10.8,2.925L10.8,2.925 M10.8,1.8c-4.97056,0-9,4.02944-9,9s4.02944,9,9,9s9-4.02944,9-9l0,0l0,0\n\tc0.00031-4.97025-4.02863-8.99969-8.99888-9c0,0,0,0,0,0L10.8,1.8z M8.034,9.333C8.00035,8.5453,8.2805,7.77642,8.813,7.195\n\tc0.56785-0.5459,1.33281-0.83818,2.12-0.81c0.67816-0.01983,1.34071,0.20563,1.866,0.635\n\tc0.51068,0.45858,0.79161,1.12008,0.767,1.806c0.03859,0.6273-0.21015,1.23812-0.676,1.66c-0.402,0.365-0.528,0.456-0.809,0.718\n\tc-0.27502,0.24814-0.47054,0.57205-0.562,0.931c-0.05649,0.24114-0.08269,0.48838-0.078,0.736h-1.305\n\tc-0.02552-0.52535,0.05228-1.0506,0.229-1.546c0.2521-0.49104,0.62388-0.91062,1.081-1.22\n\tc0.3945-0.28457,0.62284-0.74574,0.61-1.232c0.04594-0.69436-0.4797-1.29449-1.17406-1.34044L10.873,7.532\n\tc-1.046,0-1.462,0.767-1.462,1.8H8.034V9.333z M9.955,13.705h1.618v1.51H9.955V13.705z"
			},
			children: [
			]
		}
	]
};
var recycle = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M7.8,11.7l-1-2.8L3.9,9.5l-2,3.6L5,18.6h4.9v-4.5H6.4L7.8,11.7z M4.4,15.3l-1.3-2.2l1.5-2.6l1.5-0.3l0.5,1.4L4.4,15.3z\n\t M8.7,15.2v2.3H5.6l-0.6-1l0.8-1.3H8.7z M10.8,6.5l1.4,2.3l2.9,0.5l1-2.8L13.9,3H7.6L5.1,7.2L9,9.5L10.8,6.5z M13.2,4.1l1.6,2.5\n\tL14.3,8l-1.5-0.2l-2.1-3.7H13.2z M6.7,6.8l1.6-2.7h1.1l0.8,1.3L8.6,7.9L6.7,6.8z M17.3,8.8l-3.9,2.3l1.7,2.9h-2.7l-1.9,2.3l2,2.3\n\th4.1l3.1-5.5L17.3,8.8z M16,17.4h-3l-1-1.1l1-1.2h4.3L16,17.4z M16.4,14l-1.5-2.5l2-1.1l1.6,2.7L18,14H16.4z"
			},
			children: [
			]
		}
	]
};
var reminder = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.175,2.925H13.05V1.8H8.55V2.925H7.425V4.05H4.05V19.8h13.5V4.05H14.175ZM8.55,4.05H9.675V2.925h2.25V4.05H13.05V5.175H8.55Zm7.875,1.125v13.5H5.175V5.175h2.25V6.3h6.75V5.175ZM6.8625,7.707h7.875V8.832H6.8625Zm4.5,3.15152h-4.5V9.7335h4.5Zm2.53711.27548.79687.79688L9.42964,17.197,6.98115,14.75508l.79395-.79688,1.65307,1.64795Z"
			},
			children: [
			]
		}
	]
};
var reply = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.91713,10.42313,11.5657,2.00734V7.22761c-3.2183-.06832-5.66482.83366-7.31481,2.64355-2.77523,3.04354-2.42771,7.83757-2.151,9.74548a.63684.63684,0,0,0,.63415.56732.69523.69523,0,0,0,.6396-.56633c1.58266-6.1465,6.4262-6.3,7.97817-6.1861v5.54254ZM3.05635,17.13547a9.57391,9.57391,0,0,1,2.03711-6.496c1.37772-1.51039,3.45939-2.27375,6.197-2.27375q.398,0,.81584.02129l.6.03119V4.77564l5.601,5.64353-5.81481,5.80442v-3.7772l-.4703-.08416C11.95382,12.35134,5.82663,11.33649,3.05635,17.13547Z"
			},
			children: [
			]
		}
	]
};
var research = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9.86281,9.00215H4.07234v-1.125h6.903A5.15454,5.15454,0,0,0,9.86281,9.00215ZM4.07234,15.24336h6.02777a5.11134,5.11134,0,0,1-.72369-1.125H4.07234Zm9.3291-10.48682H4.07234v1.125h9.3291Zm-9.3291,6.2417v1.125H8.9087c-.0014-.04913-.01458-.095-.01458-.14453a5.12,5.12,0,0,1,.09918-.98047Zm10.67773,6.03943v1.58655H3.00251V2.97578H14.75007v3.947a5.42139,5.42139,0,0,1,1.125.28565V1.85078H1.87751V19.74922H15.87507V16.755a6.00647,6.00647,0,0,1-1.125.28265Zm4.17945.59729-2.322-2.31207a4.27356,4.27356,0,1,1,.79156-.79822l2.32337,2.31342Zm-1.78589-5.6604a3.12427,3.12427,0,1,0-3.12427,3.12427A3.12782,3.12782,0,0,0,17.14363,11.97456Z"
			},
			children: [
			]
		}
	]
};
var reservations = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.36,6.33V5.74h1.69V4.61H8.55V5.74h1.69v.59a7.87,7.87,0,0,0-7.31,7.85H18.68A7.88,7.88,0,0,0,11.36,6.33Zm-.56,1.1a6.76,6.76,0,0,1,6.66,5.62H4.14A6.76,6.76,0,0,1,10.8,7.43Zm9,8.43V17H1.8V15.86Z"
			},
			children: [
			]
		}
	]
};
var retargeting = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,11c0,4.8-3.9,8.7-8.7,8.7c-2.6,0-5.1-1.2-6.7-3.2v2.5H3.2v-4.5h4.5v1.1H5.1c2.6,3.3,7.4,3.9,10.7,1.3\n\tc1.8-1.4,2.9-3.6,2.9-6H19.8z M10.6,2.9c2.4,0,4.6,1.1,6,3h-2.7V7h4.5V2.5h-1.1V5C14.2,1.3,8.7,0.7,5,3.8C3,5.5,1.8,8,1.8,10.6h1.1\n\tC2.9,6.4,6.4,2.9,10.6,2.9z M10.2,15.3v-1.1c-1.4-0.2-2.6-1.4-2.8-2.8H6.3v-1.1h1.1c0.2-1.4,1.4-2.6,2.8-2.8V6.3h1.1v1.1\n\tc1.4,0.2,2.6,1.4,2.8,2.8h1.1v1.1h-1.1c-0.2,1.4-1.4,2.6-2.8,2.8v1.1H10.2z M13,11.4h-1.7V13C12.2,12.8,12.8,12.2,13,11.4z\n\t M11.4,8.6v1.7H13C12.8,9.4,12.2,8.8,11.4,8.6z M8.6,10.2h1.7V8.6C9.4,8.8,8.8,9.4,8.6,10.2z M10.2,13v-1.7H8.6\n\tC8.8,12.2,9.4,12.8,10.2,13z"
			},
			children: [
			]
		}
	]
};
var returns = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.696,6.3V4.722A2.9258,2.9258,0,0,0,11.773,1.8H9.827A2.9258,2.9258,0,0,0,6.904,4.722V6.3H4.05V19.8h13.5V6.3ZM7.946,4.722A1.8834,1.8834,0,0,1,9.827,2.841h1.947a1.8834,1.8834,0,0,1,1.881,1.881V6.3H7.946Zm8.479,13.953H5.175V7.425H6.904V8.718H7.946V7.425h5.708V8.718h1.042V7.425h1.729Zm-1.571-4.101a2.8152,2.8152,0,0,1-2.812,2.812h-1.5V16.261h1.5a1.688,1.688,0,0,0,0-3.376H8.9l1.289,1.29-.795.796L6.746,12.323,9.394,9.675l.795.795L8.9,11.76h3.142A2.8176,2.8176,0,0,1,14.854,14.574Z"
			},
			children: [
			]
		}
	]
};
var rewards = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.43,7.59a5.63,5.63,0,1,0-9,4.49v7.56l3.37-3.38,3.38,3.38V12.08A5.61,5.61,0,0,0,16.43,7.59ZM6.3,7.59a4.5,4.5,0,1,1,4.5,4.5A4.51,4.51,0,0,1,6.3,7.59Zm6.75,9.33L10.8,14.67,8.55,16.92V12.74a5.62,5.62,0,0,0,4.5,0Z"
			},
			children: [
			]
		}
	]
};
var ring = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M5.10762,9.29666,4.10469,10.79373l1.00293,1.5L4.10371,13.79666l.79492,1.19043-.93554.625L2.75215,13.79666l1.002-1.50293-1.00293-1.5L3.7541,9.29666l-1.00293-1.499L3.96309,5.98709l.93554.625L4.10469,7.79764Zm12.73828,0,1.00293-1.499L17.63691,5.98709l-.93554.625.79394,1.18555-1.00293,1.499,1.00293,1.49707-1.00293,1.5,1.00391,1.50293-.79492,1.19043.93554.625,1.21094-1.81543-1.002-1.50293,1.00293-1.5ZM5.85817,1.8H15.93953v18H5.85817Zm1.125,3.56207V15.53982h7.83136V2.925H6.98317V5.36209Zm0,13.31293h7.83136v-2.0102H11.92012V17.7615H9.81172V16.66482H6.98317Z"
			},
			children: [
			]
		}
	]
};
var ringing = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12,13.3c-0.7-0.5-1.4-1-2-1.7c-0.6-0.6-1.2-1.3-1.7-2l1.1-2.1L5.7,3.7L2.5,6.4c0.6,3.2,2.1,6.1,4.3,8.4\n\tc2.3,2.3,5.2,3.8,8.4,4.3l2.7-3.2l-3.7-3.7L12,13.3z M14.8,17.9c-2.7-0.6-5.2-1.9-7.2-3.9c-2-2-3.3-4.5-3.9-7.2l1.9-1.6L8,7.6\n\tc-0.1,0.1-1,2.1-1,2c0.6,1,1.3,1.9,2.2,2.7c0.8,0.8,1.8,1.5,2.7,2.2c0.1-0.1,2.1-1,2-1l2.4,2.4L14.8,17.9z M11.1,6.9V5.8\n\tc2.6,0,4.7,2.1,4.7,4.7h-1.1C14.7,8.5,13.1,6.9,11.1,6.9z M19.1,10.5H18c0-3.8-3.1-6.9-6.9-6.9V2.5C15.5,2.5,19.1,6.1,19.1,10.5z"
			},
			children: [
			]
		}
	]
};
var ringtone = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.33829,6.16381l.79436-.79435L15.59244,1.83l-1.1352-.03V8.87383a3.11775,3.11775,0,0,0-2.08353-.37825V3.9361H2.46735V19.8h9.90636V14.83475a4.57471,4.57471,0,0,0,1.491-.742,4.04787,4.04787,0,0,0,1.716-3.14668V6.62316l1.21859,1.2164.79289-.79582L15.58074,5.03592V3.40772ZM11.26218,7.95513m0,0v.8557a4.65648,4.65648,0,0,0-.96834.55087A4.19345,4.19345,0,0,0,8.59761,12.052a2.6013,2.6013,0,0,0,.46667,1.94858,2.70126,2.70126,0,0,0,2.1979,1.00464v.83861H3.59086V7.95513c-.021,0,0-1.12351,0-1.12351V5.0596h7.67132V7.95513ZM3.59086,18.6765V16.96729H6.12971v.90114H8.71684v-.90114h2.54534V18.6765ZM13.18744,13.196c-1.144.86457-2.62443.92455-3.22787.12581a1.48452,1.48452,0,0,1-.24869-1.11327,3.10861,3.10861,0,0,1,1.25882-1.9493,3.25907,3.25907,0,0,1,1.91346-.689,1.59414,1.59414,0,0,1,1.31222.561,1.3618,1.3618,0,0,1,.26186.76949l.00146.04535A2.95341,2.95341,0,0,1,13.18744,13.196Z"
			},
			children: [
			]
		}
	]
};
var router = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.1,7.88a4.47,4.47,0,0,0-6.4,0l-.8-.8a5.55,5.55,0,0,1,7.9,0Zm1.4-1.5.8-.8a7.85,7.85,0,0,0-11,0l.8.8A6.62,6.62,0,0,1,15.5,6.38Zm4.3,5.09v6.8H1.8v-6.8Zm-1.1,1.11H2.9v4.5H18.7ZM8.4,8.68l.8.79a2.25,2.25,0,0,1,3.2,0l.8-.79A3.44,3.44,0,0,0,8.4,8.68ZM5.2,15.47a.7.7,0,1,0-.7-.7A.68.68,0,0,0,5.2,15.47Zm3.3,0a.7.7,0,1,0-.7-.7A.74.74,0,0,0,8.5,15.47Z"
			},
			children: [
			]
		}
	]
};
var rss = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M4.6,14.2A2.8,2.8,0,0,0,1.8,17a2.86,2.86,0,0,0,2.8,2.8A2.86,2.86,0,0,0,7.4,17,2.73,2.73,0,0,0,4.6,14.2Zm0,4.5a1.7,1.7,0,0,1,0-3.4,1.7,1.7,0,1,1,0,3.4Zm8-9.8a11.53,11.53,0,0,1,3.3,8H14.8A10.24,10.24,0,0,0,4.6,6.7V5.6A11.36,11.36,0,0,1,12.6,8.9ZM19.8,17H18.7A14.15,14.15,0,0,0,4.6,2.9V1.8A15.19,15.19,0,0,1,19.8,17Zm-8.1-.2V17H10.6a6,6,0,0,0-5.8-6.2H4.6V9.7A7.13,7.13,0,0,1,11.7,16.8Z"
			},
			children: [
			]
		}
	]
};
var satellite = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.66,14.87l-.72-.72,1.88-1.88-.44-.4a3.2,3.2,0,0,0-4.52,4.52l.4.44,1.88-1.89.72.72Zm-3.3.27a2,2,0,0,1-.21-.9,2.09,2.09,0,0,1,2.08-2.09,2.12,2.12,0,0,1,.9.21ZM12.18,8.4,15.54,5,12.47,2,9.11,5.33l-.54-.55a2.52,2.52,0,0,0-3.21-.21L4.6,3.81l-.8.8.76.75a2.45,2.45,0,0,0,.22,3.21l.54.55-3.4,3.4L5,15.59l3.4-3.4,1.35,1.35,3.79-3.79Zm.29-4.84L14,5,11.38,7.6,9.91,6.13ZM5,14,3.51,12.52,6.1,9.94l1.47,1.47ZM9.74,12,5.57,7.78a1.35,1.35,0,0,1,0-1.88l.32-.32a1.37,1.37,0,0,1,1.88,0l.55.55h0L11.38,9.2h0l.55.56Zm6.91,2.41h1.13a3.43,3.43,0,0,1-3.43,3.42V16.66A2.3,2.3,0,0,0,16.65,14.36Zm2.88,0h.15a5.32,5.32,0,0,1-1.6,3.82,5.11,5.11,0,0,1-3.59,1.43H14.3l0-1.13a4,4,0,0,0,3-1.11,4.19,4.19,0,0,0,1.25-3l1.13,0Z"
			},
			children: [
			]
		}
	]
};
var save = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M7.93,11l2.31,2.64V7.88h1.12v5.74L13.69,11l.8.8-3.69,4-3.67-4ZM19.8,5.18v13.5H1.8V2.93h6l2,2.25ZM18.68,6.3H9.21l-2-2.25H2.93v13.5H18.68Z"
			},
			children: [
			]
		}
	]
};
var scale = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "scale",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,1.8v18h18V1.8ZM18.7,18.7H2.9V2.9H18.7ZM8.4,12.6l6.1-6.1H10V5.4h6.4v6.4H15.3V7.3L9.2,13.4Z"
			},
			children: [
			]
		}
	]
};
var search = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "a27c9b66-6276-4536-9660-1e83e383cd1e",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.75,19l-6-6a6.76,6.76,0,1,0-.79.79l6,6ZM8.6,14.23A5.63,5.63,0,1,1,14.23,8.6,5.63,5.63,0,0,1,8.6,14.23Z"
			},
			children: [
			]
		}
	]
};
var services = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 38 38"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m2.99451,19h14V5H2.99451v14Zm2-12h10v10H4.99451V7Zm-2,28h14v-14H2.99451v14Zm2-12h10v10H4.99451v-10Zm16,12h14v-14h-14v14Zm2-12h10v10h-10v-10Zm12.01099-11.50006L26.50549,3l-8.5,8.49994,8.5,8.50006,8.5-8.50006Zm-8.5-5.67151l5.67163,5.67151-5.67163,5.67163-5.67163-5.67163,5.67163-5.67151Z"
			},
			children: [
			]
		}
	]
};
var settings = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.512,11.34352a7.05091,7.05091,0,0,0-.003-1.087l1.978-1.465-1.124-2.713-2.435.362a6.65944,6.65944,0,0,0-.769-.77l.362-2.434-2.712-1.124-1.466,1.978a6.80373,6.80373,0,0,0-1.087.001L8.789,2.1125l-2.713,1.124.363,2.435a6.58284,6.58284,0,0,0-.77.769l-2.433-.363L2.111,8.79152l1.977,1.465a6.81685,6.81685,0,0,0,.001,1.088l-1.978,1.465,1.124,2.713,2.435-.363a6.65944,6.65944,0,0,0,.769.77l-.362,2.434,2.713,1.124,1.46594-1.977a6.57621,6.57621,0,0,0,1.087-.001l1.467,1.978,2.713-1.124-.363-2.435a6.67208,6.67208,0,0,0,.771-.769l2.434.362,1.124-2.713Zm.147,2.93695-2.211-.329-.201.263a5.615,5.615,0,0,1-1.034,1.032l-.264.202.33,2.212-1.09.452-1.332-1.797-.328.044a5.591,5.591,0,0,1-1.462.001l-.328-.044-1.331,1.796-1.09-.452.329-2.211-.264-.202a5.61476,5.61476,0,0,1-1.032-1.034l-.201-.263-2.211.33-.452-1.09,1.797-1.331-.044-.329a5.6206,5.6206,0,0,1-.001-1.46l.044-.329-1.796-1.331.452-1.09,2.211.329.201-.263a5.61531,5.61531,0,0,1,1.034-1.032l.264-.202-.33-2.213,1.09-.452,1.332,1.797.328-.043a5.62811,5.62811,0,0,1,1.461-.001l.328.043,1.331-1.796,1.09.452-.329,2.211.264.202a5.61323,5.61323,0,0,1,1.032,1.034l.201.263,2.212-.329.452,1.09-1.797,1.331.043.329a5.626,5.626,0,0,1,.001,1.461l-.044.329,1.797,1.331Zm-6.777-7.195a3.673,3.673,0,1,0,3.673,3.673A3.673,3.673,0,0,0,10.882,7.08546Zm0,6.221a2.548,2.548,0,1,1,2.548-2.548A2.55087,2.55087,0,0,1,10.882,13.30647Z"
			},
			children: [
			]
		}
	]
};
var share = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.425,13.05a3.36091,3.36091,0,0,0-2.716,1.388l-5.32-2.66a3.05077,3.05077,0,0,0,0-1.956l5.32-2.66a3.36259,3.36259,0,1,0-.659-1.987,3.32889,3.32889,0,0,0,.16095.978l-5.32,2.66a3.375,3.375,0,1,0,0,3.974l5.32,2.66a3.33989,3.33989,0,0,0-.16095.978,3.375,3.375,0,1,0,3.375-3.375Zm0-10.125a2.25,2.25,0,1,1-2.25,2.25A2.25214,2.25214,0,0,1,16.425,2.925ZM5.175,13.05a2.25,2.25,0,1,1,2.25-2.25A2.25207,2.25207,0,0,1,5.175,13.05Zm11.25,5.625a2.25,2.25,0,1,1,2.25-2.25A2.25207,2.25207,0,0,1,16.425,18.675Z"
			},
			children: [
			]
		}
	]
};
var shipping = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.18,4.05H1.8V15.3H2.93a2.25,2.25,0,0,0,4.5,0h6.75a2.25,2.25,0,0,0,4.5,0H19.8V10.8Zm-9,12.38A1.13,1.13,0,1,1,6.3,15.3,1.14,1.14,0,0,1,5.18,16.43Zm11.25,0a1.13,1.13,0,1,1,1.12-1.13A1.14,1.14,0,0,1,16.43,16.43Zm2.25-2.25h-.32a2.22,2.22,0,0,0-3.87,0H7.11a2.22,2.22,0,0,0-3.87,0H2.93v-9H13.65l5,6Z"
			},
			children: [
			]
		}
	]
};
var shock = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9,14.46l3.31,1.89-.53.93-1.7-1v3.5L7.76,17.11,5.42,19.8V16.18H1.8l2.69-2.34L1.8,11.49H5.42V9.3H6.49v3.26H4.66l1.47,1.28L4.66,15.11H6.49v1.83l1.27-1.47L9,16.94ZM19.8,5.34v7.07L13.61,16,9,13.33v-.88H8.14v-.92H7.43V5.34L13.61,1.8ZM9.12,5.66l1.67,1,4.49-2.57-1.67-1ZM13.05,9.2,8.55,6.63v3.78h.71v.92h.89v1.35l2.9,1.66Zm.56-1L18.1,5.66l-1.69-1L11.92,7.26Zm5.07-1.6L14.18,9.2v5.14l4.5-2.58Z"
			},
			children: [
			]
		}
	]
};
var shopping = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.63887,4.5507H5.74775L5.40107,2.85831,2.3249,1.79972,1.96113,2.85807l2.47217.85059L6.91719,15.84281a2.10574,2.10574,0,1,0,3.02588,2.43836h4.41406a2.112,2.112,0,1,0,0-1.18689H9.94307a2.104,2.104,0,0,0-1.937-1.51185l-.38378-1.87524,11.08691-1.32935Zm-3.26465,12.213a.924.924,0,1,1-.92438.924A.924.924,0,0,1,16.37422,16.76371Zm-8.44861,0H7.926a.92414.92414,0,1,1-.00037,0Zm9.77576-5.392L7.39711,12.60722,5.97676,5.66959h12.4024Z"
			},
			children: [
			]
		}
	]
};
var snooze = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.44074,3.4778,12.73463,10.309H19.429V12H10.3578V10.309l6.71148-6.81811h-6.699V1.8h9.07043ZM16.46913,14.28242H11.7082v1.42676h2.71759l-2.72418,2.66406V19.8h4.76166V18.37324H13.74568l2.72564-2.67ZM2.16877,8.40449h4.7514L2.15925,13.35621v1.691H9.24006v-1.691H4.51124L9.24958,8.39186V6.71357H2.16877Z"
			},
			children: [
			]
		}
	]
};
var sos = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M3.49784,14.00283a2.62065,2.62065,0,0,1-.89613-.412,1.93729,1.93729,0,0,1-.58224-.681A2.08533,2.08533,0,0,1,1.8,11.97358H3.39467a.91748.91748,0,0,0,.36749.69926,1.56006,1.56006,0,0,0,.887.21511,1.97054,1.97054,0,0,0,.38062-.03646,1.08493,1.08493,0,0,0,.327-.11594.69.69,0,0,0,.233-.21073.5308.5308,0,0,0,.08968-.30916.50839.50839,0,0,0-.09406-.31354A.75317.75317,0,0,0,5.312,11.687a2.22647,2.22647,0,0,0-.439-.15677q-.25977-.06672-.59135-.148-.4211-.09843-.82869-.22385a2.77911,2.77911,0,0,1-.73025-.34052,1.72667,1.72667,0,0,1-.52427-.54686,1.57742,1.57742,0,0,1-.20161-.8327,1.859,1.859,0,0,1,.19724-.883,1.73921,1.73921,0,0,1,.53775-.61323A2.36179,2.36179,0,0,1,3.538,7.58332a4.14791,4.14791,0,0,1,1.00368-.11667,3.76959,3.76959,0,0,1,.972.121,2.39934,2.39934,0,0,1,.78859.36312,1.80876,1.80876,0,0,1,.53775.614,2.042,2.042,0,0,1,.22823.87354H5.51834a.79307.79307,0,0,0-.31354-.57385,1.18743,1.18743,0,0,0-.71713-.19687,1.20671,1.20671,0,0,0-.67191.16551.50141.50141,0,0,0-.25084.43458.4227.4227,0,0,0,.09407.28219.74158.74158,0,0,0,.27343.1925,2.62345,2.62345,0,0,0,.45244.148c.18193.04521.39266.09407.63145.148q.4479.10719.85567.24208a2.69,2.69,0,0,1,.7215.358,1.6922,1.6922,0,0,1,.50167.56437,1.74586,1.74586,0,0,1,.18812.85166,1.90777,1.90777,0,0,1-.20161.891,1.87688,1.87688,0,0,1-.55562.654,2.55664,2.55664,0,0,1-.83307.40323,3.70559,3.70559,0,0,1-1.035.13927A4.524,4.524,0,0,1,3.49784,14.00283Zm6.02066-.11156a2.819,2.819,0,0,1-.9942-.69927,3.16451,3.16451,0,0,1-.63182-1.06165,4.06509,4.06509,0,0,1,0-2.6607A3.16451,3.16451,0,0,1,8.5243,8.408a2.82827,2.82827,0,0,1,.9942-.69927,3.56022,3.56022,0,0,1,2.62534,0,2.87377,2.87377,0,0,1,.99895.69927A3.12719,3.12719,0,0,1,13.779,9.46965a4.05892,4.05892,0,0,1,0,2.6607,3.12719,3.12719,0,0,1-.63619,1.06165,2.86419,2.86419,0,0,1-.99895.69927,3.56022,3.56022,0,0,1-2.62534,0Zm1.99826-1.19655a1.42784,1.42784,0,0,0,.48817-.42948,1.87985,1.87985,0,0,0,.2913-.64968,3.58274,3.58274,0,0,0,0-1.63112,1.92784,1.92784,0,0,0-.2913-.65406,1.42251,1.42251,0,0,0-2.32929,0A1.98445,1.98445,0,0,0,9.38,9.98444a3.41548,3.41548,0,0,0,0,1.63112,1.93409,1.93409,0,0,0,.29568.64968,1.42464,1.42464,0,0,0,.48817.42948,1.53791,1.53791,0,0,0,1.35295,0Zm4.49782,1.30811a2.62079,2.62079,0,0,1-.89614-.412,1.93726,1.93726,0,0,1-.58223-.681,2.08533,2.08533,0,0,1-.21948-.93624H15.9114a.91751.91751,0,0,0,.3675.69926,1.56,1.56,0,0,0,.887.21511,1.97061,1.97061,0,0,0,.38062-.03646,1.08493,1.08493,0,0,0,.327-.11594.69.69,0,0,0,.233-.21073.53081.53081,0,0,0,.08969-.30916.50839.50839,0,0,0-.09406-.31354.75321.75321,0,0,0-.27344-.2151,2.22624,2.22624,0,0,0-.439-.15677q-.25977-.06672-.59135-.148-.42108-.09843-.82869-.22385a2.77926,2.77926,0,0,1-.73025-.34052,1.72674,1.72674,0,0,1-.52426-.54686,1.57732,1.57732,0,0,1-.20162-.8327,1.85907,1.85907,0,0,1,.19724-.883,1.73914,1.73914,0,0,1,.53776-.61323,2.36173,2.36173,0,0,1,.80608-.35874,4.148,4.148,0,0,1,1.00369-.11667,3.76959,3.76959,0,0,1,.972.121,2.39919,2.39919,0,0,1,.78858.36312,1.80879,1.80879,0,0,1,.53776.614,2.042,2.042,0,0,1,.22822.87354H18.03508a.79307.79307,0,0,0-.31354-.57385,1.18747,1.18747,0,0,0-.71713-.19687,1.20672,1.20672,0,0,0-.67192.16551.50142.50142,0,0,0-.25083.43458.4227.4227,0,0,0,.09406.28219.74163.74163,0,0,0,.27344.1925,2.62316,2.62316,0,0,0,.45244.148c.18192.04521.39265.09407.63145.148q.44789.10719.85567.24208a2.69025,2.69025,0,0,1,.7215.358,1.69217,1.69217,0,0,1,.50166.56437,1.74575,1.74575,0,0,1,.18812.85166,1.90777,1.90777,0,0,1-.20161.891,1.87667,1.87667,0,0,1-.55562.654,2.55659,2.55659,0,0,1-.83306.40323,3.7057,3.7057,0,0,1-1.035.13927A4.52389,4.52389,0,0,1,16.01458,14.00283Z"
			},
			children: [
			]
		}
	]
};
var sound = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,8.8H2.93v4H1.8ZM6,17.8H7.14V3.8H6Zm4.22-5h1.12v-4H10.24Zm4.22,3h1.12V5.8H14.46Zm4.22-7v4H19.8v-4Z"
			},
			children: [
			]
		}
	]
};
var speed = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.60261,8.78468a6.55344,6.55344,0,0,0-4.2041-2.067V6.25355a2.24983,2.24983,0,1,0-.93555-.00018v.4505A6.51681,6.51681,0,0,0,7.21882,7.75209V7.752l-.48-.6153.59522-.46393-.68653-.88031L4.57722,7.40687l.686.88031L5.8589,7.823l.48193.61829a6.55355,6.55355,0,1,0,9.26178.34344ZM9.61726,4.054a1.3135,1.3135,0,1,1,1.78125,1.21905V4.15138H10.463V5.273A1.30831,1.30831,0,0,1,9.61726,4.054ZM10.795,18.68837a5.4426,5.4426,0,1,1,5.44239-5.44275v.00012A5.44856,5.44856,0,0,1,10.795,18.68837Zm3.04529-8.24762.63867.9154-3.3645,2.34729-.63867-.91546Z"
			},
			children: [
			]
		}
	]
};
var stadium = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.79164,5.836a19.30594,19.30594,0,0,0-4.90082.60218V4.95462l2.50732-1.0642L4.76973,1.80155V2.7742H4.76582v4.019C2.95045,7.45859,1.8,8.4014,1.8,9.40488l-.00055,6.97888c0,1.88672,4.04285,3.4162,8.99219,3.4162,4.9494,0,9.00824-1.52948,9.00824-3.4162L19.8,9.40506V9.40488C19.8,7.51822,15.741,5.836,10.79164,5.836Zm.57086,1.13727a17.38613,17.38613,0,0,1,4.16815.59064L14.58021,9.331a20.30918,20.30918,0,0,0-3.21771-.32386Zm5.305,4.10321a12.15662,12.15662,0,0,1-2.07568.60718l.57819-1.075A11.17576,11.17576,0,0,1,16.66755,11.07645Zm-5.305-.94446a19.60042,19.60042,0,0,1,2.65662.24225l-.82569,1.53516c-.573.06848-1.18585.11175-1.83093.12927Zm-1.125-3.1593V9.00876a20.39286,20.39286,0,0,0-3.14673.32453l-.928-1.80646A17.44646,17.44646,0,0,1,10.2375,6.97269Zm0,3.161v1.90625c-.64905-.01562-1.24994-.06524-1.82349-.13092l-.782-1.52228A19.58181,19.58181,0,0,1,10.2375,10.1337ZM7.04084,11.69828a12.02566,12.02566,0,0,1-2.11853-.603,11.59789,11.59789,0,0,1,1.56482-.47485ZM2.925,9.40488c0-.36542.74054-1.00073,2.15082-1.5318l.87872,1.71057a10.49381,10.49381,0,0,0-2.27722.85163c-.48157-.3479-.743-.70752-.743-1.03022H2.925Zm10.06055,9.15979a21.84922,21.84922,0,0,1-2.19391.11029,21.76328,21.76328,0,0,1-2.17621-.109V16.30448a23.16871,23.16871,0,0,0,4.37012,0Zm5.68933-2.18091c0,.50269-1.5813,1.55371-4.56433,2.03723V15.0369l-.63379.08105a21.86176,21.86176,0,0,1-5.35254,0l-.63379-.082v3.38672c-2.98383-.48272-4.566-1.53558-4.566-2.03876l.00043-5.09112c1.63025,1.23151,4.8042,1.88281,7.85022,1.88281,3.09985,0,6.26867-.69049,7.89984-1.9107Zm.00012-6.9787c0,.31348-.26691.66779-.7536,1.01319a10.26279,10.26279,0,0,0-2.20068-.83344l.895-1.66412C17.94465,8.43461,18.675,9.0358,18.675,9.40488Z"
			},
			children: [
			]
		}
	]
};
var stakeholder = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,10.8A3.375,3.375,0,1,0,7.425,7.425,3.37494,3.37494,0,0,0,10.8,10.8Zm0-5.625a2.25,2.25,0,1,1-2.25,2.25A2.25207,2.25207,0,0,1,10.8,5.175Zm6.75,11.25V14.77a9.98269,9.98269,0,0,0-13.5,0v1.655H1.8V17.55h18V16.425Zm-1.125.001H5.175V15.288a8.84023,8.84023,0,0,1,11.25.001Z"
			},
			children: [
			]
		}
	]
};
var star = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_4",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,1.9L8.6,8.5H1.8l5.5,4.3l-2.1,6.9l5.6-4.3l5.6,4.3l-2.2-6.9l5.6-4.3h-6.9L10.8,1.9z"
			},
			children: [
			]
		}
	]
};
var steps = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12.13432,17.21179a2.58524,2.58524,0,1,0,5.17048,0v-1.959H12.13432Zm1.13976-.8192h2.891v.8192a1.44548,1.44548,0,1,1-2.891,0ZM4.31627,13.80438a2.58487,2.58487,0,1,0,5.16974,0v-1.959H4.31627Zm1.13976-.8192H8.34624v.8192a1.44511,1.44511,0,1,1-2.89021,0ZM5.09753,2.63383a5.59732,5.59732,0,0,0-1.21544,4.079,25.71741,25.71741,0,0,0,.45635,3.722l.112.42519H9.44733l.08162-.47342a33.60546,33.60546,0,0,0,.38957-3.93351A5.49773,5.49773,0,0,0,8.65484,2.58114,2.36361,2.36361,0,0,0,5.09753,2.63383Zm3.38,7.0864H5.36021c-.08014-.489-.21073-1.44325-.34133-3.098a4.48346,4.48346,0,0,1,.91567-3.21449,1.20459,1.20459,0,0,1,1.89812-.0371,4.38787,4.38787,0,0,1,.94757,3.0364C8.72236,7.831,8.5695,9.07392,8.47749,9.72023Zm7.98872-3.73242a2.3604,2.3604,0,0,0-3.5573.05343,5.59261,5.59261,0,0,0-1.214,4.07821,26.20072,26.20072,0,0,0,.45413,3.722l.1113.42593h4.99982l.08014-.47342a33.52755,33.52755,0,0,0,.39179-3.93425A5.5057,5.5057,0,0,0,16.46621,5.98781Zm-.1766,7.13984H13.17307c-.08162-.48975-.21074-1.444-.34133-3.09873a4.483,4.483,0,0,1,.91418-3.21448A1.20506,1.20506,0,0,1,15.644,6.77733a4.38813,4.38813,0,0,1,.94832,3.0364C16.53448,11.23843,16.38162,12.48059,16.28961,13.12765Z"
			},
			children: [
			]
		}
	]
};
var stop = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,1.8a9,9,0,1,0,9,9A9,9,0,0,0,10.8,1.8Zm0,16.88a7.88,7.88,0,1,1,7.88-7.88A7.89,7.89,0,0,1,10.8,18.68ZM6.86,14.74h7.88V6.86H6.86ZM8,8h5.62v5.62H8Z"
			},
			children: [
			]
		}
	]
};
var support = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "ee26bdc4-7664-4c98-a495-cc9f16e1f58e",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,10.75h0a9,9,0,1,0-9,9.07V18.68a7.9,7.9,0,0,1-7-4.2l2.35-.41L5.4,9.61,3,10a7.88,7.88,0,0,1,15.68,0L16.26,9.6l-.78,4.47,3.62.64.69-3.91h0Zm-15.31.16.39,2.25-1.41.25-.39-2.25Zm13.7,2.49-1.41-.24.4-2.25,1.4.25Z"
			},
			children: [
			]
		}
	]
};
var survey = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9.7,10.8h3.4V7.4H9.7V10.8z M10.8,8.6h1.1v1.1h-1.1V8.6z M9.7,15.3h3.4v-3.4H9.7V15.3z M10.8,13.1h1.1v1.1h-1.1V13.1z\n\t M11.9,2.9h-1.1V1.8H6.3v1.1H5.2V4H1.8v15.7h13.5V4.1h-3.4V2.9z M6.3,4.1h1.1V2.9h2.2V4h1.1v1.1H6.3V4.1z M14.2,5.2v13.5H2.9V5.2\n\th2.3v1.1H12V5.2H14.2z M16.4,4.1v9l1.6,3.2l1.7-3.2v-9C19.7,4.1,16.4,4.1,16.4,4.1z M18.7,12.8l-0.6,1.1l-0.5-1.1V5.2h1.1V12.8z\n\t M4.1,7.4h4.5v1.1H4.1V7.4z M4.1,11.9h4.5V13H4.1V11.9z"
			},
			children: [
			]
		}
	]
};
var swipe = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.65,10H12.58L12,5.18A1.48,1.48,0,0,0,9,5.38v8c0,.14,0,.14-.23.12L8,12.77a2.72,2.72,0,0,0-3.75,0l-.42.42,5,5a5.14,5.14,0,0,0,3.72,1.6,4.58,4.58,0,0,0,.64,0c3.4-.39,4.49-3.75,4.49-5.32V12.05A2.09,2.09,0,0,0,15.65,10Zm.9,4.48c0,.79-.58,3.81-3.45,4.15a3.93,3.93,0,0,1-3.37-1.22l-4.1-4.1a1.5,1.5,0,0,1,1.57.34l.77.76a1.3,1.3,0,0,0,.89.35,1.26,1.26,0,0,0,1-.36,1.38,1.38,0,0,0,.38-1v-8c0-.31.54-.35.58,0l.77,5.8h4.1a.9.9,0,0,1,.9.91Zm-8-7.18a2.53,2.53,0,0,1-.66-1.72,2.56,2.56,0,0,1,5.12,0,2.46,2.46,0,0,1-.14.86L14,6.79A3.74,3.74,0,1,0,7.65,8.05Z"
			},
			children: [
			]
		}
	]
};
var sync = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.78242,11.03535a8.74277,8.74277,0,0,1-15.4707,5.5874v2.54932h-1.125V14.63789H7.70039v1.125H5.05848a7.62075,7.62075,0,0,0,13.59894-4.72754ZM10.56465,2.94258a7.59722,7.59722,0,0,1,6.02057,2.96777H13.89961v1.125h4.51367V2.5002h-1.125V4.97737a8.7427,8.7427,0,0,0-15.4707,5.58728h1.125A7.63031,7.63031,0,0,1,10.56465,2.94258Z"
			},
			children: [
			]
		}
	]
};
var tablet = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,4.05v13.5h18V4.05ZM2.93,5.18H15.86V16.43H2.93ZM18.68,16.43H17v-4.5h1.12V9.68H17V5.18h1.69Z"
			},
			children: [
			]
		}
	]
};
var tag = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12.31,1.8,1.8,12.31,9.29,19.8,19.8,9.29V1.8Zm6.36,7L9.29,18.21l-5.9-5.9,9.39-9.38h5.89ZM14.17,6.3A1.13,1.13,0,1,1,15.3,7.43,1.13,1.13,0,0,1,14.17,6.3Z"
			},
			children: [
			]
		}
	]
};
var talking = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		width: "21.6",
		height: "21.6",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					name: "",
					type: "text",
					value: "talking-blk",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9.043,11.801A3.3145,3.3145,0,1,0,5.729,8.486,3.31392,3.31392,0,0,0,9.043,11.801Zm0-5.504a2.1895,2.1895,0,1,1-2.19,2.189A2.1915,2.1915,0,0,1,9.043,6.297Zm-6.85,9.116v3.282H15.45V15.413a9.80492,9.80492,0,0,0-13.257,0ZM14.325,17.57H3.318V15.931a8.66026,8.66026,0,0,1,11.008,0V17.57Zm.397-12.325a4.70592,4.70592,0,0,1,0,6.648l-.795-.795a3.58029,3.58029,0,0,0,0-5.057Zm2.342,8.989-.795-.795a6.89441,6.89441,0,0,0,0-9.739l.795-.795A8.01882,8.01882,0,0,1,17.064,14.234Z"
			},
			children: [
			]
		}
	]
};
var taxes = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.1,11.9h1.7a8.87727,8.87727,0,0,0-8.4-8.88324V1.8H10.2V3a8.825,8.825,0,0,0-8.4,8.9H3.5v6.8H1.8v1.1h18V18.7H18.1ZM3,10.8a7.90722,7.90722,0,0,1,7.8-6.74407A7.81994,7.81994,0,0,1,18.6,10.8Zm5,7.9H4.6V11.9H8Zm4.5,0H9.1V11.9h3.4Zm4.5,0H13.6V11.9H17Z"
			},
			children: [
			]
		}
	]
};
var technology = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.27,7.67H7.33v6.94h6.94Zm-1.06,5.88H8.39V8.73h4.82Zm6.35-7.88V4.61H17.11V1.8H16.05V4.61h-2.9V1.8H12.09V4.61H9.26V1.8H8.2V4.61H5.42V1.8H4.36V4.61H2V5.67H4.36V8.46H2V9.52H4.36v2.82H2V13.4H4.36v2.91H2v1.06H4.36v2.39H5.42V17.48H8.2V19.8H9.26V17.48h2.83V19.8h1.06V17.48h2.9v2.28h1.06V17.37h2.45V16.31H17.11V13.4h2.45V12.34H17.11V9.52h2.45V8.46H17.11V5.67ZM16.05,16.42H5.42V5.67H16.05Z"
			},
			children: [
			]
		}
	]
};
var teletype = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M4.68,14.23H2.33V11.81H4.68ZM8.3,11.81H6v2.42H8.3Zm3.57,0H9.52v2.42h2.35Zm3.62,0H13.14v2.42h2.35Zm1.27,2.42h2.35V11.77H16.76ZM3.77,18H6.13V15.53H3.77Zm3.62,0H9.75V15.53H7.39Zm3.58,0h2.35V15.49H11Zm3.62,0h2.35V15.49H14.59ZM19.75,6.19l-.44,4.35H14.18l-.77-2.19A14.86,14.86,0,0,0,10.72,8a19.36,19.36,0,0,0-2.49.28l-.75,2.27-5.11-.05L1.89,7l0-.37s4.33-3.08,9-3A20.42,20.42,0,0,1,19.75,6.19Zm-1.12.57A18.17,18.17,0,0,0,10.81,4.7,15.43,15.43,0,0,0,3,7.13L3.29,9.5l3.43,0,.71-2.13.3-.06a20.87,20.87,0,0,1,3-.36,17.59,17.59,0,0,1,3.22.38l.29.06.73,2.05h3.43Z"
			},
			children: [
			]
		}
	]
};
var temperature = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13.02009,13.44177V4.01623a2.22009,2.22009,0,0,0-4.44018,0v9.42554a3.56632,3.56632,0,1,0,4.44018,0Zm-2.22,5.22949a2.43958,2.43958,0,0,1-1.519-4.35l.42383-.33778v-1.761h.91358V11.0979H9.70491v-.81043h.91357V9.16284H9.70491V8.35229h.91357V7.22766H9.70491V6.417h.91357V5.29223H9.70491v-1.276a1.0951,1.0951,0,1,1,2.19018-.00672v9.974l.42359.33777a2.43945,2.43945,0,0,1-1.51855,4.35Z"
			},
			children: [
			]
		}
	]
};
var template = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,2.92V18.68h18V2.92ZM18.68,4V6.3H2.93V4ZM2.93,7.42h4.5V17.56H2.93ZM8.55,17.55V7.42H18.68V17.56Z"
			},
			children: [
			]
		}
	]
};
var theme = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13.41021,5.47738v.00044L11.90572,3.97334l-3.05021,3.048L7.01481,5.17567l.325-.325L4.28961,1.8,1.807,4.28267,4.85716,7.33332l.33757-.33756L7.03453,8.8405,3.97312,11.89922,5.48163,13.4064,5.47805,13.41l6.39,6.39,7.925-7.93216Zm-8.553.39539L3.2675,4.28267,4.28961,3.26055,5.87927,4.85066ZM5.925,6.26548,6.28453,5.906,8.12479,7.75114l-.35953.35953Zm-.49044,5.63374L7.76391,9.57167l.00538.00538L9.58938,7.757l-.00449-.00448,2.32083-2.31859.77376.77421L6.20832,12.673ZM6.9386,13.41l6.47161-6.47116,4.92319,4.929-.99931,1.0001-1.74158-1.74158-.72982.72983L16.6046,13.5981l-1.08028,1.08118-3.12457-3.12614-.72983.72982,3.12485,3.12648-1.08589,1.08673L11.48074,14.268l-.73028.72983,2.22888,2.22848-1.11127,1.11222Z"
			},
			children: [
			]
		}
	]
};
var ticket = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,9.24614V5.4965l-.007-.007H8.8882l.00244.00947a.84208.84208,0,1,1-1.68415.0014V5.499L7.209,5.48954H1.8v3.7566a1.5485,1.5485,0,0,1,1.54565,1.55133V10.8A1.55006,1.55006,0,0,1,1.8,12.3538v3.75666H7.209l-.00244-.01423a.84207.84207,0,0,1,1.68414,0l-.00244.01423H19.8V12.3538a1.55385,1.55385,0,0,1,0-3.10766Zm-1.116-.87a2.67264,2.67264,0,0,0,0,4.84772v1.77063H9.667a1.95577,1.95577,0,0,0-3.23663,0H2.916V13.22361a2.673,2.673,0,0,0,0-4.84729V6.60551H6.43251a1.95464,1.95464,0,0,0,3.23211,0H18.684ZM8.52028,8.9174v.00006a.558.558,0,1,1,0-.00006Zm0,1.882v.00006a.558.558,0,1,1,0-.00006Zm0,1.882v.00006a.558.558,0,1,1,0-.00006Z"
			},
			children: [
			]
		}
	]
};
var tiles = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.39,15.72h0V1.8H5.21V15.72h0v1.12h0v3H16.39v-3h0ZM6.33,2.93h8.94V15.72H6.33Zm8.94,15.75H6.33V16.84H9.66V18h2.28V16.84h3.33Zm-1.85-6.41L10.79,14.9l-2.6-2.61.79-.8,1.81,1.81,1.83-1.83Z"
			},
			children: [
			]
		}
	]
};
var tilt = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.79,8.27a6.13,6.13,0,0,1-3.33,5.46l-.51-1a5,5,0,0,0-4.52-8.94l.51,1.07L8.56,4.6l1.91-2.8.48,1a6,6,0,0,1,2.7-.64A6.14,6.14,0,0,1,19.79,8.27ZM12.57,19.8h4.5V18.68h-4.5Zm3-5.52-5.06,5L3.65,17.49,1.81,10.65l5.06-5,6.89,1.81ZM10.33,7.71,6.65,11.35l1.89.49L12.21,8.2Zm-6.8,2.81L5.39,11,9.06,7.37,7.21,6.88Zm6,7.36L8.25,12.93l-5-1.32,1.33,4.95Zm1.09-.29,3.68-3.65L13,9,9.34,12.64Z"
			},
			children: [
			]
		}
	]
};
var timer = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.16277,17.16278A8.99871,8.99871,0,0,1,1.8,10.79988H2.925A7.87373,7.87373,0,1,0,10.79986,2.925V5.98345h-1.125V1.8h1.125a8.99866,8.99866,0,0,1,6.36291,15.36277ZM12.796,10.67967a2.25285,2.25285,0,1,1-4.5057,0c0-.01364.00375-.02619.004-.03973L2.925,9.13044,3.22948,8.052l5.3683,1.5106A2.24594,2.24594,0,0,1,12.796,10.67967Zm-1.05,0a1.20285,1.20285,0,1,0-1.20289,1.20289A1.20421,1.20421,0,0,0,11.746,10.67967Z"
			},
			children: [
			]
		}
	]
};
var tools = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.4,7,18,6.14l1.78-2.91-1.4-1.4L15.45,3.61,14.6,6.22,8,12.79,6.84,11.6l-5,5L5,19.78l5-5-1.19-1.2Zm1-2.63,1.79-1.22.27.28L17.2,5.24l-1.26.42ZM5,18.19,3.43,16.6l3.41-3.41,1.59,1.59ZM3.12,9.48A4.49,4.49,0,0,1,2.43,4L5.5,7.09,7.09,5.5,4,2.43a4.62,4.62,0,0,1,2.3-.62A4.43,4.43,0,0,1,9.48,3.12a4.48,4.48,0,0,1,1.15,4.33l.66.66-.79.8L9.38,7.79a3.7,3.7,0,0,0-.7-3.88,3.3,3.3,0,0,0-2.56-1L8.68,5.5c.11-.1-3,3-3.18,3.19C5.67,8.85,3,6.22,2.94,6.12a3.36,3.36,0,0,0,1,2.57c1.43,1.42,2.79.94,3.88.69L8.91,10.5l-.8.79-.66-.66a4.71,4.71,0,0,1-1.18.15A4.44,4.44,0,0,1,3.12,9.48Zm16.67,7.13-3.18,3.18-6.29-6.28.8-.8,5.49,5.49,1.59-1.59-5.49-5.49.8-.79Z"
			},
			children: [
			]
		}
	]
};
var traffic = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M6.8,10.8c0,0.6-0.4,1-1,1s-1-0.4-1-1s0.4-1,1-1S6.8,10.2,6.8,10.8z M14.8,10.8c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1s-0.4-1-1-1\n\tS14.8,10.2,14.8,10.8z M19.8,9.8c0,0.5-0.4,1-0.9,1h-0.1v8h-4v-2.3h-8v2.3h-4v-8c-0.5,0-1-0.4-1-0.9V9.8c0-0.5,0.4-1,0.9-1h0.1h0.5\n\tl0.9-4.1c0.3-1.1,1.3-1.9,2.5-1.9h8.2c1.2,0,2.2,0.8,2.5,1.9l0.9,4.1h0.5c0.5,0,1,0.4,1,0.9C19.8,9.7,19.8,9.8,19.8,9.8z M5.7,16.5\n\tH3.9v1.2h1.8V16.5z M17.7,16.5h-1.8v1.2h1.8V16.5z M17.7,11.1l-1.4-6.2c-0.2-0.6-0.8-1.1-1.4-1H6.7c-0.6-0.1-1.2,0.4-1.4,1l-1.4,6.2\n\tv4.2h13.8V11.1z"
			},
			children: [
			]
		}
	]
};
var transportation = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.7133102,9.8199997l-1.5808496-2.9015999h-3.5419998V5.5976701\n\tc-0.0066061-0.5016356-0.1991272-0.9829731-0.5402803-1.3508c-0.3543558-0.3387048-0.8309231-0.5192215-1.3207502-0.5002799V4.86728\n\tc0.3736839-0.0347891,0.7048168,0.2399392,0.7396059,0.6136227c0.0036144,0.0388274,0.0038805,0.0778942,0.0007944,0.1167674\n\tv5.3730006l-0.0100002,3.6520805H9.5492897c-0.6429415-0.9142885-1.9035182-1.1377935-2.8216-0.5002804\n\tc-0.190846,0.1407967-0.3594837,0.3094339-0.5002799,0.5002804H5.487c-0.6492939-0.914547-1.917037-1.1295776-2.831584-0.4802837\n\ts-1.1295772,1.917038-0.4802835,2.8315849s1.9170372,1.1295757,2.8315842,0.4802837\n\tc0.000011-0.0000095,0.0000224-0.0000172,0.0000334-0.0000248c0.532115-0.3863487,0.8480392-1.003334,0.8504601-1.6609097\n\tv-0.0500002h0.0100002c0,0.0200005-0.0100002,0.0299997-0.0100002,0.0500002\n\tc0.0024929,1.1217709,0.9138885,2.0291233,2.0356588,2.0266304c1.118247-0.0024834,2.0241461-0.9083843,2.0266314-2.0266304\n\tv-0.0500002h4.7827206v0.0500002c0.0005474,1.1217785,0.9103727,2.0307159,2.0321522,2.0301685\n\tc1.1171017-0.0005455,2.0240917-0.9030838,2.030138-2.0201683v-0.0600004h1.0405693V9.8199997H16.7133102z M3.8260901,16.7039108\n\tc-0.5028663,0.0000172-0.9105337-0.4076233-0.9105504-0.91049c-0.0000167-0.5028658,0.4076235-0.910533,0.9104898-0.9105501\n\tc0.5028665-0.0000162,0.9105337,0.4076233,0.9105504,0.91049c0,0.0000229,0,0.0000467,0,0.0000696\n\tC4.7347374,16.2955132,4.3281732,16.7020741,3.8260901,16.7039108z M7.8883801,16.7039108\n\tc-0.5028663,0.0000172-0.9105334-0.4076233-0.9105501-0.91049s0.4076238-0.9105339,0.91049-0.9105501\n\ts0.9105339,0.4076242,0.9105501,0.91049c0,0.0000229,0,0.0000467,0,0.0000696\n\tC8.7970276,16.2955132,8.3904629,16.7020741,7.8883801,16.7039108z M16.7333794,16.7039108\n\tc-0.5028667-0.0000153-0.9105072-0.4076824-0.910491-0.9105492s0.4076834-0.9105072,0.9105501-0.910491\n\tc0.5028648,0.0000162,0.9105053,0.4076834,0.91049,0.9105492c0,0.0000038,0,0.0000067,0,0.0000105\n\tc-0.0018158,0.5021324-0.4084568,0.9087257-0.9105892,0.9104805H16.7333794z M18.6844902,14.6227808h-0.2901402\n\tc-0.647644-0.9173117-1.9162922-1.1359205-2.8336039-0.4882765c-0.1894093,0.1337271-0.3545494,0.2988672-0.4882765,0.4882765\n\th-3.4820004V8.0390501h2.8816299l1.2607203,2.3213205l0.3201895,0.5802803h2.6314907L18.6844902,14.6227808z"
			},
			children: [
			]
		}
	]
};
var trash = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M5.18,19.8H16.43V6.3H5.18ZM6.3,7.43h9V18.68h-9Zm6.75-3.38V1.8H8.55V4.05H4.05V5.18h13.5V4.05Zm-1.12,0H9.68V2.93h2.25ZM8.24,16.43H9.36V9.68H8.24Zm4,0h1.12V9.68H12.24Z"
			},
			children: [
			]
		}
	]
};
var trumpet = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,5.6c-1.7,1.8-3.9,3.1-6.3,3.6c0,0-8.4,0-8.5,0C4.1,9.2,3.3,8.7,2.8,8C2.7,7.8,2.3,7.7,2.1,7.9C1.9,8,1.8,8.1,1.8,8.3\n\tv3c0,0.2,0.2,0.5,0.4,0.5c0.1,0,0.1,0,0.2,0c0.2,0,0.4-0.1,0.5-0.3c0.5-0.7,1.3-1.2,2.2-1.2h0c0.1,0,1.1,0,1.1,0\n\tc-1.2,1.4-1.1,3.5,0.2,4.7C6.9,15.7,7.8,16,8.6,16H12c1.9,0,3.4-1.5,3.4-3.3c0-0.7-0.2-1.3-0.6-1.8c1.9,0.7,3.6,1.8,5,3.2L19.8,5.6\n\tL19.8,5.6z M12,14.9H8.6c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2c0,0,0,0,0,0H12c1.2,0,2.2,1,2.2,2.2C14.2,13.9,13.2,14.9,12,14.9\n\tz M18.7,11.5c-1-0.7-2.1-1.3-3.2-1.7c1.1-0.4,2.2-1,3.2-1.7V11.5z"
			},
			children: [
			]
		}
	]
};
var tv = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,4.61H1.8V15.86H7.43L8,17h5.62l.56-1.13H19.8ZM18.68,14.74H2.93v-9H18.68Z"
			},
			children: [
			]
		}
	]
};
var twitter = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,5.25A8.13,8.13,0,0,1,18,7.15v.5A10.36,10.36,0,0,1,7.6,18.05a10.29,10.29,0,0,1-5.8-1.9,2.77,2.77,0,0,0,.9.1,7.27,7.27,0,0,0,4.5-1.6,3.54,3.54,0,0,1-3.4-2.5,1.7,1.7,0,0,0,.7.1,3.08,3.08,0,0,0,1-.1,3.75,3.75,0,0,1-2.9-3.6,3.37,3.37,0,0,0,1.7.5,3.4,3.4,0,0,1-1.6-3,3.45,3.45,0,0,1,.5-1.8,10.56,10.56,0,0,0,7.5,3.8,2,2,0,0,1-.1-.8A3.75,3.75,0,0,1,17,4.65a6.31,6.31,0,0,0,2.3-.8,3.89,3.89,0,0,1-1.6,2A8.3,8.3,0,0,0,19.8,5.25Z"
			},
			children: [
			]
		}
	]
};
var umbrella = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 38 38"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m23.5,33c-1.92969,0-3.5-1.50195-3.5-3.34766v-14.65234h15c-2.07166-6.94244-8.44971-12-16-12S5.07166,8.05756,3,15h15v14.65234c0,2.94824,2.46729,5.34766,5.5,5.34766s5.5-2.39941,5.5-5.34766h-2c0,1.8457-1.57031,3.34766-3.5,3.34766Zm-4.5-28c5.50549,0,10.53998,3.18225,13.04254,8H5.95746c2.50262-4.81775,7.53705-8,13.04254-8Z"
			},
			children: [
			]
		}
	]
};
var unification = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,2.1125A8.6875,8.6875,0,1,0,19.4875,10.8,8.6875,8.6875,0,0,0,10.8,2.1125Zm0,16.25a7.56727,7.56727,0,0,1-7.53375-6.9953H6.85011a3.07823,3.07823,0,1,0,6.05243-1.12579H11.74183a1.9301,1.9301,0,0,1,.09247.56329,1.95795,1.95795,0,1,1-3.91589,0,1.9301,1.9301,0,0,1,.09247-.56329l-4.74512.00073a7.55425,7.55425,0,0,1,15.06854.00122H15.12574a3.07823,3.07823,0,1,0-6.05242,1.12579H10.234a1.93043,1.93043,0,0,1-.09247-.56329,1.958,1.958,0,1,1,3.9159,0,1.93043,1.93043,0,0,1-.09247.56329l4.36871-.00067A7.5673,7.5673,0,0,1,10.8,18.3625Z"
			},
			children: [
			]
		}
	]
};
var uplink = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.9152,9.4156a2.3131,2.3131,0,0,0-1.61-.6794,5.591,5.591,0,0,0-.9829-6.54L12.9265,1.8,5.0021,9.7242l.3965.3961a5.527,5.527,0,0,0,6.54.9828,2.3041,2.3041,0,0,0,.5156,1.41V19.8h3.6255V12.5133a2.3095,2.3095,0,0,0-.164-3.0977ZM12.1087,9.7a4.4834,4.4834,0,0,1-5.4967,0l6.29-6.29A4.483,4.483,0,0,1,12.1087,9.7Zm2.85,8.98H13.5744V13.28a2.1323,2.1323,0,0,0,1.3843,0Zm.1641-6.7587a1.24,1.24,0,0,1-1.7129,0,1.2108,1.2108,0,1,1,1.7124-1.7123h.0005A1.2117,1.2117,0,0,1,15.1228,11.9206Z"
			},
			children: [
			]
		}
	]
};
var upload = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,4.63l6.59,6.59-.8.79L11.36,6.79v13H10.24v-13L5,12l-.8-.79ZM4.05,1.8V2.93h13.5V1.8Z"
			},
			children: [
			]
		}
	]
};
var user = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "defs",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					name: "style",
					type: "element",
					value: "",
					attributes: {
					},
					children: [
						{
							name: "",
							type: "text",
							value: ".cls-1{fill:#020202;}",
							attributes: {
							},
							children: [
							]
						}
					]
				}
			]
		},
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				"class": "cls-1",
				d: "M10.75792,11.16666A4.68333,4.68333,0,1,0,6.07459,6.48333,4.68331,4.68331,0,0,0,10.75792,11.16666Zm0-8.27574A3.59241,3.59241,0,1,1,7.16551,6.48333,3.59647,3.59647,0,0,1,10.75792,2.89092Zm.04255,8.9791A7.43237,7.43237,0,0,0,3.166,19.25454V19.8h15.2681v-.54546A7.43214,7.43214,0,0,0,10.80047,11.87ZM4.2796,18.70908a6.37279,6.37279,0,0,1,6.52087-5.74814,6.37253,6.37253,0,0,1,6.51993,5.74814Z"
			},
			children: [
			]
		}
	]
};
var vibration = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M4.29,9.78,3.16,11.47l1.13,1.69-1.13,1.7.92,1.38-.94.63-1.34-2,1.13-1.69L1.8,11.47,2.93,9.78,1.8,8.09l1.34-2,.94.62L3.16,8.09Zm14.38,0L19.8,8.09l-1.34-2-.94.62.92,1.38L17.31,9.78l1.13,1.69-1.13,1.69,1.13,1.7-.92,1.38.94.63,1.34-2-1.13-1.69,1.13-1.7ZM10.78,3.7,17,7.25v7.1l-6.2,3.55L4.57,14.35V7.25Zm-.57,7.42L5.7,8.55V13.7l4.51,2.58Zm5.65-2.57-4.52,2.57v5.16l4.52-2.59Zm-2.28-2L9.08,9.18l1.7,1,4.5-2.57ZM12.45,6,10.78,5,6.27,7.58l1.67.95Z"
			},
			children: [
			]
		}
	]
};
var video = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.175,6.3v9H2.925v-9h11.25M15.3,5.175H1.8v11.25H15.3V5.175Zm3.375,3.207v4.836L16.741,10.8l1.934-2.418M19.8,5.175,15.3,10.8l4.5,5.625V5.175Z"
			},
			children: [
			]
		}
	]
};
var visibility = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.8,6.8c-1.2,0-2.3,0.5-3,1.4H8.8C7.4,6.5,4.9,6.3,3.2,7.7s-1.9,3.9-0.5,5.6s3.9,1.9,5.6,0.5c0.2-0.2,0.4-0.3,0.5-0.5h3.9\n\tc1.4,1.7,3.9,1.9,5.6,0.5s1.9-3.9,0.5-5.6C18.1,7.3,17,6.8,15.8,6.8z M5.8,13.7c-1.6,0-2.9-1.3-2.9-2.9s1.3-2.9,2.9-2.9\n\ts2.9,1.3,2.9,2.9C8.7,12.4,7.4,13.7,5.8,13.7z M12.1,12.2H9.5c0.4-0.9,0.4-2,0-2.9h2.6C11.7,10.3,11.7,11.3,12.1,12.2z M15.8,13.7\n\tc-1.6,0-2.9-1.3-2.9-2.9s1.3-2.9,2.9-2.9s2.9,1.3,2.9,2.9v0C18.7,12.4,17.4,13.7,15.8,13.7z"
			},
			children: [
			]
		}
	]
};
var volume = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,7.41621v6.76758H6.31178l6.76758,4.51178V2.90443L6.31178,7.41621Zm4.51178,5.63965H2.92793V8.54414H6.31178Zm1.12793-5.029,4.51172-3.01392V16.587l-4.51172-3.0138Zm7.76044,6.26861H19.8v1.12793H15.20015ZM19.8,8.05653V9.18446H18.067v1.73889H16.939V9.18446H15.20015V8.05653H16.939V6.32277H18.067V8.05653Z"
			},
			children: [
			]
		}
	]
};
var volunteer = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.07856,10.58955l4.00513-3.83826A3.04932,3.04932,0,0,0,16.085,4.63746a2.81022,2.81022,0,0,0-5.00641-1.78,2.81022,2.81022,0,0,0-5.0064,1.78A2.64423,2.64423,0,0,0,6.90657,6.64ZM8.90913,2.92549a1.697,1.697,0,0,1,1.30518.6521l.86425,1.03711.86426-1.03711a1.697,1.697,0,0,1,1.30518-.6521,1.714,1.714,0,0,1,1.71161,1.67578,1.93165,1.93165,0,0,1-.6543,1.33777L11.07374,9.036,7.65913,5.80385a1.53458,1.53458,0,0,1-.462-1.16639A1.71393,1.71393,0,0,1,8.90913,2.92549ZM19.23787,16.801a.56269.56269,0,0,1-.22364.314c-1.17627.80713-4.00781,2.68457-4.8999,2.68457H8.98939A2.87221,2.87221,0,0,1,7.76185,19.506c-.19091-.10546-1.45068-.8496-2.27392-1.33544-.24707-.146-.4541-.26807-.5791-.3418H2.29164v-1.125h2.77a.56342.56342,0,0,1,.27344.0708c.02294.01318.32226.18945.72509.42725.81348.48046,2.0586,1.21582,2.24756,1.3208a1.79177,1.79177,0,0,0,.68652.15185h5.12006a21.12127,21.12127,0,0,0,4.06543-2.35205,1.1753,1.1753,0,0,0-.0542-.4707c-.021-.05957-.19287-.14063-.3623-.17725l-4.14112,1.29541c-.082.02979-.16308.05469-.24267.07569a.53669.53669,0,0,1-.14209.0086v.00946h-3.748l-1.52832-.89892.57031-.96973,1.26465.74365h3.356l.11072-.03467a2.3873,2.3873,0,0,0,.22021-.0957c.46192-.228.45459-.31055.44483-.42529a.60153.60153,0,0,0-.32129-.502.57614.57614,0,0,0-.29883-.05273,1.76283,1.76283,0,0,0-.249.01025,2.03712,2.03712,0,0,1-.34571.04688,4.76364,4.76364,0,0,1-2.63763-.7832c-.13721-.09082-.26758-.18262-.396-.27295a3.82659,3.82659,0,0,0-1.18213-.64453,1.67643,1.67643,0,0,0-1.03857.05517l-2.20557.60156a.57936.57936,0,0,1-.14746.01954h-2.814V12.736H5.03041l2.07812-.564A2.73648,2.73648,0,0,1,8.798,12.10078a4.81761,4.81761,0,0,1,1.52978.80908c.11914.084.24024.16993.36768.25391a3.47516,3.47516,0,0,0,2.02728.59668,1.86354,1.86354,0,0,1,.21728-.04053,3.11456,3.11456,0,0,1,.397-.0166,1.65689,1.65689,0,0,1,.72021.147,1.72968,1.72968,0,0,1,.9917,1.437l.00391.05665,2.49951-.78223a.53734.53734,0,0,1,.21973-.02344,1.68988,1.68988,0,0,1,1.41406.9375A2.37861,2.37861,0,0,1,19.23787,16.801Z"
			},
			children: [
			]
		}
	]
};
var wallet = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.8,11.79554v-3.99542h-1.12585v-3.00006h-2.72791c-.58496-1.73907-2.21002-2.99994-4.14624-2.99994s-3.56122,1.26086-4.14618,2.99994h-2.59473c-1.24768,0-2.25909,1.01141-2.25909,2.25909v10.48163c0,1.24762,1.01141,2.25909,2.25909,2.25909h14.74091v-3.49988h1v-4.50446h-1Zm-3.60687-5.60229c0-.09186-.02148-.17773-.02704-.26819h1.38306v1.87506h-1.66925c.19666-.49878,.31323-1.03821,.31323-1.60687Zm-4.39313-3.26813c1.80206,0,3.26813,1.46606,3.26813,3.26813,0,.58685-.16791,1.13031-.43982,1.60687h-1.99731c.0376-.02466,.08514-.03754,.11896-.06665,.10535-.09033,.18848-.2038,.24927-.34033,.06079-.13635,.09119-.29663,.09119-.4809,0-.17743-.03278-.32709-.09869-.44885-.06567-.12158-.15295-.22351-.26135-.30566-.10864-.08221-.23358-.14966-.37476-.20233-.14148-.05249-.28632-.09857-.43408-.138v-1.04071c.17761,0,.30646,.04443,.38708,.13306,.08069,.08881,.12402,.21704,.13068,.38477h.56232c0-.16107-.02887-.30243-.08636-.42419-.0575-.12158-.13489-.22186-.23181-.30084-.09692-.07892-.2113-.13806-.34259-.17749-.13153-.03943-.27155-.05914-.41931-.05914v-.3847h-.21222v.3847c-.14783,0-.28931,.02136-.42419,.06409-.13489,.04279-.25378,.10431-.3573,.18488-.10358,.08069-.18604,.18091-.24689,.3009-.06079,.12006-.09119,.25903-.09119,.41675,0,.18091,.03278,.33221,.09875,.4538,.06561,.12164,.15198,.22278,.25885,.30328,.10687,.08069,.22699,.1463,.36005,.19733,.13336,.05103,.26703,.09454,.40192,.13068v1.1936c-.22668-.00659-.38959-.07227-.48828-.19733-.09845-.12494-.1463-.2959-.14301-.51294h-.56207c-.0033,.1842,.0238,.34692,.0813,.48828,.0575,.14148,.13879,.26068,.24414,.3576,.04041,.03735,.0993,.0556,.14612,.08636h-2.01575c-.27191-.47656-.43982-1.02002-.43982-1.60687,0-1.80206,1.46606-3.26813,3.26807-3.26813Zm.72809,4.06616c0,.19714-.05658,.34106-.1701,.43152-.11346,.09045-.25885,.14227-.43646,.15533v-1.14917c.07556,.01971,.1496,.04272,.22186,.06903,.0722,.02637,.13727,.06085,.19476,.10358,.0575,.04279,.10352,.09546,.13818,.15778,.03461,.06256,.05176,.13983,.05176,.23193Zm-.81879-2.2146v.98639c-.06897-.01642-.13733-.03693-.20441-.06158-.06744-.02466-.12677-.05676-.17761-.09619-.05121-.03943-.09302-.08716-.12585-.14313-.03284-.05585-.04938-.12329-.04938-.20215,0-.17432,.04846-.29834,.14539-.37238s.2345-.11096,.41187-.11096ZM2.925,7.05916c0-.62537,.50879-1.13409,1.13409-1.13409h2.37488c-.00555,.09045-.02704,.17633-.02704,.26819,0,.56866,.11658,1.10809,.31323,1.60687H2.925v-.74097Zm14.75,11.61572H4.05909c-.62531,0-1.13409-.50879-1.13409-1.13409V8.92512h14.75v2.87042h-1.53302l-.08978,.00214c-1.24384,0-2.2522,1.00836-2.2522,2.2522s1.00836,2.2522,2.2522,2.2522l.08978-.00208h1.53302v2.37488Zm1-3.49976l-.43768,.00006-2.1214,.00012-.06372,.00177c-.62152,0-1.1272-.50562-1.1272-1.1272,0-.62152,.50568-1.1272,1.15405-1.1275l.06293-.00183h2.53302v2.25458Z"
			},
			children: [
			]
		}
	]
};
var warning = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.52557,15.78473,12.588,3.74951a2.0643,2.0643,0,0,0-3.584-.001L2.0733,15.78668a2.07277,2.07277,0,0,0,1.79688,3.10358H17.73157a2.07289,2.07289,0,0,0,1.794-3.10553ZM18.548,17.2926a.9494.9494,0,0,1-.81738.47266H3.87115a.94838.94838,0,0,1-.82226-1.419L9.97961,4.30811a.9396.9396,0,0,1,1.63184,0L18.551,16.34625A.95147.95147,0,0,1,18.548,17.2926ZM9.95,14.367h1.7V16.05H9.95Zm0-6.817h1.7v2.49048l-.56951,2.635H10.511l-.561-2.635Z"
			},
			children: [
			]
		}
	]
};
var wearable = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.4,5.2h-.1l-1-3.4h-7l-1,3.4H6.2A1.35,1.35,0,0,0,4.8,6.5V15a1.43,1.43,0,0,0,1.4,1.4h.1l1,3.4h7l1-3.4h.1A1.43,1.43,0,0,0,16.8,15V6.5A1.35,1.35,0,0,0,15.4,5.2ZM8.1,2.9h5.3l.7,2.2H7.4Zm5.4,15.8H8.1l-.7-2.2h6.7Zm2.2-3.6a.22.22,0,0,1-.2.2H6.2a.22.22,0,0,1-.2-.2V6.5a.22.22,0,0,1,.2-.2h9.3a.22.22,0,0,1,.2.2Z"
			},
			children: [
			]
		}
	]
};
var weather = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.292,16.08956a.623.623,0,1,1-.623-.623A.62306.62306,0,0,1,10.292,16.08956Zm.60334-2.5498a.623.623,0,1,0,.623.62305A.623.623,0,0,0,10.89534,13.53976ZM8.44258,17.39334a.623.623,0,1,0,.62305.623A.623.623,0,0,0,8.44258,17.39334Zm3.6748-5.77356a.623.623,0,1,0,.623.623A.623.623,0,0,0,12.11738,11.61978Zm1.22638-.68067a.623.623,0,1,0-.623-.623A.62306.62306,0,0,0,13.34376,10.93911Zm-.141,4.52747a.623.623,0,1,0,.62305.623A.623.623,0,0,0,13.20271,15.46658Zm1.22638-1.92682a.623.623,0,1,0,.623.62305A.623.623,0,0,0,14.42909,13.53976Zm-2.45276,3.85358a.623.623,0,1,0,.623.623A.623.623,0,0,0,11.97633,17.39334ZM6.13521,15.46658a.623.623,0,1,0,.623.623A.623.623,0,0,0,6.13521,15.46658Zm1.22637-1.92682a.623.623,0,1,0,.62305.62305A.623.623,0,0,0,7.36158,13.53976ZM4.90883,17.39334a.623.623,0,1,0,.623.623A.623.623,0,0,0,4.90883,17.39334Zm3.6748-4.52747a.623.623,0,1,0-.623-.623A.623.623,0,0,0,8.58363,12.86587ZM16.40846,7.4512v.00006A4.488,4.488,0,0,0,7.85853,5.54,4.48745,4.48745,0,1,0,5.4792,14.1575L6.144,13.111A3.37232,3.37232,0,1,1,7.46821,6.58553l.96161.359.43805-.92834a3.372,3.372,0,0,1,6.42462,1.43506v1.116h1.116a2.2753,2.2753,0,0,1,.21942,4.54l-.716,1.1272h.49658a3.39163,3.39163,0,1,0,0-6.78326Z"
			},
			children: [
			]
		}
	]
};
var webinar = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13.5,15.32l.3,1h-6l.44-1Zm6.3,3H1.8l2-6.12h0V3.29h14v8.9ZM4.93,12.19H6.66v-.93a6.13,6.13,0,0,1,8.28,0v.93h1.74V4.42H4.93Zm5.87-1.41a5,5,0,0,0-3,1v.4h6v-.4A5,5,0,0,0,10.8,10.78Zm-7.45,6.4h14.9L17,13.31H4.61Zm5.38-10A2.07,2.07,0,1,1,10.8,9.22,2.08,2.08,0,0,1,8.73,7.15Zm1.12,0a1,1,0,1,0,1-1A.95.95,0,0,0,9.85,7.15Z"
			},
			children: [
			]
		}
	]
};
var weights = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.65954,12.76558l-.34228-.34229a1.25325,1.25325,0,0,0-.064-1.68652L16.24841,9.73335l-2.335,2.335-4.3996-4.3996,2.3371-2.33722L10.847,4.32808A1.28389,1.28389,0,0,0,9.119,4.29237l-.34076-.34076a1.289,1.289,0,0,0-1.78174,0L5.95873,4.98933a.66863.66863,0,1,0-.94549.9455L3.91833,7.02974a1.259,1.259,0,0,0,.0376,1.77246l.33362.33362a1.225,1.225,0,0,0,.06628,1.683l1.00391,1.00439L7.619,9.56386l4.39948,4.39947L9.75036,16.2314l1.0044,1.0039a1.22884,1.22884,0,0,0,1.69073.06037l.342.342a1.26253,1.26253,0,0,0,1.78223,0l1.067-1.067a.66249.66249,0,0,0,.444.17615.67.67,0,0,0,.67-.67.66222.66222,0,0,0-.17615-.444l1.085-1.085A1.26192,1.26192,0,0,0,17.65954,12.76558ZM4.64147,7.72017l3.062-3.06153a.25993.25993,0,0,1,.36767,0l.311.311L4.95983,8.392l-.30615-.30615A.26048.26048,0,0,1,4.64147,7.72017Zm.42139,2.3916a.26083.26083,0,0,1,0-.36768l4.709-4.70947a.25993.25993,0,0,1,.36767,0l.29736.29687L5.35974,10.40864ZM8.34411,8.875l.481-.481,4.38135,4.38135-.481.481Zm3.11768,7.65332-.29737-.29687,1.561-1.561.00244.00244,1.89551-1.89453-.00293-.00293,1.62793-1.62793.29687.29639a.262.262,0,0,1,.001.36865l-4.7168,4.71582A.25993.25993,0,0,1,11.46179,16.52827Zm5.49072-2.6875-3.08984,3.08985a.267.267,0,0,1-.36817,0l-.29687-.29688,3.458-3.458.29688.29688a.26052.26052,0,0,1,0,.36816Z"
			},
			children: [
			]
		}
	]
};
var youtube = {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.4,6.4a2.17,2.17,0,0,0-1.6-1.6,50.17,50.17,0,0,0-7-.4,50.17,50.17,0,0,0-7,.4A2.34,2.34,0,0,0,2.2,6.4a23.17,23.17,0,0,0-.4,4.4,23.17,23.17,0,0,0,.4,4.4,2.34,2.34,0,0,0,1.6,1.6,50.17,50.17,0,0,0,7,.4,50.17,50.17,0,0,0,7-.4,2.17,2.17,0,0,0,1.6-1.6,23.17,23.17,0,0,0,.4-4.4A23.17,23.17,0,0,0,19.4,6.4ZM9,13.5V8.1l4.7,2.7Z"
			},
			children: [
			]
		}
	]
};
var IconData = {
	"3d-ad": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.02168,12.61738l2.0957,1.1709-.54883.98242-2.0957-1.1709Zm-3.31152-.56054,2.0957,1.17089.54883-.98242L12.259,11.07441ZM4.427,13.78828l.54883.98242,2.09473-1.1709-.54883-.98242Zm4.85743-2.71387-2.09571,1.1709.54882.98242L9.8332,12.05684Zm2.07811-1.83789V6.93574h-1.125V9.23652Zm0-5.40039h-1.125V6.13594h1.125Zm7.33692,2.43164v9.06446L10.8,19.74434,2.90059,15.33223V6.26777L10.8,1.85566ZM10.8,3.14473l-6.18317,3.453L10.8,10.051l6.18317-3.45331ZM4.02559,14.67207l6.2119,3.46906v-7.1153L4.02559,7.55647Zm13.54882,0V7.55647l-6.21192,3.46936v7.1153Z"
			},
			children: [
			]
		}
	]
},
	vpn: vpn,
	accessibility: accessibility,
	"ad-tech-stack": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		"enable-background": "new 0 0 21.6 21.6",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M3.40938,9.63887h14.875V5.155l1.38671-2.19727L1.85469,2.958l1.55469,2.216V9.63887z M17.62617,4.08955l-0.46679,0.74024\n\tv3.68408h-12.625V4.81074L4.04707,4.135L17.62617,4.08955z M18.28438,11.96113h-14.875V16.426l-1.55469,2.217l17.8164-0.00023\n\tl-1.38671-2.19824L18.28438,11.96113z M4.04707,17.465l0.48731-0.67578v-3.70309h12.625v3.68457l0.46679,0.73926L4.04707,17.465z"
			},
			children: [
			]
		}
	]
},
	"adaptive-speaker": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.8,9.26545H3.8a2,2,0,0,0-2,2v5.54169a2,2,0,0,0,2,2h14a2,2,0,0,0,2-2V11.26545A2,2,0,0,0,17.8,9.26545Zm.875,7.54169a.876.876,0,0,1-.875.875H3.8a.876.876,0,0,1-.875-.875V11.26545a.876.876,0,0,1,.875-.875h14a.876.876,0,0,1,.875.875Zm-3.64789-5.26776a2.497,2.497,0,1,0,2.49695,2.497A2.49693,2.49693,0,0,0,15.02711,11.53938Zm0,3.8689a1.372,1.372,0,1,1,1.37195-1.37195A1.37349,1.37349,0,0,1,15.02711,15.40828Zm-8.45422-3.8689a2.497,2.497,0,1,0,2.49689,2.497A2.49695,2.49695,0,0,0,6.57289,11.53938Zm0,3.8689a1.372,1.372,0,1,1,1.37189-1.37195A1.3735,1.3735,0,0,1,6.57289,15.40828ZM6.65,5.63344l-.79493-.79493a6.99923,6.99923,0,0,1,9.88965,0l-.79492.79493A5.87758,5.87758,0,0,0,6.65,5.63344Zm7.72949.79687-.79492.79492a3.94316,3.94316,0,0,0-5.56934,0l-.79492-.79492A5.06744,5.06744,0,0,1,14.37953,6.43031Z"
			},
			children: [
			]
		}
	]
},
	"add-folder": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.4,11.45V8.25H10.2v3.2H7v1.1h3.2v3.3h1.1v-3.2h3.2v-1.2Zm7.3,6.2H2.9V4.05H7.2l2,2.2h9.5ZM9.8,5.25,7.8,3h-6v15.7h18V5.25Z"
			},
			children: [
			]
		}
	]
},
	"add-to-favorite": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_3",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "g",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M10.8,18.7l-7.2-6.9C2.4,10.6,1.8,9.4,1.8,8c0-2.8,2.3-5.1,5.1-5.1c1.6,0,3,0.7,4,1.9c1-1.2,2.4-1.9,3.9-1.9\n\t\tc2.8,0,5.1,2.3,5.1,5.1c0,1.8-1,3-2,4L10.8,18.7z M6.9,4c-2.2,0-4,1.8-4,3.9c0,1.1,0.4,2,1.4,3l6.5,6.2l6.3-6\n\t\tc1.1-1.1,1.6-2.1,1.6-3.2c0-2.2-1.8-3.9-4-3.9c-1.4,0-2.4,0.8-3.5,2l-0.4,0.5L10.4,6C9.4,4.7,8.3,4,6.9,4z"
					},
					children: [
					]
				}
			]
		}
	]
},
	"add-user": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.7698059,11.9657688c-1.8686609,0-3.3887048-1.5247488-3.3887048-3.3985958s1.5200438-3.3981104,3.3887048-3.3981104\n\tc1.8681755,0,3.3887043,1.5242629,3.3887043,3.3981104S12.6379814,11.9657688,10.7698059,11.9657688z M10.7698059,6.2892866\n\tc-1.2524004,0-2.2715816,1.0220098-2.2715816,2.2778864s1.0191813,2.2778864,2.2715816,2.2778864\n\ts2.2715807-1.0220108,2.2715807-2.2778864S12.0222063,6.2892866,10.7698059,6.2892866z M19.2717915,13.6633978\n\tc0.3089695-0.8995237,0.4684105-1.8589516,0.4684105-2.8583956c0-4.9672694-4.026557-9.005002-8.9701014-9.005002\n\tC5.8266177,1.8,1.8,5.8377328,1.8,10.8050022c0,2.2887049,0.8571284,4.3875742,2.272455,5.976656\n\tc0.2591457,0.2898178,0.5282073,0.5596867,0.8172832,0.8095474c1.574707,1.3792381,3.6378374,2.2087936,5.8803625,2.2087936\n\tc1.0564766,0,2.0731077-0.1898956,3.0199633-0.5297337c0.5780296,0.3098259,1.2258949,0.4897175,1.9235811,0.4897175\n\tc0.5780897,0,1.1162748-0.1199284,1.6146135-0.339777c0.3687649-0.1499405,0.6976871-0.3597851,1.0066547-0.6196499\n\tc0.8969727-0.7495842,1.465086-1.8789597,1.465086-3.1382694C19.7999992,14.9327116,19.6106281,14.2530966,19.2717915,13.6633978z\n\t M2.8564761,10.8050022c0-4.3775706,3.5481708-7.9455938,7.9136248-7.9455938s7.9136248,3.5680232,7.9136248,7.9455938\n\tc0,0.6296549-0.0697746,1.2493048-0.2192402,1.8389435c-0.7276154-0.669611-1.6943645-1.0793562-2.7508402-1.0793562\n\tc-1.3255987,0-2.5116472,0.6395979-3.2491798,1.6290989c-0.5481606-0.1299324-1.1162739-0.1898966-1.6943645-0.1898966\n\tc-2.4418726,0-4.6245995,1.1193724-6.0697341,2.8784037C3.5441864,14.5029583,2.8564761,12.733922,2.8564761,10.8050022z\n\t M10.7701006,18.740591c-2.0332003,0-3.8770914-0.7695904-5.2823801-2.0389042\n\tc1.225894-1.5690746,3.1395597-2.5785227,5.2823801-2.5785227c0.3787432,0,0.7574854,0.029952,1.1162748,0.0999203\n\tc-0.1694183,0.4497623-0.2591457,0.9294758-0.2591457,1.4392023c0,1.0993633,0.4286242,2.0888653,1.1262503,2.8284435\n\tC12.1255684,18.6506157,11.4578114,18.740591,10.7701006,18.740591z M17.9262409,17.6511707\n\tc-0.2590847,0.2898769-0.5780296,0.5297337-0.9269028,0.6896191c-0.3887196,0.1999016-0.8271999,0.2998199-1.2856932,0.2998199\n\tc-0.159502,0-0.3289204-0.009943-0.4783859-0.0399551c-0.4684706-0.0699692-0.907011-0.2598648-1.2757769-0.5396786\n\tc-0.7375317-0.5297337-1.2159176-1.4092503-1.2159176-2.3986893c0-0.4097462,0.07969-0.7995434,0.2292166-1.1593285\n\tc0.159441-0.3598471,0.3787422-0.6796761,0.6478043-0.9594889c0.5382442-0.5297346,1.2757769-0.8595076,2.0930595-0.8595076\n\tc0.9568319,0,1.813962,0.4597054,2.3621225,1.1693325c0.2790375,0.3697901,0.4783859,0.8095474,0.558136,1.2793179\n\tc0.0299301,0.1698885,0.0498219,0.349781,0.0498219,0.5296745C18.6837254,16.4318771,18.4046879,17.1214962,17.9262409,17.6511707z\n\t M16.2729988,14.0176325h-1.1212626v1.0867977h-1.0837898v1.1243753h1.0837898v1.0867977h1.1212626v-1.0867977h1.0837898v-1.1243753\n\th-1.0837898V14.0176325z"
			},
			children: [
			]
		}
	]
},
	"added-to-favorite": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.7,2.9c-1.5,0-2.9,0.7-3.9,1.9c-1-1.2-2.4-1.9-3.9-1.9C4.1,2.9,1.8,5.2,1.8,8c0,1.4,0.5,2.7,1.5,3.6l7.5,7.1l7.2-6.9\n\tc1.1-1,1.7-2.3,1.8-3.8C19.8,5.2,17.5,2.9,14.7,2.9z"
			},
			children: [
			]
		}
	]
},
	"advanced-settings": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9.3235,6.67848a2.646,2.646,0,1,0,2.646,2.646A2.64581,2.64581,0,0,0,9.3235,6.67848Zm0,4.166a1.521,1.521,0,1,1,1.521-1.521A1.52295,1.52295,0,0,1,9.3235,10.84449Zm-1.003,3.12s1.0802.06061,1.12622.05963c-.02344.31311-.05823,1.06134-.05621,1.12738-.01044-.00287-.34455-.01568-.539-.016l-1.269,1.712-2.349-.973.314-2.108a5.82916,5.82916,0,0,1-.666-.667l-2.108.314-.973-2.35,1.713-1.269a5.7103,5.7103,0,0,1-.001-.943l-1.712-1.268.973-2.349,2.108.313a5.59379,5.59379,0,0,1,.668-.665l-.315-2.10895,2.349-.973,1.27,1.713c.158-.013.316-.019.473-.019s.313.006.469.018l1.269-1.712,2.35.973-.314,2.108a6.16321,6.16321,0,0,1,.667.666l2.108-.314.973,2.35-1.71295,1.269c.0105.141.00256.28058.00049.42059L14.01606,9.351c.00354-.13525-.05255-1.03045-.05255-1.03045l.502-.371,1.007-.746-.301-.727-1.23895.185-.618.092-.405-.476a4.88774,4.88774,0,0,0-.538-.539l-.476-.405.092-.618.184-1.239-.727-.301-.746,1.007-.371.5-.62-.048q-.189-.015-.381-.015-.19052,0-.381.015l-.62305.051-.37195-.502-.748-1.009-.726.301.185,1.24.092.62-.479.405a4.67534,4.67534,0,0,0-.536.535l-.405.47705-.618-.092-1.239-.184-.301.727,1.006.745.503.372-.051.623a4.71578,4.71578,0,0,0,.001.761l.05.622-.50195.372-1.007.746.3.727,1.239-.185.618-.092.405.476a4.724,4.724,0,0,0,.538.539l.476.405-.092.618-.184,1.23895.727.301.746-1.007Zm11.479.23-.87305-2.108-1.27795.191.191-1.278-2.107-.87195-.77,1.037-.769-1.037-2.108.872.191,1.278-1.277-.191-.873,2.108,1.038.768-1.038.769.873,2.108,1.277-.19-.191,1.277,2.108.87305.769-1.038.769,1.038,2.107-.87305-.191-1.27795,1.278.191.873-2.108-1.038-.768Zm-2.193.553a2.66636,2.66636,0,0,1,.001.428l-.026.313.843.624-.20105.484-1.037-.154-.202.238a2.60448,2.60448,0,0,1-.302.301l-.24.203.155,1.039-.483.20105-.626-.84405-.313.027a2.33179,2.33179,0,0,1-.426,0l-.311-.025-.624.842-.484-.20105.154-1.03595-.237-.203a2.74653,2.74653,0,0,1-.305-.305l-.202-.237-1.036.154-.201-.484.843-.625-.025-.312a2.53184,2.53184,0,0,1-.001-.427l.026-.311-.843-.625.201-.484,1.037.154.202-.238a2.69564,2.69564,0,0,1,.303-.30194l.239-.202-.155-1.038.484-.2.626.843.311-.025a2.78858,2.78858,0,0,1,.429-.001l.31.024.624-.84.484.2-.154,1.036.237.203a2.63547,2.63547,0,0,1,.303.304l.202.239,1.038-.155.201.484-.842.624Zm-2.643-1.639a1.854,1.854,0,1,0,1.854,1.854A1.85391,1.85391,0,0,0,14.96351,13.10847Zm0,2.584a.729.729,0,1,1,.729-.729A.72979.72979,0,0,1,14.96351,15.69252Z"
			},
			children: [
			]
		}
	]
},
	"agent-chat": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,1.8A8.9885,8.9885,0,0,0,3.19459,15.59742L2.12,19.6783l3.96386-1.22345A8.99622,8.99622,0,1,0,10.8,1.8Zm0,16.875a7.8497,7.8497,0,0,1-4.12506-1.17737l-.43469-.26843-.48816.1507-2.02832.626.55877-2.12207.1247-.47363-.26172-.414A7.869,7.869,0,1,1,10.8,18.675Z"
			},
			children: [
			]
		}
	]
},
	"agriculture-leaves": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.5,14c-0.9-1.8-2.6-3.2-4.6-3.7c-0.4-0.1-0.9-0.1-1.4-0.1c0.5-0.5,1-1,1.3-1.6c0.9-1.8,1-3.8,0.5-5.7l-0.2-0.5l-0.5,0.1\n\tC12.7,3,11,4.3,10,6C9.6,6.8,9.4,7.7,9.4,8.6C9,8,8.5,7.4,7.9,7C6.3,5.9,4.3,5.5,2.3,5.8L1.8,5.9l0.1,0.5c0.2,2,1.2,3.9,2.9,5.1\n\tc1.1,0.7,2.4,1.1,3.7,1c0.1,0,0.1,0,0.2,0c-1.4,1.9-2,4.3-1.7,6.6l1.1-0.1c-0.3-2.2,0.4-4.5,1.8-6.2c0.9,1.4,2.2,2.4,3.8,2.9\n\tc0.5,0.1,1,0.2,1.5,0.2c1.4,0,2.9-0.4,4.1-1.2l0.5-0.3L19.5,14z M11,6.5c0.7-1.3,2-2.3,3.5-2.7c0.3,1.5,0.1,3-0.5,4.3\n\tc-0.7,1.2-1.9,2.1-3.2,2.5C10.3,9.2,10.4,7.8,11,6.5L11,6.5z M5.4,10.6c-1.2-0.9-2-2.3-2.3-3.8c1.5-0.1,3,0.2,4.2,1.1\n\tc1.1,0.9,1.9,2.1,2.1,3.5C8,11.6,6.6,11.3,5.4,10.6z M14,14.7c-1.4-0.4-2.5-1.3-3.2-2.5c1.2-0.7,2.6-1,4-0.7\n\tc1.5,0.4,2.7,1.3,3.5,2.7C16.9,14.7,15.4,15,14,14.7z"
			},
			children: [
			]
		}
	]
},
	"agriculture-tractor": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M6,10.5L6,10.5c-2.2,0-4,1.8-4,4s1.8,4,4,4c2.2,0,4-1.8,4-4C10,12.3,8.2,10.5,6,10.5z M8.9,14.5c0,1.6-1.3,2.9-2.9,2.9\n\ts-2.9-1.3-2.9-2.9s1.3-2.9,2.9-2.9C7.6,11.7,8.9,12.9,8.9,14.5L8.9,14.5z M18.3,12.8v-1.5l-0.8-0.7V9.6c0-0.9-0.7-1.6-1.6-1.6h-1.7\n\tV5.3h-1.7v1.1h0.6V8h-1.5l-0.9-3.8h0.5V3.1H6c-0.9,0-1.6,0.7-1.6,1.6V7L3.2,8.3v1.3c-0.5,0.3-1,0.7-1.4,1.2l0.9,0.7\n\tC4.2,9.5,7.1,9.3,9,10.8c1,0.8,1.6,2.1,1.6,3.4l0,1.2h3.1c0,1.7,1.4,3,3.1,3c1.7,0,3-1.4,3-3.1C19.8,14.3,19.2,13.4,18.3,12.8z\n\t M5.5,4.7c0-0.3,0.2-0.5,0.5-0.5h3.4l0.6,2.6H5.5V4.7z M13.9,14.4h-2.2v-0.1c0-3.1-2.5-5.6-5.6-5.6C5.5,8.7,4.9,8.8,4.3,9V8.7\n\tl0.8-0.8h5.2l0.3,1.2h5.3c0.3,0,0.5,0.2,0.5,0.5v1.6l0.8,0.7v0.5C15.8,12.1,14.3,13,13.9,14.4z M16.7,17.4c-1.1,0-1.9-0.9-1.9-1.9\n\ts0.9-1.9,1.9-1.9c1.1,0,1.9,0.9,1.9,1.9C18.7,16.5,17.8,17.4,16.7,17.4C16.7,17.4,16.7,17.4,16.7,17.4z"
			},
			children: [
			]
		}
	]
},
	"agriculture-vineyard": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.22941,7.28531a2.42375,2.42375,0,0,0-1.71391-.70385h-.0146A2.41186,2.41186,0,0,0,13.163,8.41153,2.43144,2.43144,0,0,0,10.96037,6.623l.43413-.00269a1.28823,1.28823,0,0,1,1.2793-1.29394l-.00733-1.1521a2.42366,2.42366,0,0,0-1.72021.72449,2.46541,2.46541,0,0,0-.24707.30432A4.578,4.578,0,0,0,8.84025,2.4921a5.13387,5.13387,0,0,0-3.769-.552l-.50053.13281.07861.51172A4.72117,4.72117,0,0,0,6.5258,5.89322a5.15645,5.15645,0,0,0,2.9541.853,6.11535,6.11535,0,0,0,.6836-.03744A2.435,2.435,0,0,0,8.46623,8.43924a2.41156,2.41156,0,0,0-2.34373-1.803H6.10734a2.43851,2.43851,0,0,0,.01367,4.877h.01465a2.41058,2.41058,0,0,0,.75293-.13562A2.43054,2.43054,0,0,0,8.46916,15.6567h.01465a2.40353,2.40353,0,0,0,.75293-.13574A2.42791,2.42791,0,0,0,10.81828,19.8h.01416a2.44132,2.44132,0,0,0,2.42432-2.45263V17.347a2.42457,2.42457,0,0,0-.9087-1.86914,2.40889,2.40889,0,0,0,.81885.15137h.01416a2.44146,2.44146,0,0,0,2.42432-2.45288V13.176a2.42317,2.42317,0,0,0-.72461-1.72009c-.05518-.05445-.11865-.09607-.17774-.14453a2.42849,2.42849,0,0,0,.811.147h.01514A2.44189,2.44189,0,0,0,17.954,9.00578V9.00541A2.42517,2.42517,0,0,0,17.22941,7.28531ZM7.18791,4.9506a3.362,3.362,0,0,1-1.28369-1.979A3.73088,3.73088,0,0,1,8.2245,3.466,3.50312,3.50312,0,0,1,9.63224,5.593,4.1137,4.1137,0,0,1,7.18791,4.9506ZM10.8105,7.76078h.00732a1.28657,1.28657,0,0,1,.00778,2.57312h-.00732a1.28657,1.28657,0,0,1-.00778-2.57312Zm.0039,4.82141a2.42578,2.42578,0,0,0-.81494-1.24756,2.4139,2.4139,0,0,0,.81885.15137h.01416a2.40828,2.40828,0,0,0,.75049-.135c-.04981.04284-.104.07812-.15088.12524a2.41278,2.41278,0,0,0-.61771,1.106ZM6.12883,10.36112H6.121a1.28638,1.28638,0,0,1-.00683-2.57275H6.122a1.28638,1.28638,0,0,1,.00684,2.57275Zm2.34472-.67883a2.429,2.429,0,0,0,.815,1.24853,2.409,2.409,0,0,0-.81884-.15161H8.4555a2.40815,2.40815,0,0,0-.752.13574A2.42939,2.42939,0,0,0,8.47355,9.68229ZM8.477,14.50455H8.46916a1.28663,1.28663,0,0,1-.00684-2.57324h.00733A1.28663,1.28663,0,0,1,8.477,14.50455Zm2.34863,4.14331h-.00732a1.28657,1.28657,0,0,1-.00778-2.57312h.00732a1.28657,1.28657,0,0,1,.00781,2.57312Zm-.00781-3.7251h-.01416a2.40124,2.40124,0,0,0-.752.13562,2.42655,2.42655,0,0,0,.77-1.23291,2.42763,2.42763,0,0,0,.81543,1.24866A2.41159,2.41159,0,0,0,10.81779,14.92276Zm2.35645-.44543h-.00733a1.28657,1.28657,0,0,1-.00781-2.57312h.00781a1.28657,1.28657,0,0,1,.00733,2.57312Zm-.00684-3.72522h-.01514a2.42437,2.42437,0,0,0-.749.13306,2.43056,2.43056,0,0,0,.76709-1.2295,2.41422,2.41422,0,0,0,.63037,1.09864c.05518.05444.11865.09619.17822.14477A2.42872,2.42872,0,0,0,13.1674,10.75211Zm2.355-.4458h-.00781a1.28638,1.28638,0,0,1-.00684-2.57275h.00775a1.28638,1.28638,0,0,1,.00684,2.57275Z"
			},
			children: [
			]
		}
	]
},
	"air-conditioner": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.55,6.39189H13.05421v-1.125H17.55Zm2.25-4.0282V13.80522H1.8V2.36369ZM16.425,12.68022V11.55693H5.175v1.12329Zm0-2.24829v-1.125H5.175v1.125Zm2.25-6.94324H2.925v9.19153H4.05V8.18193h13.5v4.49829h1.125ZM7.79377,14.93065h-1.125a.66863.66863,0,0,1-.13476.42773,1.86443,1.86443,0,0,0,0,2.0127.7493.7493,0,0,1,0,.85742,1.76366,1.76366,0,0,0-.29492,1.00781h1.125a.6742.6742,0,0,1,.13476-.42969,1.86609,1.86609,0,0,0,0-2.01367.74775.74775,0,0,1,0-.85644A1.76376,1.76376,0,0,0,7.79377,14.93065Zm3.78418,0H10.453a.66769.66769,0,0,1-.13476.42675,1.86091,1.86091,0,0,0,0,2.01368.7493.7493,0,0,1,0,.85742,1.76012,1.76012,0,0,0-.2959,1.00781h1.125a.66915.66915,0,0,1,.13574-.42969,1.86351,1.86351,0,0,0-.001-2.01367.74616.74616,0,0,1,0-.85547A1.75911,1.75911,0,0,0,11.578,14.93065Zm3.78321,0h-1.125a.66764.66764,0,0,1-.13477.42675,1.86091,1.86091,0,0,0,0,2.01368.74926.74926,0,0,1,0,.85742,1.76012,1.76012,0,0,0-.2959,1.00781h1.125a.66915.66915,0,0,1,.13575-.42969,1.86348,1.86348,0,0,0-.001-2.01367.74616.74616,0,0,1,0-.85547A1.7591,1.7591,0,0,0,15.36116,14.93065Z"
			},
			children: [
			]
		}
	]
},
	airport: airport,
	"alert-notification": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,1.8c-5,0-9,4-9,9c0,1.7,0.5,3.4,1.4,4.8l-1.1,4.1l4-1.2c4.2,2.6,9.8,1.3,12.4-2.9s1.3-9.8-2.9-12.4\n\tC14.1,2.3,12.5,1.8,10.8,1.8z M10.8,18.7c-1.5,0-2.9-0.4-4.1-1.2l-0.4-0.3l-0.5,0.2l-2,0.6l0.6-2.1l0.1-0.5L4.1,15\n\tC1.8,11.3,2.9,6.5,6.6,4.1s8.5-1.2,10.9,2.5s1.2,8.5-2.5,10.9C13.7,18.3,12.3,18.7,10.8,18.7z M10,10.1c0.4-0.4,1-0.4,1.4,0\n\ts0.4,1,0,1.4s-1,0.4-1.4,0l0,0C9.6,11.1,9.6,10.5,10,10.1z M11.8,9l2.3-2.3l0.8,0.8l-2.3,2.3L11.8,9z M11.8,12.6l0.8-0.8l2.3,2.3\n\tl-0.8,0.8L11.8,12.6z M6.7,14.1L9,11.8l0.8,0.8l-2.3,2.3L6.7,14.1z M6.7,7.5l0.8-0.8L9.8,9L9,9.8L6.7,7.5z"
			},
			children: [
			]
		}
	]
},
	"allow-block-list": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.4,1.8H6.8v2.6H3.2v15.4h12.6l0-4h2.6V1.8z M4.2,18.8l0-13.4h10.6v13.4H4.2z M16,4.1H9v-1H16L16,4.1z M13,7.2v1H6.1v-1\n\tH13z M13,10.2v1H6.1v-1H13z M13,13.2v1H6.1v-1L13,13.2z"
			},
			children: [
			]
		}
	]
},
	"alternate-checkmark": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.80009,19.80015a9,9,0,1,1,9-9A9.01054,9.01054,0,0,1,10.80009,19.80015Zm0-16.87512a7.87512,7.87512,0,1,0,7.87512,7.87512A7.88411,7.88411,0,0,0,10.80009,2.925ZM14.75,8.63964,13.95474,7.85,9.62367,12.17072,7.64331,10.20631,6.85,10.9979,9.62562,13.75Z"
			},
			children: [
			]
		}
	]
},
	"american-sign-language": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.83345,13.06175a1.97105,1.97105,0,0,0,2.58593.97558.50044.50044,0,0,1,.33985.94141,3.50211,3.50211,0,0,1-1.19043.22168,2.98049,2.98049,0,0,1-2.64307-1.71875.50007.50007,0,0,1,.90772-.41992Zm3.2705,3.21289a.50006.50006,0,1,0-.45117-.89258c-2.082,1.05078-3.1416-.09278-3.1914-.14844a.5.5,0,0,0-.75879.65137,3.09319,3.09319,0,0,0,2.291.94726A4.67237,4.67237,0,0,0,14.104,16.27464ZM19.517,9.489a.49728.49728,0,0,0-.44726-.09717c-.02833.00733-2.87305.74707-4.75586-.15088-.05017-.0241-.1012-.048-.15186-.07049a2.34113,2.34113,0,0,0-2.16553.13641.49993.49993,0,0,0,.51758.85547,1.3576,1.3576,0,1,1-.63769,1.3916.50018.50018,0,0,0-.98633.167,2.35754,2.35754,0,0,0,4.68164-.39551,2.32657,2.32657,0,0,0-.12836-.73291,10.33314,10.33314,0,0,0,3.21039-.09033l-.13184,1.91992a8.40057,8.40057,0,0,0-2.82226,3.10449,2.0326,2.0326,0,0,1-.43067.52246,7.9358,7.9358,0,0,1-3.27539,1.44238.5.5,0,0,0,.11231.98731.49514.49514,0,0,0,.1123-.0127,8.88491,8.88491,0,0,0,3.68555-1.64355,3.025,3.025,0,0,0,.65137-.77832c1.43652-2.36524,2.60156-2.82227,2.60547-2.82422a.49872.49872,0,0,0,.33886-.43945l.19824-2.8711A.50308.50308,0,0,0,19.517,9.489Zm-8.2959-.66113a.50012.50012,0,0,0,.45362-.709,2.96787,2.96787,0,0,0-3.8335-1.49658.49981.49981,0,0,0,.33887.94043,1.973,1.973,0,0,1,2.5874.97608A.499.499,0,0,0,11.22114,8.82786ZM7.49653,5.32542a.49984.49984,0,0,0,.4502.89258c2.08349-1.05127,3.14258.09326,3.19238.14941a.50018.50018,0,0,0,.75879-.65186C11.8354,5.64134,10.31245,3.906,7.49653,5.32542Zm2.27588,6.28027a.50032.50032,0,0,0-.687-.16748,1.34455,1.34455,0,0,1-.69971.19385,1.35718,1.35718,0,1,1,1.33838-1.58594.50018.50018,0,1,0,.98633-.167,2.35785,2.35785,0,0,0-4.68213.396,2.32583,2.32583,0,0,0,.12842.7331,10.36328,10.36328,0,0,0-3.21094.08966l.13281-1.91944A8.40769,8.40769,0,0,0,5.90034,6.07493,2.04274,2.04274,0,0,1,6.33149,5.551,7.93955,7.93955,0,0,1,9.6064,4.10862.50008.50008,0,0,0,9.38179,3.134a8.87154,8.87154,0,0,0-3.68506,1.644,3.031,3.031,0,0,0-.65137.77832C3.60884,7.9221,2.4438,8.37815,2.43989,8.3801a.50042.50042,0,0,0-.33935.439l-.19825,2.87207a.501.501,0,0,0,.18116.42041.50831.50831,0,0,0,.44677.09766c.02832-.00782,2.87452-.74854,4.75538.15039.03936.01886.09344.04535.14733.06738a2.34226,2.34226,0,0,0,2.172-.13379A.50055.50055,0,0,0,9.77241,11.60569Z"
			},
			children: [
			]
		}
	]
},
	analytics: analytics,
	announcement: announcement,
	"app-dialer": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M6.70574,6.71227H1.8V1.8H6.70574ZM2.91688,5.59412h2.672v-2.676h-2.672Zm10.3292,1.11815H8.33937V1.8h4.90671ZM9.45625,5.59412h2.673v-2.676H9.45625ZM19.78546,6.71227H14.87875V1.8h4.90671ZM15.99563,5.59412h2.67295v-2.676H15.99563Zm-9.27535,7.662H1.81454V8.34387H6.72028ZM2.93142,12.138h2.672V9.462h-2.672Zm10.32921,1.11814H8.35392V8.34387h4.90671ZM9.4708,12.138h2.673V9.462H9.4708ZM19.8,13.25613H14.89329V8.34387H19.8ZM16.01017,12.138h2.673V9.462H16.01017ZM6.70574,19.8H1.8V14.88773H6.70574ZM2.91688,18.68185h2.672v-2.676h-2.672ZM13.24608,19.8H8.33937V14.88773h4.90671ZM9.45625,18.68185h2.673v-2.676H9.45625ZM19.78546,19.8H14.87875V14.88773h4.90671Zm-3.78983-1.11815h2.67295v-2.676H15.99563Z"
			},
			children: [
			]
		}
	]
},
	"app-level-protection": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.40182,2.925l-.00528,5.09293c0,4.02136-2.399,7.80645-6.60849,10.46746-4.19818-2.62225-6.591-6.4071-6.591-10.4663L4.2023,2.925H17.40182M18.528,1.8H3.07846L3.072,8.01793c0,4.80114,3.031,9.07217,7.71988,11.78207,4.68881-2.74915,7.72964-7.02014,7.72964-11.78207L18.528,1.8ZM9.78485,9.06941H7.91668a.56265.56265,0,0,1-.5625-.5625V6.63777a.56265.56265,0,0,1,.5625-.5625H9.78485a.56265.56265,0,0,1,.5625.5625V8.50691A.56265.56265,0,0,1,9.78485,9.06941Zm-1.30567-1.125h.74317V7.20027H8.47918Zm5.20411,1.125H11.81512a.56264.56264,0,0,1-.5625-.5625V6.63777a.56264.56264,0,0,1,.5625-.5625h1.86817a.56265.56265,0,0,1,.5625.5625V8.50691A.56265.56265,0,0,1,13.68329,9.06941Zm-1.30567-1.125h.74317V7.20027h-.74317ZM9.78485,12.9532H7.91668a.56265.56265,0,0,1-.5625-.5625V10.52156a.56265.56265,0,0,1,.5625-.5625H9.78485a.56265.56265,0,0,1,.5625.5625V12.3907A.56265.56265,0,0,1,9.78485,12.9532Zm-1.30567-1.125h.74317v-.74414H8.47918Zm5.20411,1.125H11.81512a.56264.56264,0,0,1-.5625-.5625V10.52156a.56264.56264,0,0,1,.5625-.5625h1.86817a.56265.56265,0,0,1,.5625.5625V12.3907A.56265.56265,0,0,1,13.68329,12.9532Zm-1.30567-1.125h.74317v-.74414h-.74317Z"
			},
			children: [
			]
		}
	]
},
	"ar-lens": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 38 38"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m5,13.66663h-2V3h10.66669v2H5v8.66663Zm0,10.66669h-2v10.66669h10.66669v-2H5v-8.66669Zm28,8.66669h-8.66663v2h10.66663v-10.66669h-2v8.66669ZM24.33337,3v2h8.66663v8.66663h2V3h-10.66663Zm2.44495,23.77832c-2.14453,2.14453-4.96143,3.2168-7.77832,3.2168s-5.63379-1.07227-7.77832-3.2168c-4.28857-4.28906-4.28857-11.26758,0-15.55664,4.28906-4.28906,11.26758-4.28906,15.55664,0,4.28857,4.28906,4.28857,11.26758,0,15.55664Zm-1.41406-1.41406c3.5083-3.50879,3.5083-9.21875,0-12.72852-1.75488-1.75439-4.05957-2.63135-6.36426-2.63135s-4.60938.87695-6.36426,2.63135c-3.50879,3.50977-3.50879,9.21875,0,12.72852,3.50879,3.50781,9.21875,3.50977,12.72852,0Zm-6.36487-1.36426c2.41925,0,4.37988-1.77246,4.50061-4h-9c.12048,2.22754,2.07935,4,4.49939,4Zm-2.92072-7.88617c0-.69037-.55963-1.25-1.25-1.25s-1.25.55963-1.25,1.25.55963,1.25,1.25,1.25,1.25-.55963,1.25-1.25Zm7.09271-1.25c-.69037,0-1.25.55963-1.25,1.25s.55963,1.25,1.25,1.25c.69031,0,1.25-.55963,1.25-1.25s-.55969-1.25-1.25-1.25Z"
			},
			children: [
			]
		}
	]
},
	ar: ar,
	archive: archive,
	artboard: artboard,
	"asset-tracking": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.84288,12.92619a4.22235,4.22235,0,0,0-1.46692-1.161V6.293L9.6,1.80321,1.82341,6.293v8.97882L9.6,19.761,12.2653,18.2224a4.22239,4.22239,0,0,0,6.57758-5.29621ZM9.6,3.09111l2.47,1.42621L5.96928,8.0396,3.50065,6.61241ZM9.04228,18.15105,2.93864,14.62822V7.57542l6.10364,3.52851ZM7.084,8.68413l6.10174-3.52277,2.51831,1.454L9.60429,10.141Zm4.58618,8.59369-1.51312.87347V11.10954l6.10363-3.528V11.402a4.21789,4.21789,0,0,0-4.59051,5.87586Zm7.027-1.71161a3.15787,3.15787,0,1,1,0-.00019ZM16.98,15.77739l-.38177.38153a1.498,1.498,0,0,0-2.118,0l-.38135-.38153h.00006A2.03747,2.03747,0,0,1,16.98,15.77739Zm-.69207.69238-.38184.38086a.53259.53259,0,0,0-.73437.00037l-.38135-.3816A1.08417,1.08417,0,0,1,16.288,16.46977Zm1.3836-1.38422-.38128.3816a2.47673,2.47673,0,0,0-3.50208,0l-.38135-.3816A3.01582,3.01582,0,0,1,17.67155,15.08555Z"
			},
			children: [
			]
		}
	]
},
	"assisted-listening-systems": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9.8166,7.947A2.7967,2.7967,0,0,0,8.26,9.2419a.3749.3749,0,0,1-.66-.3565A3.5163,3.5163,0,0,1,9.654,7.215a2.6508,2.6508,0,0,1,2.2007.6,2.871,2.871,0,0,1,.58,3.9908.3752.3752,0,0,1-.6231-.418,2.1769,2.1769,0,0,0-.41-2.9751A1.9413,1.9413,0,0,0,9.8166,7.947ZM9.27,11.6559a.5377.5377,0,1,0-.5377-.5377A.5377.5377,0,0,0,9.27,11.6559Zm-1.42.3649a.5377.5377,0,1,0,.5377.5376A.5377.5377,0,0,0,7.8506,12.0208ZM5.3233,14.5819a.5377.5377,0,1,0,.5376.5377A.5377.5377,0,0,0,5.3233,14.5819Zm-1.4086,1.44a.5377.5377,0,1,0,.5377.5377A.5377.5377,0,0,0,3.9147,16.0221Zm1.6138-2.5053,1.6074,1.4287.7471-.8418L6.2756,12.675ZM10.259,4.7707A5.5231,5.5231,0,0,0,4.8762,9.5661.5626.5626,0,0,0,5.9934,9.7a4.3433,4.3433,0,0,1,4.2929-3.8042,3.4623,3.4623,0,0,1,3.336,1.8711,4.4341,4.4341,0,0,1,.0078,4.2578c-1.459,2.0869-1.9614,2.91-2.064,3.669a2.8937,2.8937,0,0,0,.0239.6367c.0616.6152.1641,1.6435-.3349,2.11a2.1157,2.1157,0,0,1-1.7764.2422.57.57,0,0,0-.6489.461.5627.5627,0,0,0,.46.6484,5.4624,5.4624,0,0,0,.9156.083,2.568,2.568,0,0,0,1.8169-.6123c.9062-.8467.7636-2.2764.6865-3.044a3.0677,3.0677,0,0,1-.0283-.374c.0644-.4785.4843-1.1914,1.8711-3.1758a5.5583,5.5583,0,0,0,.0615-5.4345A4.608,4.608,0,0,0,10.259,4.7707Zm3.53-.8317-.1721.7291a1.9854,1.9854,0,0,1,1.413.731,1.7693,1.7693,0,0,1,.4443,1.4157l.76-.3028a2.6005,2.6005,0,0,0-.631-1.5958A2.7594,2.7594,0,0,0,13.7886,3.939Zm.528-2.2366-.1736.7353a3.9592,3.9592,0,0,1,3.2617,3.6077l.7256-.2892A4.7232,4.7232,0,0,0,14.3166,1.7024Z"
			},
			children: [
			]
		}
	]
},
	at: at,
	attach: attach,
	"audience-targeted-search": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.3,18.4944l-.80585.80584-4.46905-4.469A7.39274,7.39274,0,0,1,2.97236,13.198H4.37672a6.2661,6.2661,0,1,0,6.54169-10.0152V2.00618a7.39631,7.39631,0,0,1,3.91253,12.01916ZM4.314,4.3141A2.51419,2.51419,0,1,1,6.8282,6.8282,2.5142,2.5142,0,0,1,4.314,4.3141Zm1.13983,0A1.37436,1.37436,0,1,0,6.8282,2.93977,1.37584,1.37584,0,0,0,5.45387,4.3141Zm6.40259,7.74408H1.8V9.56843a7.43687,7.43687,0,0,1,10.05646,0Zm-1.13983-1.95813a6.27773,6.27773,0,0,0-7.77686,0v.81836h7.77686Z"
			},
			children: [
			]
		}
	]
},
	"audio-description": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.55,4.05H4.05A2.25,2.25,0,0,0,1.8,6.3v9a2.25,2.25,0,0,0,2.25,2.25h13.5A2.25,2.25,0,0,0,19.8,15.3v-9A2.25,2.25,0,0,0,17.55,4.05ZM18.8,15.3a1.25147,1.25147,0,0,1-1.25,1.25H4.05A1.25143,1.25143,0,0,1,2.8,15.3v-9A1.25139,1.25139,0,0,1,4.05,5.05h13.5A1.25143,1.25143,0,0,1,18.8,6.3Zm-4.09222-4.12091a5.05278,5.05278,0,0,1-.55573,2.31067h-.861a4.28326,4.28326,0,0,0-.00031-4.62213H14.152A5.05573,5.05573,0,0,1,14.70778,11.17909Zm.84863-2.31146a5.08336,5.08336,0,0,1,.00012,4.62213h-.861a4.28326,4.28326,0,0,0-.00031-4.62213Zm1.44964.00518a5.08321,5.08321,0,0,1,.00013,4.62208h-.861a4.28336,4.28336,0,0,0-.00036-4.62208ZM7.37751,8.65443H7.2281L4.04036,13.58156h1.212l.52338-.84638,1.6018.03235v.814H8.44844V8.65443H7.37751Zm0,3.12915H6.36409l1.01342-1.63891ZM12.44868,9.3611a1.9866,1.9866,0,0,0-.69183-.50525,2.21052,2.21052,0,0,0-.902-.17908L9.15406,8.66743l.0373,4.95307,1.59967-.00409a2.47309,2.47309,0,0,0,.96271-.17585,1.94262,1.94262,0,0,0,.70739-.49432,2.10606,2.10606,0,0,0,.43354-.76746,3.1873,3.1873,0,0,0,.147-.99841,3.275,3.275,0,0,0-.15326-1.02911A2.23433,2.23433,0,0,0,12.44868,9.3611Zm-.81946,2.91412a1.09878,1.09878,0,0,1-.92077.385L10.2,12.661,10.16267,9.6269l.56452.00647a1.03828,1.03828,0,0,1,.902.42139,1.888,1.888,0,0,1,.30274,1.12561A1.73112,1.73112,0,0,1,11.62922,12.27522Z"
			},
			children: [
			]
		}
	]
},
	"available-lines": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9.36355,8.93675a.55669.55669,0,0,1,0,1.11338H7.24527a.55669.55669,0,1,1,0-1.11338H9.36355m0-1.125H7.24527a1.68169,1.68169,0,1,0,0,3.36338H9.36355a1.68169,1.68169,0,0,0,0-3.36338ZM8.30171,1.8V3.79811H5.80348V5.79622H3.30519V19.8h9.9931V17.802h2.49823v-1.9981h2.49829V1.8Zm3.87158,16.875H4.43019V6.92122h7.7431Zm2.49823-1.998H13.29829V5.79622H6.92848V4.92311h7.743Zm2.49829-1.9981H15.79652V3.79811H9.42671V2.925h7.7431Z"
			},
			children: [
			]
		}
	]
},
	award: award,
	awareness: awareness,
	"baby-monitor": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,7.65865a3.14386,3.14386,0,1,0,3.14386,3.14386A3.14767,3.14767,0,0,0,10.8,7.65865Zm0,5.13283a1.989,1.989,0,1,1,1.989-1.989A1.9912,1.9912,0,0,1,10.8,12.79148Zm0-7.8777A5.69857,5.69857,0,0,0,6.24461,7.19511V1.8H5.08972v18H16.51028V10.62406A5.71648,5.71648,0,0,0,10.8,4.91378Zm4.55539,13.73133H6.24461v-8.021a4.55539,4.55539,0,0,1,9.11078,0ZM8.23358,15.81h5.13284v1.15488H8.23358Z"
			},
			children: [
			]
		}
	]
},
	barcode: barcode,
	battery: battery,
	"best-practices": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12.63636,5.77748V8.16823l-2.01348,2.01348-.14649.98359.9419-.18818,2.0166-2.01666,2.38763.00318L19.8,4.9861,16.61384,4.982V1.8Zm1.125.466L15.48884,4.516v.79969L13.76136,7.04316Zm3.32624-.13586L15.35713,7.838l-.79871-.00109,1.73035-1.73035.32355.00037Zm2.00134,1.181a8.99416,8.99416,0,1,1-4.77716-4.77729l-.87671.87684a7.90649,7.90649,0,1,0,4.777,4.77734Zm-7.577-.91663A4.49172,4.49172,0,1,0,15.3,10.8a4.46366,4.46366,0,0,0-.072-.71228l1.11951-.05725A5.57219,5.57219,0,0,1,16.425,10.8,5.625,5.625,0,1,1,10.8,5.175a5.56328,5.56328,0,0,1,.771.0777Zm-1.509,3.63562a1.12348,1.12348,0,1,0,1.59632,1.5813l1.43566-.9378c.00342.05011.01508.09783.01508.14886A2.25,2.25,0,1,1,10.8,8.55c.05054,0,.09778.01154.14734.01483Z"
			},
			children: [
			]
		}
	]
},
	bid: bid,
	"bill-down": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M4.05,1.8V16.4l3.4,3.4h10.1V1.8Zm4,16.9H8L5.25,16v-.1h2.8Zm8.4,0H9.15V14.8H5.25V3h11.2Zm-5.6-5.1-3.5-3.5.8-.8,2.1,2.2V5.8h1.2v5.7l2.1-2.2.8.8Z"
			},
			children: [
			]
		}
	]
},
	"bill-up": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M4.05,1.8V16.43L7.43,19.8H17.55V1.8ZM16.43,18.68H9.11V14.74H5.18v1.12H8v2.82h-.1L5.18,16v-13H16.43ZM8.07,10.12l-.79-.8L10.8,5.8l3.52,3.52-.79.8L11.36,8v5.66H10.24V8Z"
			},
			children: [
			]
		}
	]
},
	blind: blind,
	bluetooth: bluetooth,
	"bonus-data": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.36,10.24h2.25v1.12H11.36v2.25H10.24V11.36H8V10.24h2.25V8h1.12Zm8.44,3-2.54,1.32.13,2.86-2.86-.13L13.21,19.8,10.8,18.25,8.39,19.8,7.07,17.26l-2.86.13.13-2.86L1.8,13.21,3.35,10.8,1.8,8.39,4.34,7.07,4.21,4.21l2.86.13L8.39,1.8,10.8,3.35,13.21,1.8l1.32,2.54,2.86-.13-.13,2.86L19.8,8.39,18.25,10.8ZM16.92,10.8l1.27-2L16.1,7.74l.11-2.35-2.35.11L12.78,3.41l-2,1.27-2-1.27L7.74,5.5,5.39,5.39,5.5,7.74,3.41,8.82l1.27,2-1.27,2L5.5,13.86l-.11,2.35,2.35-.11,1.08,2.09,2-1.27,2,1.27,1.08-2.09,2.35.11-.11-2.35,2.09-1.08Z"
			},
			children: [
			]
		}
	]
},
	bookmark: bookmark,
	bot: bot,
	"box-open": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.68,8.72l2.06-2.14L12.86,1.84,10.84,4,8.78,1.8,2.86,6.58,4.92,8.72,2.86,10.86,5.1,12.67v2.56l5.72,4.57,5.71-4.57V12.64l2.21-1.77ZM10.8,12.05,6.64,8.72,10.8,5.4,15,8.72Zm5-2.59,1.25,1.3L13,14.08,11.7,12.77ZM13,3.37l4.12,3.31L15.83,8,11.7,4.68ZM8.69,3.32,10,4.64,5.77,8,4.52,6.68ZM5.77,9.46,10,12.8,8.68,14.12,4.52,10.76Zm.46,4.12,2.55,2.06,1.5-1.56v3.85l-4-3.24Zm9.18,1.11-4,3.2V14.08l1.46,1.52,2.55-2v1.14Z"
			},
			children: [
			]
		}
	]
},
	braille: braille,
	brightness: brightness,
	"bring-your-own-device": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.70071,9.82l.25-.16a1.21,1.21,0,0,0,.51-.77,1.18023,1.18023,0,0,0-.22-.84,1.20971,1.20971,0,0,0-.81-.52l.09-.06a1.2,1.2,0,0,0,.34-1.65,1.17,1.17,0,0,0-1.06-.52V1.82h-7.94V7.69a2.13987,2.13987,0,0,0-2-.48,1,1,0,0,0-.50946,1.31922L5.36069,8.55c.06.26.14.52.21.79a10.99588,10.99588,0,0,1,.37,1.56,7.67528,7.67528,0,0,1,0,1.51995V12.97a9.93062,9.93062,0,0,0,.19,2.06l-2,3.46.72.42,2.07-3.51a.93041.93041,0,0,0,.09-.4l-.08-.41a6.60993,6.60993,0,0,1-.16-1.59v-.54a6.0822,6.0822,0,0,0,0-1.64,13.5251,13.5251,0,0,0-.4-1.67l-.24-.81c0-.14-.06-.32,0-.36a1.44013,1.44013,0,0,1,1.33.55005,3.05916,3.05916,0,0,1,.34,1.06v4.93h5.8a2.52994,2.52994,0,0,1-2.17,2.1h-.18l-.42.75a8.44467,8.44467,0,0,0-.57,1.08c-.12.24-.24.51-.47.92l.73.41a9.75126,9.75126,0,0,0,.49-1,7.48523,7.48523,0,0,1,.54-1l.25-.45a3.3,3.3,0,0,0,2.64-2.87h1.36v-.07a1.94006,1.94006,0,0,0,1.1-.93,1.12019,1.12019,0,0,0,0-1.15,1.16007,1.16007,0,0,0-.38-.35l.2-.13a1.13012,1.13012,0,0,0,.50995-.76,1.1698,1.1698,0,0,0-.17-.91A1.29016,1.29016,0,0,0,16.70071,9.82Zm-.84-3.73h.05005a.37.37,0,0,1,.2.68l-1.18.75a.37166.37166,0,0,1-.41736-.615l.00738-.005,1.13-.75A.38946.38946,0,0,1,15.86069,6.09Zm-.85-3.48v3l-1,.63a1.21011,1.21011,0,0,0-.34,1.67005,1.16992,1.16992,0,0,0,.81.50994l-.09.06a1.2,1.2,0,0,0-.26,1.64,1.1697,1.1697,0,0,0,.36.34l-.25.16a1.2102,1.2102,0,0,0-.5.72h-5l-.08-8.73Zm-.61,10.38a1.1796,1.1796,0,0,0-.06.74h-5.68V12.14h2.37994v.8h1.59v-.8h1.17l.11005.22a1.08978,1.08978,0,0,0,.62994.42A1.52391,1.52391,0,0,0,14.40073,12.99Zm1.73.16a1.12,1.12,0,0,1-.73.55.26008.26008,0,0,1-.25-.1.29981.29981,0,0,1,0-.28,1.10025,1.10025,0,0,1,.31-.38,1.00017,1.00017,0,0,1,.4-.24.27.27,0,0,1,.27.12A.31.31,0,0,1,16.13071,13.15Zm.13-2-1.13.8a.39.39,0,0,1-.28,0,.36011.36011,0,0,1-.24-.16.37.37,0,0,1,.11-.50995l1.13-.75a.35945.35945,0,0,1,.2-.06.37994.37994,0,0,1,.31.16.35994.35994,0,0,1,.06.28A.37.37,0,0,1,16.26071,11.15Zm.18-2.13-1.13.8a.38.38,0,0,1-.52-.11.37.37,0,0,1,.11-.51l1.12-.75a.38.38,0,0,1,.52.06A.36994.36994,0,0,1,16.44071,9.02Z"
			},
			children: [
			]
		}
	]
},
	"business-continuity": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.59541,12.52565H13.5041v-1.116h3.09131Zm0,1.03723H13.5041v1.116h3.09131Zm0,2.15332H13.5041v1.116h3.09131ZM7.01,5.46644H5.89424v1.116H7.01Zm2.08154,0H7.97529v1.116H9.0915ZM7.01,8.05848H5.89424v1.116H7.01Zm2.08154,0H7.97529v1.116H9.0915ZM7.01,10.65053H5.89424v1.116H7.01Zm2.08154,0H7.97529v1.116H9.0915ZM7.01,13.24257H5.89424v1.116H7.01Zm2.08154,0H7.97529v1.116H9.0915ZM19.8,18.15541v1.116H1.8v-1.116h.94531V2.33339h9.49512V9.07411h6.69922v9.0813ZM11.12422,3.44935H3.861v14.688H6.37666V15.83449H8.60859v2.30285h2.51563Zm6.69922,6.74073H12.27607v7.94726h5.54737ZM16.1725,7.994h.936a3.81382,3.81382,0,0,0-3.814-3.81347v.93591A2.878,2.878,0,0,1,16.1725,7.994Zm-.916,0a1.96172,1.96172,0,0,0-1.96185-1.96142v.93591a1.02506,1.02506,0,0,1,1.02588,1.02429V7.994Zm2.76813-.00122V7.994h.936a5.6658,5.6658,0,0,0-5.666-5.6654v.93591A4.72913,4.72913,0,0,1,18.02461,7.99281Z"
			},
			children: [
			]
		}
	]
},
	"buy-plans": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9.58623,13.983a1.31863,1.31863,0,0,0,.23937.85871,1.02064,1.02064,0,0,0,.8174.33034V13.1739a6.81036,6.81036,0,0,1-.67276-.21871,2.44912,2.44912,0,0,1-.60272-.33033,1.5468,1.5468,0,0,1-.43339-.50772,1.57911,1.57911,0,0,1-.16529-.75969,1.52451,1.52451,0,0,1,.1527-.69771,1.47616,1.47616,0,0,1,.41323-.50369,1.89825,1.89825,0,0,1,.59817-.30942,2.33674,2.33674,0,0,1,.71006-.10734v-.644h.35528v.644a2.434,2.434,0,0,1,.702.099,1.65,1.65,0,0,1,.57349.29707,1.42383,1.42383,0,0,1,.388.50369,1.6456,1.6456,0,0,1,.14463.71005h-.94136a.98665.98665,0,0,0-.21871-.644.837.837,0,0,0-.64806-.22275v1.74213q.37115.099.72668.231a2.45612,2.45612,0,0,1,.6274.33865,1.485,1.485,0,0,1,.60272,1.26313,1.9629,1.9629,0,0,1-.1527.80505,1.58916,1.58916,0,0,1-.41726.5697,1.83572,1.83572,0,0,1-.61884.34671,2.73724,2.73724,0,0,1-.768.13632v.644H10.643v-.644a2.5769,2.5769,0,0,1-.8174-.14035,1.8232,1.8232,0,0,1-.63546-.37569,1.63818,1.63818,0,0,1-.4087-.59868,2.056,2.056,0,0,1-.13606-.81739ZM10.643,10.48235a1.11638,1.11638,0,0,0-.68939.18571.73584.73584,0,0,0-.24341.62337.65709.65709,0,0,0,.08265.3384.82768.82768,0,0,0,.21065.23962,1.097,1.097,0,0,0,.29732.161,3.01419,3.01419,0,0,0,.34218.10306Zm.35528,4.68968a1.2949,1.2949,0,0,0,.73071-.26.86856.86856,0,0,0,.28473-.7224.79294.79294,0,0,0-.08668-.38828.82469.82469,0,0,0-.23131-.26407,1.27417,1.27417,0,0,0-.326-.17335q-.18143-.06615-.3714-.11566ZM16.425,2.925v15.75H5.175V2.925h11.25M17.55,1.8H4.05v18h13.5V1.8Zm-4.5,3.383a.5625.5625,0,0,1,0,1.125H8.55a.5625.5625,0,1,1,0-1.125h4.5m0-1.125H8.55a1.6875,1.6875,0,0,0,0,3.375h4.5a1.6875,1.6875,0,0,0,0-3.375Z"
			},
			children: [
			]
		}
	]
},
	calendar: calendar,
	calibrate: calibrate,
	"call-disconnected": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M6.08406,13.87082a18.54029,18.54029,0,0,1-4.2793-8.9613l3.76379-3.1123L9.8932,6.12766,8.65577,8.62925a15.75087,15.75087,0,0,0,1.09656,1.44238l-.78271.81067a16.78414,16.78414,0,0,1-1.251-1.63062l-.3587-.5401.28747-.58117L8.52717,6.3519,5.49623,3.31681l-2.45612,2.031a17.41892,17.41892,0,0,0,3.82361,7.71546Zm9.38659-2.1582-2.50317,1.23419c-.26123-.17407-.50928-.37121-.76123-.56158l-.7868.81451c.30322.23322.60376.46967.92425.68323l.53967.35962.58161-.28674,1.77966-.87745,3.03088,3.035-2.03424,2.45343a17.52321,17.52321,0,0,1-6.91943-3.19556l-.7829.81043a18.65582,18.65582,0,0,0,8.139,3.62109l3.11731-3.75971Zm.69263-6.662L3.3293,18.33963l.80957.78125,12.833-13.28906Z"
			},
			children: [
			]
		}
	]
},
	"caller-id": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 38 38"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m29.00012,28h-.00024V3H8.99988v32h20v-5h.00024v-2Zm-2.00024-23v23H10.99988V5h16Zm0,28H10.99988v-3h6.00024v2h4v-2h5.99976v3Zm-11.79028-12.5495h-2.20312v-8.90363h2.20312v8.90363Zm8.21558-.80896c1.05542-.88251,1.54517-2.25162,1.54517-3.58685,0-2.27603-1.38818-4.24921-3.62915-4.48578-.16357-.01727-.32788-.0246-.49243-.02203h-3.79883v8.90363h3.66162c.96899.03705,1.9231-.24738,2.71362-.80896Zm-4.17017-1.04688v-5.2049h1.31934c1.38208,0,2.16675,1.04602,2.16675,2.66492,0,1.63104-.74634,2.53992-2.19092,2.53992l-1.29517.00006Z"
			},
			children: [
			]
		}
	]
},
	"camera-effects": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 38 38"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m7.50281,14.00122l1.99951.00391c.00391-.46082.16158-4.50281,4.4989-4.50281l.00391-1.99951c-.46082-.00391-4.50281-.16158-4.50281-4.4989l-1.99951-.00391c-.00391.46082-.16158,4.50281-4.4989,4.50281l-.00391,1.99951c.46082.00391,4.50281.16158,4.50281,4.4989Zm.96949-7.34196c.50427.78936,1.1628,1.38052,1.87357,1.81303-.78936.50427-1.38052,1.1628-1.81303,1.87357-.50427-.78936-1.1628-1.38052-1.87357-1.81303.78936-.50427,1.38052-1.1628,1.81303-1.87357Zm22.0249,17.33952l-1.99951-.00391c-.00391.46082-.16158,4.50281-4.4989,4.50281l-.00391,1.99951c.46082.00391,4.50281.16109,4.50281,4.4989l1.99951.00391c.00391-.46082.16158-4.50281,4.4989-4.50281l.00391-1.99951c-.46082-.00391-4.50281-.16109-4.50281-4.4989Zm-.96949,7.34196c-.50427-.78985-1.1628-1.38052-1.87357-1.81303.78936-.50378,1.38052-1.1628,1.81303-1.87357.50427.78985,1.1628,1.38052,1.87357,1.81303-.78936.50378-1.38052,1.1628-1.81303,1.87357Zm.64919-28.31767L3.02599,30.17391l4.7929,4.7929L34.96973,7.81596l-4.79284-4.7929Zm1.96516,4.7929l-3.21144,3.21144-1.96534-1.96504,3.21156-3.21156,1.96522,1.96516ZM5.85373,30.17391L25.55156,10.47608l1.96534,1.96504L7.81889,32.13907l-1.96516-1.96516Z"
			},
			children: [
			]
		}
	]
},
	"camera-modes": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 38 38"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m19,3C10.16345,3,3,10.16345,3,19s7.16345,16,16,16,16-7.16345,16-16S27.83655,3,19,3Zm13.3999,20.04053l-8.37402-8.37402h8.27948c.44611,1.36603.69464,2.82043.69464,4.3335,0,1.40497-.21326,2.76013-.6001,4.04053Zm-9.06641-1.84229l-2.13489,2.13477h-4.40369l-2.12842-2.12842v-4.38379l2.15417-2.1543h4.37708l2.13574,2.13574v4.396Zm8.13556-8.53174h-12.64844l6.25818-6.25842c2.75281,1.33447,5.00208,3.53687,6.39026,6.25842Zm-8.41412-7.06274l-8.38843,8.38885V5.69464c1.36603-.44611,2.82043-.69464,4.3335-.69464,1.41016,0,2.77032.21411,4.05493.60376Zm-10.38843.92719v12.67365l-6.26654-6.26654c1.33368-2.76031,3.53949-5.01611,6.26654-6.4071Zm-7.06781,8.43396l8.3681,8.3681H5.69446c-.44598-1.36591-.69446-2.82013-.69446-4.33301,0-1.40302.21289-2.75623.59869-4.0351Zm.93201,10.3681h12.66785l-6.26514,6.26483c-2.75842-1.33398-5.01251-3.53906-6.40271-6.26483Zm8.42877,7.06696l8.37402-8.37366v8.27905c-1.36603.44611-2.82043.69464-4.3335.69464-1.40497,0-2.76013-.2132-4.04053-.60004Zm10.37402-.93091v-12.66681l6.26434,6.26434c-1.33392,2.7583-3.53882,5.01227-6.26434,6.40247Z"
			},
			children: [
			]
		}
	]
},
	camera: camera,
	"cards-on-reserve": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9.6335,15.98417,6.86055,13.22538l.793-.79688,1.97705,1.96582,4.314-4.32715.79688.79493ZM16.425,2.925H5.175v15.75h11.25V2.925M17.55,1.8v18H4.05V1.8Zm-4.5,3.383H8.55a.5625.5625,0,1,0,0,1.125h4.5a.5625.5625,0,0,0,0-1.125m0-1.125a1.6875,1.6875,0,0,1,0,3.375H8.55a1.6875,1.6875,0,0,1,0-3.375Z"
			},
			children: [
			]
		}
	]
},
	"carryover-data": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.37,12.24a7.53,7.53,0,0,1-2.22,5.35l-.89-.89a6.29,6.29,0,0,0,1.84-4.46Zm-12,4.46A6.27,6.27,0,0,1,10.51,6L8.37,8.1l.89.9,3.6-3.6L9.26,1.8l-.89.89,2,2a7.56,7.56,0,1,0,4.09,14.15l-.62-1.12A6.32,6.32,0,0,1,6.34,16.7Z"
			},
			children: [
			]
		}
	]
},
	"cell-phone": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M5.175,1.8v18h11.25V1.8ZM15.3,5.7375v10.125h-9V2.925h9V5.7375ZM6.3,18.675V16.9875H9.675v1.125h2.25v-1.125H15.3V18.675Z"
			},
			children: [
			]
		}
	]
},
	"cell-signal-alt": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 38 38"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m35,6v26h-8V6h8Zm-20,26h8V12h-8v20Zm-12,0h8v-14H3v14Z"
			},
			children: [
			]
		}
	]
},
	"cell-signal": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 38 38"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m27,6v26h8V6h-8Zm6.13403,23.93793h-4.26807V8.06213h4.26807v21.87579Zm-18.13403,2.06207h8V12h-8v20Zm1.86597-17.9505h4.26807v15.90106h-4.26807v-15.90106ZM3,32h8v-14H3v14Zm1.86597-11.93176h4.26807v9.86346h-4.26807v-9.86346Z"
			},
			children: [
			]
		}
	]
},
	"cell-tower": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13.3,6.2c-1.4-1.4-3.6-1.4-4.9,0l0,0L7.5,5.4c1.8-1.8,4.7-1.8,6.5,0L13.3,6.2z M9.1,7l0.8,0.8c0.5-0.5,1.3-0.5,1.8,0\n\tL12.5,7l0,0C11.5,6,10.1,6,9.1,7z M6.8,4.6c2.2-2.2,5.9-2.2,8.1,0l0.8-0.8l0,0c-2.7-2.7-7-2.7-9.7,0l0,0L6.8,4.6L6.8,4.6z\n\t M16.4,19.8h-1.2l-0.6-1.4l-3.8-3.5L7,18.4l-0.6,1.4H5.2l5.1-11.3h1L16.4,19.8z M10,14.1l-0.7-0.7l-1,2.3L10,14.1z M11.8,12.4\n\tl-1-2.3l-1,2.3l1,1L11.8,12.4z M13.4,15.7l-1-2.3l-0.7,0.7L13.4,15.7z"
			},
			children: [
			]
		}
	]
},
	"chat-disabled": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 38 38",
		style: "enable-background:new 0 0 38 38;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M28.4,22c-3.5,0-6.3,2.8-6.3,6.3s2.8,6.3,6.3,6.3c3.5,0,6.3-2.8,6.3-6.3S31.9,22,28.4,22z M28.4,24.1c2,0,3.7,1.4,4.1,3.3\n\tl-8.2,0C24.7,25.5,26.4,24.1,28.4,24.1z M28.4,32.6c-2,0-3.6-1.4-4.1-3.2l8.2,0C32,31.2,30.4,32.6,28.4,32.6L28.4,32.6z M27.3,18.8\n\tc0,1.2-0.9,2.1-2.1,2.1s-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1S27.3,17.7,27.3,18.8z M19,3C10.2,3,3,10.2,3,19c0,3.3,1,6.5,2.8,9\n\tL3,35l7-2.8c2.6,1.8,5.7,2.8,9,2.8c1.3,0,2.5-0.2,3.6-0.4c-0.6-0.5-1.1-1.2-1.5-1.9c-0.7,0.1-1.4,0.2-2.1,0.2\n\tc-2.8,0-5.5-0.8-7.8-2.4l-0.9-0.6l-1,0.4l-2.4,1l1-2.4l0.4-1l-0.6-0.9c-1.6-2.3-2.4-5-2.4-7.8c0-7.7,6.2-13.9,13.9-13.9\n\tS32.9,11.3,32.9,19c0,0.7-0.1,1.4-0.2,2.1c0.7,0.4,1.3,0.9,1.9,1.5c0.3-1.2,0.4-2.4,0.4-3.6C35,10.2,27.8,3,19,3z M16.7,18.8\n\tc0,1.2,0.9,2.1,2.1,2.1S21,20,21,18.8c0-1.2-0.9-2.1-2.1-2.1S16.7,17.7,16.7,18.8z M10.4,18.8c0,1.2,0.9,2.1,2.1,2.1\n\tc1.2,0,2.1-0.9,2.1-2.1c0-1.2-0.9-2.1-2.1-2.1C11.3,16.7,10.4,17.7,10.4,18.8z"
			},
			children: [
			]
		}
	]
},
	chat: chat,
	checkmark: checkmark,
	"clean-surface": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.939,6.573l-.00879,5.59918L9.80519,12.17,9.814,6.57081ZM7.49916,5.62764l-.00165,6.54345h1.125l.00165-6.54345Zm-1.18927.94372-1.125.0011.00494,5.59918,1.125-.0011Zm5.48932,9.19007A2.91686,2.91686,0,0,1,6.21815,16.9485l-3.4129-6.79065L1.8,10.66322l3.41565,6.79614A4.0715,4.0715,0,0,0,8.884,19.8a4.4881,4.4881,0,0,0,.57019-.03735,4.062,4.062,0,0,0,3.47-4.00122V7.51619h-1.125ZM16.70942,4.9593c-2.81451,0-5.62933-1.81866-8.44384-1.81866A5.52784,5.52784,0,0,0,5.175,4.05V5.175H6.3V4.70363a4.36708,4.36708,0,0,1,1.96558-.438,13.14034,13.14034,0,0,1,3.876.85492,14.9816,14.9816,0,0,0,4.56781.96374A6.78961,6.78961,0,0,0,18.675,5.805v8.84137a4.36783,4.36783,0,0,1-1.96558.43793,9.27236,9.27236,0,0,1-2.53442-.44238V15.8083a9.7318,9.7318,0,0,0,2.53442.401A5.52823,5.52823,0,0,0,19.8,15.3V4.05A5.52632,5.52632,0,0,1,16.70942,4.9593Z"
			},
			children: [
			]
		}
	]
},
	clock: clock,
	"close-alternate": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,1.78a9,9,0,1,0,9,9A9,9,0,0,0,10.8,1.78Zm0,16.88a7.88,7.88,0,1,1,7.88-7.88A7.89,7.89,0,0,1,10.8,18.66ZM14.38,8l-2.79,2.78,2.79,2.79-.8.79L10.8,11.58,8,14.36l-.8-.79L10,10.78,7.22,8,8,7.2,10.8,10,13.58,7.2Z"
			},
			children: [
			]
		}
	]
},
	close: close,
	"closed-captioning-filled": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.55049,4.03853H4.04951A2.24891,2.24891,0,0,0,1.80342,6.28462v9.03076a2.24891,2.24891,0,0,0,2.24609,2.24609h13.501a2.24891,2.24891,0,0,0,2.24609-2.24609V6.28462A2.24891,2.24891,0,0,0,17.55049,4.03853ZM7.78193,13.9687a2.68456,2.68456,0,0,1-2.7832-2.811A2.67293,2.67293,0,0,1,7.74482,8.33735a2.311,2.311,0,0,1,2.4834,1.97022H8.72529a.93983.93983,0,0,0-.96191-.80322c-.78418,0-1.19531.6538-1.19531,1.65332,0,.9624.41113,1.63427,1.19531,1.63427a.96434.96434,0,0,0,1.00879-.97119h1.49414A2.28765,2.28765,0,0,1,7.78193,13.9687Zm6.30664,0a2.68456,2.68456,0,0,1-2.7832-2.811,2.67216,2.67216,0,0,1,2.74512-2.82032,2.31137,2.31137,0,0,1,2.48437,1.97022H15.031a.93916.93916,0,0,0-.96192-.80322c-.78418,0-1.19531.6538-1.19531,1.65332,0,.9624.41113,1.63427,1.19531,1.63427a.96327.96327,0,0,0,1.00879-.97119H16.572A2.28673,2.28673,0,0,1,14.08857,13.9687Z"
			},
			children: [
			]
		}
	]
},
	"closed-captioning": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.55,4.05H4.05A2.25,2.25,0,0,0,1.8,6.3v9a2.25,2.25,0,0,0,2.25,2.25h13.5A2.25,2.25,0,0,0,19.8,15.3v-9A2.25,2.25,0,0,0,17.55,4.05ZM18.8,15.3a1.25139,1.25139,0,0,1-1.25,1.25H4.05A1.25139,1.25139,0,0,1,2.8,15.3v-9A1.25139,1.25139,0,0,1,4.05,5.05h13.5A1.25139,1.25139,0,0,1,18.8,6.3ZM8.77363,11.81563h1.49414A2.28729,2.28729,0,0,1,7.7834,13.96309a2.68433,2.68433,0,0,1-2.78272-2.81055A2.67254,2.67254,0,0,1,7.74629,8.33223a2.31121,2.31121,0,0,1,2.48389,1.97021H8.72676a.93917.93917,0,0,0-.96192-.80322c-.78418,0-1.19531.65381-1.19531,1.65332,0,.96191.41113,1.63379,1.19531,1.63379A.96369.96369,0,0,0,8.77363,11.81563Zm6.30274,0h1.49414a2.287,2.287,0,0,1-2.48438,2.14746,2.6846,2.6846,0,0,1-2.78271-2.81055A2.67254,2.67254,0,0,1,14.049,8.33223a2.31138,2.31138,0,0,1,2.48438,1.97021H15.02949a.93916.93916,0,0,0-.96191-.80322c-.78418,0-1.19531.65381-1.19531,1.65332,0,.96191.41113,1.63379,1.19531,1.63379A.96316.96316,0,0,0,15.07637,11.81563Z"
			},
			children: [
			]
		}
	]
},
	"cloud-alternative": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,9.6A3.37,3.37,0,0,1,16.4,13H13.8v4.6l1.8-1.8.8.8-3.2,3.2L10,16.6l.8-.8,1.8,1.7V11.8h3.8a2.2,2.2,0,1,0,0-4.4H15.3V6.3a3.37,3.37,0,0,0-3.4-3.4,3.29,3.29,0,0,0-3,1.9l-.4.9-1-.4a5,5,0,0,0-1.2-.2,3.4,3.4,0,1,0,0,6.8H9v-3L7.1,10.8,6.3,10,9.5,6.8,12.7,10l-.8.8L10.1,8.9v4.2H6.3A4.48,4.48,0,0,1,1.8,8.6,4.42,4.42,0,0,1,6.3,4.1a4.15,4.15,0,0,1,1.6.3,4.27,4.27,0,0,1,4-2.6,4.48,4.48,0,0,1,4.5,4.5A3.29,3.29,0,0,1,19.8,9.6Z"
			},
			children: [
			]
		}
	]
},
	"cloud-document": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.4,1.8H6.3v4.9C6.6,6.5,7,6.3,7.4,6.1V2.9h7.3v3.9h3.9v11.8H7.4V17H6.3v2.8h13.5V5.2L16.4,1.8z M18.6,5.7h-2.8V2.9h0.1\n\tL18.6,5.7L18.6,5.7z M14.9,13c0-1.4-1.1-2.5-2.5-2.5c0-1.8-1.5-3.3-3.3-3.3c-1.3,0-2.4,0.7-3,1.9c-1.7-0.6-3.6,0.2-4.2,1.9\n\ts0.2,3.6,1.9,4.2c0.4,0.1,0.8,0.2,1.1,0.2h7.3C13.8,15.5,14.9,14.4,14.9,13z M3,12.2c0-1.2,0.9-2.1,2.1-2.1c0.3,0,0.5,0,0.8,0.1\n\tl1,0.4l0.4-0.9c0.5-1.1,1.8-1.5,2.8-1c0.7,0.3,1.2,1.1,1.2,1.9v1.1h1.1c0.7,0,1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.3,1.3H5.1\n\tC3.9,14.3,3,13.4,3,12.2C3,12.2,3,12.2,3,12.2z"
			},
			children: [
			]
		}
	]
},
	cloud: cloud,
	coax: coax,
	coffee: coffee,
	"cognitive-disability": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "g",
			type: "element",
			value: "",
			attributes: {
				id: "Layer_2",
				"data-name": "Layer 2"
			},
			children: [
				{
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M9.68762,8.60442l.63507-.55707-.189-.42785-.80939.08929a1.75219,1.75219,0,0,0-.16809-.18494l.12738-.82745-.41986-.20654-.56146.58807a1.74955,1.74955,0,0,0-.248-.03149L7.619,6.32933l-.45435.11152-.05188.80706a1.76329,1.76329,0,0,0-.22442.135l-.78009-.26483-.27643.37732.47565.64722a1.77134,1.77134,0,0,0-.076.24957l-.7735.30145.0307.46662.78436.19067a1.77265,1.77265,0,0,0,.09583.244l-.39655.72314.32367.3382.71839-.35559a1.776,1.776,0,0,0,.23407.116l.16223.81579.465.05029.3274-.74585c.05316-.00805.106-.00939.1593-.02252.0299-.00732.05591-.02142.085-.03015l.65271.52387.38879-.26044-.22747-.778A1.7848,1.7848,0,0,0,9.411,9.76873l.83911-.01856.13056-.44946L9.699,8.8463A1.73388,1.73388,0,0,0,9.68762,8.60442Zm-1.4613,1.356a1.19478,1.19478,0,1,1,.87561-1.44513A1.195,1.195,0,0,1,8.22632,9.96038Zm4.74652-1.691.26331-.24695-.27381-.56934a1.34374,1.34374,0,0,0,.08753-.165l.6402-.12006.04266-.35816-.57208-.25872a1.35692,1.35692,0,0,0-.03888-.18879l.4096-.499-.19738-.302-.60364.16962a1.33846,1.33846,0,0,0-.15216-.11835l-.007-.64679-.34528-.10449-.3515.515a1.36621,1.36621,0,0,0-.2019.00147l-.41358-.48218-.3316.14172.06128.61634a1.356,1.356,0,0,0-.1485.13574l-.63171-.10394-.16291.32171.4455.43463a1.36989,1.36989,0,0,0-.03229.19959l-.54724.324.08191.35151.61639.04638a1.37107,1.37107,0,0,0,.10968.16883l-.21283.605.2887.21606.51025-.36627c.03846.01562.074.0354.11457.04767.02264.0069.04553.00769.06823.01336l.2273.60407.36029-.02008.15472-.60559a1.3685,1.3685,0,0,0,.17817-.07453Zm-1.42529-.6557A.92126.92126,0,1,1,12.69623,6.999.92136.92136,0,0,1,11.54755,7.6137Zm6.8338,4.01922c-.165.522-.792.74366-1.30664.86182a.87515.87515,0,0,0,0,.125,14.87852,14.87852,0,0,1-.13086,3.27539,1.58042,1.58042,0,0,1-1.53516,1.27051,9.13451,9.13451,0,0,1-1.11718-.03223.51488.51488,0,0,0-.499.23535,4.22649,4.22649,0,0,0-.35,2.28156l-1.1236-.34052a4.997,4.997,0,0,1,.50678-2.51623,1.63258,1.63258,0,0,1,1.55957-.78125,7.62286,7.62286,0,0,0,.97265.03027c.21-.00976.44531-.13184.47461-.32031a13.80253,13.80253,0,0,0,.11914-3.03223,1.31476,1.31476,0,0,1,.27246-.98779.83987.83987,0,0,1,.56543-.29,2.47467,2.47467,0,0,0,.3877-.11377L15.68408,8.89074a1.14378,1.14378,0,0,1-.125-.96729A3.59826,3.59826,0,0,0,14.9917,6.0299a5.64943,5.64943,0,0,0-3.7168-2.77051,6.91958,6.91958,0,0,0-3.6289.15039A4.09593,4.09593,0,0,0,5.41748,4.92833a6.31436,6.31436,0,0,0-1.09961,4.125,5.01857,5.01857,0,0,0,1.084,3.041c.7276,1.04327,1.47766,2.1264.834,5.372l-1.08526-.32892c.51318-2.67889-.00739-3.44727-.67157-4.39954a6.103,6.103,0,0,1-1.28418-3.623A7.41714,7.41714,0,0,1,4.50537,4.27062,5.2218,5.2218,0,0,1,7.34229,2.32677a7.98329,7.98329,0,0,1,4.18554-.16211A6.64508,6.64508,0,0,1,15.98389,5.5006c.1543.26953.97461,1.793.64062,2.7832L18.25342,10.899A.81507.81507,0,0,1,18.38135,11.63292Z"
					},
					children: [
					]
				}
			]
		}
	]
},
	coin: coin,
	comparison: comparison,
	compass: compass,
	"compliance-document": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.2,1.8H4.1v18h13.5V5.2L14.2,1.8z M16.4,18.7H5.2V2.9h7.3v3.9h3.9V18.7z M16.4,5.7h-2.8V2.9h0.1L16.4,5.7L16.4,5.7z\n\t M10.7,8.7H6.4V7.6h4.2L10.7,8.7L10.7,8.7z M6.4,9.7H15v1.1H6.4V9.7z M13.3,12l0.8,0.8l-4.4,4.4l-2.4-2.4L8.1,14l1.6,1.6L13.3,12z"
			},
			children: [
			]
		}
	]
},
	compose: compose,
	"condition-based-maintenance": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.7521496,11.3628702c0.0283203-0.3747473,0.0273399-0.7511339-0.0029297-1.1257296l2.04883-1.51758l-1.1640491-2.8100605\n\tl-2.522459,0.375c-0.2432222-0.2871814-0.5095739-0.5539446-0.79638-0.7976098l0.375-2.5211201L12.8810501,1.80159\n\tl-1.5185499,2.04883c-0.3747606-0.0296683-0.7512932-0.0293341-1.1260004,0.0009999L8.717,1.80159L5.90693,2.96577\n\tl0.3759999,2.5221002C5.9956498,5.7309923,5.7289553,5.9974427,5.48557,6.2845001l-2.52-0.3759999L1.8,8.7195597l2.0478499,1.51758\n\tc-0.0294523,0.3750458-0.0291181,0.7518368,0.0009999,1.1268301L1.8,12.8814201L2.96455,15.6914806l2.5220003-0.3760004\n\tc0.2434011,0.2870016,0.5097427,0.553731,0.7963901,0.7975492l-0.375,2.5211201l2.81006,1.1642609l1.5184898-2.04772\n\tc0.3747187,0.0307598,0.7513428,0.0303917,1.1260004-0.0011005L12.882,19.7984104l2.8101196-1.1641808l-0.3760004-2.522089\n\tc0.2875319-0.2433434,0.554697-0.5097771,0.7988291-0.7966404l2.5209999,0.375l1.1640511-2.81005L17.7521496,11.3628702z\n\t M17.9044895,14.4050999l-2.29-0.3408203L15.4064894,14.33675c-0.308917,0.4015293-0.6690979,0.7608652-1.0713501,1.06884\n\tl-0.2734404,0.2092304l0.3417997,2.2912598l-1.1289101,0.4681396l-1.37988-1.86133l-0.3393602,0.0455303\n\tc-0.502655,0.0667152-1.011899,0.0670853-1.5146503,0.0011005l-0.3393278-0.0455208l-1.3789101,1.86022l-1.1289101-0.4681396\n\tL7.53438,15.6159201l-0.2734399-0.2092304c-0.4014659-0.3088284-0.7607989-0.6688576-1.06885-1.07092l-0.2084999-0.27246\n\tl-2.29,0.3417902l-0.4682701-1.1289997l1.8613298-1.3786697l-0.0454102-0.3406897\n\tc-0.066247-0.5019121-0.0665832-1.0103312-0.0009999-1.5123301L5.08565,9.7037106L3.2252901,8.3249998l0.46826-1.1291499\n\tl2.29,0.3408198l0.2084999-0.27246c0.3088026-0.4014525,0.6688046-0.7607756,1.0708399-1.0688195l0.2734399-0.2092299\n\tL7.1945295,3.6939204l1.1289101-0.4681399l1.37988,1.8613296l0.3398399-0.0445499\n\tc0.5022078-0.0661321,1.0108957-0.0664682,1.5131903-0.0009999L11.8961897,5.08599l1.3784199-1.86023l1.1289101,0.4681401\n\tl-0.3408194,2.2901797l0.2734299,0.2092299c0.4015045,0.3089523,0.7609844,0.6689672,1.0693398,1.07093l0.2080002,0.27246\n\tl2.2910004-0.3408198l0.4682789,1.1291199l-1.8613186,1.3786898l0.0444298,0.3407001\n\tc0.066246,0.5022364,0.0665817,1.0109768,0.0009995,1.5132999L16.5114498,11.89851l1.8613205,1.3786602L17.9044895,14.4050999z\n\t M13.4826193,11.2425098l-0.6362295,0.6362305c-1.1302519-1.1295776-2.962038-1.1295776-4.0922899,0l-0.6362295-0.6362305\n\tC9.5993738,9.76124,12.0011168,9.76124,13.4826193,11.2425098z M12.1739998,12.5513401l-0.6372004,0.6363602\n\tc-0.4120426-0.3944082-1.0615969-0.3944082-1.4736395,0l-0.6372004-0.6363602h0.0000401\n\tC10.1848574,11.7925453,11.4151421,11.7925453,12.1739998,12.5513401z M14.7911892,9.9339104l-0.6367197,0.6363602\n\tl-0.0010004-0.0010004c-1.8526068-1.8520699-4.8558416-1.851635-6.7079115,0.0009718\n\tc-0.0000095,0.0000095-0.0000191,0.0000191-0.0000286,0.0000286l-0.63623-0.6363602l0.000701-0.0007305\n\tc2.2041526-2.2037477,5.7774615-2.2034206,7.9812102,0.0007305H14.7911892z"
			},
			children: [
			]
		}
	]
},
	"condition-based-wrench": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.7999992,11.1999998l2,1.3999996l-1.1000004,2.8000002L16.2000008,15\n\tc-0.2410288,0.2911282-0.508872,0.5589714-0.8000002,0.8000002l0.3999996,2.499999L13,19.3999996l-1.5-2h-1.1000004l-1.5,2\n\tl-1.6999998-0.7000008l0.8999996-0.8999996L8.499999,18l1.3170805-1.6934204\n\tc0.7548389,0.1714401,1.5369358,0.1852589,2.2973595,0.0405903L13.3999996,18L14.5,17.5l-0.27209-1.9956598\n\tc0.6668959-0.4356184,1.2370939-1.0037155,1.6751699-1.6689997L18,14.1999998l0.5-1.1000004l-1.749691-1.3608398\n\tc0.1398621-0.7186594,0.1388435-1.4576397-0.0030003-2.17591L18.5,8.1999998L18,7.0999999l-2.1577702,0.29425\n\tc-0.4120388-0.6017318-0.9335737-1.1206007-1.5374098-1.5295501L14.6000004,3.7L13.5,3.2l-1.3810997,1.7756402\n\tc-0.7050266-0.1347985-1.4293747-0.1330161-2.1337299,0.00525L8.6000004,3.2L7.5000005,3.7l0.2987099,2.1907403\n\tC7.7560406,5.9200406,7.7164302,5.9531202,7.6746202,5.9835105L7.5,6.0999999\n\tC7.4760799,6.12392,7.4453802,6.1497397,7.42029,6.1737299c-0.3070474,0.2499595-0.587779,0.5306072-0.8378301,0.8375802\n\tC6.5564699,7.0430002,6.5247302,7.0669999,6.5,7.0999999L6.3667002,7.2999997\n\tC6.3427,7.3335695,6.31598,7.3649998,6.2927003,7.3990598L4.0999999,7.0999999l-0.5,1.0999999l1.7871003,1.3900003\n\tc-0.1364036,0.7008057-0.1374221,1.4212418-0.0029998,2.1224298l-1.7841005,1.3875704L3.8,13.5l-0.8999999,0.8999996l-0.7-1.6999998\n\tl1.9999998-1.5v-1.0999994l-2-1.5L3.3,5.8000002l2.5000002,0.4000001C6.0143223,5.8856769,6.285677,5.6143222,6.6000004,5.4000001\n\tl-0.4000006-2.5L8.8999996,1.8l1.5,2H11.5l1.5-2l2.8000002,1.1000001l-0.3999996,2.5\n\tc0.2911377,0.2410178,0.5589819,0.5088625,0.8000002,0.8000002l2.5-0.4000001l1.1000004,2.8000002l-2,1.5L17.7999992,11.1999998z\n\t M10.0810003,14.3333302l-4.8000002,4.8000011c-0.7363772,0.7731991-1.96013,0.8030491-2.7333286,0.0666714\n\tc-0.0227625-0.0216789-0.0449929-0.0439091-0.0666714-0.0666714c-0.7731985-0.7363777-0.8030479-1.9601307-0.0666707-2.7333279\n\tc0.0216782-0.0227623,0.0439084-0.0449924,0.0666707-0.0666714l4.8000002-4.8000002\n\tc-0.0826573-0.3265448-0.1163583-0.6635542-0.0999999-1C7.2053795,10.0615959,7.2723179,9.5930252,7.381,9.1333323\n\tc0.7446017-2.0194082,2.9586501-3.0821514,5.0000005-2.4000001l0.8000002,0.3000002l-2.5,2.5000005\n\tc-0.3861103,0.3870878-0.3853178,1.0138893,0.00177,1.3999996c0.3863964,0.3854198,1.0118332,0.3854198,1.3982296,0l2.5-2.5\n\tl0.3000002,0.8000002c0.1153021,0.4244413,0.1823931,0.860528,0.1999998,1.3000002\n\tc-0.0026445,2.1528139-1.7471867,3.8973551-3.9000006,3.8999996C10.8116131,14.4454536,10.4421453,14.4118643,10.0810003,14.3333302\n\tz M9.8810005,13.1333303l0.3000002,0.1000004c0.3219814,0.1144066,0.6587839,0.1817665,1,0.1999998\n\tc1.6011505-0.0011473,2.8988533-1.2988491,2.9000006-2.8999996v-0.1000004l-1.1999998,1.1999998l0,0\n\tc-0.7739391,0.7724581-2.0275421,0.7712574-2.8000002-0.0026817c-0.7714119-0.772891-0.7714119-2.0244274,0-2.7973185\n\tl1.1999998-1.1999998h-0.1000004c-1.6649561,0.0458021-2.9775391,1.4326458-2.9317369,3.0976019\n\tc0.0074873,0.2721863,0.0518026,0.5421057,0.1317368,0.8023987l0.1000004,0.3000002l-5.1999998,5.1999998\n\tc-0.3870327,0.3861656-0.3877356,1.0129662-0.0015697,1.3999996s1.0129671,0.3877354,1.3999996,0.0015697\n\tc0.000524-0.0005226,0.0010476-0.0010452,0.0015702-0.0015697L9.8810005,13.1333303z"
			},
			children: [
			]
		}
	]
},
	"connect-parts": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13.612,9.112a3.37877,3.37877,0,0,0-3.375,3.375v3.938a2.25,2.25,0,0,1-4.5,0v-2.25H7.425l1.125-4.5v-4.5H7.963V1.8H2.387V5.175H1.8v4.5l1.125,4.5H4.613v2.25a3.375,3.375,0,0,0,6.75,0V12.487a2.2534,2.2534,0,0,1,2.25-2.25H19.8V9.112ZM3.512,2.925H6.839v2.25H3.512ZM3.803,13.05,2.925,9.537V6.3h4.5V9.537L6.547,13.05Zm.141-9.419h.504v.731H3.944Zm1.964,0h.504v.731H5.908Z"
			},
			children: [
			]
		}
	]
},
	connect: connect,
	"construction-hammer": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.41572,5.66322,15.31563,3.5691l-.01172-.012-.0127-.01172a4.1121,4.1121,0,0,0-2.7998-1.2586,3.861,3.861,0,0,0-2.4502.963L9.17207,3.958l1.66455,1.66406.692-.46631a.775.775,0,0,1,.44824-.166.95911.95911,0,0,1,.42041.12036l-.70319.613-.81787.7124.76709.767c-.60638.60632-1.4209,1.42071-1.71429,1.714-.48786.48816-1.7793.65014-2.51709,1.38794-.73786.73748-4.89215,4.97967-5.21735,5.30511a1.78747,1.78747,0,0,0-.39453.915l2.78906,2.78857a1.7821,1.7821,0,0,0,.915-.394c.3252-.32544,4.56738-4.47961,5.30518-5.21728s.8999-2.0293,1.38818-2.51734c.293-.29333,1.10742-1.10766,1.71387-1.71411l2.23291,2.23316L19.8,8.04762Zm-5.93457,4.80536a3.89,3.89,0,0,0-.76465,1.35712,3.65932,3.65932,0,0,1-.623,1.16015c-.43946.4397-5.02246,4.93726-5.24365,5.15631l-1.878-1.87811c.227-.22974,4.71582-4.80328,5.15576-5.24365a3.662,3.662,0,0,1,1.16015-.62317,3.88694,3.88694,0,0,0,1.35742-.76465l1.71387-1.71411.83594.83618Zm4.66315-.1969-.9527-.95251.52051-.52076L15.14772,8.234l-.52051.52075L12.35908,6.48658l1.63623-1.426a3.14343,3.14343,0,0,0-2.01855-1.08325,1.79258,1.79258,0,0,0-1.01465.33893L10.68086,4.035a2.86673,2.86673,0,0,1,1.81055-.73566,3.135,3.135,0,0,1,2.10937.98675l2.25049,2.24445-.521.52081.56446.56452.521-.52076.95264.95252Z"
			},
			children: [
			]
		}
	]
},
	"construction-truck": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.61,13.62a3,3,0,0,0-2.51-.33V11.78l.46,0,2.87-1.42L19.55,7l-1.4-3.74L14.38,2.2,11.28,3,8.19,5.33l2.37,6.3h0v2H8.38V7.11H4.58A1.67,1.67,0,0,0,3,8.29L1.8,12.13v5l1.59,0a3.11,3.11,0,0,0,6,0H12a3.11,3.11,0,0,0,6,0H19.8V13.62ZM3.31,16H2.94V12.3L4.07,8.63a.53.53,0,0,1,.51-.38H7.24v5a3,3,0,0,0-.84-.13A3.1,3.1,0,0,0,3.31,16ZM6.4,18.26a2,2,0,1,1,2-2A2,2,0,0,1,6.4,18.26ZM9.56,5.73l2.23-1.67,2.57-.68,2.92.85,1,2.67L16.64,9.45l-2.39,1.18H14.1V9a1.67,1.67,0,0,0-1.67-1.67h-.2a1.66,1.66,0,0,0-1.6,1.22ZM11.88,16H9.49a3,3,0,0,0-.37-1.2h3.14A3,3,0,0,0,11.88,16ZM13,13.62H11.7V9a.53.53,0,0,1,.53-.53h.2A.53.53,0,0,1,13,9Zm2,4.64a2,2,0,1,1,2-2A2,2,0,0,1,15,18.26ZM18.66,16h-.59a3.17,3.17,0,0,0-.37-1.2h1Z"
			},
			children: [
			]
		}
	]
},
	"consultative-transfer": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,9.104l-3.648,3.648-.795-.795,2.29-2.29H13.05V8.542h4.597l-2.29-2.29.795-.796ZM5.175,7.144A3.375,3.375,0,1,1,8.55,10.519,3.37494,3.37494,0,0,1,5.175,7.144Zm1.125,0a2.25,2.25,0,1,0,2.25-2.25A2.25207,2.25207,0,0,0,6.3,7.144Zm2.25,4.717A10.05046,10.05046,0,0,1,15.3,14.489v3.342H1.8V14.489A10.05046,10.05046,0,0,1,8.55,11.861Zm5.625,3.146a8.83846,8.83846,0,0,0-11.25,0v1.699h11.25Z"
			},
			children: [
			]
		}
	]
},
	convergence: convergence,
	conversion: conversion,
	"count-down": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		"enable-background": "new 0 0 21.6 21.6",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.409,12.54316H9.93242v-6.124h1.125v4.999H14.409V12.54316z M10.79961,1.8127\n\tC8.51096,1.80716,6.30829,2.6842,4.64983,4.26136l0.017,0.69489l0.85638,0.02472c1.44009-1.31907,3.32351-2.04842,5.2764-2.04327\n\tc4.34223,0.00001,7.8623,3.52008,7.86229,7.86231s-3.52008,7.8623-7.86231,7.86229S2.9373,15.14222,2.9373,10.8h-1.125\n\tc-0.00028,4.96382,4.02348,8.98802,8.9873,8.9883s8.98802-4.02348,8.9883-8.9873s-4.02348-8.98802-8.9873-8.9883\n\tC10.80027,1.8127,10.79994,1.8127,10.79961,1.8127z M4.6668,4.95625l0.85638,0.02472l2.12311,0.06122l-0.0332,1.125L3.56719,6.05\n\tL3.46758,1.94941l1.125-0.02734l0.05725,2.33929L4.6668,4.95625z"
			},
			children: [
			]
		}
	]
},
	crash: crash,
	"credit-card": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M8,14.12H4.61V13H8ZM19.79,6.88v7.94A2.22,2.22,0,0,1,17.58,17H4A2.23,2.23,0,0,1,1.8,14.82V6.88A2.25,2.25,0,0,1,4,4.57H17.68A2.11,2.11,0,0,1,19.79,6.88Zm-16.88.5H18.69v-.5a1.13,1.13,0,0,0-1.11-1.11H4a1.12,1.12,0,0,0-1.1,1.11ZM18.79,10.8H2.91v3.92A1.12,1.12,0,0,0,4,15.83H17.68a1.12,1.12,0,0,0,1.11-1.11Zm0-2.21H2.91v1.1H18.79Z"
			},
			children: [
			]
		}
	]
},
	crop: crop,
	"cross-device-targeting": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13.6,2v3.1h1V3H19v6.8h-5.5v3.4h2.7v3.5h-11v-3.5H8V9.7H2.6V3H7v2.1h1V2H1.6v11.1h2.7v4.5h6v1H9.2v1h3.3v-1h-1.1v-1h6v-4.5\n\tH20V2H13.6z M2.6,12.1v-1.4h1.5v0.9h1.5v-0.9H7v1.4H2.6z M19,12.1h-4.5v-1.4H16v0.9h1.5v-0.9H19L19,12.1z M6.2,8h2\n\tc0.2,1.1,1,1.9,2.1,2.1V12h1v-1.9c1.1-0.2,1.9-1,2.1-2.1h2V7h-2c-0.2-1.1-1-1.9-2.1-2.1V2.9h-1v2.1C9.2,5.1,8.4,6,8.2,7h-2V8z\n\t M11.3,6c0.5,0.2,0.9,0.6,1.1,1.1h-1.1V6z M11.3,8h1.1c-0.2,0.5-0.6,0.9-1.1,1.1V8z M10.3,6V7H9.2C9.4,6.5,9.8,6.1,10.3,6z M10.3,8\n\tv1.1C9.8,9,9.4,8.6,9.2,8H10.3z"
			},
			children: [
			]
		}
	]
},
	"cross-device": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13.05,1.8V6.3H6.3v4.5H3.23179v6.54545L1.8,19.8H13.05l-1.63641-2.45455V15.3H17.55V13.05H19.8V1.8ZM10.28859,11.925v4.85815H4.35679V11.925Zm-6.53,6.75.44494-.76273.00241-.00412H10.4367l.04085.06132.47035.70553Zm12.66641-4.5H11.41359V10.8H7.425V7.425H13.05V13.05h3.375Zm2.25-2.25h-4.5V10.8H15.3v.5625h2.25V10.8h1.125Zm-4.5-2.25V2.925h4.5v6.75Z"
			},
			children: [
			]
		}
	]
},
	cta: cta,
	ctr: ctr,
	"custom-audience": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.3466,19.5441,12.9056,19.5l-.0217-.0668-.352-1.0831,4.6658-.0139a6.2461,6.2461,0,0,0-6.3966-5.57,6.2419,6.2419,0,0,0-6.3983,5.6083L8.9992,18.36l-.3485,1.0725-.01.0318-5.3722-.044a6.4883,6.4883,0,0,1-.01-.6841,7.3383,7.3383,0,0,1,7.543-7.0957,7.3635,7.3635,0,0,1,7.5217,6.6915ZM6.1475,6.3611A4.6121,4.6121,0,1,1,10.76,10.9732,4.6121,4.6121,0,0,1,6.1475,6.3611Zm1.125,0A3.4871,3.4871,0,1,0,10.76,2.874,3.491,3.491,0,0,0,7.2725,6.3611ZM13.28,16.912H11.37l-.59-1.8163-.59,1.8163H8.28l1.545,1.1226-.59,1.8163L10.78,18.7283l1.545,1.1226-.59-1.8163Z"
			},
			children: [
			]
		}
	]
},
	customize: customize,
	"data-boost": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M8.39,5.82,7.6,5,10.82,1.8,14,5l-.79.8L11.38,4V9.58H10.25V4Zm4.57,2a5.6,5.6,0,0,1,3.05,3l1-.43a6.75,6.75,0,0,0-3.67-3.66Zm4.56,4.44-1.14.13A5.63,5.63,0,1,1,8.65,7.82l-.44-1a6.77,6.77,0,1,0,9.31,5.48Z"
			},
			children: [
			]
		}
	]
},
	data: data,
	deaf: deaf,
	decrease: decrease,
	"device-activity": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8181,4.2249999v13.0002289h18v-13L1.8181,4.2249999z M18.7180996,5.3252296v4.5h-2.2000008L15.1180992,11.42523l-2.5-3\n\tL9.818099,12.2252302l-3-5.0999999L4.7180991,9.8252306h-1.8v-4.5L18.7180996,5.3252296z M2.9180994,16.1252289v-5.1999998\n\th2.3000002l1.4000001-1.8000002l2.9999995,5.1000004l3-4l2.3999996,2.8999996l1.8999996-2.1999998h1.7000008v5.1999998H2.9180994z"
			},
			children: [
			]
		}
	]
},
	"device-protection": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M5.18,1.8v18H16.43V1.8ZM15.3,18.68h-9V17H9.68v1.12h2.25V17H15.3Zm0-2.82h-9V2.93h9ZM10.8,14a6.14,6.14,0,0,0,3.38-5.16V6.3H7.43V8.85A6.12,6.12,0,0,0,10.8,14ZM8.55,7.43h4.5V8.85a4.79,4.79,0,0,1-2.25,3.83A4.79,4.79,0,0,1,8.55,8.85Z"
			},
			children: [
			]
		}
	]
},
	"devices-addons": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 38 38"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m35,9h-4v4h-2v-4h-4v-2h4V3h2v4h4v2ZM3.00024,3h20v32H3.00024v-5h-.00024v-2h.00024V3Zm18,30v-3h-6.00024v2h-4v-2h-5.99976v3h16ZM5.00024,5v23h16V5H5.00024Z"
			},
			children: [
			]
		}
	]
},
	"digital-content": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8185501,17.9445305l-2.0390606-5.3285303V3.6335001H3.7165v8.7288198L1.80977,17.9680004L19.8185501,17.9445305z\n\t M3.2072301,16.9659996l1.3674903-4.0205097h12.2592201l1.5314903,4.0009995L3.2072301,16.9659996z M16.7794895,4.6335001v7.2510004\n\tL4.7164898,11.9432201v-7.30972H16.7794895z M13.8364897,16.2635612l-6.03125,0.0156307l0.5781202-1.09375h4.96875\n\tL13.8364897,16.2635612z M11.8947296,5.84688L10.132,7.7204099L9.4460001,6.9284101l-4.2709999,3.7515903l10.937499,0.00037\n\tL11.8947296,5.84688z M9.34443,8.3385696l0.7573299,0.8739996l1.7656202-1.8764701l2.0361404,2.3335004L7.842,9.6398401\n\tL9.34443,8.3385696z"
			},
			children: [
			]
		}
	]
},
	"digital-signage-car": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M7.03315,12.26594a.94171.94171,0,1,1-.94189-.94177A.9417.9417,0,0,1,7.03315,12.26594Zm8.47559-.94177a.94152.94152,0,0,0-.94141.94159v.00018a.94165.94165,0,1,0,.94153-.94177Zm3.767,0a.94175.94175,0,0,1-.94177.94177h-.041l.041.1836V19.8H14.56733V17.59431H7.03315V19.8H3.26606V12.44954l.04151-.1836H3.26606a.94177.94177,0,0,1,0-1.88354h.46631l.8653-3.84522a2.37683,2.37683,0,0,1,2.34759-1.8053h.874V1.8h5.96185V4.73188h.87366a2.375,2.375,0,0,1,2.34668,1.8053l.8667,3.84522h.46576A.94175.94175,0,0,1,19.27571,11.32417ZM8.96772,4.6429h3.665V2.94856h-3.665ZM5.97358,17.59248h-1.648v1.14807h1.648V17.59248Zm11.30127,0H15.62642v1.14807h1.64843Zm.00006-5.02527L15.96876,6.76985a1.32363,1.32363,0,0,0-1.314-.97852H6.94526a1.32261,1.32261,0,0,0-1.31347.97852L4.32563,12.56721V16.533H17.27485Z"
			},
			children: [
			]
		}
	]
},
	"digital-signage": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.4,18.2c1.4,0,2.9,0.2,4.3,0.5l-0.2,1.1c-3-0.7-6.1-0.7-9.2,0L6,18.7c1.4-0.3,2.8-0.5,4.3-0.5v-0.9h1.1\n\tC11.4,17.3,11.4,18.2,11.4,18.2z M16.1,1.8v14.5H5.5V1.8H16.1z M8.8,6.1H6.7v9.1h2.2L8.8,6.1L8.8,6.1z M14.9,6.1h-5v9.1h5V6.1z\n\t M14.9,2.9H6.7V5H15L14.9,2.9z"
			},
			children: [
			]
		}
	]
},
	dining: dining,
	"direct-carrier-billing": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9.675,1.8V4.34a10.107,10.107,0,0,0,5.062,8.71A10.10585,10.10585,0,0,0,19.8,4.34V1.8Zm8.948,2.54a8.96107,8.96107,0,0,1-3.885,7.314A8.95948,8.95948,0,0,1,10.852,4.34V2.977h7.771ZM14.354,8.379,12.712,6.738l.703-.703.939.939,2.408-2.408.702.703Zm-2.429,7.483h-9V2.925H8.55V1.8H1.8v18H13.05V13.323l-1.125-1.125Zm0,2.813h-9V16.987H6.3v1.125H8.55V16.987h3.375ZM7.66084,5.56611H7.1501v.50147c-1.168.0459-1.96192.69385-1.96192,1.70654,0,1.15869.83936,1.46924,1.96192,1.71533v2.36328a1.46373,1.46373,0,0,1-1.48731-1.4873h-.7666A2.13349,2.13349,0,0,0,7.1501,12.47285v.77539h.51074v-.7666c1.19531-.07226,2.09863-.72021,2.09863-1.82422,0-1.24072-.90332-1.53271-2.09863-1.77929V6.67891A1.19936,1.19936,0,0,1,8.87471,7.7375h.73877A1.84278,1.84278,0,0,0,7.66084,6.06758ZM7.1501,8.778c-.84864-.1919-1.24121-.45655-1.24121-1.04053,0-.64795.50195-1.00342,1.24121-1.06738Zm1.86133,1.90674a1.27819,1.27819,0,0,1-1.35059,1.17675V9.60811C8.53682,9.8,9.01143,10.00947,9.01143,10.68477Z"
			},
			children: [
			]
		}
	]
},
	directory: directory,
	"display-utilities": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "a8e733f0-4476-48ef-8a7a-1da330b9b05a",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,2.7V14h18V2.7ZM18.68,12.82H2.93v-9H18.68Zm-7.32,4a8.43,8.43,0,0,1,4,1.21l-.58.9a8.08,8.08,0,0,0-4-1,8.07,8.07,0,0,0-4,1L6.28,18a8.06,8.06,0,0,1,4-1.2V15.07h1.12Z"
			},
			children: [
			]
		}
	]
},
	display: display,
	distribution: distribution,
	"domain-targeting": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.04438,11.2057h.58106v.57422h-.58106ZM8.1418,10.61934c-.03272.11425-.05811.26464-.0835.38232l-.03223.21045H8.01875c-.01465-.07129-.0293-.14258-.04-.21387-.02539-.125-.0542-.27148-.08642-.38574l-.20264-.73193h-.481l-.19531.73193c-.03272.11426-.05811.26074-.0835.38574-.01074.07129-.0249.14258-.03955.21045H6.883l-.03223-.21045c-.02539-.11816-.05078-.26465-.07959-.3789l-.20264-.73877H5.98994L6.58271,11.78H7.111l.20947-.7749c.02929-.11035.0581-.25342.08349-.3711l.04346-.21093H7.4543l.03613.21093c.02539.11768.05469.26075.0835.3711l.20263.7749h.53516L8.9084,9.88057H8.34785Zm3.05078,0c-.03272.11425-.05811.26464-.0835.38232l-.03222.21045h-.00733c-.01465-.07129-.0293-.14258-.04-.21387-.02539-.125-.0542-.27148-.08642-.38574l-.20264-.73193h-.481l-.19531.73193c-.03271.11426-.05811.26074-.0835.38574-.01074.07129-.0249.14258-.03955.21045H9.93379l-.03223-.21045c-.02539-.11816-.05078-.26465-.07959-.3789l-.20263-.73877H9.04072L9.6335,11.78h.52832l.20947-.7749c.0293-.11035.0581-.25342.0835-.3711l.04345-.21093h.00684l.03613.21093c.02539.11768.05469.26075.0835.3711l.20263.7749h.53516l.59668-1.89941h-.56055Zm3.0498,0c-.03222.11425-.05761.26464-.083.38232l-.03223.21045h-.00781c-.01368-.07129-.02832-.14258-.03907-.21387-.02539-.125-.05468-.27148-.08691-.38574l-.20313-.73193h-.48046l-.19532.73193c-.03222.11426-.05761.26074-.083.38574-.01075.07129-.0254.14258-.04.21045h-.00684l-.0332-.21045c-.02539-.11816-.05078-.26465-.0791-.3789l-.20313-.73877H12.091L12.68379,11.78h.52832l.21-.7749c.02832-.11035.05762-.25342.083-.3711l.043-.21093h.00781l.03613.21093c.02539.11768.05371.26075.083.3711l.20215.7749h.53515L15.009,9.88057h-.56054Zm5.59082.792H17.49763a6.84261,6.84261,0,0,1-6.22009,6.01819v2.09216h-1.125V17.42994a6.84294,6.84294,0,0,1-6.22937-6.01861H1.57686v-1.125H3.8907a6.83724,6.83724,0,0,1,6.26184-6.47321v-2.102h1.125V3.81355a6.837,6.837,0,0,1,6.25256,6.47278h2.3031Zm-3.47235,0h-.10772v-1.125h.152a5.71552,5.71552,0,0,0-5.12756-5.34772V7.239h-1.125V4.93812A5.71536,5.71536,0,0,0,5.0157,10.28633h.14075v1.125H5.06a5.71822,5.71822,0,0,0,5.09259,4.89361v-2.3106h1.125v2.31012A5.71844,5.71844,0,0,0,16.36085,11.41133Z"
			},
			children: [
			]
		}
	]
},
	doorbell: doorbell,
	"down-arrow": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Arrow_Down",
		"data-name": "Arrow Down",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,19.8l-9-9.08067.80985-.817,7.61765,7.683V1.8h1.145V17.58533l7.61765-7.683.80985.817Z"
			},
			children: [
			]
		}
	]
},
	"down-caret": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "polygon",
			type: "element",
			value: "",
			attributes: {
				points: "10.8 15.71 1.8 6.71 2.62 5.89 10.8 14.07 18.98 5.89 19.8 6.71 10.8 15.71"
			},
			children: [
			]
		}
	]
},
	download: download,
	"drag-and-drop": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "a46eea96-1392-4cea-aae5-8a6801a3cab9",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,16.5H2.9v1.1H1.8ZM2.9,4H1.8V5.1H2.9ZM18.7,17.6h1.1V16.5H18.7ZM18.7,4V5.1h1.1V4ZM2.9,5.8H1.8V7.2H2.9Zm0,2.1H1.8V9.3H2.9ZM1.8,13.7H2.9V12.3H1.8Zm0,2.1H2.9V14.4H1.8ZM13.7,4H12.3V5.1h1.4ZM11.5,4H10.1V5.1h1.4ZM9.3,4H7.9V5.1H9.3ZM18,4H16.6V5.1H18ZM15.8,4H14.4V5.1h1.4ZM7.2,4H5.8V5.1H7.2ZM5,4H3.6V5.1H5Zm7.3,13.6h1.4V16.5H12.3Zm-2.2,0h1.4V16.5H10.1Zm-2.2,0H9.3V16.5H7.9Zm8.7,0H18V16.5H16.6Zm-2.2,0h1.4V16.5H14.4Zm-8.6,0H7.2V16.5H5.8Zm-2.2,0H5V16.5H3.6ZM18.7,7.2h1.1V5.8H18.7Zm0,2.1h1.1V7.9H18.7Zm0,1.7-5.1,2.7L7.7,8,2.9,11v-.9H1.8v1.4H2.9v.8L7.5,9.4l5.8,5.7,5.4-2.8v-.8h1.1V10.1H18.7Zm1.1,2.7V12.3H18.7v1.4Zm-1.1,2.1h1.1V14.4H18.7Zm-4-8.89a2.16,2.16,0,0,1,2.2,2.2,2.24,2.24,0,0,1-2.2,2.3,2.31,2.31,0,0,1-2.2-2.3A2.22,2.22,0,0,1,14.68,6.91Zm0,1.15a1.1,1.1,0,1,0,1.1,1.1A1.11,1.11,0,0,0,14.68,8.06Z"
			},
			children: [
			]
		}
	]
},
	driver: driver,
	"drivers-license": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "a",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.675,5.425v10.75H2.925V5.425h15.75m1.125-1.125H1.8v13H19.8V4.3h0Zm-2.25117,4.85576h-4.98633v1.125h4.98633v-1.125Zm0-2.25781h-4.98633v1.125h4.98633v-1.125Zm0,4.5127h-4.98633v1.12451h4.98633v-1.12451Zm-8.14966-.64551c.40698-.41058,.65942-.97473,.65942-1.59717,0-1.25146-1.01855-2.27002-2.27002-2.27002-1.25195,0-2.27051,1.01855-2.27051,2.27002,0,.62268,.25256,1.18707,.65991,1.59766-1.20911,.61743-2.05005,1.89093-2.05005,3.37402h1.125c0-1.46191,1.1377-2.65137,2.53613-2.65137,1.39795,0,2.53564,1.18945,2.53564,2.65137h1.125c0-1.48346-.84106-2.75732-2.05054-3.37451Zm-1.6106-2.74219c.63135,0,1.14502,.51367,1.14502,1.14502,0,.63184-.51367,1.14551-1.14502,1.14551-.63184,0-1.14551-.51367-1.14551-1.14551,0-.63135,.51367-1.14502,1.14551-1.14502Z"
			},
			children: [
			]
		}
	]
},
	"drone-camera": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.10328,13.87165a.5604.5604,0,1,1,.56043.56043A.56042.56042,0,0,1,11.10328,13.87165ZM3.07435,16.9585H1.93873a8.933,8.933,0,0,1,4.56189-6.71594H3.926V5.72889H1.8v-1.125H7.17744v1.125H5.051V9.11756H6.59816a4.26117,4.26117,0,0,1,8.39105,0H16.549V5.72889h-2.126v-1.125H19.8v1.125H17.674v4.51367H15.06337a8.93313,8.93313,0,0,1,4.56225,6.71594H18.49a7.79987,7.79987,0,0,0-7.13385-6.66V11.705h2.67823V16.1327H7.56953V11.705h2.66162V10.29731A7.79907,7.79907,0,0,0,3.07435,16.9585ZM8.69453,12.83V15.0077h4.21485V12.83Zm-.94574-3.7124h6.08966a3.13419,3.13419,0,0,0-6.08966,0Z"
			},
			children: [
			]
		}
	]
},
	"drop-shipment": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "e8803c4b-cd89-481e-919c-dbbe91c6ffae",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.11,9.1a7.31,7.31,0,0,0-14.62,0v.23L6.3,12.87v4.36l4.5,2.57,4.5-2.57V12.76l2.81-3.45ZM10.8,2.93a6.19,6.19,0,0,1,5.63,3.61A2.7,2.7,0,0,0,15.3,6.3a2.79,2.79,0,0,0-2.25,1.13,2.81,2.81,0,0,0-4.5,0A2.79,2.79,0,0,0,6.3,6.3a2.62,2.62,0,0,0-1.12.24A6.16,6.16,0,0,1,10.8,2.93Zm-.56,15.26L7.43,16.58V13.37L10.24,15ZM8,12.4l2.8-1.6.94.53-2.8,1.61Zm1.84,1.06,2.81-1.6.95.54L10.8,14Zm4.34,3.12-2.82,1.61V15l2.82-1.61Zm.51-4.85L10.8,9.51,6.86,11.76,4.63,8.94A1.68,1.68,0,0,1,8,9.11H9.11a1.69,1.69,0,0,1,3.38,0h1.12A1.68,1.68,0,0,1,17,8.94Z"
			},
			children: [
			]
		}
	]
},
	duplicate: duplicate,
	edit: edit,
	"education-curriculum": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M6.52,1.8A2.25,2.25,0,0,0,4.27,4.05h0v13.5A2.25,2.25,0,0,0,6.52,19.8H17.33V1.8Zm0,1.12h9.69V5.17H6.51A1.12,1.12,0,0,1,5.39,4.05h0A1.12,1.12,0,0,1,6.52,2.92Zm9.69,15.76H6.52a1.13,1.13,0,0,1-1.13-1.13V6.29H16.21ZM10.64,9.77H6.88V8.65h3.76Zm3.69,2.6H6.88V11.25h7.45Z"
			},
			children: [
			]
		}
	]
},
	education: education,
	"electric-power": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17,8.9H13.27l3.35-7.1-12,10.9H8.33L5,19.8ZM7.51,11.58l5.7-5.18-1,2L11.5,10h2.59L8.39,15.2l.95-2,.76-1.6Z"
			},
			children: [
			]
		}
	]
},
	"electric-utility": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.42,6.85v-5H13.23V6.85H8.37v-5H7.18V6.85H2.67V8H4.15v2.38a6.67,6.67,0,0,0,6,6.62V19.8h1.2V17a6.67,6.67,0,0,0,6-6.62V8h1.48V6.85Zm1.83,3.57a5.45,5.45,0,0,1-10.9,0V8h10.9Z"
			},
			children: [
			]
		}
	]
},
	email: email,
	"embedded-sound": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.79963,10.8a5.6245,5.6245,0,0,1-5.625,5.625V15.3a4.5,4.5,0,0,0,0-9V5.175A5.6245,5.6245,0,0,1,19.79963,10.8Zm-3.375,0a2.24957,2.24957,0,0,0-2.25-2.25V9.675a1.125,1.125,0,0,1,0,2.25V13.05A2.24957,2.24957,0,0,0,16.42463,10.8Zm-4.016-1.846a2.61038,2.61038,0,0,1,0,3.691l-3.076,3.076a2.6099,2.6099,0,0,1-3.692,0l-3.076-3.076a2.61038,2.61038,0,0,1,0-3.691l3.075-3.075a2.61109,2.61109,0,0,1,3.692-.001Zm-.797.796L8.5356,6.674a1.48474,1.48474,0,0,0-2.1,0L3.35963,9.75a1.48472,1.48472,0,0,0,0,2.1l3.076,3.076a1.48474,1.48474,0,0,0,2.1,0l3.076-3.076A1.48657,1.48657,0,0,0,11.61165,9.75ZM6.93092,12.78376a.784.784,0,1,0,1.10877,0A.78407.78407,0,0,0,6.93092,12.78376Z"
			},
			children: [
			]
		}
	]
},
	"emergency-contact": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.08375,5.91007,19.799,7.4777l-.5625.97461L16.5207,6.88437v3.13532h-1.125V6.88462L12.68037,8.45231l-.5625-.97461,2.71527-1.56763L12.11787,4.34244l.5625-.97461L15.3957,4.93552V1.8h1.125v3.1358l2.71582-1.56793.5625.97461Zm-2.37658,6.22,4.072,4.12622L15.80513,19.8a17.46591,17.46591,0,0,1-9.26105-4.86633A17.46639,17.46639,0,0,1,1.801,5.6091l3.5827-2.92681,4.072,4.12622L8.26942,9.17106a14.63752,14.63752,0,0,0,1.82239,2.26153A14.642,14.642,0,0,0,12.32924,13.285ZM17.259,16.3176l-2.786-2.82312-1.65234.80249-.58337.28333-.53748-.3628A15.83776,15.83776,0,0,1,9.291,12.22281a15.82718,15.82718,0,0,1-1.9624-2.43487L6.973,9.24576l.291-.57947.82428-1.64166-2.786-2.82318-2.268,1.85278A16.32531,16.32531,0,0,0,7.3448,14.14341a16.32493,16.32493,0,0,0,8.03155,4.41748Z"
			},
			children: [
			]
		}
	]
},
	emoji: emoji,
	"energy-science": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.9850903,2.8096299V2.80914c-0.6420898-0.64135-1.6620903-0.73962-3.0346603-0.2971399\n\tc-0.8560915-0.9527886-2.3224783-1.0311774-3.2752666-0.1750863c-0.4918327,0.4419169-0.7716637,1.0727477-0.7691631,1.7339461\n\tc0.002553,0.2004623,0.0314474,0.3997192,0.0859404,0.5926499c-0.3940401,0.2798996-0.7898731,0.5777931-1.1875,0.8936801\n\tC7.46312,2.8991101,4.0754299,1.34857,2.615,2.8096299c-1.4595,1.4593701,0.0878501,4.84412,2.7446101,8.1852303\n\tC2.7033601,14.3358603,1.156,17.72052,2.615,19.1802406c0.4123385,0.3881836,0.9651783,0.5913754,1.53076,0.5626202\n\tc1.72119,0,4.1997104-1.3538799,6.6543002-3.3056602c2.4550705,1.9517803,4.9335899,3.3056602,6.6542892,3.3056602\n\tc0.5657082,0.0289974,1.1187-0.1744289,1.5307598-0.5631104c1.4594803-1.4593506-0.0883694-4.84412-2.7446194-8.1851797\n\tC18.8967209,7.6535001,20.4445705,4.2690001,18.9850903,2.8096299z M14.2336302,3.2162499\n\tc0.4719906-0.0017784,0.8560553,0.3794034,0.8578339,0.8513937s-0.3794031,0.8560557-0.8513937,0.8578343\n\tc-0.0002098,0.0000005-0.0004206,0.0000014-0.0006304,0.0000019h-0.0058098\n\tc-0.1653872,0.0033302-0.3269024-0.0502372-0.4575205-0.1517401c-0.0848942-0.0557404-0.1592798-0.1260328-0.2197304-0.2076402\n\tc-0.1108646-0.1416893-0.173027-0.315382-0.1772404-0.4952402C13.3798552,3.5992148,13.7619858,3.2170312,14.2336302,3.2162499z\n\t M12.7883196,5.8938599c0.0258799,0.0206299,0.0551701,0.0353999,0.0819998,0.05481\n\tc0.0459003,0.0334501,0.0922804,0.0642099,0.1406202,0.0942402c0.0746603,0.0464196,0.1519394,0.08849,0.2314501,0.1259999\n\tc0.0478497,0.0226998,0.0952101,0.0455298,0.1450005,0.0650601c0.0899391,0.0343184,0.1819391,0.0629711,0.2754602,0.0857902\n\tc0.0454102,0.0114799,0.0893497,0.02637,0.1362305,0.0351601c1.2535276,0.2479835,2.4707422-0.5671706,2.7187262-1.8206983\n\tc0.0301857-0.1525841,0.0449085-0.3078232,0.0439434-0.4633617c0.0003319-0.0681858-0.0027618-0.1363449-0.0092697-0.2042201\n\tc0.7905197-0.2302301,1.2382793-0.168,1.3911095-0.01489c0.4799995,0.4805899-0.2016602,2.8203101-2.6635704,5.9892502\n\tc-0.5117197-0.5854397-1.04883-1.1628399-1.6059999-1.7202101c-0.5561504-0.55615-1.1323299-1.0921602-1.7167997-1.6030002\n\tC12.2355804,6.30194,12.5129299,6.0907602,12.7883196,5.8938599z M14.3351898,10.9945698\n\tc-0.5102501,0.5910597-1.0732403,1.2021503-1.7031202,1.8319101s-1.2407303,1.1928701-1.8319998,1.7032499\n\tc-0.5908203-0.5102596-1.2021503-1.073-1.8319998-1.7027597c-0.6294603-0.6297598-1.19245-1.2411098-1.7027001-1.8321104\n\tC7.77562,10.4035492,8.3386097,9.7923498,8.9680004,9.1624699c0.5976601-0.5970001,1.2114296-1.1641903,1.8281298-1.6954403\n\tc0.5947304,0.5125699,1.2026396,1.0620003,1.8359404,1.6954403C13.2620001,9.7921801,13.8249397,10.4034996,14.3351898,10.9945698z\n\t M3.6564801,3.8517499C3.796407,3.7416666,3.9734123,3.6898158,4.15062,3.707c0.9418998,0,2.9555697,0.8366702,5.4995093,2.813\n\tc-0.5825195,0.5085101-1.161129,1.0380602-1.7236295,1.6008C7.36937,8.6781702,6.8322601,9.2558002,6.3204999,9.84126\n\tC3.85814,6.67206,3.1765001,4.3319998,3.6564801,3.8517499z M3.6570001,18.1381207\n\tc-0.48-0.4802208,0.2016599-2.82055,2.6635699-5.9897404c0.5117202,0.5854502,1.04883,1.1630001,1.6059999,1.7202101\n\ts1.1342802,1.0947304,1.7192402,1.6062002C6.47679,17.9363403,4.1374402,18.6167603,3.6570001,18.1381207z M17.9436207,18.1381207\n\tc-0.4819298,0.4797401-2.82129-0.2015305-5.9897499-2.6630802c0.5854502-0.5117197,1.1625996-1.0495596,1.7202196-1.6069403\n\tc0.5571299-0.55725,1.0942402-1.1347599,1.6059999-1.7200899c2.4618397,3.1693096,3.1434803,5.5093994,2.6634998,5.9901104\n\tH17.9436207z"
			},
			children: [
			]
		}
	]
},
	"energy-utilities": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.36,14.3V9.47a1.68,1.68,0,0,0,.3-.15l3.76,2.83.67-.9L12.36,8.44a1.6,1.6,0,0,0,.09-.53,1.65,1.65,0,0,0-1.09-1.55V1.8H10.24V6.36A1.65,1.65,0,0,0,9.15,7.91a1.6,1.6,0,0,0,.09.53L5.52,11.25l.68.9L9.94,9.32l.3.15V14.3c-4.73.14-7.87,2.09-7.87,4.95v.55H19.23v-.55C19.23,16.39,16.09,14.44,11.36,14.3Zm-1.1-6.39a.54.54,0,0,1,.54-.54.55.55,0,0,1,.55.54.55.55,0,0,1-.55.55.55.55,0,0,1-.54-.55ZM3.54,18.69c.4-1.72,2.69-3.3,7.26-3.3s6.86,1.58,7.26,3.3Z"
			},
			children: [
			]
		}
	]
},
	enterprise: enterprise,
	error: error,
	ethernet: ethernet,
	euro: euro,
	expense: expense,
	"external-link": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "f5a11f6b-f49f-40e8-9fef-b62ba7c1147d",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,1.8V8.2H18.68V3.72L12.56,9.84l-.8-.8,6.12-6.11H13.4V1.8ZM15.3,18.68H2.93V6.3H12.8l1-1.12H1.8V19.8H16.43V7.8l-1.13,1Z"
			},
			children: [
			]
		}
	]
},
	"face-covering": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.05781,7.33433c-.9649-.60034-2.47931-.05053-3.1261.2345a15.59574,15.59574,0,0,0-5.08581-1.63h-.0918a15.59574,15.59574,0,0,0-5.08581,1.63c-.64679-.285-2.1612-.83484-3.1261-.2345a1.6793,1.6793,0,0,0-.74414,1.544c0,1.58178,1.58972,3.29559,2.74078,4.32678a12.112,12.112,0,0,0,1.82471,1.34332l.01263.00763A8.34038,8.34038,0,0,0,10.8,15.66118,8.34038,8.34038,0,0,0,15.22383,14.556l.01263-.00763a12.112,12.112,0,0,0,1.82471-1.34332c1.15106-1.03119,2.74078-2.745,2.74078-4.32678A1.6793,1.6793,0,0,0,19.05781,7.33433ZM5.12324,12.09581c-1.1485-1.0791-2.20019-2.3465-2.20019-3.21753,0-.45508.16015-.55469.21289-.58789.38183-.23767,1.3139-.00659,1.9873.2702Zm10.22852.42505a1.318,1.318,0,0,1-.67188,1.05078A7.8327,7.8327,0,0,1,10.8,14.53618a7.8327,7.8327,0,0,1-3.87988-.96454,1.318,1.318,0,0,1-.67188-1.05078V8.53843a14.45178,14.45178,0,0,1,4.52344-1.47461h.05664a14.45178,14.45178,0,0,1,4.52344,1.47461Zm1.125-.42505V8.56059c.6734-.27679,1.60547-.50787,1.9873-.2702.05274.0332.21289.13281.21289.58789C18.677,9.74931,17.62526,11.01671,16.47676,12.09581ZM10.8,11.46422h2.6084v1.125H8.1916v-1.125Zm0-2.24317h2.6084v1.125H8.1916v-1.125Z"
			},
			children: [
			]
		}
	]
},
	facebook: facebook,
	"fall-detected": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9.01564,16.52652a.56272.56272,0,0,1-.77246.19043L2.0674,12.98746a.56256.56256,0,1,1,.582-.96289l6.17578,3.72949A.5626.5626,0,0,1,9.01564,16.52652ZM14.735,10.81931a1.49286,1.49286,0,1,0-1.49286-1.4928A1.49288,1.49288,0,0,0,14.735,10.81931Zm4.71618-4.2049a.56716.56716,0,0,0-.73242.3125l-1.61133,4.01465-.48486.47486H13.24928L12.01271,9.11149V5.36441a.56226.56226,0,1,0-1.12451,0V9.25309a.55852.55852,0,0,0,.06689.26562l1.53357,2.86041-1.68909,1.96375L9.273,10.82926a.57156.57156,0,0,0-.12109-.17578L5.21925,6.7775a.56245.56245,0,0,0-.79.80078l3.855,3.79981,2.2085,5.082a.56291.56291,0,0,0,.51611.33789h1.49707a.5639.5639,0,0,0,.39356-.16016l5.0791-4.97461a.56986.56986,0,0,0,.1289-.19238l1.65625-4.124A.564.564,0,0,0,19.45118,6.61441Z"
			},
			children: [
			]
		}
	]
},
	favorite: favorite,
	fax: fax,
	"federal-defense": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.6,8.9l-3.5,2.6,1.4,4.2-3.6-2.6L7.3,15.8l1.3-4.2L5,9l4.4-.1,1.4-4.2,1.4,4.2Zm3.2,1.9a9,9,0,1,1-9-9A9,9,0,0,1,19.8,10.8Zm-1.1,0a7.9,7.9,0,1,0-7.9,7.9A7.92,7.92,0,0,0,18.7,10.8Z"
			},
			children: [
			]
		}
	]
},
	feedback: feedback,
	"filter-off": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12.716,19.8H8.55V13.05L1.8,1.8h18l-5.577,9.295a5.03837,5.03837,0,0,0-2.25,1.563l5.84-9.733H3.787l5.888,9.813v5.937H11.655A5.05748,5.05748,0,0,0,12.716,19.8ZM19.8,15.862a3.938,3.938,0,1,1-3.938-3.937A3.93848,3.93848,0,0,1,19.8,15.862Zm-1.183.563H13.106a2.81228,2.81228,0,0,0,5.511,0Zm.001-1.125a2.81228,2.81228,0,0,0-5.511,0Z"
			},
			children: [
			]
		}
	]
},
	filter: filter,
	financial: financial,
	"find-my-remote": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M6.52,6.8a2,2,0,1,0,2,2A2,2,0,0,0,6.52,6.8Zm0,2.88A.88.88,0,1,1,7.4,8.8.88.88,0,0,1,6.52,9.68Zm-1.75,6.5h1v1h-1Zm2.5,0h1v1h-1Zm1-3h-1v-1h1Zm0,2h-1v-1h1Zm-2.5-2h-1v-1h1Zm0,2h-1v-1h1Zm2.5-9.75h-1v-1h1Zm-2.5,0h-1v-1h1ZM9.9,14.57a6,6,0,0,0,.62.51V19.8h-8V1.8h8V7.15a5,5,0,0,0-.62.52,4.68,4.68,0,0,0-.5.6V2.93H3.65V18.67H9.4V14A4.76,4.76,0,0,0,9.9,14.57Zm6.46-1.23a3.75,3.75,0,1,0-5.67.43,3.72,3.72,0,0,0,4.87.36l2.72,2.72.8-.8ZM15.21,13a2.64,2.64,0,1,1,0-3.73A2.65,2.65,0,0,1,15.21,13Z"
			},
			children: [
			]
		}
	]
},
	"fine-art": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13.7,4.8l-2.9-2.9L7.9,4.8H1.8v14h18v-14H13.7z M10.8,3.5l1.3,1.3H9.5L10.8,3.5z M18.7,17.7H2.9V5.9h15.7V17.7z M17.8,6.8\n\th-14v10h14V6.8z M16.7,15.7H4.9V7.9h11.7V15.7z"
			},
			children: [
			]
		}
	]
},
	"fingerprint-sensor": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.50264,16.3098v2.293a.554.554,0,1,1-1.108,0v-2.293a1.786,1.786,0,1,0-3.572,0v2.49a.554.554,0,1,1-1.108,0v-2.49a2.894,2.894,0,0,1,5.788,0Zm-2.894-5.234a5.23931,5.23931,0,0,0-5.234,5.234v1.452a.554.554,0,1,0,1.108,0v-1.452a4.126,4.126,0,1,1,8.252,0v.585a.554.554,0,1,0,1.108,0v-.585A5.24,5.24,0,0,0,11.60866,11.07579Zm0-2.34a7.59744,7.59744,0,0,0-7.509,6.582.55532.55532,0,0,0,.477.622.59792.59792,0,0,0,.073.004.55352.55352,0,0,0,.548-.48095,6.46492,6.46492,0,0,1,12.438-1.49005.55375.55375,0,1,0,1.032-.402A7.63893,7.63893,0,0,0,11.60866,8.73577Zm7.507,1.114a9.89626,9.89626,0,0,0-16.42,2.131.5548.5548,0,0,0,.997.487,8.78716,8.78716,0,0,1,14.584-1.895.55377.55377,0,1,0,.839-.723Zm-15.796-.907a11.00806,11.00806,0,0,1,14.286-1.979.55444.55444,0,0,0,.60394-.93,12.11719,12.11719,0,0,0-15.72,2.176.55369.55369,0,1,0,.83.733Zm1.079-3.994a.55476.55476,0,0,0,.291-.083,13.2812,13.2812,0,0,1,10.411-1.497.55385.55385,0,1,0,.29394-1.068,14.41516,14.41516,0,0,0-11.288,1.62305.55368.55368,0,0,0,.292,1.025Zm7.21,10.807a.55393.55393,0,0,0-.554.554v2.936a.554.554,0,1,0,1.108,0v-2.936A.55393.55393,0,0,0,11.60866,15.75579Z"
			},
			children: [
			]
		}
	]
},
	fire: fire,
	"fit-to-zone": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,1.8V8.2h-1.1V3.7L12.6,9.8,11.8,9l6.1-6.1H13.4V1.8ZM9,11.8,2.9,17.9V13.4H1.8v6.4H8.2V18.7h-4.5l6.1-6.1Zm9.7,6.1-6.1-6.1-.8.8,6.1,6.1H13.4v1.1h6.4V13.4h-1.1ZM8.2,2.9V1.8H1.8V8.2H2.9V3.7L9,9.8,9.8,9l-6.1-6.1Z"
			},
			children: [
			]
		}
	]
},
	flag: flag,
	"fleet-tracking": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.18,4.05H1.8V15.3H2.93a2.25,2.25,0,0,0,4.5,0h6.75a2.25,2.25,0,0,0,4.5,0H19.8V10.8Zm-9,12.38A1.13,1.13,0,1,1,6.3,15.3,1.13,1.13,0,0,1,5.18,16.43Zm11.25,0a1.13,1.13,0,1,1,1.12-1.13A1.13,1.13,0,0,1,16.43,16.43Zm2.25-2.25h-.32a2.22,2.22,0,0,0-3-.84,2.16,2.16,0,0,0-.83.84H7.11a2.22,2.22,0,0,0-3-.84,2.16,2.16,0,0,0-.83.84H2.93v-9H13.65l5,6Zm-6.7-4-.66.66a2.89,2.89,0,0,0-4.07,0l-.67-.66A3.82,3.82,0,0,1,12,10.22Zm-1.31,1.31-.66.66a1,1,0,0,0-1.45,0l-.67-.66A2,2,0,0,1,10.67,11.53Zm2.62-2.62-.66.66a4.74,4.74,0,0,0-6.69,0l-.66-.66h0A5.67,5.67,0,0,1,13.29,8.91Z"
			},
			children: [
			]
		}
	]
},
	fleet: fleet,
	"flexibility-rectangles": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.38,6.1V2.89H1.8V13H8v5.69h6.59V16.24H19.8V6.1ZM3,11.79V4.12H16.15v2h-6v5.69Zm10.29,5.69H9.19V13h1v3.22h3.13ZM11.41,15V13h1.91v2Zm0-3.22V7.33h4.74v4.46ZM18.57,15h-4V13h2.83V7.33h1.19Z"
			},
			children: [
			]
		}
	]
},
	flexibility: flexibility,
	"flexible-four-arrows": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.43,17.66V10.8a3.61,3.61,0,0,0-1-2.51h4.25L15.6,10.35l.79.79L19.8,7.73,16.39,4.32l-.79.79,2.06,2.06H10.8a3.61,3.61,0,0,0-2.51,1V3.94L10.35,6l.79-.79L7.73,1.8,4.32,5.21,5.11,6,7.17,3.94V10.8a3.61,3.61,0,0,0,1,2.51H3.94L6,11.25l-.79-.79L1.8,13.87l3.41,3.41L6,16.49,3.94,14.43H10.8a3.61,3.61,0,0,0,2.51-1v4.25L11.25,15.6l-.79.79,3.41,3.41,3.41-3.41-.79-.79ZM10.8,13.31a2.51,2.51,0,1,1,2.51-2.51A2.51,2.51,0,0,1,10.8,13.31Z"
			},
			children: [
			]
		}
	]
},
	"flexible-three-arrows": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M8.92891,5.471l-.799-.799L11.0019,1.8l2.871,2.872-.79895.799-1.507-1.507V9.878h-1.131V3.964Zm-3.433,3.451-.799-.799-2.872,2.872,2.872,2.871.799-.79895L3.9889,11.56h6.124V10.429H3.9889ZM16.903,8.10762l-.79907.79907,1.47778,1.4779H13.43989a3.09844,3.09844,0,0,0-3.09472,3.09485V19.8h1.13012V13.47944a1.96683,1.96683,0,0,1,1.9646-1.9646h4.20069L16.104,13.05146l.79907.79908L19.7751,10.9792Z"
			},
			children: [
			]
		}
	]
},
	"flip-camera": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.71748,2.009h-16V13.438h16Zm-1.143,10.286H3.86049V3.152h13.714Zm-9.779-.857a3.429,3.429,0,1,0-3.429-3.429A3.43172,3.43172,0,0,0,7.79548,11.438Zm0-5.715a2.286,2.286,0,1,1-2.286,2.286A2.288,2.288,0,0,1,7.79548,5.723Zm5.714,0a1.143,1.143,0,1,1,1.143,1.143A1.143,1.143,0,0,1,13.50947,5.723Zm6.132,9.945c-.539,1.986-4.191,3.428-8.924,3.428a16.54675,16.54675,0,0,1-6.262-1.077l-.674,1.572-1.823-3.246,3.608-.918-.672,1.567a15.74233,15.74233,0,0,0,5.823.976c4.052,0,7.023-1.13,7.713-2.302Z"
			},
			children: [
			]
		}
	]
},
	flurry: flurry,
	"folder-locked": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "a",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M7.28742,4.075l1.66365,1.9132,.33635,.3868h9.38758v11.15H2.925V4.075H7.28742m.51258-1.125H1.8v15.7H19.8V5.25H9.8l-2-2.3h0Zm5.12078,8.36988v-1.43268c0-1.17352-.95129-2.12476-2.12482-2.12476-1.17346,0-2.12476,.95123-2.12476,2.12476v1.43268h-1.06238v4.78076h6.37433v-4.78076h-1.06238Zm-3.12457-1.43268c0-.55127,.44849-.99976,.99976-.99976,.55133,0,.99982,.44849,.99982,.99976v1.43268h-1.99957v-1.43268Zm-1.06238,5.08844v-2.49152h4.12433v2.49152h-4.12433Z"
			},
			children: [
			]
		}
	]
},
	folder: folder,
	"forwarded-call": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,9.1h15.8l-4.2-4.2L14.2,4l5.6,5.6l-5.6,5.6l-0.8-0.8l4.2-4.2H2.9v7.4H1.8V9.1z"
			},
			children: [
			]
		}
	]
},
	fridge: fridge,
	fullscreen: fullscreen,
	gaming: gaming,
	gas: gas,
	gateway: gateway,
	geofence: geofence,
	"get-help": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12.33015,12.84388a14.64349,14.64349,0,0,1-2.23736-1.85247A14.63383,14.63383,0,0,1,8.2704,8.72993L9.45662,6.36738l-4.072-4.12622L1.802,5.168A17.46638,17.46638,0,0,0,6.54506,14.4925a17.46676,17.46676,0,0,0,9.261,4.86634L18.78,15.81514,14.70814,11.689Zm3.04718,5.27582a16.32424,16.32424,0,0,1-8.03155-4.41742A16.32588,16.32588,0,0,1,3.03529,5.61311L5.30323,3.76033l2.786,2.82312L7.265,8.22511l-.2909.57947.35553.54223A15.82449,15.82449,0,0,0,9.292,11.78163a15.83491,15.83491,0,0,0,2.40882,1.99469l.53747.36285.58338-.28332,1.65234-.80249L17.26,15.87642Zm-1.459-13.47156a.63573.63573,0,0,0,.07324-.30468.68254.68254,0,0,0-.16016-.47266.6181.6181,0,0,0-.4834-.17871.68892.68892,0,0,0-.53906.21.83651.83651,0,0,0-.1748.31152,1.51633,1.51633,0,0,0-.05567.44434H11.42958a2.80848,2.80848,0,0,1,.07715-.71387,1.724,1.724,0,0,1,.24511-.53222,1.51438,1.51438,0,0,1,.61963-.51368,2.66139,2.66139,0,0,1,1.80274-.0664,1.69454,1.69454,0,0,1,.57422.33887,1.36516,1.36516,0,0,1,.3457.5039,1.68017,1.68017,0,0,1,.11621.62695,1.55626,1.55626,0,0,1-.06641.47266,1.50489,1.50489,0,0,1-.18261.37793,1.8956,1.8956,0,0,1-.26563.31445,3.65444,3.65444,0,0,1-.31836.26954q-.16845.14063-.35058.26953c-.1211.08691-.24122.17382-.36036.26269s-.23339.17774-.34277.26563a2.72857,2.72857,0,0,0-.29785.28027V6.821h2.18457v.9873H11.36659a2.34007,2.34007,0,0,1,.07715-.57422,1.98507,1.98507,0,0,1,.46972-.84375,3.86865,3.86865,0,0,1,.34278-.32519q.17432-.15381.37109-.30078c.12988-.09766.25977-.19532.38867-.291.12793-.09473.252-.18945.37012-.2832q.17871-.13917.32617-.28028A1.06382,1.06382,0,0,0,13.91835,4.64814ZM19.08046,5.778V2.76143H17.87733L15.56,5.59639V6.695h2.331V7.8083h1.18946V6.695h.72168V5.778Zm-1.18946,0H16.48378V5.76436l1.39355-1.72168H17.891Z"
			},
			children: [
			]
		}
	]
},
	gift: gift,
	"gifted-data": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M6.24,15.85h9.12V8.75H12.74a3.34,3.34,0,0,0,1.08-.34,1.6,1.6,0,0,0-.54-2.89,1.55,1.55,0,0,0-1.2.23A6.85,6.85,0,0,0,10.8,7.42,7,7,0,0,0,9.52,5.75,1.59,1.59,0,0,0,7.78,8.41a3.43,3.43,0,0,0,1.08.34H6.24Zm6.33-9.18a.53.53,0,0,1,.89.09.6.6,0,0,1-.19.8,5.4,5.4,0,0,1-1.56.33A7.92,7.92,0,0,1,12.57,6.67ZM11.36,9.89h2.86v4.82H11.36Zm-3-2.33a.58.58,0,0,1-.18-.78A.55.55,0,0,1,9,6.68,7.92,7.92,0,0,1,9.9,7.89,5.3,5.3,0,0,1,8.34,7.56Zm-1,2.33h2.86v4.82H7.38Zm6.86,9.57-.43-1A7.88,7.88,0,0,0,18.07,8.13C18,8,18,7.88,17.89,7.75l1-.5c.07.15.15.29.21.45A9,9,0,0,1,14.24,19.46ZM7.79,18.41l-.43,1A9,9,0,1,1,16.9,4.54l-.74.85a7.86,7.86,0,1,0-8.37,13Z"
			},
			children: [
			]
		}
	]
},
	government: government,
	"grid-view": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,9.6H9.6V1.8H1.8ZM2.9,2.9H8.5V8.5H2.9ZM12,1.8V9.6h7.8V1.8Zm6.6,6.7H13.1V2.9h5.5ZM1.8,19.8H9.6V12H1.8Zm1.1-6.7H8.5v5.5H2.9ZM12,19.8h7.8V12H12Zm1.1-6.7h5.5v5.5H13.1Z"
			},
			children: [
			]
		}
	]
},
	"group-family": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,13.90446H18.68037a3.67023,3.67023,0,0,0-7.20434-.998A6.31918,6.31918,0,0,1,14.447,18.25865H13.32734v-.0141a5.20386,5.20386,0,0,0-10.40771.0141H1.8a6.31222,6.31222,0,0,1,8.65918-5.87128A4.79282,4.79282,0,0,1,19.8,13.90446ZM12.41627,5.92735a2.586,2.586,0,1,1,2.58606,2.586A2.586,2.586,0,0,1,12.41627,5.92735Zm1.125,0a1.461,1.461,0,1,0,1.46106-1.461A1.4627,1.4627,0,0,0,13.54127,5.92735ZM4.80781,7.90019A3.31559,3.31559,0,1,1,8.12343,11.2158,3.31558,3.31558,0,0,1,4.80781,7.90019Zm1.125,0A2.19059,2.19059,0,1,0,8.12343,5.70964,2.193,2.193,0,0,0,5.93281,7.90019Z"
			},
			children: [
			]
		}
	]
},
	"growth-opportunities": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.26777,11.38447a4.02617,4.02617,0,0,1-1.69659.73358V11.10554a2.9423,2.9423,0,0,0,1.08624-.51306,2.51758,2.51758,0,0,0,.71485-3.19775c-.56934-1.37354-2.67676-1.48682-2.69825-1.4878l-.39746-.01855-.07226-.39209A3.1508,3.1508,0,0,0,12.635,3.42988a4.56354,4.56354,0,0,0-2.34375-.61865,5.54742,5.54742,0,0,0-1.73437.28467A3.64983,3.64983,0,0,0,5.9543,6.77266l.03955.53662-.53809.00195A1.52551,1.52551,0,0,0,4.35029,7.843a2.13837,2.13837,0,0,0-.311,1.87305,2.05014,2.05014,0,0,0,1.1831,1.39062,1.58785,1.58785,0,0,0,.62012.11719H7.47157v1H5.84248a2.58193,2.58193,0,0,1-1.00879-.19531A3.07291,3.07291,0,0,1,3.07832,9.99385a3.14269,3.14269,0,0,1,.47314-2.752,2.50388,2.50388,0,0,1,1.41309-.87353A4.621,4.621,0,0,1,8.24434,2.1457a5.94266,5.94266,0,0,1,4.90234.42481A4.25791,4.25791,0,0,1,15.09883,4.946a3.94961,3.94961,0,0,1,3.19726,2.06591A3.4898,3.4898,0,0,1,17.26777,11.38447Zm-2.7326,3.733.035,4.67493L13.47944,19.8l-.02032-2.71539H9.76338l-.02222,2.72717H8.67061l.00073-4.69428L8.666,7.38435l1.0907-.001.00109,1.68244h3.6413l-.012-1.60858,1.0907-.00855Zm-4.775-2.58789h3.66485L13.4073,10.156H9.75856Zm3.69073,3.4643-.00653-.87641-.01123-1.49719H9.761l.001,1.49719.00061.87641Z"
			},
			children: [
			]
		}
	]
},
	growth: growth,
	hackers: hackers,
	"hard-brake": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M3.81782,8.85518l6.07031,6.07031-.79492.79492L6.45546,13.08265l-3.84955,3.8487L1.811,16.13643l3.84954-3.8487L3.0229,9.6501Zm15.58594,5.59961-4.03516,4.0371L5.47505,8.59736A1.785,1.785,0,0,1,7.29927,5.64131l.12207.041,7.73633,2.56641.46972,1.44336a3.27673,3.27673,0,0,0,2.917,2.24219l.21485.01172.64453.6455A1.31911,1.31911,0,0,1,19.40376,14.45479Zm-.79492-1.06836-.34766-.34668a4.41479,4.41479,0,0,1-3.7041-2.999l-.29395-.90332-.31091-.10315-.66369,1.67737-1.04688-.41406L12.882,8.67909l-.75079-.24921-.60932,1.53955-1.04687-.41406.586-1.48065-4.11627-1.366a.677.677,0,0,0-.209-.0332A.66016.66016,0,0,0,6.27,7.80244L15.3686,16.9001l3.24024-3.24024A.21751.21751,0,0,0,18.60884,13.38643ZM5.82075,4.68428,5.41157,3.10811l-1.08984.2832.40918,1.57617Zm-1.83887.81933L2.82759,4.35518l-.793.79687,1.1543,1.14844Z"
			},
			children: [
			]
		}
	]
},
	headphones: headphones,
	"healthcare-corporate": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M6.2727799,10.1435099H5.1568699V9.0286398h1.1159101V10.1435099z M7.23805,10.1435099h1.1159501V9.0286398H7.23805\n\tV10.1435099z M9.3192902,10.1435099h1.11584V9.0286398h-1.11584V10.1435099z M6.2727804,11.2585096H5.1568699V12.37325h1.1159101\n\tL6.2727804,11.2585096z M7.2380505,12.37325h1.1159496v-1.1147499H7.23805L7.2380505,12.37325z M9.3192902,12.37325h1.11584\n\tv-1.1147499h-1.11584V12.37325z M6.2727804,13.4882498H5.1568699v1.11485h1.1159101L6.2727804,13.4882498z M7.2380505,14.6031199\n\th1.1159496v-1.1148901H7.23805L7.2380505,14.6031199z M9.3192902,14.6031199h1.11584v-1.1148901h-1.11584V14.6031199z\n\t M6.2727799,15.7180004H5.1568699v1.1149998h1.1159101V15.7180004z M7.23805,16.8330002h1.1159501v-1.1149998H7.23805V16.8330002z\n\t M9.3192902,16.8330002h1.11584v-1.1149998h-1.11584V16.8330002z M14.5246696,7.7329998h-1.11584v1.11485h1.11584V7.7329998z\n\t M16.6059093,7.7329998h-1.1159096v1.11485h1.1159096V7.7329998z M14.5246696,9.9627199h-1.11584V11.07759h1.11584V9.9627199z\n\t M16.6059093,9.9627199h-1.1159096V11.07759h1.1159096V9.9627199z M14.5246696,12.1925802h-1.11584v1.1147404h1.11584V12.1925802z\n\t M16.6059093,12.1925802h-1.1159096v1.1147404h1.1159096V12.1925802z M14.5246696,14.4223099h-1.11584v1.1148701h1.11584V14.4223099\n\tz M16.6059093,14.4223099h-1.1159096v1.1148701h1.1159096V14.4223099z M14.5246696,16.65205h-1.11584v1.1149998h1.11584V16.65205z\n\t M16.6059093,16.65205h-1.1159096v1.1149998h1.1159096V16.65205z M19.7999992,18.6852493v1.1147499h-18v-1.1147499H3.105V1.8\n\th9.4949398v3.6538103h5.8950615v13.2314396H19.7999992z M11.4840002,2.915H4.2209001v15.7522001h7.2631001V2.915z\n\t M17.3791008,6.5685501h-4.743v12.0986404h4.743V6.5685501z M7.2384801,7.665H8.35359V6.6939998h0.9729996V5.579H8.35359V4.6079998\n\tH7.2384801V5.579H6.26648v1.1149998h0.9720001V7.665z"
			},
			children: [
			]
		}
	]
},
	"healthcare-general": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13.12,2.92V8.48h5.56v4.64H13.12v5.56H8.48V13.12H2.92V8.48H8.48V2.92h4.64M14.23,1.8H7.37V7.37H1.8v6.86H7.37V19.8h6.86V14.23H19.8V7.37H14.23Z"
			},
			children: [
			]
		}
	]
},
	history: history,
	"home-internet": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,1.8,2.93,8.55V19.8H18.68V8.55Zm6.75,16.88H4.05V9.07L10.8,3.28l6.75,5.79ZM13.17,14.3l-.8.79a2.26,2.26,0,0,0-3.19,0l-.79-.79A3.38,3.38,0,0,1,13.17,14.3Zm1.59-1.59L14,13.5a4.51,4.51,0,0,0-6.38,0l-.8-.79A5.64,5.64,0,0,1,14.76,12.71Zm1.56-1.57-.8.8a6.68,6.68,0,0,0-9.45,0l-.8-.8A7.83,7.83,0,0,1,16.32,11.14ZM11.56,15.9l-.8.79L10,15.9A1.13,1.13,0,0,1,11.56,15.9Z"
			},
			children: [
			]
		}
	]
},
	home: home,
	humidity: humidity,
	"ideas-solutions": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M8.56,15.4H13v1.11H8.56Zm0,2.76H13V17H8.56Zm1.77,1.64h.95l.7-1.1H9.62Zm5.12-9.71h0C15,11,13,14.41,13,14.86H8.56c0-.45-2-3.85-2.43-4.77h0a5.46,5.46,0,1,1,9.3,0Zm-1.84,1.12H8l0,.06c.66,1.2,1.06,2,1.31,2.47h2.94c.25-.51.65-1.27,1.31-2.47Zm1.53-4a4.34,4.34,0,1,0-8.68,0,4.29,4.29,0,0,0,1.08,2.83h6.52a4.29,4.29,0,0,0,1.08-2.83Z"
			},
			children: [
			]
		}
	]
},
	"identity-graph": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.2,11.1c2.5,0,4.6-2.1,4.6-4.6c0-2.5-2.1-4.6-4.6-4.6S6.6,3.9,6.6,6.4C6.6,9,8.6,11.1,11.2,11.1z M11.2,3\n\tc1.9,0,3.5,1.6,3.5,3.5c0,1.9-1.6,3.5-3.5,3.5c-1.9,0-3.5-1.6-3.5-3.5C7.7,4.5,9.2,3,11.2,3z M9.7,15.1h2.6v4.7H9.7V15.1z M6,16.4\n\th2.6v3.3H6L6,16.4z M13.5,17.1h2.6v2.7h-2.6V17.1z M18.5,18.5h-1.1c0-3.3-2.9-6-6.6-6s-6.6,2.7-6.6,6H3.1c0-3.9,3.4-7.1,7.7-7.1\n\tS18.5,14.6,18.5,18.5L18.5,18.5z"
			},
			children: [
			]
		}
	]
},
	"identity-restoration": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 38 38"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m33.00041,18.99426c-.00146,1.21069-.14624,2.42847-.46802,3.62915-.63477,2.3689-1.86304,4.45557-3.49146,6.12946-2.68188-2.70978-6.22388-4.25861-9.88867-4.25861-3.7478,0-7.33447,1.59686-10.03271,4.40192-.85474-.85687-1.61304-1.82007-2.23438-2.89618-1.86987-3.23859-2.3667-7.01135-1.39868-10.62347,1.6377-6.11157,7.19458-10.38019,13.51392-10.38049,1.21924,0,2.44141.16187,3.63257.48096,2.35718.63165,4.44702,1.85431,6.14355,3.51727h-3.75415v2h7V3.99426h-2v3.42902c-1.87158-1.79071-4.19287-3.16028-6.87183-3.87811-1.38721-.3717-2.78003-.54919-4.15112-.54913-7.06421.00037-13.52954,4.71472-15.44482,11.86285-2.28711,8.53546,2.77832,17.30884,11.31372,19.59589,1.38721.37177,2.78003.54919,4.15112.54919,7.06421,0,13.52954-4.71478,15.44482-11.86292.37158-1.38635.53003-2.77667.53027-4.14679h-1.99414Zm-17.6145,13.52869c-1.74927-.46875-3.35522-1.25977-4.76318-2.31274,2.3147-2.37103,5.3606-3.71594,8.52954-3.71594,3.14673,0,6.09033,1.2749,8.40283,3.59155-2.38794,1.84265-5.36548,2.91815-8.53564,2.91815-1.21973,0-2.44238-.16187-3.63354-.48102Zm-2.36353-15.5282c0,3.30811,2.69141,5.99951,5.99902,5.99951,3.30859,0,6.00098-2.69141,6.00098-5.99951,0-3.30859-2.69238-6.00049-6.00098-6.00049-3.30762,0-5.99902,2.69189-5.99902,6.00049Zm10,0c0,2.20557-1.79492,3.99951-4.00098,3.99951-2.20508,0-3.99902-1.79395-3.99902-3.99951,0-2.20605,1.79395-4.00049,3.99902-4.00049,2.20605,0,4.00098,1.79443,4.00098,4.00049Z"
			},
			children: [
			]
		}
	]
},
	"impression-video": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,8.5c-3.7-0.1-7.2,1.8-9,5.1c1.8,3.2,5.3,5.2,9,5.1c3.7,0.1,7.2-1.8,9-5.1C18,10.3,14.5,8.4,10.8,8.5z M3.1,13.5\n\tc1-1.5,2.5-2.7,4.2-3.3c-1.8,1.8-1.8,4.8,0,6.6C5.6,16.2,4.1,15.1,3.1,13.5z M10.8,17.2c-2,0-3.7-1.7-3.7-3.7s1.7-3.7,3.7-3.7\n\ts3.7,1.7,3.7,3.7C14.5,15.6,12.8,17.2,10.8,17.2L10.8,17.2z M14.3,16.8c1.8-1.8,1.8-4.8,0-6.6c1.7,0.6,3.2,1.8,4.2,3.3\n\tC17.5,15.1,16,16.2,14.3,16.8L14.3,16.8z M12.2,13.5c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4l0,0\n\tC11.6,12.1,12.2,12.7,12.2,13.5z M2.9,5.8L1.8,4.7l1.6-0.2L4.1,3l0.7,1.4l1.6,0.2L5.2,5.8l0.3,1.6L4.1,6.6L2.7,7.3L2.9,5.8z\n\t M9.5,5.8L8.4,4.7L10,4.5L10.6,3l0.7,1.4l1.6,0.2l-1.1,1.1l0.3,1.6l-1.4-0.7L9.2,7.3L9.5,5.8z M16.1,5.8L15,4.7l1.6-0.2L17.2,3\n\tl0.7,1.4l1.6,0.2l-1.1,1.1l0.3,1.6l-1.4-0.7l-1.4,0.7L16.1,5.8z"
			},
			children: [
			]
		}
	]
},
	"in-store-pickup": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.7,6.3V4.72A2.93,2.93,0,0,0,11.77,1.8H9.83A2.93,2.93,0,0,0,6.9,4.72V6.3H4.05V19.8h13.5V6.3ZM8,4.72A1.88,1.88,0,0,1,9.83,2.84h1.94a1.88,1.88,0,0,1,1.88,1.88V6.3H8Zm8.48,14H5.18V7.43H6.9V8.72H8V7.43h5.7V8.72h1V7.43h1.73ZM10.8,8.55a4.5,4.5,0,1,0,4.5,4.5A4.51,4.51,0,0,0,10.8,8.55Zm0,7.88a3.38,3.38,0,1,1,3.38-3.38A3.38,3.38,0,0,1,10.8,16.43ZM12,11.33l.44.41L10.5,13.81V10.3h.6v2Z"
			},
			children: [
			]
		}
	]
},
	inclusivity: inclusivity,
	"incoming-call": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "fbfeea08-ac2c-434c-9a2b-18dc674126fc",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M3.72,18.68h6V19.8H1.8V11.93H2.93v5.95L19,1.8l.8.8Z"
			},
			children: [
			]
		}
	]
},
	increase: increase,
	industry: industry,
	"inferred-identity": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		"enable-background": "new 0 0 21.6 21.6",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.75868,11.12666c2.5472,0,4.61212-2.06492,4.61212-4.61212s-2.06492-4.61212-4.61212-4.61212\n\tS6.14656,3.96734,6.14656,6.51454c-0.00003,2.54718,2.06484,4.61209,4.61202,4.61212\n\tC10.75861,11.12666,10.75865,11.12666,10.75868,11.12666z M10.75868,3.02742c1.92588-0.00247,3.48912,1.55676,3.4916,3.48264\n\ts-1.55676,3.48912-3.48264,3.4916c-1.63807,0.0021-3.05679-1.13623-3.40971-2.73583h2.91442v-1.125h-2.963\n\tC7.49629,4.37492,8.98292,3.03308,10.75868,3.02742z M18.34413,18.88984c0-0.0874-0.01361-0.35623-0.016-0.40561v-0.00142\n\tc-0.35593-3.8643-3.64859-6.78987-7.52793-6.68867c-4.0391-0.1149-7.41108,3.05712-7.543,7.0957c0,0-0.026,0.62735-0.01972,0.81641\n\tl15.10822-0.00867C18.35451,19.43391,18.34413,18.88984,18.34413,18.88984z M10.80067,12.91914\n\tc1.26257-0.00429,2.50084,0.34701,3.57306,1.01367h-3.85138v1.125h5.19385c0.32918,0.36636,0.61167,0.77212,0.841,1.208H8.35585\n\tv1.125h8.65033c0.1004,0.35879,0.16442,0.72678,0.1911,1.09839L4.40193,18.52753\n\tC4.73315,15.26885,7.52669,12.82036,10.80067,12.91914z"
			},
			children: [
			]
		}
	]
},
	info: info,
	instagram: instagram,
	insurance: insurance,
	"intelligent-tracking": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13,7.2l.36-.56h0a3.1,3.1,0,1,0-5.16,0h0l.4.59L4.79,9.39v6.94l6,3.47,6-3.47V9.39Zm-3.21-4a2,2,0,0,1,1-.27,2,2,0,0,1,2,2,2,2,0,0,1-.27,1h0l-1.65,2.6L9.09,5.91A2,2,0,0,1,9.8,3.19Zm.44,15-4.33-2.5v-5l4.33,2.5ZM6.47,9.71,9.23,8.12l1.64,2.44,1.54-2.42,2.72,1.58-4.33,2.5Zm9.22,6-4.33,2.5v-5l4.33-2.51ZM10.07,5a.73.73,0,1,1,1.46,0,.73.73,0,0,1-.73.73h0A.73.73,0,0,1,10.07,5Z"
			},
			children: [
			]
		}
	]
},
	"international-long-distance": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 38 38"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m24.12659,10c-.46875-1.70013-1.08643-3.17975-1.82251-4.3277,2.44824.78943,4.55933,2.32324,6.08203,4.3277h2.5061c-2.54175-4.19061-7.13306-7-12.39233-7-8.00806,0-14.5,6.49182-14.5,14.5,0,7.83929,6.22559,14.20898,14,14.47473v-2.1745c-1.67017-.74487-3.78101-5.01917-3.99609-11.26453h3.99609v-2.07141h-3.99609c.23706-6.88733,2.78174-11.39288,4.49609-11.39288,1.09058,0,2.51514,1.82867,3.46997,4.92859h2.15674Zm-9.43091,19.32764c-4.68091-1.50934-8.15063-5.72247-8.57202-10.79193h5.80908c.14355,4.45752,1.19922,8.35309,2.76294,10.79193Zm-2.76294-12.86334h-5.80908c.42139-5.06952,3.89111-9.28271,8.57202-10.79199-1.56372,2.43884-2.61938,6.33441-2.76294,10.79199Zm22.06738,12.22327h-.00024V12h-14v23h14v-4.31244h.00024v-2Zm-2.00024-14.68756v14.68756h-10v-14.68756h10Zm0,19h-10v-2.31244h3.75024v1.4375h2.875v-1.4375h3.37476v2.31244Z"
			},
			children: [
			]
		}
	]
},
	"international-symbol-of-access": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.81184,10.23646a.7483.7483,0,0,1,.2207.55323l-.17285,5.70947a.75044.75044,0,0,1-.75.72754l-.02246-.00049a.75074.75074,0,0,1-.72754-.772l.14942-4.91163-2.94251.09528a5.51962,5.51962,0,0,1-.49475,5.746l-1.0982-1.04229a4.056,4.056,0,0,0-5.79822-5.503L5.0674,9.787A5.51555,5.51555,0,0,1,9.83088,8.681l2.66394-3.04449L10.77571,4.03773,7.96907,6.96156A.75007.75007,0,0,1,6.887,5.9225L10.2054,2.46644a.74876.74876,0,0,1,1.05175-.02978l3.247,3.01983,1.52515,1.33887-3.09937,3.36249,4.32819-.14014A.70953.70953,0,0,1,17.81184,10.23646ZM16.6916,1.926a1.89734,1.89734,0,1,0,1.89734,1.89734A1.89736,1.89736,0,0,0,16.6916,1.926ZM8.5804,18.174a4.074,4.074,0,0,1-4.06934-4.06982,4.02388,4.02388,0,0,1,.56781-2.03821L3.95759,11.00172a5.562,5.562,0,0,0,7.95783,7.55274l-1.10767-1.05127A4.03981,4.03981,0,0,1,8.5804,18.174Z"
			},
			children: [
			]
		}
	]
},
	international: international,
	"internet-devices": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13.51808,11.81114H8.08192a3.56355,3.56355,0,0,0-3.56354,3.56354v.86182A3.56349,3.56349,0,0,0,8.08192,19.8h5.43616a3.56349,3.56349,0,0,0,3.56354-3.56347v-.86182A3.56355,3.56355,0,0,0,13.51808,11.81114Zm2.43854,4.42536A2.44126,2.44126,0,0,1,13.51808,18.675H8.08192A2.44126,2.44126,0,0,1,5.64338,16.2365v-.86182a2.44132,2.44132,0,0,1,2.43854-2.43854h5.43616a2.44132,2.44132,0,0,1,2.43854,2.43854ZM5.12764,5.28319l-.7959-.79492a9.14466,9.14466,0,0,1,12.936-.00293l-.79492.79492a8.02125,8.02125,0,0,0-11.34521.00293ZM14.44941,7.3037a5.16143,5.16143,0,0,0-7.29834.00293l-.79589-.79492a6.28484,6.28484,0,0,1,8.88916-.00293ZM13.2209,8.53221l-.79492.79493a2.35419,2.35419,0,0,0-3.25147.00292l-.7959-.79492A3.50257,3.50257,0,0,1,13.2209,8.53221Z"
			},
			children: [
			]
		}
	]
},
	"internet-of-things": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.0080509,3.56692c-0.4166603-0.4489779-1.0074024-0.6954205-1.6196098-0.6756599\n\tc-1.2615032,0.0108566-2.279954,1.033731-2.2853413,2.29527l0,0c0.0007467,0.39503,0.1070843,0.7826786,0.3079996,1.1227999\n\tl-2.2455692,1.9872503c-1.131547-1.0120821-2.8429632-1.0120821-3.9745102,0L7.1974001,7.303\n\tc0.634006-1.0913663,0.2632418-2.490057-0.8281245-3.1240625s-2.490057-0.263242-3.1240628,0.8281245\n\tC2.6125364,6.0961394,2.980284,7.491806,4.0674801,8.1277103c0.347774,0.1999283,0.741529,0.3060617,1.1426702,0.3079996\n\tC5.6691246,8.416255,6.114778,8.2756939,6.5018601,8.0283003L7.5551,9.0219307\n\tc-0.8471642,1.4115944-0.3896031,3.2426796,1.0219913,4.0898438c0.7553511,0.4533224,1.672533,0.5493183,2.5053787,0.2622252\n\tl0.6260004,1.2917099c-0.3570719,0.2978086-0.6166544,0.6958351-0.7452202,1.1426697\n\tc-0.3368092,1.2154379,0.3747063,2.4739485,1.5897999,2.8119993l0,0c0.1999121,0.0595913,0.407445,0.0897179,0.6160498,0.0894299\n\tc1.264039,0.0169182,2.3024607-0.994072,2.3193789-2.25811c0.0169191-1.26404-0.994071-2.3024607-2.25811-2.3193798\n\tc-0.208416-0.0027895-0.4162359,0.0229006-0.6176987,0.0763597l-0.6359196-1.2917099\n\tc1.1944666-0.8986788,1.53864-2.5430593,0.8048401-3.8453302l2.2754097-1.987278\n\tc0.3846025,0.2778721,0.8470402,0.4273787,1.3215208,0.4272499l0,0c1.2615032-0.0108576,2.2799511-1.0337319,2.2853394-2.29527\n\tC18.6775627,4.6004238,18.4409313,4.0052752,18.0080509,3.56692z M3.92837,6.2397699L3.92837,6.2397699\n\tC3.8940654,5.5351949,4.4272451,4.9315171,5.1306601,4.87851h0.1093397\n\tc0.7175035,0.0081987,1.2925086,0.5964966,1.2843099,1.3140001S5.9278131,7.4850192,5.2103095,7.4768205\n\tC4.5332432,7.4690838,3.9756358,6.9426522,3.9289999,6.2671499L3.9284298,6.2596498L3.92837,6.2397699z M14.2041502,15.6149998\n\tc0.2027302,0.2667904,0.2982254,0.5998173,0.2676802,0.9335003c-0.0080233,0.6547165-0.5274982,1.1884079-1.1817598,1.2140999\n\tc-0.3844891,0.0283146-0.7629757-0.1075821-1.0416403-0.3740005c-0.4598312-0.4829521-0.5074997-1.2259998-0.1131496-1.7637501\n\tc0.2647467-0.3153172,0.6566458-0.4956961,1.0683498-0.4917297C13.5916128,15.139473,13.9573059,15.3156023,14.2041502,15.6149998z\n\t M10.1981506,12.5493498c-1.0975275,0-1.9872494-0.8897228-1.9872494-1.9872503s0.8897219-1.9872494,1.9872503-1.9872494\n\ts1.9872494,0.8897219,1.9872494,1.9872494l0,0c-0.0000277,1.0975094-0.8897419,1.9872017-1.9872513,1.9872007L10.1981506,12.5493498\n\tz M16.4281502,6.4882298L16.4281502,6.4882298c-0.7188816-0.0001321-1.3015432-0.5830078-1.3014107-1.3018894\n\tc0.0001326-0.7186947,0.582716-1.3012786,1.3014107-1.3014107c0.3515167-0.0215018,0.693037,0.1217189,0.9240704,0.3875198\n\tc0.5076065,0.5051918,0.5095634,1.3262272,0.0043716,1.8338337c-0.2407837,0.2419348-0.5672474,0.3791742-0.9085712,0.3819466\n\tH16.4281502z"
			},
			children: [
			]
		}
	]
},
	inventory: inventory,
	"invitation-accepted": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.25,10.65l6.8-5.8v6h1.1V2.95H2.35v11.2h7.9v-1.1H3.45V4.85Zm-6-6.6h11.9l-5.9,5.1Zm10.6,14.6-2.6-2.6.8-.8,1.8,1.8,3.6-3.6.8.8Z"
			},
			children: [
			]
		}
	]
},
	"invitation-expired": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,10l6.8-5.8v6h1.1V2.3H2.9v11.2h7.9v-1.1H4V4.2L10.8,10z M16.7,3.4l-5.9,5.1l-6-5.1H16.7z M15.6,16.8h-1l-0.1-1.6v-4\n\th1.2v3.9L15.6,16.8z M14.4,17.8h1.5v1.5h-1.5L14.4,17.8z"
			},
			children: [
			]
		}
	]
},
	"invitation-rejected": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "b8facbea-3a8b-4e77-aab5-e2a9558c2152",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9.7,9.5l6.8-5.8v6h1.1V1.8H1.8V13H9.7V11.9H2.9V3.7Zm-6-6.6H15.6L9.7,8Zm11.6,7.9a4.5,4.5,0,1,0,4.5,4.5A4.48,4.48,0,0,0,15.3,10.8Zm0,1.1a3.34,3.34,0,0,1,3.3,2.8H12A3.34,3.34,0,0,1,15.3,11.9Zm0,6.8A3.34,3.34,0,0,1,12,15.9h6.6A3.34,3.34,0,0,1,15.3,18.7Z"
			},
			children: [
			]
		}
	]
},
	irobot: irobot,
	"ironing-board": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.69065,4.03693H9.0358a1.8943,1.8943,0,1,0,0,3.78859h4.14383a1.6514,1.6514,0,0,1,1.6498,1.64981v2.25412a8.34523,8.34523,0,0,0-1.24494-.47707,2.55594,2.55594,0,0,0-5.04122.11276A8.81242,8.81242,0,0,0,5.64473,13.0686L2.06892,16.19175a.78193.78193,0,0,0,.51425,1.37132H18.72739A1.0746,1.0746,0,0,0,19.8,16.48954V9.1472A5.11562,5.11562,0,0,0,14.69065,4.03693ZM11.07577,10.2313a1.49293,1.49293,0,0,1,1.29842.76516,8.4795,8.4795,0,0,0-2.6425.06193A1.50343,1.50343,0,0,1,11.07577,10.2313Zm-1.4214,1.91359a7.18862,7.18862,0,0,1,5.26606.83088.65052.65052,0,0,0,.64705.00644.63937.63937,0,0,0,.32077-.55331V9.47533A2.71167,2.71167,0,0,0,13.17963,6.7667H9.0358a.83548.83548,0,0,1,0-1.671h5.65485A4.05565,4.05565,0,0,1,18.74118,9.1472l-.00982,5.233H5.75307l.58835-.51379A7.46018,7.46018,0,0,1,9.65437,12.14489ZM3.32075,16.50425,4.54059,15.439H18.72941l-.002,1.06525Z"
			},
			children: [
			]
		}
	]
},
	"join-call": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M5.17744,1.8v8.96143l-.00488.55468.00488.00013V19.8h11.25V1.8Zm10.125,16.875h-9V16.9875h3.375v1.125h2.25v-1.125h3.375Zm0-2.8125h-9V9.91737H9.63838L8.20967,11.29518l.67871.7207L11.64473,9.4203,8.93916,6.77162l-.69238.7074L9.63057,8.80153H6.30244V2.925h9V6.11134a3.32753,3.32753,0,0,0,0,6.56476v3.1864Zm0-4.27142a2.26489,2.26489,0,0,1,0-4.39514v4.39514Z"
			},
			children: [
			]
		}
	]
},
	"k12-education": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.8,11.2V8.3l0,0h1.6L11,1.9L4.3,8.3h1.6v2.9h-4v8.6h18v-8.6C19.9,11.2,15.8,11.2,15.8,11.2z M7,7.1l4-3.7l3.7,3.7v4H7\n\tV7.1z M12.2,18.6H9.4v-4h2.8V18.6z M18.7,18.6h-5.3v-5.1H8.3v5.1H2.9v-6.3h15.8V18.6z M10.8,5.8c-1.3,0-2.4,1.1-2.4,2.4\n\ts1.1,2.4,2.4,2.4s2.4-1.1,2.4-2.4l0,0C13.2,6.9,12.1,5.8,10.8,5.8z M10.8,9.5c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3\n\ts1.3,0.6,1.3,1.3S11.5,9.5,10.8,9.5L10.8,9.5L10.8,9.5z"
			},
			children: [
			]
		}
	]
},
	"kids-stroller": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.1,1.8h-2.3v6.4H5.2L2.6,5.7L1.8,6.6l2.5,2.4v4.5h9.8c3.2,0,5.8-2.7,5.7-5.9C19.8,4.4,17.2,1.8,14.1,1.8z M14.1,12.2H5.5\n\tV9.4H13V3h1.1c2.5,0,4.6,2.1,4.6,4.7C18.6,10.2,16.6,12.2,14.1,12.2L14.1,12.2z M14.8,15.5c-0.9,0-1.8,0.6-2,1.5H8.4\n\tc-0.3-1.1-1.5-1.8-2.6-1.4C4.7,16,4,17.1,4.3,18.3S5.9,20,7,19.7c0.7-0.2,1.2-0.7,1.4-1.4h4.4c0.3,1.1,1.5,1.7,2.6,1.4\n\ts1.7-1.5,1.4-2.6C16.6,16.1,15.8,15.5,14.8,15.5L14.8,15.5z M6.4,18.6c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9\n\tc0.5,0,0.9,0.4,0.9,0.9c0,0,0,0,0,0C7.3,18.2,6.9,18.6,6.4,18.6z M14.8,18.6c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9\n\ts0.9,0.4,0.9,0.9c0,0,0,0,0,0C15.8,18.2,15.4,18.6,14.8,18.6z"
			},
			children: [
			]
		}
	]
},
	landscape: landscape,
	"laptop-antivirus": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13.5,15.30564l.30371,1.00122H7.79628L8.235,15.30564Zm6.3,2.99249H1.8l2.00256-6.12V3.30185H17.7975v8.87628Zm-14.87244-6.12H16.6725V4.42685H4.92756Zm-1.56378,4.995H18.23622l-1.24872-3.87H4.6125ZM8.28633,5.55405h5.02734V6.84751a4.236,4.236,0,0,1-.48047,2.05273,6.88377,6.88377,0,0,1-1.71582,2.0376L10.8,11.17466l-.31738-.23682A6.88377,6.88377,0,0,1,8.7668,8.90024a4.236,4.236,0,0,1-.48047-2.05273ZM9.40742,6.84751a3.11371,3.11371,0,0,0,.34375,1.51367A5.84058,5.84058,0,0,0,10.8,9.72367a5.84058,5.84058,0,0,0,1.04883-1.36249,3.11371,3.11371,0,0,0,.34375-1.51367V6.67514H9.40742Z"
			},
			children: [
			]
		}
	]
},
	"laptop-controls": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.8,12.2V3.3h-14v8.9l-2,6.1h18L17.8,12.2z M4.9,4.4h11.8v7.8H4.9V4.4z M4.6,13.3H17l1.3,3.9H3.4L4.6,13.3z M13.5,15.3\n\tl0.3,1h-6l0.4-1C8.2,15.3,13.5,15.3,13.5,15.3z M9.6,9.6h2.3v0.8H9.6V9.6z M12.9,7.7h2.3v0.8h-2.3V7.7z M6.3,7h2.3v0.8H6.3V7z\n\t M7,8.2h0.9v2.6H7V8.2z M11.2,9.3h-0.9V5.8h0.9V9.3z M13.6,8.9h0.9v1.9h-0.9V8.9z M14.5,7.2h-0.9V5.8h0.9V7.2z M7.9,6.5H7V5.8h0.9\n\tV6.5z"
			},
			children: [
			]
		}
	]
},
	"laptop-gps-tracking": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.80037,12.17518V3.29976h-14v8.87542L1.8,18.30024h18ZM4.92476,4.42482H16.67524v7.75036H4.92476Zm-.314,8.87549H16.98927l1.25031,3.87487H3.361ZM13.496,15.30079l.304.999h-6l.436-.999ZM9.739,5.89784a1.919,1.919,0,0,0-.55,2.65753l.00183-.001,1.64575,2.446,1.54688-2.4256v.00031A1.919,1.919,0,0,0,9.739,5.89784Zm2.073,2.2099-.00036-.00031-.99158,1.55481L9.76875,8.09956a1.18552,1.18552,0,1,1,2.04327.00818Zm-.57342-.554a.44687.44687,0,1,1-.44684-.44684A.44682.44682,0,0,1,11.2386,7.55372Z"
			},
			children: [
			]
		}
	]
},
	"laptop-settings": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13.496,15.30079l.304.999h-6l.436-.999ZM19.8,18.30024H1.8l2.00037-6.12506V3.29975h14v8.87543ZM4.92476,12.17518H16.67524V4.42481H4.92476Zm-1.56372,5H18.23958L16.98927,13.3003H4.61073ZM13.2967,7.60944a.83354.83354,0,0,0-.002,1.40149,2.5805,2.5805,0,0,1-.23877.56714.83351.83351,0,0,0-.99213.99024,2.59482,2.59482,0,0,1-.56988.23169.83367.83367,0,0,0-1.40149-.002,2.57867,2.57867,0,0,1-.56726-.23871A.83349.83349,0,0,0,8.535,9.56709a2.59563,2.59563,0,0,1-.23169-.57.83348.83348,0,0,0,.002-1.40137,2.58166,2.58166,0,0,1,.23877-.56726.83346.83346,0,0,0,.99207-.99017,2.59654,2.59654,0,0,1,.56994-.23169.83356.83356,0,0,0,1.40143.002,2.584,2.584,0,0,1,.56726.23865.83352.83352,0,0,0,.99023.99225A2.59782,2.59782,0,0,1,13.2967,7.60944Zm-2.2611-.33429a1.0548,1.0548,0,1,0,.7926,1.2638A1.05486,1.05486,0,0,0,11.0356,7.27515Z"
			},
			children: [
			]
		}
	]
},
	"laptop-trends": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.8,12.18V3.3H3.8v8.88l-2,6.12h18ZM4.92,4.42H16.68v7.76H4.92ZM4.61,13.3H17l1.25,3.88H3.36Zm8.89,2,.3,1h-6l.44-1ZM7.82,8.38H9v2.43H7.82Zm2.41-1h1.14v3.42H10.23Zm2.41-1.58h1.14v5H12.64Z"
			},
			children: [
			]
		}
	]
},
	"laptop-wireless": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12.82,8.45h0L12.31,9a2.14,2.14,0,0,0-3,0h0l-.52-.52A2.86,2.86,0,0,1,12.82,8.45Zm-3.07,1,.52.52a.75.75,0,0,1,1.06,0l.52-.52A1.52,1.52,0,0,0,9.75,9.43Zm-1.95-2L8.31,8h0a3.52,3.52,0,0,1,5,0l.51-.52h0A4.24,4.24,0,0,0,7.8,7.47Zm12,10.83H1.8l2-6.12V3.3h14v8.88ZM4.92,12.18H16.68V4.42H4.92Zm-1.56,5H18.24L17,13.3H4.61ZM8.24,15.3l-.44,1h6l-.3-1Z"
			},
			children: [
			]
		}
	]
},
	"large-plan": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Large_Plan",
		"data-name": "Large Plan",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.175,14.71931H8.71534V6.88069H10.656V13.075h3.519ZM19.8,1.8v18H1.8V1.8ZM18.675,2.925H2.925v15.75h15.75Z"
			},
			children: [
			]
		}
	]
},
	law: law,
	"left-arrow": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Left_Arrow",
		"data-name": "Left Arrow",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,11.37251H4.01466l7.68305,7.61761-.817.80988L1.8,10.8l9.08069-9,.817.80988-7.683,7.61761H19.8Z"
			},
			children: [
			]
		}
	]
},
	"left-caret": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "polygon",
			type: "element",
			value: "",
			attributes: {
				points: "14.89 19.8 5.89 10.799 14.89 1.8 15.71 2.619 7.53 10.799 15.71 18.981 14.89 19.8"
			},
			children: [
			]
		}
	]
},
	levers: levers,
	light: light,
	link: link,
	list: list,
	lmr: lmr,
	loader: loader,
	"location-only-device": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 38 38"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m9,3v32h20V3H9Zm18,30H11v-3h6v2h4v-2h6v3Zm-16-5V5h16v23H11Zm9-12.93488c0,.55237-.44769,1-.99994,1-.55231,0-1.00006-.44763-1.00006-1,0-.55225.44775-1,1.00006-1,.55225,0,.99994.44775.99994,1Zm-1-5.06512c-2.88239,0-5.21881,2.33661-5.21881,5.21881,0,.73383.15161,1.43219.42493,2.06573.79376,1.70862,4.79456,6.71545,4.79456,6.71545,0,0,3.70227-4.49084,4.7121-6.60242.3443-.71954.5061-1.68384.5061-2.17877,0-2.8822-2.33649-5.21881-5.21887-5.21881Zm2.90845,6.53473c-.47528.9939-1.76703,2.76929-2.8924,4.23035-1.30548-1.71539-2.62854-3.55408-2.98474-4.29907-.16602-.39429-.25012-.81378-.25012-1.24719,0-1.77484,1.44397-3.21881,3.21881-3.21881s3.21887,1.44397,3.21887,3.21881c0,.2265-.1095.89606-.31042,1.31592Z"
			},
			children: [
			]
		}
	]
},
	"location-pin": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,1.8A6.67922,6.67922,0,0,0,4.14259,8.5a8.62191,8.62191,0,0,0,.49683,2.7C5.63307,13.4,10.8,19.8,10.8,19.8s4.6701-5.8,5.96185-8.5a8.82351,8.82351,0,0,0,.69556-2.8A6.67922,6.67922,0,0,0,10.8,1.8Zm0,10.92877a4.372,4.372,0,0,1,0-8.744,4.41824,4.41824,0,0,1,4.372,4.372A4.33593,4.33593,0,0,1,10.8,12.72877Zm-2.96582-3.192A1.46118,1.46118,0,0,1,7.969,9.20674a1.4405,1.4405,0,0,1,.20019-.27246,2.98913,2.98913,0,0,1,.24512-.23242c.083-.07325.17138-.14454.26465-.21485.09375-.07031.186-.13965.27783-.208.09131-.06738.17969-.13574.26514-.20214a3.04831,3.04831,0,0,0,.23242-.2002.74749.74749,0,0,0,.14746-.1875.4504.4504,0,0,0,.05224-.2168.48453.48453,0,0,0-.11474-.33789A.44207.44207,0,0,0,9.194,7.00654a.49225.49225,0,0,0-.38476.15039.59555.59555,0,0,0-.125.22266,1.06662,1.06662,0,0,0-.04.31738H7.82393a2.00386,2.00386,0,0,1,.05517-.50976,1.23341,1.23341,0,0,1,.17481-.37989,1.083,1.083,0,0,1,.44287-.36816,1.907,1.907,0,0,1,1.2876-.04687,1.204,1.204,0,0,1,.40966.24218.97637.97637,0,0,1,.24756.36035,1.19242,1.19242,0,0,1,.08252.44727,1.04372,1.04372,0,0,1-.17724.60742,1.34878,1.34878,0,0,1-.19043.22461,2.39262,2.39262,0,0,1-.22754.19238c-.07959.06739-.16309.13086-.25.19336q-.12965.09229-.25733.1875c-.085.0625-.1665.126-.24512.18946a1.8931,1.8931,0,0,0-.2124.20019v.00488h1.56006V9.947H7.779A1.68373,1.68373,0,0,1,7.83418,9.53682ZM10.77412,9.152V8.36689L12.42939,6.3415h.85987V8.49678h.51513V9.152h-.51513V9.947h-.8501V9.152Zm1.665-1.89551h-.00977L11.43428,8.487v.00977h1.00488Z"
			},
			children: [
			]
		}
	]
},
	location: location,
	"lock-closed": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9.6750002,13.7256899c0-0.6213207,0.5036802-1.125,1.125-1.125c0.6213207,0,1.125,0.5036802,1.125,1.125\n\tc-0.0042677,0.3950777-0.2183313,0.7580729-0.5620003,0.9530001v2.421999h-1.125V14.678689\n\tC9.8937769,14.48419,9.6792402,14.1210394,9.6750002,13.7256899z M17.5499992,9.7886896v10.124999H4.0500002V9.7886801h2.25v-3.375\n\tc0-2.4852815,2.014719-4.5,4.5-4.5s4.5,2.0147185,4.5,4.5v3.375L17.5499992,9.7886896z M7.4249992,9.7886896h6.75v-3.375\n\tc0-1.8639612-1.5110388-3.375-3.375-3.375s-3.375,1.5110388-3.375,3.375V9.7886896z M16.4249992,10.9136896H5.1750002v7.874999\n\th11.249999V10.9136896z"
			},
			children: [
			]
		}
	]
},
	"lock-open": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M7.4250002,9.7886801v-3.375c0-1.8639612,1.5110388-3.375,3.375-3.375s3.375,1.5110388,3.375,3.375h1.125\n\tc0-2.4852815-2.014719-4.5-4.5-4.5s-4.5,2.0147185-4.5,4.5v3.375h-2.25v10.125001h13.499999V9.7886801H7.4250002z\n\t M16.4249992,18.788681H5.1750002v-7.875h11.249999V18.788681z M9.6749992,13.7256813c0-0.6213207,0.5036793-1.125,1.125-1.125\n\ts1.125,0.5036793,1.125,1.125c-0.0042677,0.3950777-0.2183313,0.7580729-0.5620003,0.9530001v2.4219999h-1.124999v-2.4219999\n\tC9.8937788,14.4841833,9.6792431,14.1210375,9.6749992,13.7256813z"
			},
			children: [
			]
		}
	]
},
	locker: locker,
	logout: logout,
	"loyalty-retention": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.7824192,11.0353498c0.0023766,4.8284979-3.9099684,8.7446947-8.7384663,8.7470713\n\tc-2.6025028,0.0012817-5.0702863-1.1569347-6.732234-3.1596718v2.5493202h-1.125v-4.5341797h4.5136709v1.125H5.0584798\n\tc2.6102147,3.3016624,7.4027381,3.8621922,10.704401,1.2519779c1.8285475-1.4456053,2.8949442-3.6485615,2.8945379-5.9795179\n\tH19.7824192z M10.5646496,2.94258c2.3587503,0.0009971,4.5832396,1.097533,6.0205708,2.9677699h-2.6856108v1.125h4.5136709V2.5002\n\th-1.125v2.4771698C14.2049294,1.2615972,8.6931496,0.7489187,4.9773769,3.8322701\n\tc-2.00283,1.6619501-3.1610999,4.1298027-3.1597967,6.7323794h1.125C2.9471219,6.3569794,6.3569794,2.9471216,10.5646496,2.94258z\n\t M12.6502199,7.8400002C13.986165,7.8398995,15.0737934,8.914156,15.0902195,10.25\n\tc-0.0231495,0.6915045-0.3307009,1.3427887-0.8500004,1.8000002l-3.2399998,3.1099997l-3.3499999-3.1900005\n\tc-0.4837255-0.4393911-0.7535915-1.0666475-0.7400002-1.7200003c0.0164256-1.335845,1.1040554-2.4101009,2.4400005-2.4099998\n\tc0.6157722,0.0024467,1.2068424,0.2424564,1.6499996,0.6700001C11.4433699,8.0824451,12.0344448,7.8424339,12.6502199,7.8400002z\n\t M12.6502199,8.8400002c-0.4117231,0.0033569-0.8004408,0.190382-1.0600004,0.5100002l-0.5900002,0.6599998l-0.5799999-0.6499996\n\tc-0.4672756-0.6021051-1.3341799-0.7114058-1.936285-0.2441301c-0.3434801,0.2665653-0.5412521,0.6794128-0.5337152,1.11413\n\tc-0.0240345,0.3806639,0.1313629,0.750658,0.4200001,1l2.6300001,2.4899998l2.5199499-2.4200001\n\tc0.3092394-0.2698479,0.4996662-0.6507006,0.5299997-1.0600004C14.050169,9.4668207,13.423399,8.8400278,12.6502199,8.8400002z"
			},
			children: [
			]
		}
	]
},
	manufacturing: manufacturing,
	"map-view": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "f9981fa4-c952-4bc3-86b8-9659ae249464",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,4.3l6-2.5,6,2.5,6-2.5V17.3l-6,2.5-6-2.5-6,2.5Zm5,12.2V3.4L2.9,5V18.1Zm7.1,2,4.8-2V3.5l-4.8,2Zm-1.1-.3V5.1l-4.9-2v13Z"
			},
			children: [
			]
		}
	]
},
	"masonry-view": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,11.6H9.6V1.8H1.8ZM2.9,2.9H8.5v7.6H2.9ZM12,1.8V7.6h7.8V1.8Zm1.1,4.7V2.9h5.5l.1,3.6ZM1.8,19.8H9.6V14H1.8Zm1.1-4.7H8.5v3.5H2.9ZM12,19.8h7.8V10H12Zm1.1-8.7h5.5v7.6H13.1Z"
			},
			children: [
			]
		}
	]
},
	maximize: maximize,
	"media-entertainment": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.06,2.64,1.8,5l.57,4.11,17.26-2.4ZM3.32,7.89,3.06,6l3.18-.44L4.63,7.68l0,0ZM6.16,7.5,7.8,5.33l3-.42L9.19,7l0,0Zm4.57-.64L12.36,4.7l3-.42L13.76,6.41l0,0Zm4.56-.63,1.64-2.17,1.18-.16.27,1.9ZM2.37,9.15V19H19.8V9.15Zm11.69,1.12,0,0,1.88,1.89h-3L11,10.27Zm-4.61,0,0,0,1.88,1.89h-3L6.35,10.27Zm-6,0H4.84l1.85,1.92H3.49Zm15.19,7.58H3.49V13.3H18.68Zm0-5.66H17.49l-1.92-1.92h3.11Z"
			},
			children: [
			]
		}
	]
},
	"medium-business": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.6,18.7v-5.7l0,0v-1.1l0,0v-10H4.9v10l0,0v1.1l0,0v5.7H3.7v1.2h14.1v-1.1H16.6z M10.2,18.7H8.5v-3.2h1.7V18.7z M13,18.7\n\th-1.7v-3.2H13L13,18.7z M15.4,18.7h-1.3v-4.4H7.4v4.4H6.1v-5.7h9.4V18.7z M15.4,11.8H6.1V2.9h9.4V11.8z M8.6,5.5H7.5V4.3h1.1V5.5z\n\t M11.3,5.5h-1.1V4.3h1.1L11.3,5.5z M14,5.5h-1.1V4.3H14L14,5.5z M8.6,8H7.5V6.8h1.1V8z M11.3,8h-1.1V6.8h1.1L11.3,8z M14,8h-1.1V6.8\n\tH14L14,8z M8.6,10.5H7.5V9.3h1.1V10.5z M11.3,10.5h-1.1V9.3h1.1L11.3,10.5z M14,10.5h-1.1V9.3H14L14,10.5z"
			},
			children: [
			]
		}
	]
},
	"medium-plan": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Medium_Plan",
		"data-name": "Medium Plan",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M8.50891,14.7193H6.7655V6.88068H9.37482l.95337,3.43145c.14282.49366.45,1.78711.45,1.78711h.02142s.30707-1.29345.43921-1.78711l.964-3.43145h2.63165V14.7193H13.058V10.77277c0-.31781.033-1.56757.033-1.56757h-.02233s-.27405,1.173-.36152,1.45776L11.57794,14.7193H9.97736L8.85883,10.67365c-.08747-.28473-.36152-1.46845-.36152-1.46845H8.47589s.033,1.26044.033,1.57825ZM19.8,1.8v18H1.8V1.8ZM18.675,2.925H2.925v15.75h15.75Z"
			},
			children: [
			]
		}
	]
},
	menu: menu,
	"merge-calls": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,10.802,16.152,14.45l-.795-.795,2.29-2.291H12.226l-4.5,7.311H1.8V17.55H7.124l4.125-6.748L7.124,4.05H1.8V2.925H7.726l4.5,7.314h5.421L15.357,7.95l.795-.796Z"
			},
			children: [
			]
		}
	]
},
	"microphone-alternate": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.79957,15.903a3.79683,3.79683,0,0,0,3.79682-3.79688V5.59684a3.79685,3.79685,0,1,0-7.59369,0v6.50927A3.79684,3.79684,0,0,0,10.79957,15.903ZM8.1277,5.59684a2.67185,2.67185,0,1,1,5.34369,0v6.50927a2.67185,2.67185,0,1,1-5.34369,0Zm8.64691,6.61194a5.98213,5.98213,0,0,1-5.4126,5.9461V19.8H10.237V18.15488a5.9817,5.9817,0,0,1-5.4126-5.9461h1.125a4.8501,4.8501,0,0,0,9.7002,0Z"
			},
			children: [
			]
		}
	]
},
	microphone: microphone,
	minus: minus,
	"missed-call": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "e855d4c2-fe7c-417d-9bfa-76e6cc6c876f",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9.69,16.25,2.93,9.49v6H1.8V7.57H9.69V8.7h-6l6,6L19,5.35l.8.79Z"
			},
			children: [
			]
		}
	]
},
	"mobile-apps": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M5.175,1.8v18h11.25V1.8ZM15.3,18.675h-9V16.987H9.675v1.125h2.25V16.987H15.3Zm0-2.813h-9V2.925h9ZM8.147,10.775H9.534a.7153.7153,0,0,0,.713-.713V8.675a.71662.71662,0,0,0-.713-.713H8.147a.71531.71531,0,0,0-.713.713v1.387A.714.714,0,0,0,8.147,10.775Zm.187-1.913H9.345V9.874H8.334Zm3.732,1.913h1.387a.71526.71526,0,0,0,.71295-.713V8.675a.71526.71526,0,0,0-.71295-.713H12.066a.71531.71531,0,0,0-.713.713v1.387A.714.714,0,0,0,12.066,10.775Zm.187-1.913h1.012V9.874H12.253ZM8.147,6.812H9.534a.71535.71535,0,0,0,.713-.713V4.712a.71667.71667,0,0,0-.713-.713H8.147a.71536.71536,0,0,0-.713.713V6.099A.71406.71406,0,0,0,8.147,6.812Zm.187-1.913H9.345V5.912H8.334Zm3.732,1.913h1.387a.7153.7153,0,0,0,.71295-.713V4.712a.71531.71531,0,0,0-.71295-.713H12.066a.71535.71535,0,0,0-.713.713V6.099A.714.714,0,0,0,12.066,6.812Zm.187-1.913h1.012V5.912H12.253ZM8.147,14.738H9.534a.71531.71531,0,0,0,.713-.713V12.638a.716.716,0,0,0-.713-.713H8.147a.71531.71531,0,0,0-.713.713v1.387A.714.714,0,0,0,8.147,14.738Zm.187-1.913H9.345v1.012H8.334Z"
			},
			children: [
			]
		}
	]
},
	"mobile-command-center": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.18,6.27H9.3a2.71,2.71,0,0,0,.78-1l.23-.51-2-.94.75-1.58-1-.48L7.33,3.38l-2-.94L5.11,3a2.73,2.73,0,0,0,.77,3.32H1.8V17.55H2.92a2.25,2.25,0,0,0,4.5,0h6.76a2.25,2.25,0,1,0,4.5,0H19.8V13Zm-5.44-1A1.63,1.63,0,0,1,6,4ZM5.17,18.67A1.13,1.13,0,1,1,6.3,17.55,1.12,1.12,0,0,1,5.17,18.67Zm11.26,0a1.13,1.13,0,1,1,1.12-1.12A1.12,1.12,0,0,1,16.43,18.67Zm2.25-2.25h-.32a2.22,2.22,0,0,0-3-.83,2.07,2.07,0,0,0-.83.83H7.11a2.22,2.22,0,0,0-3-.83,2.07,2.07,0,0,0-.83.83H2.92v-9H13.65l5,6Z"
			},
			children: [
			]
		}
	]
},
	"mobile-hotspot": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,19.8h9V6.3h-9ZM2.93,7.43H9.68v8.43H2.93Zm0,9.56H5.18v1.12H7.43V17H9.68v1.69H2.93ZM15.36,9.61H14.24A2.25,2.25,0,0,0,12,7.36V6.24A3.37,3.37,0,0,1,15.36,9.61Zm2.25,0H16.49A4.51,4.51,0,0,0,12,5.11V4A5.62,5.62,0,0,1,17.61,9.61Zm2.19,0H18.68A6.68,6.68,0,0,0,12,2.93V1.8A7.81,7.81,0,0,1,19.8,9.6Z"
			},
			children: [
			]
		}
	]
},
	"mobile-kiosk-info": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.17,17.87V1.8H4.43V17.87H7v.81H4.43V19.8H17.17V18.68H14.6v-.81ZM5.55,2.92h10.5v10.5H5.55Zm7.93,15.76H8.12v-.81h5.36ZM5.55,16.75V14.53h6.92v1.11h2.46V14.53h1.12v2.22ZM10.38,6.33h.83v.74h-.83Zm0,1.49h.83v2.71h-.83Z"
			},
			children: [
			]
		}
	]
},
	"mobile-kiosk-wireless": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12.78883,8.80415l-.50879.509a2.09361,2.09361,0,0,0-2.96,0l-.50879-.509h.00006A2.81261,2.81261,0,0,1,12.78883,8.80415Zm-3.01721.95972h.00006l.5083.50976a.75323.75323,0,0,1,1.04,0l.5083-.50976A1.45469,1.45469,0,0,0,9.77162,9.76387ZM7.851,7.84419l-.00025.0003.50928.509a3.45037,3.45037,0,0,1,4.87988,0l.50928-.509A4.17063,4.17063,0,0,0,7.851,7.84419Zm6.74585,10.02295v.81714h2.5708V19.8H4.43232V18.68428H7.00264v-.81714H4.43232V1.8H17.16768V17.86714ZM5.54854,13.4156H16.05146V2.91615L5.54854,2.91609Zm7.93261,4.45154H8.11885v.81714h5.3623Zm2.57031-1.116V14.53145H14.93135v1.10363h-2.4585V14.53145H5.54854v2.21972Z"
			},
			children: [
			]
		}
	]
},
	"mobile-plus-tv": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,12.10127V2.09313H3.79978V7.68467H1.8v11.8222H8.91272V14.91916a7.59543,7.59543,0,0,1,.868-.3278,6.85787,6.85787,0,0,1,4.02812,0A9.36,9.36,0,0,1,15.171,15.098l.47328-1.0125a9.3752,9.3752,0,0,0-3.28287-.8849V12.10127ZM7.79547,18.38963H2.91724V17.3073H4.71v.7264H5.964v-.7264H7.79547Zm0-7.80372v5.60415H2.91724V8.80191H7.79547v1.784Zm3.44871,2.61041a7.99027,7.99027,0,0,0-2.33146.50292v-1.598h2.33146ZM8.91272,10.98451V7.68467H4.917V3.21037H18.68276v7.77414Z"
			},
			children: [
			]
		}
	]
},
	"mobile-retail": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.18,4.05H1.8V15.3H2.93a2.25,2.25,0,0,0,4.5,0h6.75a2.25,2.25,0,0,0,4.5,0H19.8V10.8ZM2.93,5.18H13.65a3.81,3.81,0,0,1-.09.78,1.09,1.09,0,0,1-.81.84,1.58,1.58,0,0,1-1.52-.36L10.81,6l-.41.46a1.44,1.44,0,0,1-1,.41,1.36,1.36,0,0,1-1-.41L7.91,6l-.42.46a1.4,1.4,0,0,1-1,.41,1.4,1.4,0,0,1-1-.41L5,6l-.42.46a1.42,1.42,0,0,1-1,.41,1.49,1.49,0,0,1-.63-.14Zm0,2.71A2.59,2.59,0,0,0,3.56,8,2.61,2.61,0,0,0,5,7.54a2.66,2.66,0,0,0,2.9,0,2.67,2.67,0,0,0,2.9,0,2.62,2.62,0,0,0,.88.37,2.69,2.69,0,0,0,.57.06h0a2.73,2.73,0,0,0,1.37-.34l0,0v3.09H2.93Zm2.25,8.54A1.13,1.13,0,1,1,6.3,15.3,1.13,1.13,0,0,1,5.18,16.43Zm11.25,0a1.13,1.13,0,1,1,1.12-1.13A1.13,1.13,0,0,1,16.43,16.43Zm2.25-2.25h-.32a2.22,2.22,0,0,0-3-.84,2.16,2.16,0,0,0-.83.84H7.11a2.22,2.22,0,0,0-3-.84,2.16,2.16,0,0,0-.83.84H2.93V11.81H14.82V6.58l3.86,4.63Z"
			},
			children: [
			]
		}
	]
},
	"mobile-retargeting": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 38 38"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m21,28H5V5h16v7.72723c.57227-.65039,1.24658-1.20654,2-1.64417V3H3v32h20v-10.08307c-.75342-.43762-1.42773-.99377-2-1.64417v4.72723Zm0,5H5v-3h6v2h4v-2h6v3Zm11.91016-16c-.42212-2.51074-2.39941-4.48785-4.91016-4.91003v-2.08997h-2v2.08997c-2.51074.42218-4.48779,2.39929-4.90991,4.91003h-2.09009v2h2.09009c.42212,2.51074,2.39917,4.48785,4.90991,4.91003v2.08997h2v-2.08997c2.51074-.42218,4.48804-2.39929,4.91016-4.91003h2.08984v-2h-2.08984Zm-6.91016,4.85797c-1.39868-.36365-2.49414-1.45923-2.85791-2.85797h2.85791v2.85797Zm0-4.85797h-2.85791c.36377-1.39874,1.45923-2.49432,2.85791-2.85797v2.85797Zm2,4.85797v-2.85797h2.85815c-.36377,1.39874-1.45923,2.49432-2.85815,2.85797Zm0-4.85797v-2.85797c1.39893.36365,2.49438,1.45923,2.85815,2.85797h-2.85815Z"
			},
			children: [
			]
		}
	]
},
	"mobile-search": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.54585,9.51753a4.48313,4.48313,0,0,0-4.2417-4.46472V1.8h-11.25v18h11.25V13.98408a4.50292,4.50292,0,0,0,1.32275-.26587l1.84278,3.59143,1-.51635-1.84619-3.59778A4.48468,4.48468,0,0,0,18.54585,9.51753ZM4.17915,4.6125m9,.125v.37891a4.48713,4.48713,0,0,0,0,8.80224V15.8625h-9V2.925h9V4.7375Zm0,13.9375h-9V16.9875h3.375v1.125h2.25v-1.125h3.375Zm.877-5.78369a3.37369,3.37369,0,1,1,.00062,0Z"
			},
			children: [
			]
		}
	]
},
	"mobile-workforce-management": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M8.15629,11.22327A3.31562,3.31562,0,1,0,4.84038,7.90759,3.31561,3.31561,0,0,0,8.15629,11.22327Zm0-5.51148A2.1958,2.1958,0,1,1,5.96,7.90759,2.1958,2.1958,0,0,1,8.15629,5.71179Zm6.87842,2.80859a2.58594,2.58594,0,1,0-2.58594-2.58593A2.586,2.586,0,0,0,15.03471,8.52038Zm0-4.05212A1.46625,1.46625,0,1,1,13.5684,5.93445,1.46617,1.46617,0,0,1,15.03471,4.46826Zm4.79785,9.44324H18.71293a3.67033,3.67033,0,0,0-7.20459-.99768,6.31858,6.31858,0,0,1,2.9712,5.35193H13.35991a5.20386,5.20386,0,0,0-10.40772,0H1.83256a6.31257,6.31257,0,0,1,8.65918-5.8711,4.79279,4.79279,0,0,1,9.34082,1.51685Zm-9.974.473.792.792-3.108,3.108-1.699-1.701.791-.792.908.909Z"
			},
			children: [
			]
		}
	]
},
	"more-horizontal": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "b273a468-b6b2-4146-b27d-6a6d76d70155",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12.73,10.8A1.93,1.93,0,1,1,10.8,8.87,1.92,1.92,0,0,1,12.73,10.8Zm5.14-1.93A1.93,1.93,0,1,0,19.8,10.8,1.93,1.93,0,0,0,17.87,8.87Zm-14.14,0A1.93,1.93,0,1,0,5.66,10.8,1.92,1.92,0,0,0,3.73,8.87Z"
			},
			children: [
			]
		}
	]
},
	"motion-detector": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.21016,12.14292h-1.0175a1.592,1.592,0,0,1-1.58984-1.58984v-2.035a1.592,1.592,0,0,1,1.58984-1.58984h1.0175A1.592,1.592,0,0,1,19.8,8.51808v2.035A1.592,1.592,0,0,1,18.21016,12.14292Zm-1.0175-4.07a.44571.44571,0,0,0-.44516.44516v2.035a.4457.4457,0,0,0,.44516.44515h1.0175a.44569.44569,0,0,0,.44515-.44515v-2.035a.4457.4457,0,0,0-.44515-.44516ZM4.94689,7.0743A1.94408,1.94408,0,1,1,6.89147,5.13072,1.94519,1.94519,0,0,1,4.94689,7.0743Zm0-2.74347a.7994.7994,0,1,0,.79989.79989A.80043.80043,0,0,0,4.94689,4.33083ZM6.40359,18.6424H3.44052l-.30207-4.21209A1.58182,1.58182,0,0,1,2.0663,13.05112L1.8,9.316l.14507-.17588A3.942,3.942,0,0,1,4.98068,7.67149a3.93782,3.93782,0,0,1,2.9581,1.37819l.158.18085-.306,3.8345a1.58829,1.58829,0,0,1-1.03936,1.35931ZM4.50571,17.49771h.84461l.33983-4.12366h.52663A.43734.43734,0,0,0,6.65,12.97361L6.91731,9.632a2.78162,2.78162,0,0,0-3.94182.07055L3.209,12.96964a.43647.43647,0,0,0,.43323.40441h.5326l.07452.53161ZM15.574,13.45156a5.54625,5.54625,0,0,1,0-7.832l-.80883-.80884a6.6893,6.6893,0,0,0,0,9.44963Zm-1.85714,1.85316a8.16974,8.16974,0,0,1,0-11.53828L12.908,2.9576a9.3137,9.3137,0,0,0,0,13.156Z"
			},
			children: [
			]
		}
	]
},
	"move-to": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "fcc187bf-9bcd-482b-bfd2-e97fe131f135",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M8.3,5.8l-.8-.7,3.3-3.3,3.3,3.3-.8.7L11.4,3.9V9.1H10.2V3.9Zm3.1,11.9V12.5H10.2v5.2L8.3,15.8l-.8.7,3.3,3.3,3.3-3.3-.8-.7ZM16.5,7.5l-.7.8,1.9,1.9H12.5v1.2h5.2l-1.9,1.9.7.8,3.3-3.3ZM9.1,11.4V10.2H3.9L5.8,8.3l-.7-.8L1.8,10.8l3.3,3.3.7-.8L3.9,11.4Z"
			},
			children: [
			]
		}
	]
},
	multicast: multicast,
	"multiple-device-protection": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.267,8.1474l.89844.67774-3.49024,4.62793-2.25293-1.834.71094-.87305,1.34668,1.09766Zm2.53418-4.16674V19.79854H10.767V15.27021H1.79878V1.80146H18.63325v2.1792ZM4.55806,2.90205H2.89937V14.17061H4.55806V9.71748L3.45894,9.70869l.019-2.30078,1.08008.00861Zm6.209,1.07861h6.7666V2.90205H5.65864V14.17061H10.767Zm7.90918,13.00928h-2.2774L16.393,18.1042l-2.24121-.01172.00573-1.10254H11.892v1.6836h6.78418Zm0-11.88428H11.892V6.85713h.00159v1.125H11.892v7.88281h6.78418V7.98213h-.00165v-1.125h.00165Z"
			},
			children: [
			]
		}
	]
},
	"multiple-devices": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.80122,3.98066V19.79854H10.767V15.27021H1.79878V1.80146H18.63325v2.1792ZM4.55806,2.90205H2.89937V14.17061H4.55806V9.71748L3.45894,9.70869l.019-2.30078,1.08008.00861Zm6.209,1.07861h6.7666V2.90205H5.65864V14.17061H10.767Zm7.90918,13.00928h-2.2774L16.393,18.1042l-2.24121-.01172.00573-1.10254H11.892v1.6836h6.78418Zm0-11.88428H11.892V6.85713h.00159v1.125H11.892v7.88281h6.78418V7.98213h-.00165v-1.125h.00165Z"
			},
			children: [
			]
		}
	]
},
	"multiple-documents": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9.2,10.7L7.9,9.4l0.8-0.8l0.5,0.5l1.4-1.4l0.8,0.8L9.2,10.7z M17.2,8.5h-4.7v1.1h4.7V8.5z M11.4,11.9l-0.8-0.8l-1.4,1.4\n\tL8.7,12l-0.8,0.8L9.2,14L11.4,11.9z M17.2,11.9h-4.7V13h4.7V11.9z M11.4,15.3l-0.8-0.8l-1.4,1.4l-0.5-0.5l-0.8,0.8l1.3,1.3\n\tL11.4,15.3z M17.2,15.3h-4.7v1.1h4.7V15.3z M19.8,5.4v14.4H5.4v-3.6H1.8V1.8h14.4v3.6C16.2,5.4,19.8,5.4,19.8,5.4z M5.4,5.4h9.7V2.9\n\tH2.9V15h2.5V5.4z M18.7,6.5H6.5v12.1h12.2V6.5z"
			},
			children: [
			]
		}
	]
},
	music: music,
	mute: mute,
	"my-account": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "a7213c4e-e6bf-4405-8610-8a8b81089e83",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,1.8a9,9,0,1,0,9,9A9,9,0,0,0,10.8,1.8Zm0,1.13a7.86,7.86,0,0,1,6,13,7.66,7.66,0,0,0-11.94,0,7.86,7.86,0,0,1,6-13ZM5.63,16.72a6.53,6.53,0,0,1,10.34,0,7.8,7.8,0,0,1-10.34,0Zm5.17-4.79A3.38,3.38,0,1,0,7.43,8.55,3.38,3.38,0,0,0,10.8,11.93Zm0-5.63A2.25,2.25,0,1,1,8.55,8.55,2.25,2.25,0,0,1,10.8,6.3Z"
			},
			children: [
			]
		}
	]
},
	"my-plans-details": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.425,2.925v15.75H5.175V2.925h11.25M17.55,1.8H4.05v18h13.5V1.8Zm-4.5,3.383a.5625.5625,0,0,1,0,1.125H8.55a.5625.5625,0,1,1,0-1.125h4.5m0-1.125H8.55a1.6875,1.6875,0,0,0,0,3.375h4.5a1.6875,1.6875,0,0,0,0-3.375Zm-1.6875,7.728h-1.125v4.69239h1.125Zm0-2.21875h-1.125v1.03321h1.125Z"
			},
			children: [
			]
		}
	]
},
	"my-plans": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.425,2.925v15.75H5.175V2.925h11.25M17.55,1.8H4.05v18h13.5V1.8Zm-4.5,3.383a.5625.5625,0,0,1,0,1.125H8.55a.5625.5625,0,1,1,0-1.125h4.5m0-1.125H8.55a1.6875,1.6875,0,0,0,0,3.375h4.5a1.6875,1.6875,0,0,0,0-3.375ZM7.47482,11.59724l.72934,1.235c.00924.01848.02352.0448.04312.07923s.03836.06888.05684.10332q.03444.06173.06887.13075h.00672c-.00224-.05516-.00336-.10779-.00336-.15847-.00224-.0434-.00336-.086-.00336-.12711V11.59724h.595v2.4599H8.35563l-.72234-1.21791a.7778.7778,0,0,1-.04648-.07728q-.0294-.05333-.05684-.112-.03444-.06508-.07223-.14111h-.007c0,.05992.00112.11591.00364.16883,0,.04564.00056.091.00168.13579s.00168.07728.00168.098v1.14568H6.8625v-2.4599Zm3.79821,0v.50228H10.01732v.44041h1.0768v.47485h-1.0768v.52636h1.27642v.516H9.40836v-2.4599Zm.84638,0,.2475,1.032c.01372.05992.02688.1246.03976.19459q.01888.105.03611.19767.01722.11044.0378.2167h.00672q.01722-.09617.03808-.19934.0168-.0861.03947-.18927c.01484-.06888.02912-.13411.04284-.19627l.2307-1.05608h.56416L13.633,12.6466c.01372.06412.02772.13019.04144.19767.01371.06775.02631.13159.03779.191q.01722.1033.0378.203h.007q.02058-.10625.04116-.2167.01722-.09282.03947-.19935.02268-.10667.04312-.19963l.24414-1.02528h.6126l-.67447,2.4599h-.59524L13.20993,12.877q-.01722-.07224-.03108-.15315c-.00924-.05376-.0182-.1036-.02744-.14951l-.02744-.15483h-.007c-.00924.0504-.01848.10219-.02744.15483q-.01386.06886-.02576.14951-.01218.081-.0294.15315l-.25786,1.18011h-.59888l-.67419-2.4599Z"
			},
			children: [
			]
		}
	]
},
	nationwide: nationwide,
	"native-video": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,10.8l-6.89055,4.0985L6.01884,18.997V13.43126l1.05459.76616v2.9453l5.29688-3.15057L17.7371,10.8,12.37031,7.60785,7.07343,4.45728V7.86409L6.01884,4.61749V2.603L12.90945,6.7015Zm-12.56562.28965,2.4303-1.76571H6.66061l-.92824-2.857-.9283,2.857H1.8l2.4303,1.76571-.92823,2.857,2.4303-1.76571,2.43031,1.76571Z"
			},
			children: [
			]
		}
	]
},
	native: native,
	"network-attached-storage": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,2.95536V18.64464h18V2.95536ZM18.675,17.51964H2.925V4.08036h15.75ZM8.66353,16.22874h6.05926V5.10045H3.73719V16.22874H8.66353ZM13.59779,6.22545v8.87829h-1.423V6.22545Zm-2.548,0v8.87829H9.79646V6.22545Zm-2.38629,0v8.87829H7.24061V6.22545ZM4.86219,15.10374V6.22545H6.11561v8.87829ZM17.72279,8.256H15.7989V6.865h1.92389Z"
			},
			children: [
			]
		}
	]
},
	"network-connection": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.3,1.8V6.3h1.688V9.112H4.612V6.3H6.3V1.8H1.8V6.3H3.488v3.938h6.75V15.3H8.55v4.5h4.5V15.3H11.362V10.238h6.75V6.3H19.8V1.8ZM2.925,5.175V2.925h2.25v2.25Zm9,11.25v2.25H9.675v-2.25h2.25Zm6.75-11.25h-2.25V2.925h2.25Z"
			},
			children: [
			]
		}
	]
},
	network: network,
	"new": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M5.54848,8.72185,6.7809,10.80877c.02881.06347.1045.1914.16846.30762.04053.07031.07568.1455.11621.2207h.01172c-.00586-.09278-.00586-.17969-.00586-.2666-.00586-.14551-.00586-.30274-.00586-.37793V8.72185H8.07143V12.8781H7.03676L5.81557,10.82049a2.3745,2.3745,0,0,1-.17431-.32032c-.04053-.07519-.08106-.15136-.12207-.23828H5.50747c0,.09864,0,.19825.00586.28516,0,.15723.00586.32519.00586.39551V12.8781H4.51333V8.72185Zm6.2417,0v.84864H9.66811v.74414h1.81934v.80176H9.66811V12.006h2.15674v.87207h-3.186V8.72185Zm1.25391,0,.41845,1.74317c.04688.2041.08741.4541.12793.66308.01758.12207.041.24414.064.36621h.01172c.01758-.11035.041-.2207.064-.33691l.13965-.65137.38965-1.78418h.95312l.38965,1.77246.13379.65723c.01758.11621.04053.23242.064.34277h.01172l.06933-.36621c.041-.209.09326-.46484.13965-.67382l.41309-1.73243H17.4684L16.32876,12.8781H15.3229l-.436-1.99414c-.04053-.16308-.06934-.35449-.09863-.51172l-.04639-.26171h-.01172l-.04638.26171c-.0293.15723-.05225.34864-.09327.51172l-.436,1.99414H13.14321L12.00356,8.72185ZM17.55,5.175A1.12629,1.12629,0,0,1,18.675,6.3v9a1.12629,1.12629,0,0,1-1.125,1.125H4.05A1.12629,1.12629,0,0,1,2.925,15.3v-9A1.12629,1.12629,0,0,1,4.05,5.175h13.5m0-1.125H4.05A2.25,2.25,0,0,0,1.8,6.3v9a2.25,2.25,0,0,0,2.25,2.25h13.5A2.25,2.25,0,0,0,19.8,15.3v-9a2.25,2.25,0,0,0-2.25-2.25Z"
			},
			children: [
			]
		}
	]
},
	news: news,
	next: next,
	"nfc-tag": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.14668,10.8a7.29508,7.29508,0,0,1-2.15234,5.19434l-.707-.707a6.345,6.345,0,0,0,0-8.97509l.707-.707A7.29869,7.29869,0,0,1,18.14668,10.8ZM14.88105,6.719l-.707.707a4.77715,4.77715,0,0,1,0,6.748l.707.707a5.77147,5.77147,0,0,0,0-8.1621ZM7.426,7.426l-.707-.707a5.77147,5.77147,0,0,0,0,8.1621l.707-.707A4.77714,4.77714,0,0,1,7.426,7.426ZM6.31221,6.31221l-.707-.707a7.34578,7.34578,0,0,0,0,10.38916l.707-.707a6.34613,6.34613,0,0,1,0-8.97509Zm2.452,3.11059v1.081c0,.236.0188.61517.03339.83654H8.7903c-.09406-.19891-.26325-.54412-.38648-.75042L7.702,9.4228H7.0262v2.7923h.634V11.14143c0-.23608-.02295-.61938-.0376-.84082H7.6299c.094.20685.2705.55566.39477.762l.69354,1.15253h.67993V9.4228Zm1.23115,2.7923h.62688V11.11165h.92736v-.54049H10.6222V9.98575h1.165V9.4228H9.99532Zm3.42151.07292a1.211,1.211,0,0,0,.89894-.319,1.14014,1.14014,0,0,0,.34225-.73257h-.66866a.54611.54611,0,0,1-.57253.50123c-.4331,0-.70669-.38715-.70669-.91479,0-.52394.23133-.91479.70246-.91479a.52681.52681,0,0,1,.55458.45529h.6676a1.10624,1.10624,0,0,0-.44366-.79331,1.30033,1.30033,0,0,0-.77429-.22025,1.37087,1.37087,0,0,0-1.39015,1.47306A1.37527,1.37527,0,0,0,13.41683,12.288ZM10.8,2.925A7.875,7.875,0,1,0,18.675,10.8,7.88392,7.88392,0,0,0,10.8,2.925m0-1.125a9,9,0,1,1-9,9,9,9,0,0,1,9-9Z"
			},
			children: [
			]
		}
	]
},
	night: night,
	"no-fee": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,1.8a9,9,0,1,0,9,9A8.99943,8.99943,0,0,0,10.8,1.8Zm0,16.875a7.83236,7.83236,0,0,1-5.149-1.93l1.882-1.881-.795-.796L4.856,15.95A7.86369,7.86369,0,0,1,15.95,4.856L14.155,6.65l.795.795,1.794-1.794A7.86281,7.86281,0,0,1,10.8,18.675Zm.45764-8.60535V7.02131A1.66278,1.66278,0,0,1,12.94026,8.4886h1.02441c-.18945-1.36621-.999-2.17578-2.707-2.31494v-.6958h-.70849v.6958c-1.61915.063-2.71924.96142-2.71924,2.36523,0,1.60645,1.16357,2.03662,2.71924,2.37842v3.27588a2.02877,2.02877,0,0,1-2.06153-2.06152h-1.063a2.95836,2.95836,0,0,0,3.12452,2.92187v1.0752h.70849v-1.0625c1.65723-.10157,2.90918-.999,2.90918-2.53028C14.16682,10.81575,12.91487,10.411,11.25764,10.06965Zm-.70849-.13916C9.37288,9.66487,8.82893,9.29817,8.82893,8.4886c0-.89844.6958-1.3916,1.72022-1.48Zm.70849,4.27539V11.08137c1.21485.26563,1.87207.55664,1.87207,1.49268A1.77179,1.77179,0,0,1,11.25764,14.20588Z"
			},
			children: [
			]
		}
	]
},
	"no-location": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.3406,17.517a4.73967,4.73967,0,0,0,.63562,1.01587c-.60038.764-1.00774,1.26428-1.00774,1.26428S4.77378,13.363,3.7534,11.16665A6.70913,6.70913,0,1,1,16.6241,8.51127a7.65893,7.65893,0,0,1-.5415,2.52149,4.72567,4.72567,0,0,0-1.12551-.20518l.00074-.00135a6.40694,6.40694,0,0,0,.54039-2.315,5.58258,5.58258,0,1,0-10.711,2.20941,63.13413,63.13413,0,0,0,5.1823,7.27084C10.08167,17.84926,10.21361,17.6797,10.3406,17.517Zm8.0522-1.94863a3.70875,3.70875,0,1,1-3.70874-3.70881A3.70874,3.70874,0,0,1,18.3928,15.5684Zm-1.192.56318-5.03406-.00153a2.57805,2.57805,0,0,0,5.03406.00153ZM17.201,15.0057a2.57794,2.57794,0,0,0-5.03344-.00152ZM9.91565,5.18045A3.37762,3.37762,0,1,1,6.538,8.55807,3.37759,3.37759,0,0,1,9.91565,5.18045Zm0,1.12588a2.25175,2.25175,0,1,0,2.25174,2.25174A2.25428,2.25428,0,0,0,9.91565,6.30633Z"
			},
			children: [
			]
		}
	]
},
	"no-off": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.6313,18.63014A7.92454,7.92454,0,0,1,10.8,18.675a7.83386,7.83386,0,0,1-5.1944-1.9715L16.7317,5.63661a7.79059,7.79059,0,0,1,1.894,6.02344,5.05477,5.05477,0,0,1,.99768.91284,9.01382,9.01382,0,1,0-7.08862,7.05633A5.05275,5.05275,0,0,1,11.6313,18.63014ZM2.925,10.8a7.864,7.864,0,0,1,13.01-5.95752L4.81477,15.90449A7.83493,7.83493,0,0,1,2.925,10.8Zm12.89911,1.10608a3.9375,3.9375,0,1,0,3.938,3.937A3.93786,3.93786,0,0,0,15.82411,11.90608Zm0,6.75a2.81825,2.81825,0,0,1-2.756-2.25h5.511A2.81477,2.81477,0,0,1,15.82411,18.65608Zm-2.755-3.375a2.81228,2.81228,0,0,1,5.511,0Z"
			},
			children: [
			]
		}
	]
},
	"no-smoking": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.89,13.06H17v3.39H15.89Zm2.25,3.39h1.13V13.06H18.14ZM9.62,14.19h4v1.13H8.49L7.36,16.45h7.4V13.06h-4Zm6.09-6.11a.45.45,0,0,1,.18.36V10.8H17V8.44a1.59,1.59,0,0,0-.51-1.16Zm1.71-1.71A2.26,2.26,0,0,1,18.14,8V10.8h1.13V8a3.41,3.41,0,0,0-1.05-2.45ZM19.8,2.6,2.63,19.8,1.84,19l2.54-2.55H1.8V13.06h6L12.84,8H10.35A3.49,3.49,0,0,1,6.87,4.49V2.89H8v1.6a2.36,2.36,0,0,0,2.35,2.36H14l1.09-1.1H12.9a1.52,1.52,0,0,1-1.52-1.52V2.89h1.13V4.23a.38.38,0,0,0,.39.39h3c.1,0,.18,0,.27,0L19,1.8ZM6.64,14.19H2.93v1.13H5.51Z"
			},
			children: [
			]
		}
	]
},
	"no-video": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.3,10.8l4.5,5.6V5.2L15.3,10.8z M18.7,13.2l-1.9-2.4l1.9-2.4V13.2z M15.3,7.7v8.7h-7l0.9-1.1h5V9.1L15.3,7.7z M17.1,2\n\tl-2.5,3.2H1.8v11.2h3.8l-2,2.5l0.9,0.7L18,2.7L17.1,2z M2.9,15.3v-9h10.8l-7.2,9H2.9z"
			},
			children: [
			]
		}
	]
},
	no: no,
	notification: notification,
	"notifications-off": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.934,16.425H1.8V15.3l3.375-2.259V7.425a5.625,5.625,0,0,1,11.25,0v3.424a4.858,4.858,0,0,0-.485-.049,5.00094,5.00094,0,0,0-.64.064V7.425a4.5,4.5,0,0,0-9,0v6.217L3.823,15.3h7.111a4.9544,4.9544,0,0,0-.05694.562A4.97166,4.97166,0,0,0,10.934,16.425ZM8.55,17.55a2.23826,2.23826,0,0,0,3.675,1.728,5.02137,5.02137,0,0,1-1.038-1.728ZM19.8,15.862a3.938,3.938,0,1,1-3.938-3.937A3.93849,3.93849,0,0,1,19.8,15.862Zm-1.183.563H13.106a2.81228,2.81228,0,0,0,5.511,0Zm.001-1.125a2.81227,2.81227,0,0,0-5.511,0Z"
			},
			children: [
			]
		}
	]
},
	"notify-me": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,1.8A9,9,0,0,0,3.19,15.61L2.1,19.7l4-1.24A9,9,0,1,0,10.8,1.8Zm0,16.87A7.88,7.88,0,0,1,6.66,17.5l-.43-.27-.49.16-2,.63.57-2.12.13-.48L4.14,15a7.88,7.88,0,1,1,6.66,3.67Zm1-3.73a1,1,0,1,1-1-1A1,1,0,0,1,11.8,14.94Zm-2-9h2l-.71,6h-.58Z"
			},
			children: [
			]
		}
	]
},
	"notify-someone": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 38 38"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m19,3C10.16357,3,3,10.16345,3,19c0,3.34851,1.03223,6.4541,2.79077,9.02344l-2.79077,6.97656,6.97656-2.79065c2.56934,1.75854,5.67505,2.79065,9.02344,2.79065,8.83667,0,16-7.16345,16-16S27.83667,3,19,3Zm0,30c-2.83081,0-5.56055-.84412-7.8938-2.4411l-.8811-.60303-.99121.39655-2.64355,1.05743,1.05737-2.64362.39648-.99133-.60303-.8811c-1.59692-2.33337-2.44116-5.06305-2.44116-7.8938,0-7.7196,6.28027-14,14-14s14,6.2804,14,14-6.28027,14-14,14Zm-1.75-20c0-.96655.78369-1.75,1.75-1.75.96655,0,1.75.78345,1.75,1.75,0,.96643-.78345,1.75-1.75,1.75-.96631,0-1.75-.78357-1.75-1.75Zm2.3501,5l1.3999,10h-4l1.3999-10h1.2002Z"
			},
			children: [
			]
		}
	]
},
	"office-phone-system": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.9013195,2.8188701H7.5661702L7.5660501,18.6421108h11.3352699\n\tc0.4956913-0.0014229,0.897192-0.4028702,0.8986797-0.8985615V3.7174301\n\tC19.7985764,3.2217131,19.3970375,2.8202269,18.9013195,2.8188701z M18.684,17.5261497H8.6820803L8.6822004,3.93484H18.684\n\tV17.5261497z M5.81636,2.8188701H2.6986799C2.2029626,2.8202267,1.8014228,3.2217128,1.8,3.7174301v14.0258808\n\tc0.0014336,0.4957314,0.4029479,0.8972454,0.89868,0.8986797H5.81636c0.4957209-0.001461,0.8972192-0.4029579,0.8986802-0.8986797\n\tV3.7174301C6.7135901,3.221724,6.3120661,2.8202541,5.81636,2.8188701z M5.599,17.5259991H2.9159999V3.93484H5.599V17.5259991z\n\t M17.7793007,4.7167988h-7.956111v3.5882816h7.9561205L17.7793007,4.7167988z M16.6633015,7.1891489h-5.724V5.8327298h5.724\n\tV7.1891489z M11.72651,9.8923597v0.0001202c-0.0000334,0.4628916-0.375308,0.8381128-0.8382006,0.8380795\n\tc-0.4628916-0.0000324-0.8381128-0.375308-0.8380795-0.8381996s0.375308-0.8381128,0.8381996-0.8380795\n\tC11.3512754,9.0543127,11.7264767,9.4295149,11.72651,9.8923597z M11.72651,13.9142094v0.0000601\n\tc-0.0000162,0.4628754-0.3752651,0.8380966-0.8381405,0.8380804c-0.4628754-0.0000172-0.8380966-0.3752651-0.8380795-0.8381405\n\tc0.0000162-0.4628754,0.3752642-0.8380966,0.8381395-0.8380804C11.3512821,13.0761461,11.7264938,13.4513578,11.72651,13.9142094z\n\t M11.72651,15.9251289v0.0001297c-0.0000362,0.4628925-0.3753128,0.8381119-0.8382053,0.8380756\n\tc-0.4628916-0.0000362-0.8381109-0.3753128-0.8380747-0.8382053c0.0000362-0.4628916,0.3753128-0.8381109,0.8382044-0.8380747\n\tC11.3512764,15.0870895,11.7264738,15.4622879,11.72651,15.9251289z M14.6394196,15.9251289\n\tc0.0000219,0.4628754-0.3751945,0.8381271-0.8380699,0.83815s-0.8381281-0.3751945-0.83815-0.8380699\n\ts0.3751945-0.8381281,0.8380699-0.83815c0.0000029,0,0.0000067,0,0.0000095,0h0.0000601\n\tc0.4628534-0.0000057,0.8380747,0.375206,0.8380804,0.8380594C14.6394196,15.9251223,14.6394196,15.9251261,14.6394196,15.9251289z\n\t M14.6394196,13.9142094c0,0.4628592-0.3752213,0.8380795-0.8380804,0.8380795s-0.8380795-0.3752213-0.8380795-0.8380804\n\tc0-0.4628353,0.3751841-0.8380461,0.8380194-0.8380795h0.0000601\n\tC14.2641897,13.0761509,14.6393986,13.4513597,14.6394196,13.9142094z M12.96315,9.8924198\n\tc-0.0000114-0.4628696,0.3752003-0.8381128,0.8380699-0.8381405H13.80128\n\tc0.4628754,0.0000114,0.8381014,0.3752546,0.8380899,0.83813c-0.0000105,0.4628754-0.3752546,0.8381014-0.83813,0.8380899\n\tC13.3383846,10.7304888,12.9631672,10.3552752,12.96315,9.8924198z M17.552,9.8923597v0.0001202\n\tc-0.0000324,0.4628916-0.375309,0.8381128-0.8381996,0.8380795c-0.4628925-0.0000324-0.8381138-0.375308-0.8380804-0.8381996\n\ts0.375308-0.8381128,0.8382006-0.8380795C17.1767654,9.0543127,17.5519676,9.4295149,17.552,9.8923597z M17.552,13.9142094\n\tv0.0000601c-0.0000172,0.4628754-0.3752651,0.8380966-0.8381405,0.8380804\n\tc-0.4628754-0.0000172-0.8380966-0.3752651-0.8380795-0.8381405c0.0000162-0.4628754,0.3752651-0.8380966,0.8381405-0.8380804\n\tC17.1767712,13.0761461,17.5519829,13.4513578,17.552,13.9142094z M11.7264996,11.9032793v0.0001202\n\tc-0.0000334,0.4628868-0.3753033,0.8381033-0.8381901,0.8380699s-0.8381033-0.3753033-0.8380699-0.8381901\n\ts0.3753033-0.8381033,0.8381901-0.8380699C11.3512688,11.0652428,11.7264662,11.4404402,11.7264996,11.9032793z\n\t M14.63941,11.9032793c0.0000057,0.4628592-0.3752108,0.8380842-0.8380699,0.8380899s-0.8380842-0.3752108-0.8380899-0.8380699\n\tc-0.0000057-0.4628391,0.3751802-0.8380566,0.8380194-0.8380899h0.0000601\n\tC14.2641821,11.0652208,14.6393976,11.4404278,14.63941,11.9032793z M17.552,11.9032793v0.0001202\n\tc-0.0000324,0.4628868-0.3753033,0.8381033-0.8381901,0.8380699s-0.8381033-0.3753033-0.8380699-0.8381901\n\ts0.3753033-0.8381033,0.8381901-0.8380699C17.1767693,11.0652428,17.5519676,11.4404402,17.552,11.9032793z M17.552,15.9251289\n\tv0.0001297c-0.0000362,0.4628925-0.3753128,0.8381119-0.8382053,0.8380756\n\tc-0.4628906-0.0000362-0.8381109-0.3753128-0.8380747-0.8382053c0.0000362-0.4628916,0.3753138-0.8381109,0.8382044-0.8380747\n\tC17.1767654,15.0870895,17.5519638,15.4622879,17.552,15.9251289z"
			},
			children: [
			]
		}
	]
},
	"oil-industry": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.28814,8.12665l-.48828-.86409-.48827.86409c-.10856.19278-1.28422,2.27392-1.645,2.96812a2.3203,2.3203,0,0,0-.20641,1.5802A2.42226,2.42226,0,0,0,10.64262,14.556c.05306.0039.10564.00585.15724.00585.05209,0,.10515-.002.14653-.00487a2.42835,2.42835,0,0,0,2.19408-1.883,2.32034,2.32034,0,0,0-.20836-1.57923C12.57674,10.40738,11.4186,8.3574,11.28814,8.12665Zm.756,4.30881a1.3041,1.3041,0,0,1-1.16008,1.00186l-.1626-.001-.00584.001a1.30354,1.30354,0,0,1-1.15959-1.00186,1.17735,1.17735,0,0,1,.10612-.82418c.21907-.4211.74191-1.35968,1.13769-2.06556.39578.70588.91862,1.64446,1.1372,2.06507v.00049A1.178,1.178,0,0,1,12.04416,12.43546Zm4.02931-1.18881v-.00048c-1.07-2.05923-4.63448-8.3669-4.78539-8.63465L10.76962,1.8l-.48828.86458C9.15972,4.65225,6.45108,9.46637,5.52613,11.24665a5.63034,5.63034,0,0,0-.50775,3.88966,5.99544,5.99544,0,0,0,5.41534,4.653c.12121.00682.24194.00974.371.01071.11927-.001.23951-.00389.36462-.01071a5.996,5.996,0,0,0,5.41242-4.653A5.63012,5.63012,0,0,0,16.07347,11.24665ZM15.4854,14.8968a4.85478,4.85478,0,0,1-4.37647,3.77281c-.222.00974-.41964.00974-.61485,0A4.85631,4.85631,0,0,1,6.11372,14.8968a4.53994,4.53994,0,0,1,.408-3.13364c.81006-1.55878,3.08251-5.611,4.27813-7.734,1.04227,1.84941,3.43935,6.11878,4.27862,7.73355A4.54134,4.54134,0,0,1,15.4854,14.8968Z"
			},
			children: [
			]
		}
	]
},
	"on-demand": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8462,17.55s4.12006-5.05109,5.25617-7.42688a6.59017,6.59017,0,0,0,.5694-2.45135A5.87177,5.87177,0,1,0,5.40632,9.99592C6.29945,11.91829,10.8462,17.55,10.8462,17.55ZM10.8,2.925a4.75215,4.75215,0,0,1,4.74677,4.74677,5.53044,5.53044,0,0,1-.45936,1.966A46.12249,46.12249,0,0,1,10.84712,15.744,53.74822,53.74822,0,0,1,6.43928,9.55031,4.74963,4.74963,0,0,1,10.8,2.925Zm0,7.73438A2.95313,2.95313,0,1,0,7.84688,7.70625,2.95312,2.95312,0,0,0,10.8,10.65938Zm0-4.78125A1.82813,1.82813,0,1,1,8.97188,7.70625,1.83016,1.83016,0,0,1,10.8,5.87813ZM18.675,16.425c0,1.86395-3.52576,3.375-7.875,3.375-4.34918,0-7.875-1.51105-7.875-3.375,0-1.12109,1.28076-2.11163,3.24371-2.72546.23688.32348.47333.64349.71363.965C5.0757,15.16072,4.05,15.92421,4.05,16.425c0,.79321,2.56268,2.25,6.75,2.25s6.75-1.45679,6.75-2.25c0-.49231-.99011-1.2392-2.73987-1.73578q.35157-.47946.69782-.96515C17.42714,14.33961,18.675,15.31862,18.675,16.425Z"
			},
			children: [
			]
		}
	]
},
	"on-go-car": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M6.76344,10.8a1,1,0,1,1-1-1A1,1,0,0,1,6.76344,10.8Zm8,0a1,1,0,1,0,1-1A1,1,0,0,0,14.76344,10.8Zm5-1a1.00036,1.00036,0,0,1-1,1h-.044l.044.195V18.8h-4V16.458h-8V18.8h-4V10.995l.044-.195h-.044a1,1,0,0,1,0-2h.495l.919-4.083A2.524,2.524,0,0,1,6.67042,2.8h8.186a2.52205,2.52205,0,0,1,2.492,1.917l.92,4.083h.495A1.00036,1.00036,0,0,1,19.76344,9.8Zm-14.125,6.656h-1.75v1.219h1.75V16.456Zm12,0h-1.75v1.219h1.75Zm0-5.336-1.387-6.156a1.40475,1.40475,0,0,0-1.395-1.039h-8.186a1.40477,1.40477,0,0,0-1.395,1.039l-1.387,6.156v4.211h13.75Z"
			},
			children: [
			]
		}
	]
},
	"on-screen-text": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 38 38"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m3,3v32h32V3H3Zm30,30H5V5h28v28ZM11.72632,14.39093h-4.62012v-3.33124h13.21533v3.33124h-4.66406v12.54938h-3.93115v-12.54938Zm12.72192,3.13776h-3.46509v-2.49792h9.91064v2.49792h-3.49756v9.41162h-2.948v-9.41162Z"
			},
			children: [
			]
		}
	]
},
	"one-year": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.87,11.76a1.38,1.38,0,0,1,0-1.92l.62-.63a.73.73,0,0,0-.35-1.33l-.87-.24a1.38,1.38,0,0,1-1-1.67l.21-.84c.16-.61-.13-1-.66-1a1.15,1.15,0,0,0-.31,0l-.88.22a1.24,1.24,0,0,1-.33,0A1.43,1.43,0,0,1,14,3.4l-.24-.84c-.12-.43-.39-.66-.7-.66a1,1,0,0,0-.64.3l-.64.62a1.4,1.4,0,0,1-1.94,0L9.19,2.2a1,1,0,0,0-.64-.3c-.31,0-.58.23-.7.67l-.24.83a1.41,1.41,0,0,1-1.35,1,1.24,1.24,0,0,1-.33,0l-.88-.22a1.77,1.77,0,0,0-.3,0c-.54,0-.83.41-.67,1L4.29,6a1.38,1.38,0,0,1-1,1.66l-.87.24A.74.74,0,0,0,2.1,9.21l.63.63a1.38,1.38,0,0,1,0,1.92l-.63.64a.73.73,0,0,0,.36,1.32l.87.24a1.38,1.38,0,0,1,1,1.67l-.21.84c-.16.61.13,1,.66,1a1.15,1.15,0,0,0,.31,0l.88-.22a1.24,1.24,0,0,1,.33,0,1.42,1.42,0,0,1,1.35,1l.24.84c.12.43.39.66.7.66a1,1,0,0,0,.64-.3l.64-.62a1.43,1.43,0,0,1,1.94,0l.64.62a1,1,0,0,0,.64.3c.31,0,.58-.23.7-.66L14,18.2a1.41,1.41,0,0,1,1.35-1,1.24,1.24,0,0,1,.33,0l.88.22a1.13,1.13,0,0,0,.3,0c.54,0,.83-.41.67-1l-.21-.84a1.38,1.38,0,0,1,1-1.67l.87-.24a.73.73,0,0,0,.35-1.33Zm-.8.79.23.23-.34.1a2.53,2.53,0,0,0-1.75,3l.09.32-.36-.09a2.47,2.47,0,0,0-.6-.08,2.54,2.54,0,0,0-2.43,1.83l-.1.33L12.55,18a2.54,2.54,0,0,0-3.5,0l-.27.25-.09-.33a2.54,2.54,0,0,0-2.43-1.83,2.49,2.49,0,0,0-.61.08l-.35.09.08-.32a2.51,2.51,0,0,0-1.75-3l-.33-.1.23-.23a2.51,2.51,0,0,0,0-3.5L3.3,8.82l.33-.1a2.51,2.51,0,0,0,1.75-3L5.3,5.37l.36.09a2.41,2.41,0,0,0,.6.08A2.54,2.54,0,0,0,8.69,3.71l.1-.33.26.25a2.54,2.54,0,0,0,3.5,0l.27-.25.09.33a2.54,2.54,0,0,0,2.43,1.83,2.41,2.41,0,0,0,.6-.08l.36-.08-.08.32a2.5,2.5,0,0,0,1.75,3l.33.1-.23.23A2.51,2.51,0,0,0,18.07,12.55ZM10.49,7.9h1.08v6.25H10.33V9.82H8.93V9C9.69,9,10.37,8.7,10.49,7.9Z"
			},
			children: [
			]
		}
	]
},
	"open-captioning": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.55,4.05H4.05A2.25,2.25,0,0,0,1.8,6.3v9a2.25,2.25,0,0,0,2.25,2.25h13.5A2.25,2.25,0,0,0,19.8,15.3v-9A2.25,2.25,0,0,0,17.55,4.05ZM18.8,15.3a1.2514,1.2514,0,0,1-1.25,1.25H4.05A1.2514,1.2514,0,0,1,2.8,15.3v-9A1.2514,1.2514,0,0,1,4.05,5.05h13.5A1.2514,1.2514,0,0,1,18.8,6.3ZM9.6475,8.7771a2.5784,2.5784,0,0,0-.891-.5989,2.9945,2.9945,0,0,0-1.1574-.2171,3.0208,3.0208,0,0,0-1.1681.2171,2.6276,2.6276,0,0,0-.8964.5989,2.6677,2.6677,0,0,0-.5738.9008,3.2336,3.2336,0,0,0,0,2.2451,2.6682,2.6682,0,0,0,.5738.9009,2.64,2.64,0,0,0,.8964.5988,3.0375,3.0375,0,0,0,1.1681.2162,3.0111,3.0111,0,0,0,1.1574-.2162,2.5907,2.5907,0,0,0,.891-.5988,2.6832,2.6832,0,0,0,.5685-.9009,3.2336,3.2336,0,0,0,0-2.2451A2.6827,2.6827,0,0,0,9.6475,8.7771ZM8.5,12.0231a1.0339,1.0339,0,0,1-.9116.4683,1.03,1.03,0,0,1-.9161-.4683A2.1654,2.1654,0,0,1,6.36,10.8a2.2133,2.2133,0,0,1,.3119-1.2387,1.0282,1.0282,0,0,1,.9161-.4728A1.0318,1.0318,0,0,1,8.5,9.5617,2.1914,2.1914,0,0,1,8.8173,10.8,2.1442,2.1442,0,0,1,8.5,12.0231Zm6.82-.5488h1.52a2.2122,2.2122,0,0,1-.2065.8508,2.1577,2.1577,0,0,1-.5085.69,2.3185,2.3185,0,0,1-.78.4576,2.9477,2.9477,0,0,1-1.0116.1662,3.0007,3.0007,0,0,1-1.1628-.2162,2.5954,2.5954,0,0,1-.8857-.5988,2.7008,2.7008,0,0,1-.5693-.9009A3.0822,3.0822,0,0,1,11.5145,10.8a3.1348,3.1348,0,0,1,.1966-1.1225,2.6608,2.6608,0,0,1,.5586-.9008,2.5436,2.5436,0,0,1,.8759-.5989,2.92,2.92,0,0,1,1.1476-.2171,3.0081,3.0081,0,0,1,.9661.1465,2.3515,2.3515,0,0,1,.7507.4076,2.1585,2.1585,0,0,1,.5183.6292,2.4972,2.4972,0,0,1,.2718.8H15.27a1.0785,1.0785,0,0,0-.3227-.5889.9156.9156,0,0,0-.6336-.2163,1.0056,1.0056,0,0,0-.9018.4531A2.1809,2.1809,0,0,0,13.1152,10.8a2.1381,2.1381,0,0,0,.2967,1.1878,1.0054,1.0054,0,0,0,.9018.4532.9535.9535,0,0,0,.6989-.2521A1.1342,1.1342,0,0,0,15.32,11.4743Z"
			},
			children: [
			]
		}
	]
},
	"operational-transformation": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.7891903,11.3263798c0.0279121-0.3748598,0.0267696-0.751317-0.0034199-1.1260004l2.04883-1.5173798L18.6705303,5.87289\n\tl-2.522459,0.375c-0.2431288-0.2872677-0.5094881-0.554038-0.79638-0.7976098l0.375-2.52124L12.9175997,1.765l-1.5185499,2.0487003\n\tc-0.3747597-0.0297201-0.7512989-0.0293519-1.1260004,0.0011001L8.75354,1.765L5.94348,2.9289999l0.3759999,2.5222197\n\tC6.0320826,5.6942143,5.765378,5.9606748,5.52212,6.2478495l-2.52-0.3759999L1.83655,8.6829996l2.0478499,1.5174007\n\tc-0.0299423,0.3751106-0.029608,0.7520237,0.0009999,1.12708L1.83655,12.8448095l1.1640599,2.8100595l2.52246-0.3758688\n\tc0.2432923,0.2870836,0.5096426,0.5538015,0.7963901,0.7974901l-0.375,2.5209999l2.8101196,1.1644897l1.5184898-2.0478592\n\tc0.3747158,0.030798,0.7513399,0.0304642,1.1260004-0.0009995l1.5194702,2.04883l2.8101206-1.1644306l-0.3760004-2.5219994\n\tc0.2875042-0.2433481,0.5546675-0.5097551,0.7988291-0.7965698l2.5209999,0.3749399l1.1641197-2.8100595L17.7891903,11.3263798z\n\t M17.94104,14.3684902l-2.29-0.3407001l-0.2080002,0.2724705c-0.3089628,0.4014692-0.6691141,0.7607975-1.07129,1.06884\n\tl-0.2734404,0.2093496l0.3417997,2.2909994l-1.1289101,0.4682598l-1.37994-1.8614502l-0.3398504,0.0455303\n\tc-0.5024862,0.0667553-1.0115671,0.0671654-1.5141602,0.0012207l-0.3398399-0.0456505l-1.3784084,1.8603706l-1.1289001-0.4682598\n\tl0.3408198-2.29L7.2974901,15.370121c-0.401588-0.3088837-0.7610798-0.6689329-1.0693398-1.0710001l-0.2080002-0.2724695\n\tl-2.29,0.3419199l-0.4682701-1.1288996l1.8612697-1.3789997l-0.0454102-0.34058\n\tc-0.066247-0.5019522-0.0665832-1.0104113-0.0009999-1.5124502l0.0454102-0.3405704L3.2618401,8.2881699l0.4682598-1.1289101\n\tl2.2899997,0.3408198l0.2080002-0.27246c0.3090925-0.4013715,0.6692476-0.7606859,1.0713401-1.0688396L7.5728798,5.94943\n\tL7.2310796,3.65731l1.1289201-0.46826l1.3798704,1.8613303l0.3393602-0.04456\n\tc0.5022116-0.0659752,1.0108728-0.0663447,1.5131798-0.0011001L11.93225,5.0494003l1.3789101-1.8603501l1.1289101,0.46826\n\tl-0.3408203,2.2900002l0.2734299,0.2094698C14.7742271,6.46562,15.133709,6.825592,15.4420004,7.22756L15.6499996,7.5\n\tL17.941,7.1591802l0.4682598,1.1289096l-1.8612595,1.3789902l0.0444298,0.3405704\n\tc0.066246,0.5022802,0.0665836,1.0110626,0.0009995,1.5134296l-0.0454102,0.3408203l1.8613205,1.3786602L17.94104,14.3684902z\n\t M10.3853798,11.0930996l-1.4492197,3.1357403l-3.1357403-1.4497004L6.26966,11.7644892l1.4033198,0.6485596l-0.1567402-0.4259005\n\tC6.839602,10.1585226,7.7734728,8.1276064,9.6020985,7.4509687c0.6090994-0.2253823,1.2685661-0.2783794,1.9058409-0.1531606\n\tl-0.4892597,1.0580001c-1.3297129-0.103919-2.4919014,0.8897839-2.5958204,2.2194967\n\tc-0.0272226,0.3483295,0.0214615,0.6984177,0.1426907,1.026103L8.72229,12.0271883l0.6489296-1.4031887L10.3853798,11.0930996z\n\t M12.7369404,7.3034296L15.8726797,8.7535l-0.46875,1.0146503l-1.4038095-0.6486797l0.1567402,0.4257803\n\tc0.6768818,1.8282871-0.2565174,3.859129-2.0848045,4.5360098c-0.6092529,0.2255621-1.2689362,0.278616-1.9064054,0.1533203\n\tl0.4887705-1.0579996c1.3297138,0.1039143,2.4918985-0.8897915,2.5958128-2.2195053\n\tc0.0272207-0.34832-0.0214605-0.6983986-0.142684-1.0260763l-0.1567402-0.4257803l-0.6484404,1.4034395l-1.0146503-0.4689999\n\tL12.7369404,7.3034296z"
			},
			children: [
			]
		}
	]
},
	orders: orders,
	"out-of-stock": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.7,6.3V4.72A2.93,2.93,0,0,0,11.77,1.8H9.83A2.93,2.93,0,0,0,6.9,4.72V6.3H4.05V19.8h13.5V6.3ZM8,4.72A1.88,1.88,0,0,1,9.83,2.84h1.94a1.88,1.88,0,0,1,1.88,1.88V6.3H8Zm8.48,14H5.18V7.42H6.9v1.3H8V7.42h5.7v1.3h1V7.42h1.73Zm-2-8.2-2.79,2.78L14.38,16l-.8.79L10.8,14.05,8,16.83,7.22,16,10,13.25,7.22,10.47l.8-.8,2.78,2.79,2.78-2.79Z"
			},
			children: [
			]
		}
	]
},
	"outgoing-call": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "polygon",
			type: "element",
			value: "",
			attributes: {
				points: "1.8 19 2.6 19.8 18.68 3.72 18.68 9.68 19.8 9.68 19.8 1.8 11.93 1.8 11.93 2.92 17.88 2.92 1.8 19"
			},
			children: [
			]
		}
	]
},
	"pack-backpack": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.9,15.7c0,0.6-0.5,1-1,1s-1-0.5-1-1c0-0.6,0.5-1,1-1C11.4,14.7,11.9,15.1,11.9,15.7z M17,9.4v8.9c0,0.9-0.7,1.6-1.6,1.6\n\tc0,0,0,0,0,0H6.3c-0.9,0-1.6-0.7-1.6-1.6V9.4l1.6-3.8c0.3-0.7,0.9-1.1,1.6-1.1h0.3c0-1.5,1.2-2.6,2.6-2.6s2.6,1.2,2.6,2.6\n\tc0,0,0,0,0,0h0.3c0.7,0,1.4,0.4,1.6,1.1L17,9.4z M9.4,4.5h2.9c0-0.8-0.7-1.5-1.5-1.5C10,3,9.4,3.7,9.4,4.5C9.4,4.5,9.4,4.5,9.4,4.5z\n\t M5.8,9.7l1.1,2c0.3,0.5,0.9,0.9,1.5,0.9h4.9c0.6,0,1.2-0.3,1.5-0.9l1.1-2v0L14.3,6c-0.1-0.2-0.3-0.4-0.6-0.4H7.9\n\tC7.7,5.6,7.4,5.8,7.3,6L5.8,9.7L5.8,9.7z M15.8,12.1l-0.1,0.2c-0.5,0.9-1.4,1.5-2.5,1.5H8.4c-1,0-2-0.6-2.5-1.5l-0.1-0.2v6.2\n\tc0,0.2,0.2,0.4,0.4,0.4h9.1c0.2,0,0.4-0.2,0.4-0.4V12.1z"
			},
			children: [
			]
		}
	]
},
	"pack-luggage": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13.8,5.9h-0.9V3.3c0-0.8-0.7-1.5-1.5-1.5h-1.2c-0.8,0-1.5,0.7-1.5,1.5v2.5H7.8c-1.1,0-2,0.9-2,2c0,0,0,0,0,0v12h1.1v-1.2\n\tc0.3,0.1,0.6,0.2,0.9,0.2h6c0.3,0,0.6-0.1,0.9-0.2v1.2h1.1v-12C15.8,6.8,14.9,5.9,13.8,5.9C13.8,5.9,13.8,5.9,13.8,5.9z M9.9,3.3\n\tC9.9,3.2,10,3,10.2,3c0,0,0,0,0,0h1.2c0.2,0,0.3,0.2,0.3,0.3c0,0,0,0,0,0v2.5H9.9V3.3z M13.8,17.8h-6c-0.5,0-0.9-0.4-0.9-0.9v-9\n\tC6.9,7.4,7.3,7,7.8,7h0.9v4h1.1V7h1.9v4h1.1V7h0.9c0.5,0,0.9,0.4,0.9,0.9v9C14.7,17.4,14.3,17.7,13.8,17.8z"
			},
			children: [
			]
		}
	]
},
	"pack-purse": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.5,10c-0.2-1.2-1.3-2.2-2.5-2.2h-2.1v-1c0-1.7-1.4-3.1-3.1-3.1c-1.7,0-3.1,1.4-3.1,3.1v1H5.7c-1.3,0-2.3,0.9-2.5,2.2\n\tl-1.3,7.8h18L18.5,10z M8.9,6.8c0-1.1,0.9-1.9,1.9-1.9s1.9,0.9,1.9,1.9v1H8.9V6.8z M4.3,10.2C4.4,9.5,5,9,5.7,9h2.1v3.7h1.1V9h3.9\n\tv3.7h1.1V9h2.1c0.7,0,1.3,0.5,1.4,1.2l1.1,6.5H3.1L4.3,10.2z"
			},
			children: [
			]
		}
	]
},
	"paper-free-billing": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.35673,1.8H6.2321V7.87086h1.125V2.925h7.31244V6.8625H18.6071V18.675H7.3571v-.559H6.2321V19.8h13.5V5.175ZM18.6071,5.7375H15.79454V2.925h.09625L18.6071,5.64106Zm-1.96185,5.51172A17.362,17.362,0,0,0,11.25267,8.591,7.37581,7.37581,0,0,0,7.467,8.697a5.18635,5.18635,0,0,0-3.729,6.10987l.00915.02209A12.909,12.909,0,0,0,1.8679,16.92012l.94287.61328A11.468,11.468,0,0,1,4.411,15.708a4.647,4.647,0,0,0,2.48474,1.29517,4.3288,4.3288,0,0,0,.68116.05468,4.89631,4.89631,0,0,0,3.35644-1.35449,19.06454,19.06454,0,0,1,5.584-3.47461l.96191-.373ZM7.79515,9.77314a6.25924,6.25924,0,0,1,3.20752-.08544,13.54191,13.54191,0,0,1,3.04107,1.259A14.52178,14.52178,0,0,0,4.7642,13.97285,3.9297,3.9297,0,0,1,7.79515,9.77314Zm2.42724,5.05909a3.72475,3.72475,0,0,1-3.1455,1.05957,3.48844,3.48844,0,0,1-1.80365-.9303,13.29328,13.29328,0,0,1,9.0094-2.89136A34.6851,34.6851,0,0,0,10.22239,14.83223Z"
			},
			children: [
			]
		}
	]
},
	passenger: passenger,
	"pause-alternate": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "a",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M8.13093,2.925v15.75H4.12503V2.925h4.0059m1.125-1.125H3.00003V19.8h6.2559V1.8h0Zm8.21905,1.125v15.75h-4.0059V2.925h4.0059m1.125-1.125h-6.2559V19.8h6.2559V1.8h0Z"
			},
			children: [
			]
		}
	]
},
	"pause-internet": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.89192,14.72548l-.93305.933-.933-.933A1.31955,1.31955,0,0,1,11.89192,14.72548Zm-5.82758-6.651A8.84148,8.84148,0,0,0,4.60273,9.22969l.79493.79492A7.91991,7.91991,0,0,1,6.86207,8.88014ZM19.8,10.8a9,9,0,1,1-9-9A9,9,0,0,1,19.8,10.8Zm-3.70081,5.80829-3.02252-3.05274-.00165.00165L11.40345,11.869l-1.473-1.48773-.91522-.92432L7.903,8.33363l-.83869-.847.00226-.00134L5.04438,5.44288A7.86194,7.86194,0,0,0,16.09919,16.60829ZM18.675,10.8A7.86678,7.86678,0,0,0,5.864,4.67286L8.19526,7.02742l.00391-.0011.9057.91479,1.23126,1.24366,1.13062,1.142-.00592-.001L16.88,15.799A7.83836,7.83836,0,0,0,18.675,10.8ZM7.9076,9.93611A6.46542,6.46542,0,0,0,6.382,11.05781l.79492.79492a5.34911,5.34911,0,0,1,1.56488-1.07409Zm5.93494,1.19244a5.16627,5.16627,0,0,1,.93695.72418l.79492-.79492a6.44221,6.44221,0,0,0-3.60571-1.8219ZM11.0002,6.5793a8.95767,8.95767,0,0,0-1.52814.13488L10.4853,7.73756c.17151-.012.34119-.03326.5149-.03326a7.87389,7.87389,0,0,1,5.60253,2.32031l.79493-.79492A8.9819,8.9819,0,0,0,11.0002,6.5793ZM9.94288,11.99165a3.6423,3.6423,0,0,0-1.69464.93237l.79492.79493a2.71525,2.71525,0,0,1,1.84967-.76789Z"
			},
			children: [
			]
		}
	]
},
	pause: pause,
	"payment-received": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 38 38"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m8.00146,20.00348h6v2h-6v-2Zm26.99854-12.74347v18.23999c-.07007,4.09003-3.40991,7.5-7.5,7.5-3.62988,0-6.6499-2.56995-7.34985-6H5.26025c-1.25,0-2.26025-1.00995-2.26025-2.25995V7.26001c0-1.25,1.01025-2.26001,2.26025-2.26001h27.47998c1.25,0,2.25977,1.01001,2.25977,2.26001Zm-2,4.74347H5v2h28v-2ZM5,7.26001v2.74347h28v-2.74347c0-.13995-.10986-.26001-.25977-.26001H5.26025c-.14014,0-.26025.12006-.26025.26001Zm28,18.23999c0-.16998-.00977-.33997-.02979-.5-.25-2.79999-2.61011-5-5.47021-5-2.85986,0-5.21997,2.20001-5.46997,5-.01978.16003-.03003.33002-.03003.5,0,.52002.07007,1.02002.21021,1.5.6499,2.31006,2.78003,4,5.28979,4,2.51025,0,4.64014-1.68994,5.29004-4,.14014-.47998.20996-.97998.20996-1.5Zm0-5.07996v-4.41656H5v8.73657c0,.14996.12012.25995.26025.25995h14.76978c.23999-3.90997,3.5-7,7.46997-7,2.18018,0,4.14014.93005,5.5,2.42004Zm-6.34473,5.64105l-1.43311-1.49121-1.44141,1.38672,2.87451,2.98926,4.56689-4.74902-1.44141-1.38672-3.12549,3.25098Z"
			},
			children: [
			]
		}
	]
},
	"peel-sticker": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.7,12.12l.89-.89,2.57,2.56v-2h1.26V16H12.21V14.69h2ZM19.8,1.8V13.93a5.87,5.87,0,0,1-5.87,5.87H1.8V7.67A5.87,5.87,0,0,1,7.67,1.8ZM18.67,2.93,2.92,18.68h11a4.75,4.75,0,0,0,4.74-4.75Z"
			},
			children: [
			]
		}
	]
},
	"pets-collar": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.79667,9.08951c-3.74495,0-6.78478,4.59187-6.78478,7.58966a1.9883,1.9883,0,0,0,.61049,1.62977c.725.60311,1.81677.40451,3.2006.15027a16.41022,16.41022,0,0,1,2.97369-.34783,16.41034,16.41034,0,0,1,2.9737.34783,11.23319,11.23319,0,0,0,1.8945.24588,1.95666,1.95666,0,0,0,1.3061-.39615,1.9883,1.9883,0,0,0,.61049-1.62977C17.58146,13.68138,14.54163,9.08951,10.79667,9.08951ZM16.21337,17.4c-.315.229-1.28089.06931-2.23074-.10512a17.31919,17.31919,0,0,0-3.186-.36772,17.31918,17.31918,0,0,0-3.186.36772C6.65978,17.46934,5.67943,17.649,5.38,17.4a1.0477,1.0477,0,0,1-.186-.7219c0-2.41359,2.61848-6.4076,5.60266-6.4076s5.60267,3.994,5.60267,6.4076C16.39934,16.93664,16.39135,17.27063,16.21337,17.4ZM6.092,9.90067a2.146,2.146,0,1,0-2.146,2.146A2.14594,2.14594,0,0,0,6.092,9.90067ZM3.946,10.92208A1.02138,1.02138,0,1,1,4.96741,9.90067,1.02257,1.02257,0,0,1,3.946,10.92208ZM17.654,7.75473A2.146,2.146,0,1,0,19.8,9.90067,2.14594,2.14594,0,0,0,17.654,7.75473Zm0,3.16735a1.02138,1.02138,0,1,1,1.02142-1.02141A1.02257,1.02257,0,0,1,17.654,10.92208ZM13.89331,8.501a2.80344,2.80344,0,1,0-2.80347-2.80347A2.80341,2.80341,0,0,0,13.89331,8.501Zm0-4.48229a1.67886,1.67886,0,1,1-1.67889,1.67882A1.68075,1.68075,0,0,1,13.89331,4.01875ZM7.7001,8.501A2.80344,2.80344,0,1,0,4.89663,5.69757,2.80341,2.80341,0,0,0,7.7001,8.501Zm0-4.48229A1.67886,1.67886,0,1,1,6.02122,5.69757,1.68075,1.68075,0,0,1,7.7001,4.01875Z"
			},
			children: [
			]
		}
	]
},
	pharmaceutical: pharmaceutical,
	"phone-all-good": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M5.175,1.8v18h11.25V1.8ZM15.3,18.675h-9V16.9875H9.675v1.125h2.25v-1.125H15.3ZM6.3,4.6125m9,11.25h-9V2.925h9ZM9.847,11.96763l-2.162-2.162.789-.789,1.373,1.373,3.279-3.279.789.789Z"
			},
			children: [
			]
		}
	]
},
	"phone-data": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13.3623,11.25476h-1.125V7.27917h1.125ZM15.8407,1.8v18H5.75928V1.8ZM14.7157,16.665H11.85449v1.09668H9.74561V16.665H6.88428v2.01H14.7157Zm0-13.74H6.88428V15.54H14.7157ZM11.36279,8.27917h-1.125v3h1.125Zm-2.00049,1H8.2373v1.97559h1.125Z"
			},
			children: [
			]
		}
	]
},
	"phone-favorite": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M5.175,1.8v18h11.25V1.8ZM15.3,18.675h-9V16.9875H9.675v1.125h2.25v-1.125H15.3Zm0-14.0625v11.25h-9V2.925h9Z"
			},
			children: [
			]
		},
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.41316,13.19923l.38281.36945.387-.36487c1.34722-1.26917,2.84942-2.97919,3.0263-3.97058a2.58076,2.58076,0,0,0-.02106-.983,2.06747,2.06747,0,0,0-.65075-1.10151,2.13873,2.13873,0,0,0-.84552-.4331,2.35987,2.35987,0,0,0-1.82953.38641,2.30032,2.30032,0,0,0-1.54932-.489,2.03075,2.03075,0,0,0-1.29272.53613,2.00874,2.00874,0,0,0-.54877.91089,2.57439,2.57439,0,0,0-.03729,1.14642C7.59785,10.05378,8.73933,11.58345,10.41316,13.19923ZM9.2375,7.7021a1.50662,1.50662,0,0,1,1.58875.76251,1.50854,1.50854,0,0,1,1.59021-.76251,1.01217,1.01217,0,0,1,.69775,1.374A11.17268,11.17268,0,0,1,10.828,12.09059V12.093l-.001-.00122-.0011.00122v-.00238A11.17246,11.17246,0,0,1,8.53969,9.07606,1.01219,1.01219,0,0,1,9.2375,7.7021Z"
			},
			children: [
			]
		}
	]
},
	"phone-medical": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M5.18,1.8v18H16.43V1.8ZM15.3,18.68h-9V17H9.68v1.12h2.25V17H15.3Zm0-2.82h-9V5.74h9Zm0-11.25h-9V2.93h9Zm-5.06,6.75H8.65V10.24h1.59V8.65h1.12v1.59H13v1.12H11.36V13H10.24Z"
			},
			children: [
			]
		}
	]
},
	"phone-number": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M8.94478,12.44022H9.875l.25037-1.54736H11.046l-.25036,1.54736h.93017l.25037-1.54736h.82318l.18774-1.12671H12.164l.14337-.89453h.832l.19648-1.12671h-.84064l.24164-1.44037h-.93018L11.565,7.74491h-.92144l.24163-1.44037H9.955L9.71333,7.74491H8.89088L8.69435,8.87162h.83124l-.1427.89453H8.5597l-.19647,1.12671h.83191Zm1.511-3.5686h.92145l-.14343.89453h-.92072ZM5.75929,1.8v18H15.84071V1.8Zm8.95642,16.875H6.88429V16.66483H9.7458v1.09668h2.10889V16.66483h2.861Zm0-14.43786V15.53983H6.88429V2.925h7.83142Z"
			},
			children: [
			]
		}
	]
},
	"phone-public-safety": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13.389,8.90553l-1.6,1.162.611,1.881-1.6-1.162-1.6,1.162.611-1.881-1.6-1.162h1.978l.611-1.881.611,1.881ZM16.425,1.8v18H5.175V1.8ZM15.3,16.9875H11.925v1.125H9.675v-1.125H6.3V18.675h9Zm0-12.375V2.925h-9V4.17158H6.299v2.314H6.3v9.377h9V4.6125Z"
			},
			children: [
			]
		}
	]
},
	"phone-volume": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		"enable-background": "new 0 0 21.6000004 21.6000004",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12.8639097,12.4827499L10.552,13.1754398c-0.5611706-0.5174637-1.0639353-1.0948744-1.4992905-1.7218895\n\tc-0.3896503-0.6147804-0.9499502-1.7027102-1.2406797-2.2773094L9.1554403,7.296L6.0703301,2.875L2.0327899,5.13623\n\tl0.02229,0.4415798c0.2557855,3.0801959,1.3326416,6.035501,3.1184402,8.5581894\n\tc1.9688134,2.3623543,4.4521866,4.2427654,7.2599096,5.4972095l0.4058504,0.1374092l0.3970003-0.3910007l2.6644802-2.4672203\n\tL12.8639097,12.4827499z M12.5200005,18.1054802c-2.3889256-1.1422272-4.5038853-2.78547-6.2010798-4.8179998\n\tC4.7904143,11.1074772,3.8280349,8.5815763,3.51842,5.93717l2.1214402-1.1881099l1.77141,2.5370002l-1.25561,1.7578001\n\tL6.34373,9.4261503c0.0370698,0.0754204,0.9203,1.86658,1.5054398,2.79\n\tc0.5890446,0.8429585,1.2762804,1.6128483,2.0472202,2.2934399l0.2956104,0.2609997l2.0855598-0.6241302l1.7528801,2.5575008\n\tL12.5200005,18.1054802z M12.5255203,8.6117601c0.2884703,0.430069,0.488863,0.9130373,0.5895996,1.4210005l-0.9484701,0.0475502\n\tc-0.1794481-0.7772179-0.673234-1.4451866-1.3636494-1.8446808l0.2826605-0.8927097\n\tc0.5782166,0.2963271,1.0731869,0.7324944,1.4398994,1.2688398H12.5255203z M11.9400902,4.6447601l-0.28372,0.8959999\n\tc1.6287327,0.6420989,2.8507967,2.026257,3.28613,3.7220001c0.0476265,0.2221165,0.0811605,0.4470215,0.1004,0.6733704\n\tl0.948-0.0476198c-0.2488728-2.3737602-1.8168631-4.4034753-4.0508499-5.2437L11.9400902,4.6447601z M17.5620899,5.2398801\n\tC16.4461861,3.5744562,14.758584,2.3757772,12.8185596,1.87062l-0.2801104,0.8843601\n\tc3.2161036,0.8247628,5.4744844,3.7106099,5.5019999,7.0306702l0.9195499-0.0461302\n\tc-0.0162697-1.6042461-0.5022392-3.1685681-1.39785-4.49964H17.5620899z"
			},
			children: [
			]
		}
	]
},
	phone: phone,
	photo: photo,
	"place-address": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.65291,16.427c0,1.8628-3.51587,3.373-7.85291,3.373s-7.85291-1.51019-7.85291-3.373c0-1.13934,1.319-2.14477,3.33283-2.75543l.63794.9892c-1.8158.49554-2.84577,1.26367-2.84577,1.76623,0,.79248,2.55439,2.248,6.72791,2.248s6.72791-1.45551,6.72791-2.248c0-.532-1.15516-1.361-3.17389-1.84967l.68176-.98773C17.20924,14.18953,18.65291,15.23488,18.65291,16.427ZM10.79972,2.925a.75.75,0,1,0,.75023.75023.7508.7508,0,0,0-.75023-.75023m0-1.125A1.875,1.875,0,1,1,8.92505,3.67522,1.87591,1.87591,0,0,1,10.79972,1.8Zm1.87235,11.31014A1.64226,1.64226,0,0,0,13.77266,11.698l.32519-3.96777-.15625-.17872A4.23652,4.23652,0,0,0,10.8,6.02126a4.0508,4.0508,0,0,0-3.15137,1.542l-.14355.17383.28222,3.94629A1.63194,1.63194,0,0,0,8.924,13.116l.31836,4.46h3.0625Zm-2.65723-.51465L9.9377,12.073H9.41426a.50692.50692,0,0,1-.50391-.46973l-.25-3.4873A2.90611,2.90611,0,0,1,10.8,7.14626a3.09725,3.09725,0,0,1,2.13672.97656l-.28516,3.48438a.503.503,0,0,1-.50488.46582h-.51856L11.26777,16.451h-.97851Z"
			},
			children: [
			]
		}
	]
},
	platform: platform,
	"play-alternate": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M3,19.8V1.8l15.6,9Zm13.4-9L4.1,3.8V17.9Z"
			},
			children: [
			]
		}
	]
},
	"play-with": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,11.1A8.70623,8.70623,0,0,1,11.1,19.8,8.8408,8.8408,0,0,1,4.3,16.6v2.5H3.2V14.6H7.7v1.1H5.1a7.39009,7.39009,0,0,0,6,3,7.59667,7.59667,0,0,0,7.6-7.6ZM10.5,2.9a7.39006,7.39006,0,0,1,6,3H13.9V7h4.5V2.5H17.3V4.9a8.89983,8.89983,0,0,0-6.8-3.1,8.7063,8.7063,0,0,0-8.7,8.7H2.9A7.59662,7.59662,0,0,1,10.5,2.9ZM8.9,7.5l5.7,3.3L8.9,14.1Zm3.5,3.3L10.1,9.55412V12.2Z"
			},
			children: [
			]
		}
	]
},
	play: play,
	plus: plus,
	"police-fleet": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.26,3.38h-1.1V1.8h1.1Zm2.65.05-.77-.77L12,3.78l.77.78ZM9.4,3.78,8.28,2.66l-.78.77L8.62,4.56ZM6.3,11.71h0a.9.9,0,1,0,.9.9h0A.9.9,0,0,0,6.3,11.71Zm9,0a.9.9,0,0,0-.9.9h0a.9.9,0,1,0,.9-.9Zm3.59,0a.9.9,0,0,1-.9.9h0l0,.17v7H14.4V17.69H7.2V19.8H3.61v-7l0-.17h0a.9.9,0,1,1,0-1.8h.44l.83-3.67A2.27,2.27,0,0,1,7.12,5.41H9.76v-1h1.9v1h2.82a2.26,2.26,0,0,1,2.24,1.73l.83,3.67H18A.9.9,0,0,1,18.89,11.71Zm-12.7,6H4.62v1.1H6.19v-1.1Zm10.79,0H15.41v1.1H17Zm0-4.8L15.73,7.36a1.28,1.28,0,0,0-1.25-.94H7.12a1.28,1.28,0,0,0-1.25.94L4.62,12.89v3.79H17Z"
			},
			children: [
			]
		}
	]
},
	portrait: portrait,
	pressure: pressure,
	previous: previous,
	print: print,
	"professional-services-case": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					name: "",
					type: "text",
					value: "icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.4132814,5.5217738V5.4307094c0.0033569-2.00354-1.6181641-3.6303711-3.6216431-3.633728\n\tc-2.00354-0.0032959-3.6303711,1.6181642-3.633728,3.6217041c0,0.0039673,0,0.0079956,0,0.0120239v0.0910645H1.8v14.28125h18\n\tv-14.28125H14.4132814z M8.2741213,5.4307094c0-1.387085,1.1244507-2.5114746,2.5114746-2.5114746\n\tc1.387085,0,2.5115356,1.1243896,2.5115356,2.5114746v0.0910645H8.2741213V5.4307094z M18.6837883,18.6871185L2.9162109,18.6869965\n\tv-6.9808969h5.9013672v1.7549438h3.9359741v-1.7549438h5.9302359V18.6871185z M9.9337893,12.3451986v-2.394165h1.7036133v2.394165\n\tH9.9337893z M18.6837883,10.5901327h-5.9301748V8.8352499H8.8176394v1.7548828H2.9162109V6.6377406h4.2416992h11.525878V10.5901327z\n\t"
			},
			children: [
			]
		}
	]
},
	"professional-services-chart": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.9,3.25A7.8,7.8,0,0,0,12,2.2h-.58v8.14l7.05,4.07.29-.5A7.8,7.8,0,0,0,15.9,3.25Zm-3.33.13a6.21,6.21,0,0,1,1.89.45L12.57,5.72Zm0,6.3V7.35l3-3a6.79,6.79,0,0,1,1.31,1.08L12.61,9.7Zm1.07.62,3.92-3.92A6.51,6.51,0,0,1,18.33,8l-3.17,3.17ZM18,12.83l-1.83-1.06,2.42-2.42a4.78,4.78,0,0,1,0,.66A6.74,6.74,0,0,1,18,12.83Zm-7.83-9H9.61A7.77,7.77,0,0,0,1.8,11.53a7.91,7.91,0,0,0,10,7.58,8,8,0,0,0,2.21-1,7.64,7.64,0,0,0,2.39-2.57l.29-.5-6.47-3.74ZM6.79,5.56A6.77,6.77,0,0,1,9,5v6.3L4.3,14l-.72.41A6.66,6.66,0,0,1,6.79,5.56Zm8.28,9.85a6.67,6.67,0,0,1-10.92,0l5.46-3.15Z"
			},
			children: [
			]
		}
	]
},
	"promo-badge": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 38 38"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m3,35h32V3L3,35Zm25.77778-4.08889l-3.73333-2.66667-3.73333,2.66667,1.42222-4.44444-3.73333-2.66667h4.62222l1.42222-4.44444,1.42222,4.44444h4.62222l-3.73333,2.66667,1.42222,4.44444Z"
			},
			children: [
			]
		}
	]
},
	"protection-score": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9.39466,10.18664,6.99,8.30783H9.96186l.963-2.88909.92168,2.88909h3.01909l-2.45192,1.87881.963,3.01912L10.9249,11.327l-2.446,1.8788ZM17.40182,2.925H4.2023L4.197,8.01909c0,4.0592,2.39285,7.84405,6.591,10.4663,4.20948-2.661,6.60849-6.4461,6.60849-10.46746L17.40182,2.925M18.528,1.8l-.00644,6.21793c0,4.76193-3.04083,9.03292-7.72964,11.78207C6.10305,17.0901,3.072,12.81907,3.072,8.01793L3.07846,1.8Z"
			},
			children: [
			]
		}
	]
},
	"public-safety": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.79933,9.55873A2.35566,2.35566,0,1,0,8.44386,7.20289,2.35843,2.35843,0,0,0,10.79933,9.55873Zm0-3.59546a1.23981,1.23981,0,1,1-1.23956,1.24A1.2413,1.2413,0,0,1,10.79933,5.96327ZM7.75618,13.292l-1.061-.34521a4.31563,4.31563,0,0,1,8.21.0003l-1.0617.34455a3.19958,3.19958,0,0,0-6.08728.00036ZM2.925,1.8V7.76136c0,4.88477,3.09937,9.24079,7.875,12.03864,4.77563-2.79785,7.875-7.15387,7.875-12.03864V1.8ZM17.55,7.76136c0,4.13105-2.45135,8.00776-6.75,10.72242C6.50135,15.76912,4.05,11.89125,4.05,7.76136V2.925h13.5Z"
			},
			children: [
			]
		}
	]
},
	"public-transportation": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9,16.87H6.77V15.71H9Zm5.86-1.16h-2.2v1.16h2.2Zm4.23-8.79v4.42H17.9V8.08h-1v9.68a1.29,1.29,0,0,1-.73,1.16v.88H13.52v-.73H8.09v.73H5.46v-.88a1.31,1.31,0,0,1-.73-1.16V8.08h-1v3.26H2.54V6.92H4.73v-2A3.15,3.15,0,0,1,7.87,1.8h5.86a3.14,3.14,0,0,1,3.14,3.14v2h2.19Zm-3.35,7H5.89v3.82a.15.15,0,0,0,.15.15h9.52a.15.15,0,0,0,.15-.15Zm0-6.59H5.89v5.43h9.82Zm0-2.41a2,2,0,0,0-2-2H7.87a2,2,0,0,0-2,2V6.19h9.82ZM8.6,5.22H13V4.06H8.6Z"
			},
			children: [
			]
		}
	]
},
	"purchase-data": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.2,19.45l-.4-1a7.83,7.83,0,0,0,4.3-10.3c-.1-.2-.1-.3-.2-.4l1-.5c.1.2.1.3.2.5A9,9,0,0,1,14.2,19.45ZM3.5,14.15A8,8,0,0,1,7.8,3.85a8,8,0,0,1,8.4,1.5l.7-.8a9,9,0,0,0-14.4,10,9,9,0,0,0,4.9,4.9l.4-1A8.21,8.21,0,0,1,3.5,14.15Zm9.6-6.5v.6h1.7v7.8H6.9V8.15H8.5v-.5a1.79,1.79,0,0,1,1.8-1.8h1A1.79,1.79,0,0,1,13.1,7.65Zm-3.5.5H12v-.5a.68.68,0,0,0-.7-.7h-1a.68.68,0,0,0-.7.7Zm3.5,1.2v.7H12v-.7H9.6v.7H8.5v-.7H8V15h5.6V9.35Z"
			},
			children: [
			]
		}
	]
},
	"push-notification": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12.8,10.52H11V9.69l.5-.35V8.66a1.35,1.35,0,1,1,2.7,0v.68l.5.35v.83Zm4.56-5V13H13.82v5.78H4.24V2.85h9.58V5.53ZM5.24,15.16h5.13V13H8.06V5.53h4.76V3.85H5.24Zm7.58,1H10V17H8.09v-.82H5.24v1.59h7.58Zm0-2.48-2.1,1.48h2.1Zm3.54-7.15H9.06V12h2.31v1.51L13.53,12h2.83ZM12.8,11.16a.46.46,0,0,0,.46-.46h-.92A.47.47,0,0,0,12.8,11.16Z"
			},
			children: [
			]
		}
	]
},
	"push-to-talk": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.425,2.08466v18H5.175v-18ZM15.3,17.27216H11.925v1.125H9.675v-1.125H6.3v1.6875h9Zm0-12.375V3.20966h-9V4.45624H6.299v2.314H6.3v9.377h9v-11.25ZM13.25508,10.388l-.71289.71228a2.464,2.464,0,0,0-3.48413,0L8.34517,10.388l.002-.00195A3.47042,3.47042,0,0,1,13.25508,10.388ZM9.507,11.54884l-.00043.00043.71314.71289a.84068.84068,0,0,1,1.16089,0l.71289-.71289A1.82893,1.82893,0,0,0,9.507,11.54884ZM10.8,8.736a4.08035,4.08035,0,0,1,2.904,1.20264l.71289-.71289a5.11491,5.11491,0,0,0-7.2334,0l.71216.71289A4.08306,4.08306,0,0,1,10.8,8.736Z"
			},
			children: [
			]
		}
	]
},
	question: question,
	"real-time-tracking": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.435,2.34651a3.36215,3.36215,0,0,0-3.082,4.71A44.55468,44.55468,0,0,0,16.455,11.31752a37.275,37.275,0,0,0,3.019-4.195,3.72364,3.72364,0,0,0,.326-1.412A3.3692,3.3692,0,0,0,16.435,2.34651Zm2.03,4.295a21.919,21.919,0,0,1-2.007,2.892,25.4167,25.4167,0,0,1-2.086-2.934,2.21784,2.21784,0,0,1-.183-.889,2.24652,2.24652,0,0,1,4.493.001A2.61572,2.61572,0,0,1,18.465,6.64149Zm-2.029-2.413a1.499,1.499,0,1,0,1.499,1.499A1.50078,1.50078,0,0,0,16.436,4.22847Zm0,2.091a.591.591,0,1,1,.591-.591A.5915.5915,0,0,1,16.436,6.31947Zm-9.049-2.123a5.58994,5.58994,0,0,0-5.132,7.799c.85,1.829,5.176,7.188,5.176,7.188s3.92005-4.806,5.001-7.067a6.26413,6.26413,0,0,0,.542-2.333A5.58719,5.58719,0,0,0,7.387,4.19648Zm4.038,7.438a43.5116,43.5116,0,0,1-3.992,5.755,50.52514,50.52514,0,0,1-4.152-5.837,4.4702,4.4702,0,1,1,8.576-1.768A5.20244,5.20244,0,0,1,11.425,11.63447Zm-4.038-4.504a2.654,2.654,0,1,0,2.654,2.654A2.65755,2.65755,0,0,0,7.387,7.13051Zm0,4.19a1.5365,1.5365,0,1,1,1.536-1.536A1.53851,1.53851,0,0,1,7.387,11.32051Zm2.708,7.37695a.556.556,0,1,1-.556-.556A.556.556,0,0,1,10.095,18.69746Zm2.016-.15594a.556.556,0,1,1-.556-.556A.556.556,0,0,1,12.111,18.54152Zm1.86-.794a.556.556,0,1,1-.556-.556A.556.556,0,0,1,13.971,17.74751Zm1.519-1.333a.556.556,0,1,1-.556-.556A.556.556,0,0,1,15.49,16.4145Zm1.049-1.716a.556.556,0,1,1-.556-.556A.556.556,0,0,1,16.539,14.6985Zm.461-1.967a.556.556,0,1,1-.556-.556A.556.556,0,0,1,17,12.73146Z"
			},
			children: [
			]
		}
	]
},
	"real-time": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		"enable-background": "new 0 0 21.6 21.6",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.44618,6.57667l-0.8349,0.8393c0.43458,0.86944,0.69708,1.81466,0.77307,2.78369h-2.23621v1.125h2.24006\n\tc-0.2624,3.74648-3.21641,6.74257-6.95881,7.05792v-2.23077h-1.12548v2.23761c-3.78174-0.25022-6.80376-3.24358-7.09-7.02277\n\th2.12955v-1.125h-2.13c0.28106-3.7668,3.28084-6.75829,7.0484-7.02893v2.13489h1.12452V3.21522\n\tc1.54542,0.11674,3.01785,0.70471,4.21862,1.68457l0.7959-0.80017c-3.70661-3.096-9.22122-2.601-12.31722,1.10562\n\ts-2.601,9.22122,1.10562,12.31723s9.22122,2.601,12.31722-1.10562c2.31488-2.77143,2.68817-6.68073,0.93961-9.84017\n\tL18.44618,6.57667z M16.3578,5.61189l0.79315-0.7973l1.58216-1.59052l0.79687,0.793l-1.65875,1.66776l-0.8006,0.805L10.841,12.75337\n\tL7.27314,9.11079l0.80372-0.78711l2.77,2.82813L16.3578,5.61189z"
			},
			children: [
			]
		}
	]
},
	recycle: recycle,
	"remind-me": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,10.8a9,9,0,1,0-9,9,8.88,8.88,0,0,0,3.06-.55,4,4,0,0,0,1.86.47,4.08,4.08,0,0,0,4.08-4.08,4,4,0,0,0-.5-1.92A8.78,8.78,0,0,0,19.8,10.8Zm-9,7.87a7.82,7.82,0,0,1-5.2-2,7.06,7.06,0,0,1,5.27-2.46,6.77,6.77,0,0,1,1,.09,3.81,3.81,0,0,0-.24,1.31,4.06,4.06,0,0,0,1.11,2.78A7.84,7.84,0,0,1,10.8,18.67Zm4.92-.08a3,3,0,1,1,3-2.95A2.95,2.95,0,0,1,15.72,18.59Zm2.71-6a4,4,0,0,0-2.71-1,4.08,4.08,0,0,0-3.33,1.73,7.69,7.69,0,0,0-1.52-.17A8.15,8.15,0,0,0,4.81,15.9a7.87,7.87,0,1,1,13.87-5.1A7.19,7.19,0,0,1,18.43,12.61ZM17,14.31l.66.66-2.33,2.34-1.45-1.46.66-.66.79.79ZM10.8,5.17a3.38,3.38,0,1,0,3.38,3.38A3.38,3.38,0,0,0,10.8,5.17Zm0,5.63a2.25,2.25,0,1,1,2.25-2.25A2.25,2.25,0,0,1,10.8,10.8Z"
			},
			children: [
			]
		}
	]
},
	reminder: reminder,
	"remove-item": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.1,6.5V1.8H1.8v13.3h4.7v4.7h13.3V6.5H15.1z M6.5,14H2.9V2.9H14v3.6H6.5V14z M18.7,18.7H7.6V7.6h11.1\n\tC18.7,7.6,18.7,18.7,18.7,18.7z M9.6,15.9l2.8-2.7l-2.8-2.8l0.8-0.8l2.8,2.8l2.7-2.8l0.8,0.8l-2.8,2.8l2.8,2.7l-0.8,0.8l-2.7-2.8\n\tl-2.8,2.8L9.6,15.9z"
			},
			children: [
			]
		}
	]
},
	"reoccurring-payment": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,11.03578A8.75986,8.75986,0,0,1,4.299,16.63411v2.55432H3.17183v-4.543H7.69435v1.1272H5.04725A7.63566,7.63566,0,0,0,18.6728,11.03578ZM10.56416,2.9272a7.61194,7.61194,0,0,1,6.03235,2.97357H13.90565V7.028h4.52252V2.484H17.301V4.966A8.75983,8.75983,0,0,0,1.8,10.56416H2.9272A7.64523,7.64523,0,0,1,10.56416,2.9272Zm-.09668,13.21655v-1.0625a2.92148,2.92148,0,0,1-3.08643-2.88672H8.43037a2.00579,2.00579,0,0,0,2.03711,2.03711v-3.2373c-1.53711-.33692-2.687-.76172-2.687-2.34864,0-1.38769,1.0874-2.27441,2.687-2.33691v-.6875h.69971v.6875c1.6875.13672,2.4873.93652,2.6748,2.28613H12.8293A1.64176,1.64176,0,0,0,11.16719,7.1457v3.01172c1.63769.33789,2.874.73731,2.874,2.43653,0,1.51269-1.23633,2.39941-2.874,2.5v1.0498Zm.69971-1.89941A1.75085,1.75085,0,0,0,13.0168,12.632c0-.9248-.64942-1.21191-1.84961-1.47461Zm-.69971-4.22461V7.133c-1.01221.08789-1.69971.57519-1.69971,1.46191C8.76777,9.39473,9.30537,9.758,10.46748,10.01973Z"
			},
			children: [
			]
		}
	]
},
	"replace-a-photo": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,16.18H15V6.75H1.8Zm1.12-8.3h11v7.18h-11Zm3.6.67a2.92,2.92,0,1,0,2.92,2.92A2.92,2.92,0,0,0,6.52,8.55Zm0,4.71a1.8,1.8,0,1,1,1.79-1.79A1.8,1.8,0,0,1,6.52,13.26Zm6.6-3.77a.95.95,0,1,1-.94-.94A.94.94,0,0,1,13.12,9.49ZM19.8,6.75V7.88H18.46V9.22H17.34V7.88H16V6.75h1.34V5.42h1.12V6.75Z"
			},
			children: [
			]
		}
	]
},
	reply: reply,
	research: research,
	"resend-email": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 38 38"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m34.99998,26.09092c-.00428,3.1583-2.56406,5.71725-5.72236,5.72051-.26371.00001-.52712-.01792-.78839-.05367l.25909-1.8766c2.14893.35734,4.18066-1.09503,4.53799-3.24396s-1.09503-4.18066-3.24396-4.53799c-2.14893-.35734-4.18066,1.09503-4.53799,3.24396-.11277.67817-.04633,1.37404.19273,2.01862l1.34489-1.34489,1.33991,1.33991-3.64033,3.64033-3.64023-3.64034,1.33989-1.33991,1.28082,1.2808c-.67516-3.07773,1.27251-6.12005,4.35024-6.79522,3.07773-.67516,6.12005,1.27251,6.79522,4.35024.08921.40667.13364.82187.13249,1.2382Zm-13.46452-.95125H3V6.18857h26.53154v12.07418c-.08155-.00254-.15778-.02429-.23989-.02429-.55668.00203-1.11155.06342-1.65522.18311v-9.36101l-11.37109,9.746L4.89511,9.05998v14.18458h17.0977c-.23124.61005-.38489,1.24674-.45735,1.89511ZM6.66809,8.08368l9.59726,8.22815,9.59877-8.22821-19.19602.00005Z"
			},
			children: [
			]
		}
	]
},
	reservations: reservations,
	"retail-store-alt": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.78798,7.82229h.01202l-1.98803-4.52134H3.80201L1.8023,7.8222h-.0023v2.48553h1.01384v7.99133h15.99799v-7.99133h.97614v-2.48544ZM2.92487,9.14698v-1.32469h15.73825v1.32469H2.92487Zm1.60959-4.72118h12.54335l.99877,2.27163H3.5297l1.00476-2.27163Zm9.70344,12.7484h-2.87953v-4.74126h2.87953v4.74126Zm-4.00438,0h-2.86976v-4.74126h2.86976v4.74126Zm7.45346,0h-2.32422v-5.86611H6.2389v5.86611H3.93871v-6.90236h13.74827v6.90236Z"
			},
			children: [
			]
		}
	]
},
	"retail-store": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,4h-18v3.8h1.5v9.7h14.9V7.8h1.5V4z M8.9,16.4v-4h1.3v4H8.9z M11.4,16.4v-4h1.3v4H11.4z M17.1,16.4h-3.3v-5.1h-2.4v0\n\th-1.1v0H7.8v5.1H4.5V7.8h12.6L17.1,16.4z M18.7,6.7h-0.4v0H3.3v0H2.9V5.2h15.7L18.7,6.7z"
			},
			children: [
			]
		}
	]
},
	retargeting: retargeting,
	returns: returns,
	rewards: rewards,
	"rewind-and-fast-forward": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "a",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M2.925,7.55553l5.62375,3.24447-5.62375,3.24447V7.55553m-1.125-1.94784V15.99231l9-5.19231L1.8,5.60769h0Zm10.125,1.94784l5.62375,3.24447-5.62375,3.24447V7.55553m-1.125-1.94784V15.99231l9-5.19231L10.8,5.60769h0Z"
			},
			children: [
			]
		}
	]
},
	"right-arrow": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.71933,19.8l-.817-.80985,7.683-7.61765H1.8v-1.145H17.58533l-7.683-7.61765.817-.80985L19.8,10.8Z"
			},
			children: [
			]
		}
	]
},
	"right-caret": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "polygon",
			type: "element",
			value: "",
			attributes: {
				points: "6.71 19.8 5.89 18.981 14.07 10.799 5.89 2.619 6.71 1.8 15.71 10.799 6.71 19.8"
			},
			children: [
			]
		}
	]
},
	ring: ring,
	ringing: ringing,
	ringtone: ringtone,
	"risk-monitor": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,12.382a8.86871,8.86871,0,0,1-.08,1.2l-1.114-.149a7.98055,7.98055,0,0,0,.069-1.051,7.81507,7.81507,0,0,0-3.15-6.3l.677-.9A8.93549,8.93549,0,0,1,19.8,12.382ZM17.105,17.093H4.495A7.78139,7.78139,0,0,1,2.925,12.382,7.88046,7.88046,0,0,1,13.639,5.034l.406-1.049A9.00509,9.00509,0,0,0,1.8,12.382a8.89783,8.89783,0,0,0,1.981,5.626l.168.21H17.651l.168-.21a8.96754,8.96754,0,0,0,1.228-2.025l-1.031-.452A7.7938,7.7938,0,0,1,17.105,17.093Zm.048-6.97406L12.58,12.684a1.711,1.711,0,1,1-.606-.95l4.629-2.596Zm-5.655,2.936a.562.562,0,1,0-.562.562A.56315.56315,0,0,0,11.498,13.055Z"
			},
			children: [
			]
		}
	]
},
	"risky-connection": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,8.14882l-.7613.7613a11.66669,11.66669,0,0,0-16.4774,0L1.8,8.14882A12.74257,12.74257,0,0,1,19.8,8.14882ZM8.87711,8.32611a9.003,9.003,0,0,0-4.521,2.44892l.7613.7613A7.93252,7.93252,0,0,1,8.87711,9.434Zm.11907,3.90722a5.23846,5.23846,0,0,0-1.95966,1.22215l.7613.7613a4.1984,4.1984,0,0,1,1.34391-.90247Zm3.34624,1.0607a4.18566,4.18566,0,0,1,1.39616.92275l.76131-.7613a5.228,5.228,0,0,0-2.01262-1.23834Zm.2617-3.87373a7.93308,7.93308,0,0,1,3.81585,2.116l.7613-.7613a9.00992,9.00992,0,0,0-4.57715-2.46242ZM9.82428,15.36145V17.173h1.83358V15.36145Zm.01076-4.0768.45313,3.36507h.9058l.45266-3.36507V7.72331H9.835Z"
			},
			children: [
			]
		}
	]
},
	router: router,
	rss: rss,
	"safe-browsing": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M3.07847,1.8,3.072,8.0179C3.072,12.819,6.10307,17.09,10.79191,19.8c4.68878-2.74921,7.72962-7.02014,7.72962-11.7821L18.528,1.8ZM17.39653,8.0179c0,4.0213-2.399,7.80639-6.60846,10.46746C6.58989,15.86311,4.197,12.07826,4.197,8.01906L4.20231,2.925H17.40184Zm-6.596-2.51545a4.15821,4.15821,0,1,0,4.15723,4.15821A4.16275,4.16275,0,0,0,10.8005,5.50245Zm2.9754,3.59571H12.77309a7.26614,7.26614,0,0,0-.39257-2.0141A3.02858,3.02858,0,0,1,13.7759,9.09816ZM10.894,12.6844c-.0318.001-.06146.00946-.0935.00946s-.06177-.00848-.09357-.00946a3.65039,3.65039,0,0,1-.81586-2.46124H11.709A3.65194,3.65194,0,0,1,10.894,12.6844ZM9.89107,9.09816a3.65043,3.65043,0,0,1,.81586-2.46125c.0318-.001.06152-.00946.09357-.00946s.0617.00849.0935.00946a3.652,3.652,0,0,1,.815,2.46125Zm-.6715-2.014a7.26531,7.26531,0,0,0-.39264,2.014H7.82412A3.02815,3.02815,0,0,1,9.21957,7.08418Zm-1.39545,3.139H8.82693a7.26523,7.26523,0,0,0,.39264,2.014A3.02815,3.02815,0,0,1,7.82412,10.22316Zm4.5564,2.0141a7.26621,7.26621,0,0,0,.39257-2.0141H13.7759A3.02861,3.02861,0,0,1,12.38052,12.23726Z"
			},
			children: [
			]
		}
	]
},
	"satellite-off": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.12687,14.42l-.64-.64,1.68005-1.68-.34-.35a2.80985,2.80985,0,0,0-2-.75,2.85993,2.85993,0,0,0-2.83026,2.88941l.00025.02057a2.81,2.81,0,0,0,.75,1.92l.35.39,1.73-1.73.59.64Zm-2.94.25a1.75069,1.75069,0,0,1-.19-.76A1.86,1.86,0,0,1,13.806,12.00047L13.82688,12a1.7489,1.7489,0,0,1,.81.19Zm6.56-.68a4.78971,4.78971,0,0,1-1.42,3.41,4.6,4.6,0,0,1-3.2,1.27h-.18v-1a3.63021,3.63021,0,0,0,2.65-1,3.7599,3.7599,0,0,0,1.12-2.69h1Zm-2.72-.02h1a3.08,3.08,0,0,1-3.07,3.06v-1A2.08,2.08,0,0,0,16.0269,13.97Zm-4-5.32,2.99-3-2.73-2.74-3,3-.35-.35a2.38994,2.38994,0,0,0-3-.31l-.69-.7-.71.71.7.69a2.39011,2.39011,0,0,0,.31,3l.35.35-2.36,2.36a4.43981,4.43981,0,0,1,2.37-1l.69-.68.78.78a4.40009,4.40009,0,0,1,2.13,1.22,4.27931,4.27931,0,0,1,.69.91l3-3Zm.26-4.33,1.32,1.33-2.29,2.26-1.32-1.29Zm-2.46,7.5-3.56-3.58a1.41421,1.41421,0,0,1,2-2l.35.35,2.7,2.76.5.5Zm-3.46374-.15a3.51,3.51,0,1,0,3.51,3.51A3.51,3.51,0,0,0,6.36314,11.67Zm0,1a2.51391,2.51391,0,0,1,2.45941,2.00952H3.90373A2.51391,2.51391,0,0,1,6.36314,12.67Zm0,5.02a2.51376,2.51376,0,0,1-2.45953-2.0105H8.82267A2.51377,2.51377,0,0,1,6.36314,17.69005Z"
			},
			children: [
			]
		}
	]
},
	satellite: satellite,
	save: save,
	"scale-alt": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "scale-alt",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,1.8v18h18V1.8ZM18.675,18.675H2.925V2.925h15.75ZM7.515,10.337a7.84381,7.84381,0,0,1,6.402.105l.508.243,2.43-5.102-.508-.242A13.56345,13.56345,0,0,0,5.262,5.155l-.517.224L7,10.563Zm7.834-4.209L13.885,9.203a8.862,8.862,0,0,0-2.748-.597V5.989H10.463V8.586a8.93369,8.93369,0,0,0-2.873.513L6.232,5.976A12.44338,12.44338,0,0,1,15.349,6.128Z"
			},
			children: [
			]
		}
	]
},
	scale: scale,
	"school-notebook": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.4,3.8v-2h-1.1v2H8.4v-2H7.2v2H3.8v16h14v-16H14.4z M4.9,18.7V4.9h2.3v0.9h1.1V4.9h4.9v0.9h1.1V4.9h2.3v13.7H4.9z\n\t M6.8,8.2h8v1.1h-8V8.2z M12.8,12.4h-6v-1.1h6V12.4z M6.8,14.2h8v1.1h-8V14.2z"
			},
			children: [
			]
		}
	]
},
	"screen-orientation-locked": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 38 38"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m32.99468,18.99426c.00073,1.19965-.13721,2.41656-.46216,3.62921-1.6377,6.11188-7.19434,10.38049-13.51294,10.38049-1.21997,0-2.44238-.1618-3.63354-.48096-7.45654-1.99805-11.89746-9.68994-9.89941-17.14648,1.6377-6.11157,7.19458-10.38019,13.51392-10.38049,1.21924,0,2.44141.16187,3.63257.48096,2.40063.64325,4.47266,1.89087,6.13281,3.51752h-3.74365v2h7V3.99451h-2v3.42859c-1.87134-1.79053-4.19287-3.16016-6.87158-3.87793-1.38721-.3717-2.78003-.54919-4.15112-.54913-7.06421.00037-13.52954,4.71472-15.44482,11.86285-2.28711,8.53546,2.77832,17.30884,11.31372,19.59595,1.38721.3717,2.78003.54913,4.15112.54913,7.06421,0,13.52954-4.71472,15.44482-11.86285.37134-1.38641.53003-2.77673.53003-4.14685h-1.99976Zm-20.47217,9h13v-10h-2.01318c.00269-.04388.01318-.08545.01318-.13v-3.37c0-2.48523-2.01465-4.5-4.5-4.5s-4.5,2.01477-4.5,4.5v3.37c0,.04456.0105.08612.01318.13h-2.01318v10Zm4-10.13v-3.37c0-1.37848,1.12158-2.5,2.5-2.5s2.5,1.12152,2.5,2.5v3.37c0,.07166-.05835.13-.13013.13h-4.73975c-.07178,0-.13013-.05835-.13013-.13Zm-2,2.13h9v6h-9v-6Z"
			},
			children: [
			]
		}
	]
},
	"screen-orientation-unlocked": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "a",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.64333,12.25105c.36295-1.68262,.10027-3.41522-.76746-4.91644-.9267-1.60327-2.42294-2.75012-4.21315-3.22931-.59044-.15802-1.19628-.23816-1.80054-.23816-3.13174,.00018-5.88591,2.1134-6.69749,5.13904-.47972,1.78821-.23354,3.65594,.69316,5.25922s2.42294,2.75012,4.21315,3.22931c.5905,.15802,1.19641,.23816,1.8009,.23816,1.64851,0,3.18276-.59698,4.39371-1.59308l.79471,.79382c-1.43495,1.20996-3.26005,1.92426-5.18842,1.92426-.69108,0-1.3931-.08936-2.09237-.27649C3.47719,17.42982,.92398,13.01252,2.07682,8.71498c.96543-3.599,4.22427-5.97266,7.78501-5.97284,.69102,0,1.3931,.08936,2.09237,.27649,4.18699,1.12067,6.7069,5.33423,5.77703,9.52039l1.50565-.8681,.56313,.97461-3.17249,1.8291-1.83115-3.16846,.9757-.5625,.87127,1.50739Zm-3.2204-2.69153v5.3324H6.30512v-5.3324h1.18632v-1.72888c0-1.3089,1.06222-2.36993,2.37259-2.36993s2.37259,1.06104,2.37259,2.36993v.60101h-1.12626v-.60101c0-.68646-.5591-1.24493-1.24633-1.24493s-1.24633,.55847-1.24633,1.24493v1.72888h4.80524Zm-1.12626,1.125H7.43138v3.0824h4.8653v-3.0824Z"
			},
			children: [
			]
		}
	]
},
	search: search,
	"security-alert": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.64,15.3H10V13.58h1.68Zm7-13.5v6c0,4.89-3.09,9.24-7.87,12C6,17,2.93,12.65,2.93,7.76v-6ZM17.55,2.92H4.05V7.76c0,4.13,2.45,8,6.75,10.72,4.3-2.71,6.75-6.59,6.75-10.72ZM11.19,12.3l.38-4.23V5.17H10v2.9l.38,4.23Z"
			},
			children: [
			]
		}
	]
},
	"security-check": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.11,12.25,7.23,9.37,8,8.58l2.09,2.1,4-4,.79.79ZM18.68,1.8v6c0,4.89-3.1,9.24-7.88,12C6,17,2.93,12.65,2.93,7.76v-6ZM17.55,2.92H4.05V7.76c0,4.13,2.45,8,6.75,10.72,4.3-2.71,6.75-6.59,6.75-10.72Z"
			},
			children: [
			]
		}
	]
},
	"security-keyhole": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9.18,10.1v3.49h3.24V10.1a2.74,2.74,0,1,0-3.24,0Zm.2-3a1.63,1.63,0,1,1,2.21,2.21l-.28.16v3h-1v-3L10,9.31A1.62,1.62,0,0,1,9.38,7.1ZM2.93,1.8v6c0,4.89,3.09,9.24,7.87,12,4.78-2.8,7.88-7.15,7.88-12v-6Zm14.62,6c0,4.13-2.45,8-6.75,10.72C6.5,15.77,4.05,11.89,4.05,7.76V2.92h13.5Z"
			},
			children: [
			]
		}
	]
},
	"security-wireless": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.05,9.91h0l-.79.79a3.48,3.48,0,0,0-4.92,0l-.79-.79A4.59,4.59,0,0,1,14.05,9.91ZM9.13,11.49l.79.78a1.29,1.29,0,0,1,1.76,0l.79-.78h0A2.36,2.36,0,0,0,9.13,11.49ZM6.77,9.12a5.69,5.69,0,0,1,8.06,0l.79-.79h0A6.81,6.81,0,0,0,6,8.33l.79.79ZM18.68,1.8v6c0,4.89-3.1,9.24-7.88,12C6,17,2.93,12.65,2.93,7.76v-6ZM17.55,2.92H4.05V7.76c0,4.13,2.45,8,6.75,10.72,4.3-2.71,6.75-6.59,6.75-10.72Z"
			},
			children: [
			]
		}
	]
},
	"send-message": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,17.5l18-6.8L1.8,4l2.3,6.8l0,0L1.8,17.5z M5,11.4h10L3.6,15.7L5,11.4z M15.1,10.2H5L3.6,5.9L15.1,10.2z"
			},
			children: [
			]
		}
	]
},
	"server-search": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,18.54681H15.61348V14.72333H1.8Zm1.144-2.67968h11.5257v1.53576H2.944Zm10.97223.76782a.43286.43286,0,1,1-.43286-.43286A.43285.43285,0,0,1,13.91621,16.635ZM16.57,9.47638a4.13852,4.13852,0,0,0,.62646-2.17224A4.21491,4.21491,0,1,0,15.83955,10.366l3.13916,3.24109L19.8,12.81146Zm-3.552.86243a3.03455,3.03455,0,1,1,3.03467-3.03467A3.03456,3.03456,0,0,1,13.018,10.33881ZM8.02266,9.13788H1.8V5.31433H8.07979a5.213,5.213,0,0,0-.32032,1.14819H2.94307v1.476H7.72969A5.2722,5.2722,0,0,0,8.02266,9.13788Zm6.48584,3.13574a5.26825,5.26825,0,0,0,1.105-.50415v2.147H1.8V10.093H8.497a5.26588,5.26588,0,0,0,.95581,1.12042H2.94307v1.545H14.5085Z"
			},
			children: [
			]
		}
	]
},
	"server-stack": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.80005,1.8V7.056h18V1.8ZM18.684,5.94H2.91608V2.916H18.684Zm-1.12048-.954H11.597V3.87h5.96656ZM4.032,4.428a.558.558,0,1,1,.558.558A.558.558,0,0,1,4.032,4.428Zm1.62,0a.558.558,0,1,1,.558.558A.558.558,0,0,1,5.652,4.428Zm-3.852,9h18V8.172h-18Zm1.116-4.14H18.684V12.312H2.91608Zm8.6809.954h5.96656v1.116H11.597ZM5.148,10.8a.558.558,0,1,1-.558-.558A.558.558,0,0,1,5.148,10.8Zm1.62006,0a.558.558,0,1,1-.558-.558A.558.558,0,0,1,6.76807,10.8Zm-4.968,9h18V14.544h-18Zm1.116-4.14H18.684v3.024H2.91608Zm8.6809.954h5.96656V17.73H11.597ZM5.148,17.172A.558.558,0,1,1,4.59,16.614.558.558,0,0,1,5.148,17.172Zm1.62006,0A.558.558,0,1,1,6.21,16.614.558.558,0,0,1,6.76807,17.172Z"
			},
			children: [
			]
		}
	]
},
	"service-end-date": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,1.8V16.425L5.17543,19.8H19.8V1.8ZM2.925,6.28792H5.74141V9.6678H2.925Zm0,9.67108v-.65937H5.74141V18.675h-.1Zm7.3125-1.78437h-2.23v1.125h2.23V18.675H6.86641V14.17463H2.925V10.7928H5.74141v2.374h1.125v-2.374H10.2375Zm0-4.50683H6.86641V6.28792H10.2375Zm4.499,9.0072h-3.374V15.29963h3.374Zm0-4.50037h-3.374V10.7928h3.374Zm0-4.50683h-3.374V6.28792h3.374ZM18.675,18.675H15.86152V15.29963H18.675Zm0-4.50037H15.86152V10.7928H18.675Zm0-4.50683H15.86152V6.28792H18.675Zm0-4.50488H2.925V2.925h15.75Z"
			},
			children: [
			]
		}
	]
},
	services: services,
	"set-fallback-image": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M4.661,1.74092v8.6l4.2-2.7,4.3,5.8,5.5-3.2v5.6h-8.1l-.4,1.1h9.7v-15.2Zm14.1,7-5.2,3.1-4.5-5.8-3.3,2.2v-5.3h13Zm-4.11713.36352a2.28934,2.28934,0,1,0-2.28936-2.28936A2.28937,2.28937,0,0,0,14.64393,9.10444Zm0-3.45367a1.16434,1.16434,0,1,1-1.16436,1.16431A1.16568,1.16568,0,0,1,14.64393,5.65077ZM9.65449,13.26533l-3.895-2.35254L1.739,13.30244l.03174.35254A7.31335,7.31335,0,0,0,5.52363,19.7292l.27783.12988.25879-.16308c4.01661-2.52735,3.645-6.01172,3.62745-6.15821ZM5.737,18.56318A6.29314,6.29314,0,0,1,2.92939,13.904l2.8252-1.67968,2.8252,1.706A5.75371,5.75371,0,0,1,5.737,18.56318Z"
			},
			children: [
			]
		}
	]
},
	"set-gallery-image": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.98439,4.61561v-2.8h-15.2v15.1h2.9v2.9h15.1v-15.2Zm-14-1.6h12.9v5.8l-5.19995,3.1-4.4-5.8-3.4,2.6Zm-.1,12.8v-5.6l3.1-2.5,4.3,5.8,5.5-3.2v5.5Zm15.80005,2.8h-12.8v-1.7h11.1v-11.1h1.7ZM11.80317,9.13435a2.25,2.25,0,1,0-2.25-2.25A2.25,2.25,0,0,0,11.80317,9.13435Zm0-3.375a1.125,1.125,0,1,1-1.125,1.125A1.12631,1.12631,0,0,1,11.80317,5.75935Z"
			},
			children: [
			]
		}
	]
},
	settings: settings,
	share: share,
	shipping: shipping,
	shock: shock,
	"shopping-bag": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.7,6.3V4.72A2.93,2.93,0,0,0,11.77,1.8H9.83A2.93,2.93,0,0,0,6.9,4.72V6.3H4.05V19.8h13.5V6.3ZM8,4.72A1.88,1.88,0,0,1,9.83,2.84h1.94a1.89,1.89,0,0,1,1.89,1.88V6.3H8Zm8.48,14H5.18V7.43H6.9V8.72H8V7.43h5.7V8.72h1V7.43h1.73Z"
			},
			children: [
			]
		}
	]
},
	shopping: shopping,
	"signal-broadcast": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.26289,7.86543a5.4739,5.4739,0,0,1-1.48047,3.70312l-.82812-.76171a4.35087,4.35087,0,0,0,1.18359-2.94141A4.2983,4.2983,0,0,0,14.95527,4.925l.82813-.76172A5.477,5.477,0,0,1,17.26289,7.86543ZM6.64277,4.92793l-.82812-.76172A5.4724,5.4724,0,0,0,4.33711,7.86543,5.483,5.483,0,0,0,5.8166,11.56855l.82813-.76171a4.24692,4.24692,0,0,1-.002-5.87891ZM17.552,2.38594l-.81445.77539a6.81821,6.81821,0,0,1,1.9248,4.7041,6.82694,6.82694,0,0,1-1.92675,4.708l.81445.77539a7.94559,7.94559,0,0,0,2.2373-5.4834A7.93688,7.93688,0,0,0,17.552,2.38594Zm-12.6875.77343L4.05,2.384A7.93392,7.93392,0,0,0,1.8127,7.86543,7.94559,7.94559,0,0,0,4.05,13.34883l.81445-.77539a6.82694,6.82694,0,0,1-1.92675-4.708A6.817,6.817,0,0,1,4.86445,3.15937ZM13.177,6.676A1.76618,1.76618,0,0,1,13.175,9.05781l.85742.72852a2.89028,2.89028,0,0,0,.00391-3.83692ZM7.56367,5.94941A2.88845,2.88845,0,0,0,7.549,9.76387l.86328-.72071A1.76538,1.76538,0,0,1,8.42305,6.676ZM10.8,6.54084a1.31869,1.31869,0,0,0-.5625,2.51435V19.216h1.125V9.05519A1.31869,1.31869,0,0,0,10.8,6.54084Z"
			},
			children: [
			]
		}
	]
},
	"sim-card": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.18,1.8H4.05v18h13.5V5.18Zm2.25,16.88H5.18V2.93h8.53l2.72,2.71ZM8.66,8.18A1.8,1.8,0,0,0,6.86,10v5.6a1.8,1.8,0,0,0,1.8,1.79h4.28a1.8,1.8,0,0,0,1.8-1.79V10a1.8,1.8,0,0,0-1.8-1.79ZM13.61,10v5.6a.67.67,0,0,1-.67.67h-.43V14H11.38v2.23H10.22V14H9.09v2.23H8.66A.67.67,0,0,1,8,15.57V10a.67.67,0,0,1,.67-.67h.43v2.17h1.13V9.3h1.17v2.17h1.12V9.3h.43A.67.67,0,0,1,13.61,10Z"
			},
			children: [
			]
		}
	]
},
	"single-document": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14.2,1.8H4.1v18h13.5V5.2L14.2,1.8z M16.4,18.7H5.2V2.9h7.3v3.9h3.9V18.7z M16.4,5.7h-2.8V2.9h0.1L16.4,5.7L16.4,5.7z"
			},
			children: [
			]
		}
	]
},
	"skip-back": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "a",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.16285,17.16395c-1.758,1.75739-4.06226,2.63605-6.36646,2.63605s-4.6084-.87866-6.36652-2.63605c-2.14087-2.14001-2.97034-5.08856-2.50415-7.86188h1.13916c-.47723,2.4812,.24286,5.14917,2.16083,7.06641,1.48798,1.48737,3.46637,2.30652,5.57068,2.30652s4.0827-.81915,5.57068-2.30652c3.07166-3.0705,3.07166-8.06647,0-11.13696-1.48798-1.48737-3.46631-2.30652-5.57068-2.30652-2.05231,0-3.98132,.78418-5.45593,2.20245h2.2157v1.125H3.53468V2.23146h1.125v1.99695c1.72729-1.61285,3.92932-2.42841,6.13672-2.42841,2.3042,0,4.60846,.87866,6.36646,2.63605,3.51617,3.51471,3.51617,9.2132,0,12.72791Zm-9.07152-7.86183v4.80792h.83247V7.46247h-.64738c-.0307,.24017-.09571,.44242-.19412,.60539-.09842,.16342-.22031,.29615-.36477,.39773-.14537,.10158-.30969,.17426-.49479,.21715-.18509,.04334-.37922,.06817-.58237,.07404v.54535h1.45095Zm4.29959,4.94652c.41262,0,.7783-.07991,1.09521-.24017,.31782-.16026,.58417-.39141,.79997-.69342s.38102-.66408,.49479-1.08664c.11376-.4221,.17155-.89793,.17155-1.42838,0-.54219-.06049-1.02614-.18058-1.45141s-.29164-.78597-.51285-1.08167c-.22211-.29615-.49027-.52233-.80448-.67988-.31511-.1571-.66634-.23566-1.05458-.23566s-.74128,.07855-1.05819,.23566c-.31782,.15756-.58869,.38554-.81351,.6844-.22572,.29886-.39908,.66092-.52278,1.08618s-.18509,.90606-.18509,1.44238c0,.53045,.05688,1.00628,.17155,1.42838,.11376,.42256,.2799,.78462,.4993,1.08664,.2185,.30202,.48847,.53316,.809,.69342s.68349,.24017,1.0907,.24017Zm.00903-.72096c-.29525,0-.55167-.0632-.76746-.18961s-.39457-.30653-.53632-.54083-.24739-.52097-.31872-.86001c-.07043-.33904-.10654-.7178-.10654-1.1372,0-.8564,.14175-1.5268,.42526-2.01075s.71871-.72593,1.30378-.72593c.28351,0,.53361,.0632,.7494,.18961s.39276,.30834,.53181,.54535c.13814,.23746,.24288,.52549,.31421,.86452,.07043,.33904,.10564,.71825,.10564,1.1372,0,.85685-.13724,1.52544-.41082,2.00624-.27448,.48079-.70426,.72141-1.29024,.72141Z"
			},
			children: [
			]
		}
	]
},
	"skip-forward": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "a",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.17015,17.16395c-1.75812,1.75739-4.06232,2.63605-6.36652,2.63605s-4.60846-.87866-6.36652-2.63605C.92094,13.64924,.92094,7.95076,4.43712,4.43605c1.75806-1.75739,4.06226-2.63605,6.36652-2.63605,2.20758,0,4.40979,.81573,6.13708,2.42877v-1.99731h1.125V6.25245h-4.02246v-1.125h2.21625c-1.47455-1.41827-3.40356-2.20245-5.45587-2.20245-2.10437,0-4.08276,.81915-5.57068,2.30652-3.07178,3.0705-3.07178,8.06647,0,11.13696,1.48792,1.48737,3.46631,2.30652,5.57068,2.30652s4.0827-.81915,5.57062-2.30652c1.91803-1.91724,2.63812-4.58521,2.16089-7.06641h1.13916c.46619,2.77332-.36328,5.72186-2.50415,7.86188Zm-9.07162-7.86185v4.80792h.83247V7.46246h-.64738c-.0307,.24017-.09571,.44242-.19412,.60539-.09842,.16342-.22031,.29615-.36477,.39773-.14537,.10158-.30969,.17426-.49479,.21715-.18509,.04334-.37922,.06817-.58237,.07404v.54535h1.45095Zm4.29959,4.94652c.41262,0,.7783-.07991,1.09521-.24017,.31782-.16026,.58417-.39141,.79997-.69342s.38102-.66408,.49479-1.08664c.11376-.4221,.17155-.89793,.17155-1.42838,0-.54219-.06049-1.02614-.18058-1.45141s-.29164-.78597-.51285-1.08167c-.22211-.29615-.49027-.52233-.80448-.67988-.31511-.1571-.66634-.23566-1.05458-.23566s-.74128,.07855-1.05819,.23566c-.31782,.15756-.58869,.38554-.81351,.6844-.22572,.29886-.39908,.66092-.52278,1.08618s-.18509,.90606-.18509,1.44238c0,.53045,.05688,1.00628,.17155,1.42838,.11376,.42256,.2799,.78462,.4993,1.08664,.2185,.30202,.48847,.53316,.809,.69342s.68349,.24017,1.0907,.24017Zm.00903-.72096c-.29525,0-.55167-.0632-.76746-.18961s-.39457-.30653-.53632-.54083-.24739-.52097-.31872-.86001c-.07043-.33904-.10654-.7178-.10654-1.1372,0-.8564,.14175-1.5268,.42526-2.01075s.71871-.72593,1.30378-.72593c.28351,0,.53361,.0632,.7494,.18961s.39276,.30834,.53181,.54535c.13814,.23746,.24288,.52549,.31421,.86452,.07043,.33904,.10564,.71825,.10564,1.1372,0,.85685-.13724,1.52544-.41082,2.00624-.27448,.48079-.70426,.72141-1.29024,.72141Z"
			},
			children: [
			]
		}
	]
},
	"small-business": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.79365,6.95051a.72378.72378,0,0,0-.0625-.31848l-1.27-3.01367H3.08223L1.86055,6.6501a.71165.71165,0,0,0-.05078.30115L1.8,6.94917V8.03828A2.21723,2.21723,0,0,0,2.90645,9.95063v8.031H18.64277V9.9781A2.21766,2.21766,0,0,0,19.8,8.03828V6.94917ZM3.8127,4.6999H17.74287l.793,1.88111H3.05439ZM15.3293,7.66316v.37512a1.13941,1.13941,0,1,1-2.27881.0069v-.382Zm-3.38282,0v.37512a1.1394,1.1394,0,1,1-2.2788,0V7.66316Zm-3.39941,0v.37512a1.13941,1.13941,0,0,1-2.27881.00678v-.3819Zm-5.66162.3819v-.3819H5.16426v.37512a1.13941,1.13941,0,0,1-2.27881.00678Zm12.50348,8.855H13.78346V12.43525h1.60547Zm2.1723,0H16.47047V11.35383H12.70186V16.9001H3.988V10.25959c.01269.00013.02441.00379.03711.00379a2.21173,2.21173,0,0,0,1.6914-.79663A2.19362,2.19362,0,0,0,9.10713,9.457a2.19488,2.19488,0,0,0,3.3916.01,2.19392,2.19392,0,0,0,3.38379-.00158,2.21062,2.21062,0,0,0,1.67871.7965Zm1.15338-8.86182a1.13941,1.13941,0,1,1-2.27881.00659V7.66316h2.27881ZM5.05977,15.71846h6.55859V11.36677H5.05977Zm1.08154-3.27027h4.39551V14.637H6.14131Z"
			},
			children: [
			]
		}
	]
},
	"small-plan": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12.19257,12.52643c0-.62488-.63556-.75611-1.71039-1.01947-1.35956-.31775-2.7959-.73468-2.7959-2.379,0-1.67737,1.35956-2.41205,3.11371-2.41205,1.69964,0,3.0155.7677,3.09228,2.41205h-1.897c-.07678-.6026-.53741-.94269-1.2605-.94269-.68017,0-1.12921.29639-1.12921.73468,0,.5481.60254.67932,1.77551.94269,1.45868.34009,2.77356.78912,2.77356,2.46649,0,1.64429-1.40326,2.55481-3.21185,2.55481-2.0835,0-3.4538-.9212-3.4975-2.653H9.39667c.08838.78912.60345,1.11761,1.53546,1.11761C11.56769,13.34857,12.19257,13.11914,12.19257,12.52643ZM19.8,1.8v18H1.8V1.8ZM18.675,2.925H2.925v15.75h15.75Z"
			},
			children: [
			]
		}
	]
},
	"smart-assistant": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_2_00000103964272299165175710000004676413688441617842_",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M4.7,4.4v12.9c0,1.7,3.1,2.6,6.1,2.6s6.1-0.9,6.1-2.6V4.4C16.9,0.9,4.7,0.9,4.7,4.4z M10.8,2.9c3.1,0,5,0.9,5,1.5\n\tc0,0.5-1.9,1.5-5,1.5s-5-0.9-5-1.5S7.7,2.9,10.8,2.9z M10.8,18.7c-3.1,0-5-0.9-5-1.5v-2.1c1.6,0.7,3.3,1,5,1c1.7,0,3.4-0.3,5-1v2.1\n\tC15.8,17.7,13.9,18.7,10.8,18.7z M10.8,15c-3.1,0-5-0.9-5-1.5V5.9c1.6,0.7,3.3,1,5,1c1.7,0,3.4-0.3,5-1v7.6\n\tC15.8,14.1,13.9,15,10.8,15z"
			},
			children: [
			]
		}
	]
},
	"smart-boiler": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M3.195,1.8v18H6.53888V17.58744H15.0621V19.8H18.405V1.8ZM17.27368,2.93132V6.89684H14.32532a3.56817,3.56817,0,0,0-7.05064,0H4.32632V2.93132ZM13.2512,7.4625A2.4512,2.4512,0,1,1,10.8,5.0113,2.45436,2.45436,0,0,1,13.2512,7.4625ZM5.40756,18.66868H4.32632V17.58744H5.40756Zm11.86612,0H16.19342V17.58744h1.08026ZM15.0621,16.45612H4.32632v-8.428H7.27468a3.56817,3.56817,0,0,0,7.05064,0h2.94836v8.428ZM10.10765,7.35546l1.27962-1.27961.79939.79939L10.907,8.15485ZM9.103,12.12135h3.394v1.13132H9.103Zm0,2.26264h3.394v1.13132H9.103Z"
			},
			children: [
			]
		}
	]
},
	"smart-communities": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,11.64H18.24l0,0-.4-.4v5.07H14.9V15.11h1.79v-5l-3.2-3.22-.57.56-.78-.78L13.49,5.3Zm-3.75,0H14.48l0,0-.38-.38v5.86H3.78V11.22l-.42.42H1.8L8.92,4.52ZM13,10.12l-4-4-4,4V16H13ZM7,12.3H7l.5.5a2,2,0,0,1,2.88,0h0l.5-.5A2.73,2.73,0,0,0,7,12.3Zm.93.94h0l.5.49a.73.73,0,0,1,1,0l.5-.49A1.41,1.41,0,0,0,7.92,13.24ZM6.05,11.37l.5.49a3.36,3.36,0,0,1,4.75,0h0l.5-.49a4.07,4.07,0,0,0-5.75,0Z"
			},
			children: [
			]
		}
	]
},
	"smart-family-child-address-book": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M3.4875,1.8V4.7668H2.3625v.8164h1.125V8.1418H2.3625v.8164h1.125v2.5586H2.3625v.8164h1.125v2.5586H2.3625v.8164h1.125V19.8h15.75V1.8Zm1.0444,17a8.3139,8.3139,0,0,1,6.8828-4.2158A8.1836,8.1836,0,0,1,18.2074,18.8Zm13.7056-1.6968a8.8732,8.8732,0,0,0-6.8228-3.519A9.1274,9.1274,0,0,0,4.4875,17.13V15.7082h.125v-.8164h-.125V12.3332h.125v-.8164h-.125V8.9582h.125V8.1418h-.125V5.5832h.125V4.7668h-.125V2.8h13.75ZM7.3121,8.6489A4.3219,4.3219,0,1,0,9.0644,5.0375,8.4274,8.4274,0,0,0,6.48,5.0847c-.9068.167-1.4756.64-1.522,1.2661A1.498,1.498,0,0,0,5.45,7.4763,4.3959,4.3959,0,0,0,7.3121,8.6489ZM11.606,5.1923a3.3026,3.3026,0,0,1,2.7034,1.4123c-.0777-.03-.1541-.0585-.2321-.0888a31.6107,31.6107,0,0,0-3.4155-1.17A3.2631,3.2631,0,0,1,11.606,5.1923ZM9.6094,5.88A24.2038,24.2038,0,0,1,13.8059,7.215c.3242.1259.6443.2487.9633.3686a3.2633,3.2633,0,0,1,.1455.9175A3.3087,3.3087,0,1,1,9.6094,5.88ZM6.6154,5.822a7.3275,7.3275,0,0,1,1.7232-.1A4.2636,4.2636,0,0,0,7.36,7.88a3.6481,3.6481,0,0,1-1.3607-.9146.8355.8355,0,0,1-.2934-.5595C5.7287,6.0944,6.21,5.8967,6.6154,5.822Z"
			},
			children: [
			]
		}
	]
},
	"smart-lighting": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M8.5568304,15.40242h4.48633v1.1159992h-4.48633V15.40242z M8.5568304,18.1626701h4.48633v-1.1159992h-4.48633V18.1626701z\n\t M10.3245296,19.7999992h0.9510002l0.7069998-1.0960007H9.6175003L10.3245296,19.7999992z M15.4591799,10.0949993\n\tc-0.4252996,0.9218798-2.4159994,4.3197098-2.4159994,4.76758H8.5568304c0-0.4478703-1.9907198-3.8457003-2.4159999-4.76758\n\tc-1.5693216-2.573194-0.7555223-5.9313664,1.8176718-7.5006876s5.9313664-0.7555223,7.5006881,1.817672\n\tc1.0641594,1.7448883,1.0641594,3.9381275,0,5.6830158H15.4591799z M13.6125002,11.2110004h-5.625l0.03613,0.0654297\n\tc0.65625,1.1999998,1.0595703,1.9556904,1.3027296,2.4700899h2.9472704\n\tc0.2431602-0.5142803,0.6464796-1.2701397,1.3027296-2.4700899L13.6125002,11.2110004z M15.1437502,7.2595806\n\tc0.0021887-2.3967438-1.9389811-4.3414631-4.3357248-4.3436518C8.4112816,2.9137397,6.4665623,4.8549099,6.4643736,7.2516537\n\tc-0.0009537,1.0441761,0.3746099,2.053688,1.0577965,2.8433466h6.5556593\n\tC14.7642345,9.3098059,15.142909,8.3025093,15.1437502,7.2595806z M9.0489998,7.0542698L9.55828,7.5632696\n\tc0.686017-0.6851811,1.7973833-0.6851811,2.4834003,0l0.5092697-0.5089998\n\tC11.5836878,6.0877776,10.0162621,6.0877776,9.0489998,7.0542698z M9.8776102,7.8826399l0.50879,0.5089998\n\tc0.2315283-0.2207584,0.5956221-0.2207584,0.8271503,0l0.50879-0.5089998c-0.5161247-0.492908-1.3285856-0.492908-1.8447104,0\n\tH9.8776102z M8.2222996,6.2254801L8.2213793,6.2263899l0.50879,0.5089998\n\tc1.1430149-1.1430969,2.9962626-1.1432042,4.13941-0.0002398l0.0002403,0.0002398l0.50879-0.5089998\n\tc-1.4235764-1.4241271-3.7320957-1.4245734-5.1562223-0.0009975C8.2223577,6.2254214,8.2223291,6.225451,8.2222996,6.2254801z"
			},
			children: [
			]
		}
	]
},
	"smart-meter": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M5.43,14.85H16.35V10.23H5.43Zm1.11-3.51h8.7v2.4H6.54ZM10.8,1.8h0a9,9,0,1,0,9,9A9,9,0,0,0,10.8,1.8Zm0,16.88a7.88,7.88,0,1,1,7.87-7.88A7.88,7.88,0,0,1,10.8,18.68ZM12.29,7.57a2,2,0,0,0-2.8,0L9,7.07a2.68,2.68,0,0,1,3.8,0h0ZM11.88,8l-.51.51a.69.69,0,0,0-1,0L9.9,8A1.43,1.43,0,0,1,11.88,8ZM8.58,6.66l-.51-.51a4,4,0,0,1,5.64,0h0l-.51.51A3.28,3.28,0,0,0,8.58,6.66Z"
			},
			children: [
			]
		}
	]
},
	"smart-scooter": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.14009,14.65032,16.04624,2.68019H12.17032V3.86267h2.8823l1.44282,8.24459a4.78251,4.78251,0,0,0-3.59915,4.05343H6.04358a2.1679,2.1679,0,1,0,0,1.18248h9.51284a2.16272,2.16272,0,1,0,2.58367-2.69285Zm-14.17221,3.087a.9854.9854,0,1,1,.9854-.9854A.987.987,0,0,1,3.96788,17.73733Zm11.58854-1.57664H14.07877A3.60513,3.60513,0,0,1,16.7,13.27608l.25,1.42844A2.16143,2.16143,0,0,0,15.55642,16.16069Zm2.0757,1.57664a.9854.9854,0,1,1,.9854-.9854A.987.987,0,0,1,17.63212,17.73733ZM10.0784,10.43715l-.83554.83553a3.16825,3.16825,0,0,0-4.47536,0L3.932,10.43715A4.349,4.349,0,0,1,10.0784,10.43715ZM3.62813,9.58108l-.83554-.83554a5.96231,5.96231,0,0,1,8.42518,0l-.83554.83554A4.78148,4.78148,0,0,0,3.62813,9.58108Z"
			},
			children: [
			]
		}
	]
},
	"smart-socket": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13.58478,6.91451a3.94226,3.94226,0,0,0-5.56933,0l-.79493-.79492a5.06656,5.06656,0,0,1,7.15918,0Zm2.16016-2.16308a7.00011,7.00011,0,0,0-9.88965,0l.79492.79492a5.8776,5.8776,0,0,1,8.29981,0ZM18.675,9.68282H2.925v8.086h15.75v-8.086m1.125-1.125v10.336H1.8V8.55782ZM6.94749,11.5307a2.19514,2.19514,0,1,0,2.19515,2.19514A2.19763,2.19763,0,0,0,6.94749,11.5307m0-1.125a3.32014,3.32014,0,1,1-3.32014,3.32014A3.32015,3.32015,0,0,1,6.94749,10.4057Zm1.125,2.75764a.5625.5625,0,1,0,.5625.5625.5625.5625,0,0,0-.5625-.5625Zm-2.25,0a.5625.5625,0,1,0,.5625.5625.5625.5625,0,0,0-.5625-.5625Zm8.83-1.63264a2.19514,2.19514,0,1,0,2.19514,2.19514A2.19763,2.19763,0,0,0,14.6525,11.5307m0-1.125a3.32014,3.32014,0,1,1-3.32014,3.32014A3.32014,3.32014,0,0,1,14.6525,10.4057Zm1.125,2.75764a.5625.5625,0,1,0,.5625.5625.5625.5625,0,0,0-.5625-.5625Zm-2.25,0a.5625.5625,0,1,0,.5625.5625.5625.5625,0,0,0-.5625-.5625Z"
			},
			children: [
			]
		}
	]
},
	"smart-switch": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M4.2903,1.8v18H17.3097V1.8ZM16.1847,18.675H5.4153V2.925H16.1847ZM13.452,5.851H8.148v9.89788H13.452ZM12.327,6.976v3.26141H9.273V6.976ZM9.273,14.62391V11.36244H12.327v3.26147Zm2.06171-9.67346H10.26533V3.88112h1.06934Zm-1.06934,11.699h1.06934v1.06933H10.26533Z"
			},
			children: [
			]
		}
	]
},
	"smoke-detector": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M8.48908,14.11855a1.41256,1.41256,0,0,0,0,1.59063,2.536,2.536,0,0,1,0,2.75271,1.29019,1.29019,0,0,0-.24517.7963H7.11419a2.39171,2.39171,0,0,1,.406-1.37685,1.4142,1.4142,0,0,0,0-1.59161,2.53429,2.53429,0,0,1,0-2.75173,1.2883,1.2883,0,0,0,.24516-.79433H8.89507A2.3819,2.3819,0,0,1,8.48908,14.11855Zm3.20185-1.37488H10.56121a1.28931,1.28931,0,0,1-.24517.79335,2.53253,2.53253,0,0,0,0,2.75369,1.41256,1.41256,0,0,1,0,1.59063,2.37855,2.37855,0,0,0-.407,1.37685h1.12972a1.30065,1.30065,0,0,1,.24517-.7963,2.53087,2.53087,0,0,0,0-2.75271,1.411,1.411,0,0,1,0-1.58965A2.38006,2.38006,0,0,0,11.69093,12.74367Zm2.79488,0H13.35609a1.28824,1.28824,0,0,1-.24517.79433,2.53434,2.53434,0,0,0,0,2.75173,1.41415,1.41415,0,0,1,0,1.59161,2.39179,2.39179,0,0,0-.406,1.37685h1.12972a1.29025,1.29025,0,0,1,.24516-.7963,2.53595,2.53595,0,0,0,0-2.75271,1.41261,1.41261,0,0,1,0-1.59063A2.38181,2.38181,0,0,0,14.48581,12.74367ZM19.8,2.34181v.56486A3.57311,3.57311,0,0,1,16.78741,6.427V9.07992a2.576,2.576,0,0,1-2.57324,2.57325H7.38583A2.576,2.576,0,0,1,4.81259,9.07992V6.427A3.57311,3.57311,0,0,1,1.8,2.90667V2.34181ZM15.6577,6.48412H5.9423v2.5958a1.44474,1.44474,0,0,0,1.44353,1.44353h6.82834A1.44474,1.44474,0,0,0,15.6577,9.07992Zm2.94688-3.01259H2.99542a2.452,2.452,0,0,0,2.382,1.88287H16.22256A2.452,2.452,0,0,0,18.60458,3.47153ZM8.56949,7.60207H7.43977V9.37118H8.56949Zm2.79488,0H10.23465V9.37118h1.12972Zm2.79586,0H13.03051V9.37118h1.12972Z"
			},
			children: [
			]
		}
	]
},
	snooze: snooze,
	"social-distancing": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12.40645,10.09687a1.68149,1.68149,0,0,0,.58105.44532,1.87445,1.87445,0,0,0,.80566.16211,1.9596,1.9596,0,0,0,.68457-.11524,1.63277,1.63277,0,0,0,.54-.32129,1.49013,1.49013,0,0,0,.35645-.49316,1.61386,1.61386,0,0,0,.00293-1.26172,1.52721,1.52721,0,0,0-.33887-.49023,1.499,1.499,0,0,0-.49609-.31543,1.59471,1.59471,0,0,0-.59571-.11231,1.25726,1.25726,0,0,0-.62793.14453,1.40087,1.40087,0,0,0-.44628.4043h-.01172Q12.93233,6.84,13.81074,6.84A.74351.74351,0,0,1,14.05,6.8752a.56551.56551,0,0,1,.17676.09472.48861.48861,0,0,1,.11816.13281.66426.66426,0,0,1,.06738.15039h.96192a1.34758,1.34758,0,0,0-.17383-.44824,1.36977,1.36977,0,0,0-.32422-.36035,1.52971,1.52971,0,0,0-.47265-.24219,2.01543,2.01543,0,0,0-.61622-.08789,1.97928,1.97928,0,0,0-.79687.14453,1.59352,1.59352,0,0,0-.57227.42188,2.00509,2.00509,0,0,0-.39257.7666,3.582,3.582,0,0,0-.11426.97949,3.423,3.423,0,0,0,.12109.94727A1.92726,1.92726,0,0,0,12.40645,10.09687Zm.752-1.52539a.89185.89185,0,0,1,.90918-.16211.74335.74335,0,0,1,.251.165.77838.77838,0,0,1,.168.25391.83032.83032,0,0,1,.06153.32422.8149.8149,0,0,1-.06153.31836.77823.77823,0,0,1-.168.2539.7432.7432,0,0,1-.251.165.80182.80182,0,0,1-.30957.05957.87908.87908,0,0,1-.32813-.05957.75764.75764,0,0,1-.25879-.165.7908.7908,0,0,1-.23925-.57812A.76645.76645,0,0,1,13.1584,8.57148Zm3.28418-.56836h-.31641V7.59883h.31641V7.42109a.63332.63332,0,0,1,.17773-.49316.59925.59925,0,0,1,.2627-.12988,1.34084,1.34084,0,0,1,.36133-.03614c.042,0,.084.001.12695.00391.042.00293.085.00684.12988.01172v.44238c-.0791-.00195-.14648-.00195-.20117,0a.37377.37377,0,0,0-.13672.0293.158.158,0,0,0-.07715.07812.333.333,0,0,0-.02343.1377v.13379h.43847v.40429H17.0627V9.70234h-.62012Zm1.58008-.00781h-.31641V7.59883h.31641v-.6709H18.631v.6709h.41114v.39648H18.631v1.043a.18228.18228,0,0,0,.06153.16016.30413.30413,0,0,0,.17187.041c.02051,0,.04395,0,.07032-.00195l.07128-.00586h.03223v.46289c-.03418.00488-.082.01172-.14258.01953a1.73,1.73,0,0,1-.21777.01172,1.329,1.329,0,0,1-.2666-.02539.52041.52041,0,0,1-.207-.0918.42337.42337,0,0,1-.13477-.16992.65048.65048,0,0,1-.04687-.26562Zm.30639,6.61518v-.89838H13.09694v.89838l-1.46119-1.46125,1.46119-1.46118v.899h5.23211v-.899l1.46125,1.46118ZM6.718,10.91523a4.5845,4.5845,0,0,0-3.38867,1.29,6.07246,6.07246,0,0,0-1.51953,3.9502l.0039.55859h9.84766v-.5625C11.66133,14.34,10.62812,10.91523,6.718,10.91523ZM2.98066,15.58906A4.60091,4.60091,0,0,1,4.133,12.99336a3.49919,3.49919,0,0,1,2.585-.95313,3.70716,3.70716,0,0,1,3.77246,3.54883Zm3.75489-5.082A2.81055,2.81055,0,1,0,3.925,7.69648,2.81364,2.81364,0,0,0,6.73555,10.507Zm0-4.49609A1.68555,1.68555,0,1,1,5.05,7.69648,1.6871,1.6871,0,0,1,6.73555,6.01094Z"
			},
			children: [
			]
		}
	]
},
	"social-security": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "a",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M6.85762,12.58467c-.19482-.05078-.36182-.12793-.5-.22949s-.24658-.22852-.3252-.37988c-.07812-.15137-.11914-.32617-.12207-.52246h.88965c.02002,.17969,.08838,.30957,.20508,.38965s.28174,.12012,.49512,.12012c.07324,0,.14453-.00684,.21289-.01953,.06836-.01367,.12891-.03516,.18262-.06543,.05273-.03027,.09668-.06934,.12988-.11719,.0332-.04883,.0498-.10645,.0498-.17285,0-.07031-.01758-.12793-.05273-.1748s-.08594-.08691-.15234-.12012-.14844-.0625-.24512-.08789c-.09668-.02441-.20654-.05176-.33008-.08203-.15674-.03711-.31104-.07812-.4624-.125-.15186-.04688-.2876-.11035-.40771-.19043-.11963-.08008-.21729-.18164-.29248-.30469-.07471-.12305-.1123-.27832-.1123-.46484,0-.19043,.03662-.35449,.10986-.49316,.07324-.1377,.17334-.25195,.30029-.3418,.12646-.08984,.27637-.15723,.44971-.2002s.35986-.06543,.56006-.06543c.19385,0,.37451,.02246,.54248,.06836,.16895,.04492,.31543,.1123,.44043,.20215s.22559,.2041,.2998,.34277c.0752,.1377,.11719,.30078,.12695,.4873h-.86426c-.0166-.14062-.0752-.24707-.1748-.32031-.10059-.07324-.2334-.11035-.40039-.11035-.15674,0-.28174,.03125-.375,.09277-.09375,.06152-.14014,.14258-.14014,.24316,0,.0625,.01758,.11523,.05225,.15723,.03516,.04199,.08594,.07715,.15283,.10742,.06641,.03027,.15088,.05762,.25244,.08203,.10156,.02539,.21973,.05273,.35254,.08301,.16699,.04004,.32617,.08496,.47754,.13477s.28613,.11719,.40332,.2002c.11621,.08301,.20898,.18848,.2793,.31445,.07031,.12695,.10547,.28516,.10547,.47559,0,.18652-.03711,.35254-.11328,.49707-.07422,.14551-.17773,.2666-.30957,.36523s-.28711,.17383-.46484,.22461c-.17871,.05176-.37109,.07812-.57812,.07812-.23682,0-.45264-.02637-.64746-.07812Zm3.2998,0c-.19531-.05078-.36133-.12793-.5-.22949s-.24707-.22852-.3252-.37988-.11914-.32617-.12207-.52246h.88965c.02051,.17969,.08887,.30957,.20508,.38965,.11719,.08008,.28125,.12012,.49512,.12012,.07324,0,.14453-.00684,.21289-.01953,.06738-.01367,.12891-.03516,.18164-.06543,.05371-.03027,.09668-.06934,.13086-.11719,.0332-.04883,.0498-.10645,.0498-.17285,0-.07031-.01758-.12793-.05273-.1748s-.08594-.08691-.15234-.12012-.14844-.0625-.24512-.08789c-.09668-.02441-.20703-.05176-.33008-.08203-.15625-.03711-.31055-.07812-.46289-.125-.15137-.04688-.28711-.11035-.40723-.19043s-.21777-.18164-.29199-.30469c-.0752-.12305-.11328-.27832-.11328-.46484,0-.19043,.03711-.35449,.11035-.49316,.07324-.1377,.17383-.25195,.2998-.3418,.12695-.08984,.27734-.15723,.4502-.2002,.17383-.04297,.36035-.06543,.56055-.06543,.19238,0,.37402,.02246,.54199,.06836,.16797,.04492,.31543,.1123,.44043,.20215s.22461,.2041,.2998,.34277c.0752,.1377,.11719,.30078,.12695,.4873h-.86426c-.01758-.14062-.0752-.24707-.17578-.32031-.09961-.07324-.2334-.11035-.39941-.11035-.15723,0-.28223,.03125-.375,.09277-.09375,.06152-.14062,.14258-.14062,.24316,0,.0625,.01758,.11523,.05273,.15723s.08594,.07715,.15234,.10742c.06738,.03027,.15137,.05762,.25293,.08203,.10156,.02539,.21875,.05273,.35254,.08301,.16699,.04004,.3252,.08496,.47754,.13477,.15137,.0498,.28516,.11719,.40234,.2002,.11621,.08301,.20996,.18848,.28027,.31445,.06934,.12695,.10449,.28516,.10449,.47559,0,.18652-.03711,.35254-.1123,.49707-.0752,.14551-.17871,.2666-.30957,.36523-.13184,.09863-.28711,.17383-.46582,.22461-.17773,.05176-.37012,.07812-.57715,.07812-.23633,0-.45215-.02637-.64746-.07812Zm3.3623-3.58203l1.06055,1.79492c.0127,.02637,.03418,.06543,.0625,.11523s.05566,.09961,.08203,.14941c.0332,.06055,.06641,.12402,.10059,.19043h.00977c-.00391-.08008-.00488-.15625-.00488-.23047-.00391-.0625-.00488-.125-.00488-.18457v-1.83496h.86426v3.5752h-.88965l-1.0498-1.77051c-.0166-.02344-.03906-.06055-.06738-.1123s-.05664-.10547-.08301-.16211c-.0332-.06348-.06836-.13184-.10449-.20508h-.01074c0,.08691,.00195,.16797,.00586,.24512,0,.06641,0,.13184,.00195,.19727,.00195,.06445,.00293,.1123,.00293,.14258v1.66504h-.86523v-3.5752h.88965Zm5.15527-3.57764v10.75H2.925V5.425h15.75m1.125-1.125H1.8v13H19.8V4.3h0Z"
			},
			children: [
			]
		}
	]
},
	"solar-panel": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,1.8V14.998H9.04753v1.683H5.54361V19.8H16.05639V16.681H12.55247V14.998H19.8V1.8ZM18.63,8.498H14.18966V6.301H18.63ZM8.58034,11.847V9.65h4.43932v2.197Zm0-3.349V6.301h4.43932V8.498Zm-1.17,0H2.97V6.301H7.41034Zm1.17-3.349V2.952h4.43932V5.149Zm10.04965,0H14.18966V2.952H18.63ZM7.41034,2.952V5.149H2.97V2.952ZM2.97,9.65H7.41034v2.197H2.97Zm11.91637,8.183v.815H6.71362v-.815h8.17276Zm-3.50392-1.152H10.21754V14.998h1.16492ZM18.63,13.846H2.97v-.847H18.63Zm-4.44033-1.999V9.65H18.63v2.197Z"
			},
			children: [
			]
		}
	]
},
	sos: sos,
	sound: sound,
	"speaker-mute": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.67,11.07a7,7,0,0,0-2-4.92l.81-.79a8.12,8.12,0,0,1,.7,10.55l-.8-.8A7,7,0,0,0,18.67,11.07Zm.1,7.05h0l-.8.79L13.11,14v5l-6.8-4.53H1.81V7.69h4.5l.34-.23-4-4.09.8-.79L18.77,18.12ZM6.31,8.82H2.93v4.55H6.31Zm5.67,4L7.46,8.28h0v5.63l4.52,3Zm3-.19.83.84a4.7,4.7,0,0,0,.69-2.43A4.77,4.77,0,0,0,15.1,7.72l-.8.79a3.65,3.65,0,0,1,1,2.56A3.5,3.5,0,0,1,15,12.66ZM12,5.28V9.66l1.13,1.13V3.18l-4.55,3L9.37,7Z"
			},
			children: [
			]
		}
	]
},
	"speaker-phone": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.1,7.4c1.8,1.8,1.8,4.8,0,6.6l-0.8-0.8c1.4-1.4,1.4-3.7,0-5.1L15.1,7.4z M17.4,5.1l-0.8,0.8c2.7,2.7,2.7,7,0,9.7l0.8,0.8\n\tC20.5,13.3,20.5,8.2,17.4,5.1z M6.3,7.4l6.8-4.5v15.7l-6.8-4.5H1.8V7.4H6.3z M6.3,13.1V8.6H3v4.5H6.3z M12,5L7.5,8v5.5l4.5,3V5z"
			},
			children: [
			]
		}
	]
},
	"speed-monitoring": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.7,13.9c0-4.9-4-8.9-8.9-8.9s-8.9,4-8.9,8.9v0.6h17.8V13.9z M9.3,13.3c0-0.9,0.7-1.5,1.6-1.5c0.8,0,1.5,0.7,1.5,1.5H9.3z\n\t M13.5,13.3c0-0.3-0.1-0.5-0.2-0.8l3.2-2.1l-0.6-0.9l-3.2,2.1c-1-1.1-2.7-1.1-3.8-0.1c-0.5,0.5-0.8,1.2-0.8,1.9H3\n\tc0.3-4.3,4-7.5,8.3-7.2c3.9,0.3,6.9,3.4,7.2,7.2L13.5,13.3z M19.8,15.5v1.1h-18v-1.1H19.8z"
			},
			children: [
			]
		}
	]
},
	speed: speed,
	"sports-bike": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9,6.7H5.2V5.5H9V6.7z M19.8,13.6c0,2.2-1.8,4-4,4s-4-1.8-4-4c0-1.6,0.9-3,2.3-3.6l-0.6-2L9.9,8.9l1.4,4.2v1.1H9.7\n\tc-0.3,2.2-2.3,3.7-4.5,3.4C3,17.2,1.5,15.2,1.8,13s2.3-3.7,4.5-3.4c1.8,0.2,3.1,1.6,3.4,3.4h0.4L8.4,8.1l4.7-1.2L12.5,5L16.3,4\n\tl0.3,1.1l-2.6,0.7l1.2,3.9c0.2,0,0.4-0.1,0.6-0.1C18,9.6,19.8,11.4,19.8,13.6z M5.2,14.1V13h3.4c-0.3-1.6-1.8-2.6-3.4-2.3\n\tc-1.6,0.3-2.6,1.8-2.3,3.4s1.8,2.6,3.4,2.3c1.1-0.2,2-1.1,2.3-2.3H5.2z M18.7,13.6c0-1.6-1.3-2.9-2.9-2.9c-0.1,0-0.2,0-0.3,0\n\tl0.9,2.8l-1.1,0.3l-0.9-2.8c-1.4,0.7-1.9,2.5-1.2,3.9s2.5,1.9,3.9,1.2C18.1,15.6,18.7,14.6,18.7,13.6z"
			},
			children: [
			]
		}
	]
},
	"sports-skis": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M7.8,2.5C8.4,3.2,8.7,4,8.7,4.9v3.7C8.2,8.4,7.7,8.6,7.5,9l-1.4,1.8L3.1,10l0,0.7C3.1,12,3,13.4,3,13.7l-0.2,0.6l5.5,1.2\n\tl0.1,0c0.1,0,0.2,0,0.4-0.1v4.5h1.1V4.9c0-1.1-0.4-2.2-1.1-3.1L7.8,2.5z M8.3,14.3l-4.1-0.9c0-0.4,0-1,0.1-1.9L6.5,12l1.8-2.3\n\tL8.3,14.3z M18.6,13.7c0-0.3-0.1-1.7-0.1-2.9l0-0.7l-3,0.7l-1.4-1.7c-0.2-0.3-0.5-0.6-0.9-0.6c-0.1,0-0.2,0-0.3,0.1V4.9\n\tc0-0.9,0.3-1.7,0.8-2.4l-0.9-0.7c-0.7,0.9-1.1,2-1.1,3.1v14.9h1.1v-4.5c0.1,0,0.2,0.1,0.4,0.1l0.1,0l5.5-1.2L18.6,13.7z M13.3,14.3\n\tl0-4.5l1.8,2.3l2.3-0.5c0,1,0,1.6,0.1,1.9L13.3,14.3z"
			},
			children: [
			]
		}
	]
},
	"sports-soccer": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,1.8c-5,0-9,4-9,9s4,9,9,9s9-4,9-9l0,0C19.8,5.8,15.8,1.8,10.8,1.8z M17.6,6.8c0.6,1,0.9,2.1,1.1,3.2l-1.2-1.4\n\tL17.6,6.8z M16.6,5.5l-0.3,3l-1.7,0.9l-3.3-2.4V4.7L14,3.6C15,4,15.9,4.7,16.6,5.5z M13.9,10.1l-1.2,3.7H8.9l-1.2-3.7l3.1-2.3\n\tL13.9,10.1z M12.5,3.1L12.5,3.1l-1.7,0.7L9.1,3.1C10.2,2.8,11.4,2.8,12.5,3.1z M7.6,3.6l2.7,1.1v2.2L7,9.3L5.2,8.4L5,5.5\n\tC5.7,4.7,6.6,4,7.6,3.6L7.6,3.6z M4,6.8l0.2,1.9L2.9,10C3,8.9,3.4,7.8,4,6.8z M3.9,14.7c-0.5-0.9-0.9-2-1-3l1.9-2.2l1.7,0.9l1.3,3.9\n\tl-1,1.1L3.9,14.7z M4.9,16l1.8,0.4l1,1.6C6.6,17.6,5.6,16.9,4.9,16z M12.4,18.6c-1,0.2-2.1,0.2-3.2,0l0,0L7.7,16l1-1.1h4.2l1,1.1\n\tL12.4,18.6z M14,18L14,18l1-1.6l1.8-0.4C16,16.9,15,17.6,14,18z M17.7,14.7l-2.9,0.7l-1-1.1l1.2-3.8l1.8-1l1.9,2.2\n\tC18.5,12.7,18.2,13.8,17.7,14.7L17.7,14.7z"
			},
			children: [
			]
		}
	]
},
	"sports-tennis": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		"enable-background": "new 0 0 21.6 21.6",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.556,3.11979c-0.86059-0.82916-2.01843-1.27745-3.213-1.244c-1.98462,0.07304-3.86198,0.91931-5.231,2.358\n\tc-1.50465,1.42272-2.35561,3.40323-2.352,5.474c0.071,1.618-0.411,3.153-2.1,3.74l-3.86,3.859l2.586,2.413l3.86-3.86\n\tc0.534-1.438,1.916-1.951,3.42-1.951c0.1,0,0.201,0.002,0.303,0.007c0.081,0.004,0.162,0.005,0.244,0.005\n\tc1.98432-0.07307,3.86136-0.91935,5.23-2.358C20.082,8.92479,20.58,5.14379,18.556,3.11979z M7.29,15.22479l-2.931,2.931\n\tl-0.94-0.877l2.866-2.866c0.49691-0.20495,0.94802-0.50682,1.327-0.888l0.51,0.51C7.77158,14.37499,7.48921,14.77886,7.29,15.22479z\n\t M16.647,10.76779c-1.16192,1.22204-2.75063,1.94851-4.435,2.028c-0.065,0-0.13-0.001-0.194-0.004\n\tc-0.118-0.005-0.235-0.008-0.352-0.008c-0.90815-0.02153-1.80795,0.17785-2.622,0.581l-0.744-0.744\n\tc0.46029-0.91627,0.66252-1.94055,0.585-2.963c0.01209-1.7547,0.7429-3.42775,2.022-4.629\n\tc1.16218-1.22224,2.75128-1.94873,4.436-2.028c0.89521-0.0292,1.76511,0.29975,2.417,0.914\n\tC19.343,5.49779,18.843,8.57179,16.647,10.76779z"
			},
			children: [
			]
		}
	]
},
	"stadium-flag": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.86342,7.30494c-.07569.10224-.7284.92981-2.74976.92981-2,0-3.626-1.43475-5.19995-2.82605-1.966-1.87817-3.73859-2.94329-6.15454-2.02862V1.8h-1.125v18h1.125V12.24348c1.22961-2.94116,4.63092-1.87012,6.45025-.87823,3.72126,2.04913,8.231,1.81976,8.75641-3.69568Zm-.5467,2.27051c-1.07367,2.93323-4.98425,1.71607-6.60754.7818-1.51141-.85547-5.17462-2.09387-6.95-.0434V4.58064a5.10509,5.10509,0,0,1,2.03277-.4035c1.01874,0,2.15271.99762,3.37665,2.07446,2.14209,2.131,5.39929,4.07605,8.41358,2.62805A6.09735,6.09735,0,0,1,17.31672,9.57545Z"
			},
			children: [
			]
		}
	]
},
	stadium: stadium,
	stakeholder: stakeholder,
	star: star,
	"start-trip": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 38 38"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m19,3C10.16333,3,3,10.16345,3,19s7.16333,16,16,16,16-7.16345,16-16S27.83643,3,19,3Zm0,30c-7.71973,0-14-6.2804-14-14s6.28027-14,14-14,14,6.2804,14,14-6.28027,14-14,14Zm0-24c-5.52295,0-10,4.47717-10,10s4.47705,10,10,10,10-4.47717,10-10-4.47729-10-10-10Zm0,18c-4.41113,0-8-3.58881-8-8s3.58887-8,8-8,8,3.58881,8,8-3.58887,8-8,8Zm0-12c-2.20923,0-4,1.79083-4,4s1.79077,4,4,4c2.20898,0,4-1.79089,4-4s-1.79102-4-4-4Zm0,6c-1.10278,0-2-.89722-2-2s.89722-2,2-2,2,.89722,2,2-.89722,2-2,2Z"
			},
			children: [
			]
		}
	]
},
	steps: steps,
	"stock-together": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M7.64924,6.9764299c1.1045699,0,2.0000005-0.8954306,2.0000005-2s-0.8954306-2-2.0000005-2s-2,0.8954306-2,2\n\tS6.5446706,6.9764299,7.64924,6.9764299z M7.64924,4.1014299c0.4832492,0,0.8750005,0.3917508,0.8750005,0.875\n\ts-0.3917513,0.875-0.8750005,0.875s-0.875-0.3917508-0.875-0.875C6.7747912,4.4934092,7.1662192,4.1019812,7.64924,4.1014299z\n\t M12.7046003,7.9874802c1.1045694,0,2-0.8954306,2-2s-0.8954306-2-2-2s-2,0.8954306-2,2S11.6000309,7.9874802,12.7046003,7.9874802z\n\t M12.7046003,5.1124802c0.4832487,0,0.875,0.3917508,0.875,0.875s-0.3917513,0.875-0.875,0.875s-0.875-0.3917508-0.875-0.875l0,0\n\tC11.8301516,5.5044594,12.2215796,5.1130314,12.7046003,5.1124802z M5.6842799,10.6808395\n\tC5.6818833,9.5955534,6.5597391,8.7138119,7.6450257,8.7114153s1.9670281,0.8754587,1.9694247,1.9607458\n\tc0.0000067,0.0028925,0.0000067,0.0057859,0,0.0086784v2.5457096l1.0611601,1.0353403h0.0638399v-2.5703096\n\tc-0.0019875-1.0831718,0.874485-1.9628677,1.9576578-1.9648561c0.8629875-0.0015841,1.6256056,0.5611191,1.8786516,1.3861761\n\tl0.8612003-0.84027c-0.7748766-1.5105362-2.6275692-2.1069059-4.1381054-1.3320293\n\tc-0.2925215,0.1500578-0.5590763,0.3460712-0.789505,0.5805693C9.8704576,7.9402099,8.0709124,7.1765127,6.4899526,7.8154044\n\tc-1.167789,0.4719224-1.9318371,1.6058955-1.9306726,2.8654351v3.5504103l1.125-1.0983305V10.6808395z M15.7399998,8.5430002v1.125\n\th1.9659996l-6.697999,6.5349989L7.5970001,12.875l-3.848,3.757l-1.595,1.5939999l0.7949998,0.7950001l4.6480002-4.5740004\n\tl3.4110003,3.3289995l7.4779997-7.296999v1.9169998h1.125V8.5430002H15.7399998z"
			},
			children: [
			]
		}
	]
},
	"stop-alternate": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,1.8v18h18V1.8ZM18.6,18.6H2.9V2.9H18.6Z"
			},
			children: [
			]
		}
	]
},
	stop: stop,
	"support-drawer": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,1.8c-5,0-9,4-9,9c0,1.7,0.5,3.4,1.4,4.8l-1.1,4.1l4-1.2c4.2,2.6,9.8,1.3,12.4-2.9s1.3-9.8-2.9-12.4\n\tC14.1,2.3,12.5,1.8,10.8,1.8z M10.8,18.7c-1.6,0-3.2-0.5-4.6-1.4c-0.1,0-2.7,0.8-2.5,0.8c0-0.1,0.7-2.4,0.7-2.6\n\tc-1-1.3-1.5-3-1.5-4.6c0-4.3,3.5-7.9,7.9-7.9s7.9,3.5,7.9,7.9S15.1,18.7,10.8,18.7L10.8,18.7z M11.9,14.8c0,0.6-0.5,1-1,1\n\tc-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1C11.4,13.8,11.9,14.2,11.9,14.8L11.9,14.8z M13.6,8.6c0,1.1-0.4,1.4-1,2c-0.7,0.6-1,1-1,2h-1.3\n\tc0-0.7,0.1-1.4,0.5-2c0.6-0.7,1.4-0.9,1.4-1.9c0-0.8-0.6-1.3-1.2-1.3c-1,0-1.4,0.7-1.4,1.8H8.2c0-1.8,1.2-2.9,2.8-2.9\n\tC12.5,6.3,13.6,7.2,13.6,8.6z"
			},
			children: [
			]
		}
	]
},
	support: support,
	survey: survey,
	"swipe-left": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M4.63944,7.59712,1.8,4.75767,4.63944,1.91823l.85362.85257L4.10947,4.15438H8.936V5.361H4.10947L5.49306,6.74455Zm10.58194,12.0438C18.68088,19.23873,19.8,15.80961,19.8,14.21131V11.91546a2.27589,2.27589,0,0,0-2.27019-2.27281l-2.984-.0021L13.90064,4.7671a1.50535,1.50535,0,0,0-2.9976.19795l-.00419,8.18946c-.00209.14139-.044.1393-.22833.11521l-.76144-.76145a2.7699,2.7699,0,0,0-3.82922,0l-.42628.42629,5.11278,5.11225a5.21057,5.21057,0,0,0,3.79256,1.635A5.44,5.44,0,0,0,15.22138,19.64092ZM9.056,13.36084l.77925.77925a1.35054,1.35054,0,0,0,.91436.36239,1.32117,1.32117,0,0,0,.9704-.37391,1.42021,1.42021,0,0,0,.38543-.97825l.00419-8.18527c0-.31316.55249-.35087.59491-.03875l.78344,5.92083,4.04079.0021a1.06754,1.06754,0,0,1,1.06466,1.06623v2.29585c0,.80753-.596,3.89206-3.516,4.23141a4.018,4.018,0,0,1-3.44745-1.238L7.44879,13.02358A1.52947,1.52947,0,0,1,9.056,13.36084Z"
			},
			children: [
			]
		}
	]
},
	"swipe-right": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.54,4.68,16.66,7.55l-.86-.86,1.4-1.4H12.31V4.07H17.2L15.8,2.66l.86-.86Zm-3.15,7.25v2.33c0,1.62-1.13,5.09-4.63,5.5a5.17,5.17,0,0,1-.68,0,5.25,5.25,0,0,1-3.84-1.66L2.06,13l.43-.43a2.8,2.8,0,0,1,3.88,0l.77.77c.19,0,.23,0,.24-.11V4.89a1.53,1.53,0,0,1,3-.2l.65,4.94h3A2.3,2.3,0,0,1,16.39,11.93Zm-1.22,0a1.08,1.08,0,0,0-1.08-1.08H10l-.79-6c-.05-.32-.61-.28-.61,0v8.29a1.47,1.47,0,0,1-.39,1,1.4,1.4,0,0,1-1.91,0l-.79-.79a1.57,1.57,0,0,0-1.63-.34l4.24,4.24a4,4,0,0,0,3.49,1.25c3-.34,3.56-3.47,3.56-4.28Z"
			},
			children: [
			]
		}
	]
},
	swipe: swipe,
	"switch": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,7.7l-4.6,4.6-.8-.8,3.3-3.2H8.5V7.2h9.2L14.4,3.9l.8-.8ZM7.2,10.1l-.8-.8L1.8,13.9l4.6,4.6.8-.8L3.9,14.4h9.2V13.3H3.9Z"
			},
			children: [
			]
		}
	]
},
	sync: sync,
	"tablet-data": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M6.39,12.71l-2-2L5.21,10l1.18,1.19L8.86,8.67l.79.79Zm7.5-5.35h-3V8.48h3Zm0,2.88h-3v1.12h3Zm0,2.88h-3v1.12h3ZM19.8,4.05v13.5H1.8V4.05ZM15.86,5.18H2.93V16.43H15.86Zm2.82,0H17v4.5h1.12v2.25H17v4.5h1.69Z"
			},
			children: [
			]
		}
	]
},
	"tablet-wireless": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.4,11.1l-0.5,0.5c-0.8-0.8-2.1-0.8-3,0l-0.5-0.5C8.5,10,10.3,10,11.4,11.1z M8.4,12.1l0.5,0.5c0.3-0.3,0.7-0.3,1,0\n\tl0.5-0.5l0,0C9.9,11.5,8.9,11.5,8.4,12.1L8.4,12.1z M19.8,4.1v13.5h-18V4.1H19.8z M15.9,5.2h-13v11.2h12.9V5.2H15.9z M18.7,5.2H17\n\tv4.5h1.1v2.2H17v4.5h1.7V5.2z M7,10.7c1.3-1.3,3.5-1.3,4.9,0l0,0l0.5-0.5l0,0c-1.6-1.6-4.3-1.6-5.9,0L7,10.7L7,10.7z"
			},
			children: [
			]
		}
	]
},
	tablet: tablet,
	tag: tag,
	talking: talking,
	"target-goal": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.65,10.26A6.87,6.87,0,0,0,11.36,3.9V1.8H10.27V3.9A6.87,6.87,0,0,0,4,10.26H1.8v1.08H4a6.88,6.88,0,0,0,6.29,6.24V19.8h1.09V17.58a6.88,6.88,0,0,0,6.29-6.24H19.8V10.26ZM10.27,5V6.8a4,4,0,0,0-3.4,3.46H5.06A5.78,5.78,0,0,1,10.27,5Zm0,11.5a5.78,5.78,0,0,1-5.2-5.15H6.88a4,4,0,0,0,3.39,3.34Zm0-4.36V13.6A2.91,2.91,0,0,1,8,11.34h1.5V10.26H8a2.93,2.93,0,0,1,2.32-2.38V9.47h1.09V7.88a2.92,2.92,0,0,1,2.32,2.38H12.13v1.08h1.53a2.91,2.91,0,0,1-2.3,2.26V12.13Zm1.09,4.36V14.68a4,4,0,0,0,3.39-3.34h1.81A5.78,5.78,0,0,1,11.36,16.49Zm3.4-6.23a4,4,0,0,0-3.4-3.46V5a5.78,5.78,0,0,1,5.21,5.27Z"
			},
			children: [
			]
		}
	]
},
	taxes: taxes,
	"team-leader": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.906,10.428A1.99649,1.99649,0,1,0,8.91,8.432,1.9958,1.9958,0,0,0,10.906,10.428Zm0-2.868a.87149.87149,0,1,1-.871.872A.8719.8719,0,0,1,10.906,7.56ZM7.194,12.426v1.838H14.619V12.426a5.49162,5.49162,0,0,0-7.425,0Zm6.299.714H8.319v-.18a4.34538,4.34538,0,0,1,5.174,0ZM18.68,10.8a7.84874,7.84874,0,0,0-.389-2.435,1.68031,1.68031,0,0,0-1.648-2.829,7.84937,7.84937,0,0,0-4.202-2.427,1.68331,1.68331,0,0,0-3.283.003A7.84355,7.84355,0,0,0,4.964,5.539,1.668,1.668,0,0,0,3.006,6.3a1.68575,1.68575,0,0,0,.311,2.074,7.79687,7.79687,0,0,0,0,4.852A1.68586,1.68586,0,0,0,3.006,15.3a1.66826,1.66826,0,0,0,1.958.761,7.84393,7.84393,0,0,0,4.194,2.427,1.68331,1.68331,0,0,0,3.283.003,7.84327,7.84327,0,0,0,4.202-2.427,1.68031,1.68031,0,0,0,1.648-2.829A7.87978,7.87978,0,0,0,18.68,10.8ZM10.8,2.925a.5625.5625,0,1,1-.562.563A.56251.56251,0,0,1,10.8,2.925ZM3.98,6.862a.56226.56226,0,1,1,.206.768A.56068.56068,0,0,1,3.98,6.862Zm.768,8.082a.56226.56226,0,1,1,.206-.768A.56227.56227,0,0,1,4.748,14.944ZM10.8,18.675a.5625.5625,0,1,1,.562-.563A.56251.56251,0,0,1,10.8,18.675Zm4.936-3.282a6.74116,6.74116,0,0,1-3.427,1.978,1.6765,1.6765,0,0,0-3.017-.002,6.73621,6.73621,0,0,1-3.425-1.983,1.68159,1.68159,0,0,0,.061-1.773,1.65492,1.65492,0,0,0-1.571-.83,6.6612,6.6612,0,0,1,0-3.966,1.655,1.655,0,0,0,1.571-.83,1.67936,1.67936,0,0,0-.06-1.773A6.7401,6.7401,0,0,1,9.293,4.231,1.6757,1.6757,0,0,0,12.309,4.229a6.73385,6.73385,0,0,1,3.427,1.978,1.6834,1.6834,0,0,0-.065,1.78,1.65522,1.65522,0,0,0,1.58106.829,6.64767,6.64767,0,0,1,0,3.968,1.65441,1.65441,0,0,0-1.58106.829A1.6834,1.6834,0,0,0,15.736,15.393Zm1.884-.655a.56226.56226,0,1,1-.206-.768A.56051.56051,0,0,1,17.62,14.738ZM17.414,7.63a.56226.56226,0,1,1,.206-.768A.56027.56027,0,0,1,17.414,7.63Z"
			},
			children: [
			]
		}
	]
},
	"tech-laptop": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.8,12.18V3.3H3.8v8.88l-2,6.12h18ZM4.93,4.43H16.68v7.75H4.93ZM4.61,13.3H17l1.25,3.88H3.36Zm8.89,1.77.3,1.23h-6l.44-1.23Z"
			},
			children: [
			]
		}
	]
},
	technology: technology,
	"telematics-car": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12.15,4.31a1.9,1.9,0,0,0-2.7,0L9,3.82H9a2.62,2.62,0,0,1,3.7,0Zm-2.31.4.49.49a.68.68,0,0,1,.94,0l.49-.49A1.38,1.38,0,0,0,9.84,4.71Zm1-2.21A3.14,3.14,0,0,1,13,3.43l.49-.5a3.86,3.86,0,0,0-5.46,0l.49.5A3.14,3.14,0,0,1,10.8,2.5ZM6.36,11.81a.89.89,0,1,0,.89.89h0A.89.89,0,0,0,6.36,11.81Zm8.88,0a.89.89,0,1,0,.89.89.89.89,0,0,0-.89-.89Zm3.55,0a.89.89,0,0,1-.89.89h0l0,.17V19.8H14.35V17.72H7.25V19.8H3.7V12.87l0-.17h0a.89.89,0,1,1,0-1.78h.44L5,7.3A2.25,2.25,0,0,1,7.17,5.59h7.26A2.25,2.25,0,0,1,16.65,7.3l.81,3.62h.44A.89.89,0,0,1,18.79,11.81ZM6.25,17.72H4.7V18.8H6.25V17.72Zm10.65,0H15.35V18.8H16.9Zm0-4.74L15.67,7.52a1.26,1.26,0,0,0-1.24-.93H7.17a1.26,1.26,0,0,0-1.24.93L4.7,13v3.74H16.9Z"
			},
			children: [
			]
		}
	]
},
	teletype: teletype,
	temperature: temperature,
	template: template,
	"text-to-speech": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,8.54323H2.89048v4.512H1.8Zm2.82449,7.48352H5.715V5.57325H4.62449ZM7.437,14.56126H8.52748V7.04918H7.437Zm8.46-.41556H16.9875V7.45421H15.897Zm2.8125-5.46743v4.24191H19.8V8.67827Zm-8.448,4.992H11.352v-5.748H10.26149Zm2.8125,1.58844h1.09048V6.3412H13.074Z"
			},
			children: [
			]
		}
	]
},
	theme: theme,
	"thermostat-tech": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,1.8a9,9,0,1,0,9,9A8.99943,8.99943,0,0,0,10.8,1.8Zm0,16.875A7.875,7.875,0,1,1,18.675,10.8,7.88432,7.88432,0,0,1,10.8,18.675ZM14.544,5.919l-.631.839A5.0707,5.0707,0,0,0,10.8,5.676a5.12367,5.12367,0,0,0-3.623,8.747l.001.001-.744.74395-.001-.001a6.16146,6.16146,0,0,1,8.111-9.248Zm2.432,4.881a6.15735,6.15735,0,0,1-1.823,4.379l-.746-.746a5.06783,5.06783,0,0,0,.359-6.838l.808-.668A6.11679,6.11679,0,0,1,16.97605,10.8ZM7.95371,8.95214h2.58838v.63624A4.30762,4.30762,0,0,0,9.30674,12.46H8.43418A4.17978,4.17978,0,0,1,9.73106,9.63574c-.36432.00641-1.32373.02948-1.77735.019ZM13.776,11.77148V12.46H11.07383a1.34716,1.34716,0,0,1,.37256-.97608c.36334-.509,1.468-.85687,1.4859-1.457a.43374.43374,0,0,0-.45807-.47613c-.38214-.00354-.56128.27972-.55664.66015h-.78711a1.434,1.434,0,0,1,.22168-.82519c.56506-.89063,2.52112-.567,2.42377.61774.05456.884-1.13068,1.25878-1.585,1.75433C12.1627,11.79449,13.77665,11.76,13.776,11.77148Z"
			},
			children: [
			]
		}
	]
},
	"thumbs-down": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.06,1.8H12.75V2.9H4.59a2.05,2.05,0,0,0-2,2v6.54a2,2,0,0,0,2.05,2h5.56V18a1.85,1.85,0,0,0,2.64,1.67A1.81,1.81,0,0,0,13.86,18V13.21h5.2V1.8ZM12.75,18a.72.72,0,0,1-.43.66A.75.75,0,0,1,11.26,18V12.41H4.59a.94.94,0,0,1-.94-.93v-.31H7.06V10.06H3.65V8.68H7.06V7.57H3.65V6.37H7.06V5.26H3.65V4.94A.94.94,0,0,1,4.59,4h8.16ZM18,12.1H13.86V2.91H18Z"
			},
			children: [
			]
		}
	]
},
	"thumbs-up": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "e978f97b-2168-4969-ae69-0310e5181b40",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17,8.09H11.44V3.64a1.84,1.84,0,0,0-3.68,0V8.39H2.61V19.8H8.87V18.7H17a2,2,0,0,0,2-2V10.12A2,2,0,0,0,17,8.09ZM7.76,18.7h-4V9.49h4ZM17,17.59H8.87V3.64A.73.73,0,0,1,9.3,3a.74.74,0,0,1,1,.67V9.19H17a.93.93,0,0,1,.92.93v.31H14.51v1.11h3.37v1.38H14.51V14h3.37v1.21H14.51v1.11h3.37v.32A.91.91,0,0,1,17,17.59Z"
			},
			children: [
			]
		}
	]
},
	ticket: ticket,
	tiles: tiles,
	tilt: tilt,
	timer: timer,
	tools: tools,
	"top-box": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.31,11.12V8.42H15.2v2.7H1.8v6.75h18V11.12Zm2.37,5.64H2.92V12.24H18.68Zm-3.6-2.26a.68.68,0,1,1,.68.67A.67.67,0,0,1,15.08,14.5Zm-4.7.56H4.58V13.94h5.8Zm6.86-8.64a2.09,2.09,0,0,0-3,0l-.51-.51h0a2.81,2.81,0,0,1,4,0l-.51.51Zm-2.51.45a1.45,1.45,0,0,1,2.06,0l-.51.51a.75.75,0,0,0-1,0l-.51-.51ZM13.32,5.46,12.81,5h0a4.17,4.17,0,0,1,5.9,0l-.51.51a3.45,3.45,0,0,0-2.44-1A3.42,3.42,0,0,0,13.32,5.46Z"
			},
			children: [
			]
		}
	]
},
	"total-mobile-protection": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M5.21,1.8v18H16.39V1.8Zm4,1.06,2.12,3.45L9.27,9l2.93,3.35h0L10.58,9l2-2.63L10.4,2.86h4.93V15.75H6.27V2.86ZM6.27,18.74V16.81h3.4v1.3l2.26,0,0-1.27h3.41v1.93Z"
			},
			children: [
			]
		}
	]
},
	"trading-deck": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,3.4H1.7v11h2.8L3.6,18h1.2l0.9-3.6h10.1l0.9,3.6h1.2L17,14.5h2.8V3.4z M18.6,13.4H2.9V4.6h15.8L18.6,13.4z M9,5.7\n\tL4.3,9.1L9,12.5V5.7z M7.9,10.3L6.2,9.1l1.7-1.2L7.9,10.3z M17.4,9.1l-4.7-3.4l0.1,6.8L17.4,9.1z M15.5,9.1l-1.6,1.2V7.9L15.5,9.1z"
			},
			children: [
			]
		}
	]
},
	"traffic-light": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.8,8.22A2.15,2.15,0,1,0,8.66,6.08h0A2.15,2.15,0,0,0,10.8,8.22ZM9.65,6.08A1.15,1.15,0,1,1,10.8,7.23,1.16,1.16,0,0,1,9.65,6.08ZM10.8,17.67a2.15,2.15,0,1,0-2.14-2.15h0A2.15,2.15,0,0,0,10.8,17.67ZM9.65,15.52a1.15,1.15,0,1,1,1.15,1.16,1.15,1.15,0,0,1-1.15-1.16Zm1.15-2.58A2.14,2.14,0,1,0,8.66,10.8h0A2.14,2.14,0,0,0,10.8,12.94ZM9.65,10.8A1.15,1.15,0,1,1,10.8,12,1.14,1.14,0,0,1,9.65,10.8Zm7.5-2H15.74V6.52A2.78,2.78,0,0,0,17.15,4.1H15.74V1.8H5.86V4.1H4.45A2.78,2.78,0,0,0,5.86,6.52V8.79H4.45a2.81,2.81,0,0,0,1.41,2.43v2.3H4.45a2.79,2.79,0,0,0,1.41,2.42V19.8h9.88V15.94a2.79,2.79,0,0,0,1.41-2.42H15.74v-2.3A2.81,2.81,0,0,0,17.15,8.79Zm-2.52,9.89H7V2.92h7.66Z"
			},
			children: [
			]
		}
	]
},
	traffic: traffic,
	transportation: transportation,
	trash: trash,
	"travel-keys": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M5.8,10.8c0,0.6-0.4,1-1,1s-1-0.4-1-1s0.4-1,1-1S5.8,10.2,5.8,10.8z M19.8,10.8l-2,2h-1l-1-0.7l-1,0.7l-1-0.7l-1,0.7h-2.5\n\tc-1.1,2.2-3.8,3.1-6,2s-3.1-3.8-2-6s3.8-3.1,6-2c0.9,0.4,1.6,1.1,2,2h7.5L19.8,10.8z M18.2,10.8l-0.9-0.9H9.6L9.3,9.3\n\tC8.5,7.6,6.5,6.9,4.8,7.8s-2.4,2.9-1.5,4.5s2.9,2.4,4.5,1.5C8.5,13.5,9,13,9.3,12.3l0.3-0.6h2.9l1.3-0.9l1,0.7l1-0.7l1.3,0.9h0.3\n\tL18.2,10.8z"
			},
			children: [
			]
		}
	]
},
	"travel-pass": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.13,1.8H3.8v18H15.13a2.68,2.68,0,0,0,2.67-2.67V4.47A2.68,2.68,0,0,0,15.13,1.8Zm1.55,15.33a1.56,1.56,0,0,1-1.55,1.55H4.93V2.93h10.2a1.55,1.55,0,0,1,1.55,1.54ZM10.8,4.2A4.8,4.8,0,1,0,15.6,9,4.8,4.8,0,0,0,10.8,4.2ZM6.89,9.42H8.64a7.61,7.61,0,0,0,.78,3.28A4,4,0,0,1,6.89,9.42Zm1.75-.84H6.89A3.93,3.93,0,0,1,9.42,5.31,7.53,7.53,0,0,0,8.64,8.58ZM10.8,13c-.37,0-1.22-1.25-1.32-3.54h2.64C12,11.71,11.17,13,10.8,13ZM9.48,8.58C9.58,6.29,10.43,5,10.8,5S12,6.29,12.12,8.58Zm2.7,4.12A7.61,7.61,0,0,0,13,9.42h1.75A4,4,0,0,1,12.18,12.7ZM13,8.58a7.53,7.53,0,0,0-.78-3.27,3.93,3.93,0,0,1,2.53,3.27ZM8.2,16h5.2v1.12H8.2Z"
			},
			children: [
			]
		}
	]
},
	"trip-planner": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.86873,15.38374c-.39838.6842-.829,1.07257-1.19373,1.07257-.92993,0-2.29773-2.45434-2.42926-6.1875H9.96119a5.56345,5.56345,0,0,1,.494-1.125H7.24574c.13153-3.73315,1.49933-6.1875,2.42926-6.1875.78088,0,1.86163,1.74475,2.26874,4.51a5.59159,5.59159,0,0,1,1.05615-.63293A9.95618,9.95618,0,0,0,11.741,3.2826,6.7709,6.7709,0,0,1,15.522,6.35365a5.57338,5.57338,0,0,1,1.38593.23914,7.87308,7.87308,0,1,0-4.144,10.35833A5.6149,5.6149,0,0,1,10.86873,15.38374ZM7.609,3.2826A12.02944,12.02944,0,0,0,6.10835,9.14381H2.9535A6.76087,6.76087,0,0,1,7.609,3.2826ZM2.9535,10.26881H6.10835A12.02963,12.02963,0,0,0,7.609,16.13,6.761,6.761,0,0,1,2.9535,10.26881ZM19.812,11.95643a4.5607,4.5607,0,1,0-2.96814,4.2179l1.84089,3.60614,1.002-.51172-1.8363-3.59723A4.49716,4.49716,0,0,0,19.812,11.95643Zm-7.884,0A3.37952,3.37952,0,1,1,15.30751,15.336,3.38335,3.38335,0,0,1,11.928,11.95643Z"
			},
			children: [
			]
		}
	]
},
	trumpet: trumpet,
	"trusted-browser": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 38 38"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m34.98871,3l-31.98871.01294.01135,31.98706,31.98865-.01294-.01129-31.98706Zm-1.99933,2.00079l.0014,4.01093H5.00214l-.0014-3.99957,27.98865-.01135ZM5.01062,32.99921l-.00775-21.98749h27.98865l.00781,21.97614-27.98871.01135Zm1.98938-25.99921c0-.55231.44775-1,1-1,.55231,0,1,.44769,1,1,0,.55225-.44769,1-1,1-.55225,0-1-.44775-1-1Zm4,0c0-.55231.44775-1,1-1,.55231,0,1,.44769,1,1,0,.55225-.44769,1-1,1-.55225,0-1-.44775-1-1Zm4,0c0-.55231.44775-1,1-1,.55231,0,1,.44769,1,1,0,.55225-.44769,1-1,1-.55225,0-1-.44775-1-1Zm11.74072,10.67188l-9.8042,10.80664-5.66943-6.10352,1.46582-1.36133,4.18604,4.50781,8.34033-9.19336,1.48145,1.34375Z"
			},
			children: [
			]
		}
	]
},
	"turn-on-off": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.3,9.7H10.2V1.8h1.1Zm2.9-4.9V6.1A6.77,6.77,0,1,1,4,11.9,6.65,6.65,0,0,1,7.4,6.1V4.8a8,8,0,0,0-4.5,7.1,7.9,7.9,0,1,0,15.8,0A8,8,0,0,0,14.2,4.8Z"
			},
			children: [
			]
		}
	]
},
	"tv-content": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "defs",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					name: "style",
					type: "element",
					value: "",
					attributes: {
					},
					children: [
						{
							name: "",
							type: "text",
							value: ".cls-1{fill:#050706;}",
							attributes: {
							},
							children: [
							]
						}
					]
				}
			]
		},
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				"class": "cls-1",
				d: "M19.8,4.6125H1.8v11.25H7.425l.562,1.125h5.625l.562-1.125H19.8Zm-1.125,10.126H2.925v-9h15.75ZM8.42384,7.00239l.01178,6.54535,5.49408-3.28247Zm1.0035,1.7435,2.5463,1.51036L9.43147,11.77393Z"
			},
			children: [
			]
		}
	]
},
	tv: tv,
	twitter: twitter,
	umbrella: umbrella,
	unification: unification,
	"unified-communications": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6000004 21.6000004",
		style: "enable-background:new 0 0 21.6000004 21.6000004;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.818244,8.8418703c1.3618774-0.0014648,2.5842285-0.8359375,3.081543-2.1037598\n\tc1.6192017,0.9135742,2.7352915,2.5136719,3.0332041,4.3487549l1.1020508-0.1778564\n\tc-0.3695068-2.3005371-1.8221436-4.2833252-3.9042978-5.3292236c0.0004883-0.019165,0.0058594-0.0368652,0.0058594-0.0559692\n\tc0.000061-1.8325808-1.4855347-3.3181765-3.3180542-3.3181765C8.9859686,2.2055786,7.5004344,3.6911743,7.5003734,5.523694\n\tC7.5003734,7.3561525,8.9857855,8.8417482,10.818244,8.8418703z M10.818244,3.3216674v-0.000061\n\tc1.2162476,0,2.2021484,0.9859622,2.2021484,2.2021487c0,1.2162476-0.9859009,2.2021484-2.2021484,2.2021484\n\tc-1.2161865,0-2.2021484-0.9859009-2.2021484-2.2021484C8.6174383,4.3081179,9.6026068,3.3229492,10.818244,3.3216674z\n\t M8.0106268,13.7050295c-0.6782222-1.1953125-2.030334-1.8403931-3.38623-1.6154785l-0.0004883-0.0056152\n\tc-0.0028687-1.8601074,0.8330688-3.6224365,2.2754517-4.7969971L6.19239,6.4226809\n\tc-1.7017822,1.3864746-2.6879885,3.4661865-2.6846926,5.6612549c0,0.1278076,0.0146484,0.2539062,0.0224609,0.3808594\n\tc-0.0170898,0.0095215-0.0351562,0.0158691-0.0522461,0.0257568c-1.5869751,0.9163208-2.1306763,2.9456787-1.2144165,4.5327139\n\tc0.9163208,1.5869751,2.9456789,2.1307373,4.5327148,1.2144165C8.3831854,17.3213615,8.9269476,15.2920656,8.0106268,13.7050295z\n\t M7.2640452,15.9340334c-0.2579346,0.9614859-1.128479,1.6306753-2.1239624,1.6326895\n\tC3.9235909,17.568615,2.93592,16.5839348,2.9340279,15.367444c-0.0018311-1.2164307,0.9827881-2.2041016,2.19928-2.2059937\n\tc0.788208-0.0012207,1.5170288,0.4188843,1.9110718,1.1015625C7.3378367,14.7683229,7.4169383,15.3700075,7.2640452,15.9340334z\n\t M18.158638,12.4905519h-0.000061c-1.5840454-0.9171143-3.6116343-0.3764038-4.5287485,1.2076416\n\tc-0.6834717,1.180542-0.5738525,2.6593008,0.2763062,3.7260733c-1.5997925,0.9499512-3.5458374,1.1170044-5.2841797,0.4537354\n\tl-0.3955078,1.043457c2.1768799,0.8267822,4.6182251,0.55896,6.5640259-0.7200928\n\tc0.0180664,0.0108643,0.0317383,0.0257568,0.050293,0.0362549c1.5870371,0.9161987,3.6162729,0.3724365,4.5324717-1.2145996\n\tS19.7456741,13.4067507,18.158638,12.4905519z M18.406868,16.4647942c-0.000061,0.0001221-0.0001221,0.0002441-0.0002441,0.0003662\n\tc-0.6079712,1.053772-1.9551392,1.4151001-3.0088511,0.8070679c-1.053772-0.6079712-1.4151001-1.9550772-0.8071289-3.0088491\n\tc0.6080322-1.053772,1.9551401-1.4151001,3.0089121-0.8071289c0.0004883,0.0003052,0.0009766,0.0005493,0.0014038,0.0008545\n\tC18.6540604,14.0651369,19.0149002,15.4116945,18.406868,16.4647942z"
			},
			children: [
			]
		}
	]
},
	"unlimited-plan": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Unlimited_plan",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,1.8v18h18v-18H1.8z M18.7,18.7H2.9V2.9h15.8V18.7z M7.5,11.9V6.8h1.9V12c0,0.8,0.4,1.3,1.3,1.3c0.9,0,1.3-0.5,1.3-1.3\n\tV6.8h1.9v5.1c0,1.8-1.1,2.9-3.3,2.9C8.6,14.8,7.5,13.7,7.5,11.9z"
			},
			children: [
			]
		}
	]
},
	"unmanaged-devices": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M8.19624,11.85239l.82739.74987.65869-.72674L10.8,12.86777l1.10919-.976a4.7333,4.7333,0,0,0,1.67462-3.47644V7.57059l.41736-.46051-.82739-.74988Zm2.96979-.80518-.36273.31915-.36548-.32446,1.96356-2.16663A3.7362,3.7362,0,0,1,11.166,11.04721ZM8.35328,10.003a4.98406,4.98406,0,0,1-.33007-1.74841l-.007-1.52253H11.3177l-1.01959,1.125H9.14637l.00184.39234a3.95414,3.95414,0,0,0,.08813.77917ZM5.75929,1.8v18H15.84071V1.8Zm8.95642,16.875H6.88429v-2.0102h2.861v1.09668h2.10938V16.66476h2.861Zm0-14.43793V15.53976H6.88429V2.925h7.83142Z"
			},
			children: [
			]
		}
	]
},
	"up-arrow": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.8,10.88067l-.80985.817-7.61765-7.683V19.8h-1.145V4.01467l-7.61765,7.683L1.8,10.88067,10.8,1.8Z"
			},
			children: [
			]
		}
	]
},
	"up-caret": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "polygon",
			type: "element",
			value: "",
			attributes: {
				points: "18.98 15.71 10.8 7.53 2.62 15.71 1.8 14.89 10.8 5.89 19.8 14.89 18.98 15.71"
			},
			children: [
			]
		}
	]
},
	uplink: uplink,
	upload: upload,
	"url-transparency": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.86274,6.7375v8.125H19.73726V6.7375Zm16.74952,7H2.98774V7.8625H18.61226Zm-13.79-1.42676L4.0019,9.65059h.79981L5.082,10.68574c.01953.08008.03906.167.05664.2627q.02929.14208.05274.2666c.01758.09766.03222.19531.04492.2959H5.246q.03076-.145.05567-.2959c.0166-.08594.03418-.17774.05273-.27441s.03907-.18555.0625-.26465l.27051-1.02539h.66406L6.63179,10.676c.02343.0791.04492.168.06543.26465.01953.09667.03711.18847.05468.27441.01661.10059.03516.20019.05469.30078h.00977c.01367-.09668.02929-.19531.04492-.29492.01758-.084.03516-.17383.05273-.27051.01856-.09668.03907-.18457.0625-.26465l.28516-1.03515h.77539l-.82519,2.66015H6.47163l-.28027-1.085c-.01953-.07715-.03907-.16211-.05957-.25488-.02051-.09375-.03809-.18164-.05567-.26563-.01562-.09668-.0332-.19433-.04883-.29492H6.01655c-.02051.10059-.04.19824-.05957.29492-.01758.084-.03515.17188-.05469.26563-.0205.09277-.041.17773-.06054.25488l-.29,1.085Zm4.334,0L8.33687,9.65059h.7998l.28027,1.03515c.01953.08008.03907.167.05762.2627q.02637.14208.05273.2666c.01563.09766.03125.19531.04493.2959H9.582c.01953-.09668.03809-.19531.05469-.2959.0166-.08594.03418-.17774.05273-.27441a2.52928,2.52928,0,0,1,.0625-.26465l.26954-1.02539h.665l.28028,1.02539c.02344.0791.04492.168.06445.26465.02051.09667.03906.18847.05567.27441.0166.10059.03417.20019.05468.30078h.01074c.0127-.09668.02735-.19531.04493-.29492.01562-.084.0332-.17383.05175-.27051s.04-.18457.0625-.26465l.28516-1.03515H12.371l-.82421,2.66015h-.74024l-.2793-1.085c-.0205-.07715-.041-.16211-.06054-.25488-.01953-.09375-.03906-.18164-.05469-.26563-.01758-.09668-.0332-.19433-.05078-.29492h-.00977c-.01953.10059-.04.19824-.05957.29492-.0166.084-.03515.17188-.05566.26563-.01953.09277-.03906.17773-.05957.25488l-.29,1.085Zm4.33594,0-.82031-2.66015h.7998l.28027,1.03515c.01954.08008.03907.167.05664.2627q.02931.14208.05274.2666c.01758.09766.03223.19531.04492.2959H13.916q.03075-.145.05566-.2959c.0166-.08594.03418-.17774.05274-.27441s.03906-.18555.0625-.26465l.2705-1.02539h.66407l.28027,1.02539c.02344.0791.04492.168.06543.26465.01953.09667.03711.18847.05469.27441.0166.10059.03515.20019.05468.30078h.00977c.01367-.09668.0293-.19531.04492-.29492.01758-.084.03516-.17383.05274-.27051.01855-.09668.03906-.18457.0625-.26465l.28515-1.03515H16.707l-.82519,2.66015h-.74024l-.28027-1.085c-.01953-.07715-.03906-.16211-.05957-.25488-.02051-.09375-.03809-.18164-.05567-.26563-.01562-.09668-.0332-.19433-.04882-.29492h-.01075c-.0205.10059-.04.19824-.05957.29492-.01757.084-.03515.17188-.05468.26563-.02051.09277-.041.17773-.06055.25488l-.29,1.085Zm4.17969,0h-.83008v-.82031h.83008Z"
			},
			children: [
			]
		}
	]
},
	"user-registration": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M8.85,10.7368a4.133,4.133,0,1,0-4.1329-4.133A4.133,4.133,0,0,0,8.85,10.7368Zm0-7.141a3.008,3.008,0,1,1-3.0079,3.008A3.0114,3.0114,0,0,1,8.85,3.5958Zm1.9976,13.79.98,1L2.0629,18.38c0-.1939.0059-.6864.0059-.6864a6.6344,6.6344,0,0,1,6.8184-6.417,6.86,6.86,0,0,1,6.1624,3.69l-.8415.8622a5.6963,5.6963,0,0,0-5.3209-3.4272,5.5359,5.5359,0,0,0-5.6756,4.967Zm3.0708,1.7436-3.2446-3.3125.8037-.7871,2.4351,2.4863,4.81-4.9766.8086.7813Z"
			},
			children: [
			]
		}
	]
},
	"user-settings": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M8.72749,8.42952a3.31452,3.31452,0,1,0-3.314-3.315A3.314,3.314,0,0,0,8.72749,8.42952Zm0-5.504a2.18952,2.18952,0,1,1-2.19,2.189A2.19151,2.19151,0,0,1,8.72749,2.92549Zm.61,11.273a5.56163,5.56163,0,0,0-.076.757c0,.126.029.244.037.368h-7.421v-3.282a9.87033,9.87033,0,0,1,6.629-2.58,9.70927,9.70927,0,0,1,3.527.664,5.64283,5.64283,0,0,0-1.093.821,8.57931,8.57931,0,0,0-2.434-.361,8.755,8.755,0,0,0-5.504,1.974v1.639Zm10.385-.004-.873-2.108-1.278.191.191-1.278-2.107-.872-.77,1.037-.768-1.037-2.108.872.191,1.278-1.277-.191-.873,2.108,1.038.768-1.038.769.873,2.108,1.277-.19-.191,1.277,2.108.873.769-1.038.769,1.038,2.107-.873-.191-1.278,1.278.191.873-2.108-1.038-.768Zm-2.193.553a2.65716,2.65716,0,0,1,.001.428l-.026.313.843.624-.201.484-1.037-.154-.202.238a2.59949,2.59949,0,0,1-.302.301l-.24.203.155,1.039-.483.201-.626-.844-.313.027a2.33164,2.33164,0,0,1-.426,0l-.311-.025-.624.842-.484-.201.154-1.036-.237-.203a2.74653,2.74653,0,0,1-.305-.305l-.202-.237-1.036.154-.201-.484.843-.625-.025-.312a2.53922,2.53922,0,0,1-.001-.427l.026-.311-.84295-.625.201-.484,1.037.154.202-.238a2.69113,2.69113,0,0,1,.303-.302l.239-.202-.155-1.038.484-.2.626.843.311-.025a2.79627,2.79627,0,0,1,.429-.001l.31.024.624-.84.484.2-.154,1.036.237.203a2.63338,2.63338,0,0,1,.303.304l.202.239,1.038-.155.20105.484-.842.624Zm-2.644-1.639a1.854,1.854,0,1,0,1.854,1.854A1.85394,1.85394,0,0,0,14.88551,13.10847Zm0,2.584a.729.729,0,1,1,.729-.729A.72979.72979,0,0,1,14.88551,15.69252Z"
			},
			children: [
			]
		}
	]
},
	user: user,
	"utility-grid-management": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.89,9.16V8a2.25,2.25,0,0,1,2.25,2.25H12A1.13,1.13,0,0,0,10.89,9.16Zm3.24,1.14h1.12a4.36,4.36,0,0,0-4.36-4.36V7.06A3.24,3.24,0,0,1,14.13,10.3Zm2.09,0h1.12a6.45,6.45,0,0,0-6.45-6.45V5A5.33,5.33,0,0,1,16.22,10.29Zm-11-5.43H4.1V5.94H5.22Zm2.13,0H6.23V5.94H7.35ZM5.22,7H4.1V8.06H5.22ZM7.35,7H6.23V8.06H7.35ZM5.22,9.1H4.1v1.08H5.22Zm2.13,0H6.23v1.08H7.35ZM5.22,11.22H4.1V12.3H5.22Zm2.13,0H6.23V12.3H7.35ZM5.22,13.34H4.1v1.08H5.22Zm2.13,0H6.23v1.08H7.35ZM5.22,15.46H4.1v1.08H5.22Zm2.13,0H6.23v1.08H7.35Zm12.44.6h-1.6l-.31-.3V19.3H1.81V2.3H9.63V18.17h2V15.78l-.29.28H9.77l5-5ZM8.51,3.42H2.94V18.17H8.51Zm8.25,11.2-2-2-2,2v3.52h4Z"
			},
			children: [
			]
		}
	]
},
	vibration: vibration,
	"video-on-tablet": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8,4.05v13.5h18V4.05ZM15.86,16.43H2.93V5.18H15.86Zm2.82,0H17v-4.5h1.12V9.68H17V5.18h1.69ZM7.27,7.34v6.92l6-3.46ZM8.36,9.23l2.72,1.57L8.36,12.37Z"
			},
			children: [
			]
		}
	]
},
	video: video,
	"virtual-reality": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_2",
		"data-name": "Layer 2",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12.812,15.29918c-1.03821,1.752-2.72145,1.752-3.75966,0Zm5.863-6.79892v3.47448A2.20029,2.20029,0,0,1,16.47474,14.175h-.43219l-.18438,1.15973a5.09753,5.09753,0,0,1-10.11634,0l-.145-1.15973H5.12526A2.20029,2.20029,0,0,1,2.925,11.97474V8.50026A2.19532,2.19532,0,0,1,5.02571,6.31,5.956,5.956,0,0,1,10.8,1.8c.10284,0,.205,1.46362.3064,1.46869A5.94924,5.94924,0,0,1,15.99153,6.3h.48321A2.20029,2.20029,0,0,1,18.675,8.50026ZM6.06111,6.3h8.71972c-.06408-.0871-.1109-.18274-.18115-.26648a4.968,4.968,0,0,0-3.54358-1.766c-.8034-.04053-.96246-.70471-1.065-1.401A4.95691,4.95691,0,0,0,6.06111,6.3Zm8.9693,7.875H6.60469l.12945,1.03571a4.0975,4.0975,0,0,0,8.13172,0ZM17.675,8.50026A1.20164,1.20164,0,0,0,16.47474,7.3H5.12526a1.14774,1.14774,0,0,0-.26514.05365A1.18475,1.18475,0,0,0,3.925,8.50026v3.47448A1.20164,1.20164,0,0,0,5.12526,13.175H16.47474A1.20164,1.20164,0,0,0,17.675,11.97474Z"
			},
			children: [
			]
		}
	]
},
	"visibility-off": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M3.55885,4.92395,5.24711,6.61227A8.77747,8.77747,0,0,0,1.95954,9.81089L1.8,10.08912l.15954.27822a10.03026,10.03026,0,0,0,8.841,4.67924,11.42755,11.42755,0,0,0,2.578-.3026l2.72479,2.72491.79187-.79284L4.35072,4.13111ZM7.42482,8.79l4.67365,4.67383a3.49443,3.49443,0,0,1-1.29908.255A3.63368,3.63368,0,0,1,7.16982,10.0893,3.49417,3.49417,0,0,1,7.42482,8.79ZM6.59172,7.957a4.58266,4.58266,0,0,0-.54258,2.13235A4.722,4.722,0,0,0,7.3403,13.32859a8.318,8.318,0,0,1-4.23965-3.23947A7.87738,7.87738,0,0,1,6.07248,7.43771ZM12.252,10.0893a1.44868,1.44868,0,0,1-.04116.33057L10.46876,8.6778A1.44112,1.44112,0,0,1,12.252,10.0893Zm7.548-.00018-.15954.27822a8.99156,8.99156,0,0,1-3.92178,3.56056l-.86386-.86392a8.13406,8.13406,0,0,0,3.64453-2.97486,8.32128,8.32128,0,0,0-4.24142-3.23978,4.72166,4.72166,0,0,1,1.29172,3.24,4.67441,4.67441,0,0,1-.91347,2.756l-.79279-.79278A3.61908,3.61908,0,0,0,8.83625,7.04524L7.43667,5.64554a11.50311,11.50311,0,0,1,3.36382-.5134,10.03039,10.03039,0,0,1,8.84,4.67875Z"
			},
			children: [
			]
		}
	]
},
	visibility: visibility,
	"voice-hd": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.1",
		id: "Ebene_1",
		xmlns: "http://www.w3.org/2000/svg",
		"xmlns:xlink": "http://www.w3.org/1999/xlink",
		x: "0px",
		y: "0px",
		viewBox: "0 0 21.6 21.6",
		style: "enable-background:new 0 0 21.6 21.6;",
		"xml:space": "preserve"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M5.7,10.2H2.9V7.7H1.8v6.2h1.1v-2.8h2.8v2.8h1.1V7.7H5.7V10.2z M10.7,7.7H8.1v6.2h2.6c0.8,0,1.6-0.3,2.1-0.9\n\tc0.5-0.6,0.7-1.4,0.7-2.2s-0.2-1.6-0.7-2.2C12.3,7.9,11.6,7.7,10.7,7.7z M12,12.4c-0.4,0.5-1,0.6-1.7,0.6H9.2V8.6h1.1\n\tc0.6,0,1.3,0.1,1.7,0.6c0.3,0.4,0.4,1,0.4,1.6C12.4,11.3,12.3,12,12,12.4z M14.3,5.6l-0.8,0.8c2.4,2.4,2.4,6.4,0,8.8l0.8,0.8\n\tC17.1,13.1,17.1,8.5,14.3,5.6z M16.4,3.6l-0.8,0.8c1.7,1.7,2.7,4,2.7,6.4s-0.9,4.7-2.7,6.4l0.8,0.8c1.9-1.9,3-4.5,3-7.2\n\tS18.3,5.5,16.4,3.6z"
			},
			children: [
			]
		}
	]
},
	"voice-mail": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.82,6.86a3.94,3.94,0,0,0-2.75,6.75H8.45A3.93,3.93,0,1,0,5.7,14.74H15.83a3.94,3.94,0,0,0,0-7.88ZM2.89,10.8A2.81,2.81,0,1,1,5.7,13.61,2.81,2.81,0,0,1,2.89,10.8Zm12.93,2.81a2.81,2.81,0,1,1,2.82-2.81A2.81,2.81,0,0,1,15.82,13.61Z"
			},
			children: [
			]
		}
	]
},
	volume: volume,
	volunteer: volunteer,
	wallet: wallet,
	warning: warning,
	"water-resistant": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.27852,11.41717c-.907-1.953-5.526-9.674-5.526-9.674s-4.185,7.131-5.339,9.545a6.6827,6.6827,0,0,0-.578,2.49,5.96448,5.96448,0,1,0,11.443-2.361Zm-5.479,7.201a4.84525,4.84525,0,0,1-4.84-4.84,5.65492,5.65492,0,0,1,.468-2.00494c.782-1.636,3.033-5.565,4.334-7.811,1.399,2.364,3.873,6.587,4.483,7.901a4.84189,4.84189,0,0,1-4.445,6.755Zm2.553-7.115-1.758,1.758,1.758,1.758-.795.795-1.758-1.758-1.758,1.758-.795-.795,1.75806-1.758-1.75806-1.758.795-.795,1.758,1.758,1.758-1.758Z"
			},
			children: [
			]
		}
	]
},
	"water-utility": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.78865,10.33119a2.322,2.322,0,0,0,.2677-.37744A2.62633,2.62633,0,0,0,15.863,7.35859L13.95155,4.1s-.44183.75317-.90045,1.53509C11.90034,3.67335,10.80153,1.8,10.80153,1.8L5.9557,10.06129a6.65816,6.65816,0,0,0-.49036,6.57923,5.99106,5.99106,0,0,0,4.769,3.14105q.23429.0185.4696.01843h.19513q.235,0,.46961-.01843a5.99086,5.99086,0,0,0,4.769-3.141A6.54393,6.54393,0,0,0,15.78865,10.33119Zm-2.778-2.40369.94086-1.604.9386,1.6001A1.72658,1.72658,0,0,1,15.136,9.18934a1.01593,1.01593,0,0,1-.07221.23481,1.2334,1.2334,0,0,1-.74383.59753,1.16093,1.16093,0,0,1-.233.0495q-.04843.00384-.097.00378h-.077c-.03235,0-.0647-.00122-.09674-.00372a1.231,1.231,0,0,1-.97705-.64709A1.561,1.561,0,0,1,13.01069,7.9275Zm2.13446,8.18341a4.86269,4.86269,0,0,1-3.865,2.54914q-.19016.015-.381.015H10.704q-.1908,0-.38116-.015A4.86279,4.86279,0,0,1,6.4579,16.11091c-1.131-2.11956-.19061-4.34607.4682-5.48047l3.87543-6.60693L12.399,6.74684c-.21082.35943-.35889.61175-.35889.61175a2.62633,2.62633,0,0,0-.19342,2.59516,2.363,2.363,0,0,0,1.88111,1.239q.09246.00732.18524.00726h.077q.09275,0,.18524-.00726a2.27953,2.27953,0,0,0,.70453-.18585A5.47234,5.47234,0,0,1,15.14515,16.11091Z"
			},
			children: [
			]
		}
	]
},
	wearable: wearable,
	weather: weather,
	webinar: webinar,
	weights: weights,
	"wifi-scan": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M2.56966,8.43915,1.8,7.66949A12.86,12.86,0,0,1,14.0022,4.29893a5.65456,5.65456,0,0,0-1.87758.76422A11.76043,11.76043,0,0,0,2.56966,8.43915Zm6.91446,7.02013,1.35506,1.35511,1.35512-1.35511A1.9164,1.9164,0,0,0,9.48412,15.45928ZM9.729,11.60673a5.29164,5.29164,0,0,0-2.635,1.42768l.76966.76966A4.214,4.214,0,0,1,10.171,12.62955,5.66468,5.66468,0,0,1,9.729,11.60673Zm.16571-3.90928a9.11588,9.11588,0,0,0-5.51059,2.62708l.76965.76966a8.03017,8.03017,0,0,1,4.4038-2.24882A5.64648,5.64648,0,0,1,9.89472,7.69745Zm8.94652,9.98328L16.868,14.02078a4.589,4.589,0,1,1,.94245-.54646L19.8,17.16448Zm-3.68567-4.40615a3.39681,3.39681,0,1,0-3.39728-3.39634A3.40055,3.40055,0,0,0,15.15557,13.27458Z"
			},
			children: [
			]
		}
	]
},
	"wifi-wireless": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.77,11.88a5.3,5.3,0,0,1,3.75,1.55l-.81.81a4.26,4.26,0,0,0-5.88,0L7,13.43A5.26,5.26,0,0,1,10.77,11.88ZM4.35,10.76l.81.81a7.94,7.94,0,0,1,11.22,0l.81-.81a9.08,9.08,0,0,0-12.84,0ZM10.8,4.41a12.66,12.66,0,0,0-9,3.73L2.61,9A11.59,11.59,0,0,1,19,9l.81-.81A12.66,12.66,0,0,0,10.8,4.41ZM9.4,15.85l1.34,1.34,1.34-1.34A1.9,1.9,0,0,0,9.4,15.85Z"
			},
			children: [
			]
		}
	]
},
	"wireless-vending": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15,1.8H6v16h9.56V1.8ZM7.14,2.92h3.1V4.56H7.14Zm0,2.76h3.1V7.32H7.14Zm0,2.76h3.1v1.64H7.14Zm3.78,7.23L9.5,15l.65-1.42,1.42.64Zm3.54,1H11.7l1.34-3L9.59,12.13,8,15.59l2.38,1.07H7.14V11.2h7.32Zm0-6.58h-3.1V8.44h3.1Zm0-2.76h-3.1V5.68h3.1Zm0-2.76h-3.1V2.92h3.1ZM6.58,18.68H15V19.8H6.58Z"
			},
			children: [
			]
		}
	]
},
	"wireless-video-surveillance": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13.31,2.85v-1A6.5,6.5,0,0,1,19.8,8.32h-1A5.47,5.47,0,0,0,13.31,2.85Zm3.48,5.47h1a4.52,4.52,0,0,0-4.5-4.5v1A3.5,3.5,0,0,1,16.79,8.32Zm-2,0h1a2.5,2.5,0,0,0-2.5-2.5v1A1.48,1.48,0,0,1,14.79,8.32Zm2.29,6.58,1.74,1.74-3.14,3.13L14,18l-1.5,1.49L8.07,15.15,6.49,16.72H3.94A2.24,2.24,0,0,1,1.8,18.31V17.16A1.1,1.1,0,1,0,1.8,15V13.82A2.26,2.26,0,0,1,4,15.57H6l1.23-1.24L2,9.07V5.46l5.5-2.08L18.05,13.94Zm-.81-.81.15-.15L7.2,4.72,3.14,6.25V8.59l9.31,9.31.68-.68Zm0,1.63-1.51,1.5.92.92,1.51-1.5Z"
			},
			children: [
			]
		}
	]
},
	"yield": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Ebene_1",
		"data-name": "Ebene 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.3,7.3a5.5,5.5,0,1,0-6.063,5.472V19.8h1.125V12.772A5.501,5.501,0,0,0,16.3,7.3Zm-5.5,4.376a4.376,4.376,0,1,1,4.376-4.376A4.3809,4.3809,0,0,1,10.8,11.676ZM4.2939,12.736a4.28643,4.28643,0,0,0,5.451,5.451A4.28623,4.28623,0,0,0,4.2939,12.736Zm4.531,4.53a3.18305,3.18305,0,0,1-3.61-3.61A3.183,3.183,0,0,1,8.82491,17.266Zm8.481-4.53a4.28641,4.28641,0,0,0-5.451,5.451A4.28661,4.28661,0,0,0,17.30593,12.736Zm-4.531,4.53a3.18266,3.18266,0,0,1,3.61-3.61A3.18264,3.18264,0,0,1,12.77492,17.266ZM11.06661,6.83076v-1.96a1.06931,1.06931,0,0,1,1.082.94336h.65869a1.64311,1.64311,0,0,0-1.74072-1.48828V3.87861h-.45508v.44727c-1.041.041-1.749.61816-1.749,1.521,0,1.03271.74853,1.30957,1.749,1.5288V9.48213A1.30476,1.30476,0,0,1,9.28585,8.15645H8.60274a1.90146,1.90146,0,0,0,2.00879,1.8789v.69141h.45508v-.68311c1.06543-.06543,1.8706-.64258,1.8706-1.62695C12.93721,7.31074,12.132,7.05049,11.06661,6.83076Zm-.45508-.08935c-.75635-.1709-1.10645-.40674-1.10645-.92725,0-.57715.44727-.89453,1.10645-.95117Zm.45508,2.749V7.48164c.78076.1709,1.20361.35791,1.20361.95947A1.1389,1.1389,0,0,1,11.06661,9.49043Z"
			},
			children: [
			]
		}
	]
},
	youtube: youtube,
	"zoom-in": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.17,4.43a9,9,0,1,0,0,12.74A9,9,0,0,0,17.17,4.43Zm-.8,11.92a7.92,7.92,0,0,1-11.14,0,7.82,7.82,0,0,1,0-11.13,8,8,0,0,1,11.14,0A7.82,7.82,0,0,1,16.37,16.35Zm-5-6.15h3.91v1.2H11.4v3.91H10.2V11.4H6.29V10.2H10.2V6.29h1.2Z"
			},
			children: [
			]
		}
	]
},
	"zoom-out": {
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		id: "Layer_1",
		"data-name": "Layer 1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21.6 21.6"
	},
	children: [
		{
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.15,4.45a9,9,0,1,0,0,12.7A9,9,0,0,0,17.15,4.45Zm-.78,11.9a7.79,7.79,0,0,1-11.1,0,7.88,7.88,0,0,1,0-11.1,7.79,7.79,0,0,1,11.1,0A8,8,0,0,1,16.37,16.35ZM6.3,10.25h9v1.1h-9Z"
			},
			children: [
			]
		}
	]
}
};

export { accessibility, airport, analytics, announcement, ar, archive, artboard, at, attach, award, awareness, barcode, battery, bid, blind, bluetooth, bookmark, bot, braille, brightness, calendar, calibrate, camera, chat, checkmark, clock, close, cloud, coax, coffee, coin, comparison, compass, compose, connect, convergence, conversion, crash, crop, cta, ctr, customize, data, deaf, decrease, IconData as default, dining, directory, display, distribution, doorbell, download, driver, duplicate, edit, education, email, emoji, enterprise, error, ethernet, euro, expense, facebook, favorite, fax, feedback, filter, financial, fire, flag, fleet, flexibility, flurry, folder, fridge, fullscreen, gaming, gas, gateway, geofence, gift, government, growth, hackers, headphones, history, home, humidity, inclusivity, increase, industry, info, instagram, insurance, international, inventory, irobot, landscape, law, levers, light, link, list, lmr, loader, location, locker, logout, manufacturing, maximize, menu, microphone, minus, multicast, music, mute, nationwide, native, network, news, next, night, no, notification, orders, passenger, pause, pharmaceutical, phone, photo, platform, play, plus, portrait, pressure, previous, print, question, recycle, reminder, reply, research, reservations, retargeting, returns, rewards, ring, ringing, ringtone, router, rss, satellite, save, scale, search, services, settings, share, shipping, shock, shopping, snooze, sos, sound, speed, stadium, stakeholder, star, steps, stop, support, survey, swipe, sync, tablet, tag, talking, taxes, technology, teletype, temperature, template, theme, ticket, tiles, tilt, timer, tools, traffic, transportation, trash, trumpet, tv, twitter, umbrella, unification, uplink, upload, user, vibration, video, visibility, volume, volunteer, vpn, wallet, warning, wearable, weather, webinar, weights, youtube };
